{
 " ao(à) paciente {nome}{cpf}": " to patient {nome}{cpf}",
 " junto ao plano de saúde {c}": " with the health plan {c}",
 " às {h}": " at {h}",
 "\"1\", \"1 / 10\" ou \"Página 1 de 10\", no canto que quiser.": "\"1\", \"1 / 10\" or \"Page 1 of 10\", in any corner you like.",
 "\"{nome}\" está no {provedor}.": "\"{nome}\" is in {provedor}.",
 "\"{nome}\" não é JPG nem PNG. Converta para JPG e tente de novo.": "\"{nome}\" is not a JPG or PNG. Convert it to JPG and try again.",
 "\"{nome}\" não é um PDF.": "\"{nome}\" is not a PDF.",
 "\"{nova}\" às {hora} coincide com: {outras}.": "\"{nova}\" at {hora} overlaps with: {outras}.",
 "\"{n}\" agora é do grupo. Em até 1 minuto os outros membros veem tudo.": "\"{n}\" now belongs to the group. Within 1 minute the other members will see everything.",
 "\"{titulo}\" foi criada com os mesmos dados.": "\"{titulo}\" was created with the same details.",
 "\"{titulo}\" já foi adicionado em {data}.": "\"{titulo}\" was already added on {data}.",
 "% ao mês": "% per month",
 "(No computador do administrador: 32-LIGAR-DRIVE-ONEDRIVE.bat.)": "(On the admin's computer: 32-LIGAR-DRIVE-ONEDRIVE.bat.)",
 "(cópia)": "(copy)",
 "(sem título)": "(untitled)",
 "+ Adicionar alerta": "+ Add alert",
 "+ Adicionar outra OAB": "+ Add another OAB",
 "+ Adicionar pausa": "+ Add break",
 "+ Adicionar subtarefa": "+ Add subtask",
 "+ Matéria em {nome}": "+ Subject in {nome}",
 "+ Perfil": "+ Profile",
 "+ Subtarefa": "+ Subtask",
 "+5 min": "+5 min",
 "+{n} acompanhante(s)": "+{n} plus-one(s)",
 "+{n} páginas acima da meta": "+{n} pages above the goal",
 ", carteirinha nº {n},": ", member card no. {n},",
 ", pago em {d}{f}": ", paid on {d}{f}",
 "1 cápsula": "1 capsule",
 "1 dose": "1 serving",
 "1 dose (30 g)": "1 serving (30 g)",
 "1 pessoa": "1 person",
 "1 publicação nova": "1 new publication",
 "1 página": "1 page",
 "1 tarja no documento": "1 black bar in the document",
 "1. Instale o My Planner e crie sua conta.  2. Abra este link de novo (ou digite o código em Ajustes › Grupos e convites).": "1. Install My Planner and create your account.  2. Open this link again (or enter the code in Settings › Groups & invites).",
 "1. Quais dados tratamos": "1. What data we process",
 "1. Sobre o app": "1. About the app",
 "1ª dose": "1st dose",
 "2 por folha": "2 per sheet",
 "2 xícaras de farinha\n3 ovos\n1 colher de fermento": "2 cups of flour\n3 eggs\n1 spoon of baking powder",
 "2, 4, 6 ou 9 páginas em cada folha (para imprimir).": "2, 4, 6 or 9 pages on each sheet (for printing).",
 "2. Para que usamos": "2. What we use it for",
 "2. Sua conta": "2. Your account",
 "2ª dose": "2nd dose",
 "3 a 5 g": "3 to 5 g",
 "3. Bases legais (LGPD)": "3. Legal bases (LGPD)",
 "3. Uso correto": "3. Proper use",
 "3ª dose": "3rd dose",
 "4 por folha": "4 per sheet",
 "4. Com quem compartilhamos": "4. Who we share it with",
 "4. Planos e testes": "4. Plans and trials",
 "5. Limites": "5. Limitations",
 "5. Segurança": "5. Security",
 "6 por folha": "6 per sheet",
 "6. Por quanto tempo": "6. How long we keep it",
 "7. Seus direitos (art. 18 da LGPD)": "7. Your rights (art. 18 of the LGPD)",
 "8. Crianças e adolescentes": "8. Children and teenagers",
 "9 por folha": "9 per sheet",
 "9. Mudanças": "9. Changes",
 "@letra-dom": "S",
 "@letra-qua": "W",
 "@letra-qui": "T",
 "@letra-sab": "S",
 "@letra-seg": "M",
 "@letra-sex": "F",
 "@letra-ter": "T",
 "A IA está classificando...": "AI is categorizing...",
 "A IA está lendo a caixa...": "The AI is reading the box...",
 "A IA lê as páginas e o PDF passa a aceitar busca e cópia.": "AI reads the pages and the PDF becomes searchable and copyable.",
 "A IA lê o PDF e sugere um nome claro.": "AI reads the PDF and suggests a clear name.",
 "A IA não devolveu uma resposta no formato esperado. Tente de novo.": "The AI didn't return a response in the expected format. Try again.",
 "A IA não encontrou dados para esta ficha no arquivo.": "The AI found no data for this record in the file.",
 "A IA não encontrou tarefas nesta caixa.": "The AI found no tasks in this box.",
 "A IA resume o PDF e responde perguntas.": "AI summarizes the PDF and answers questions.",
 "A SEFAZ registra que a nota chegou ao seu conhecimento (não confirma nem recusa a compra) e libera o XML completo na próxima busca, em até 1 hora.": "SEFAZ records that the invoice has come to your attention (it neither confirms nor rejects the purchase) and releases the full XML on the next search, within 1 hour.",
 "A VENCER (7 DIAS)": "DUE SOON (7 DAYS)",
 "A aba inteira": "The entire tab",
 "A aba {aba} está perto do limite. Arquive ou apague itens antigos dela.": "The {aba} tab is close to the limit. Archive or delete old items in it.",
 "A aba {aba} não está assinada. O vínculo fica guardado e volta ao assinar.": "The {aba} tab is not subscribed. The link is kept and comes back when you subscribe.",
 "A busca de \"{nome}\" está ampla demais. Use o nome completo.": "The search for \"{nome}\" is too broad. Use the full name.",
 "A busca de GIFs ainda não foi ligada neste app. Enquanto isso, use as figurinhas animadas (🎉).": "GIF search isn't turned on in this app yet. Meanwhile, use the animated stickers (🎉).",
 "A cada": "Every",
 "A cada N páginas": "Every N pages",
 "A cada quantos dias": "Every how many days",
 "A cada {n} dia(s)": "Every {n} day(s)",
 "A cada {n} mês(es)": "Every {n} month(s)",
 "A cada {n} mês(es) · dia {d}": "Every {n} month(s) · day {d}",
 "A cada {n} semana(s)": "Every {n} week(s)",
 "A cada {n} semana(s) · {dia}": "Every {n} week(s) · {dia}",
 "A caixa está em {aba}, em \"Anotações recebidas\".": "The box is in {aba}, under \"Received notes\".",
 "A caixa foi para {destino}.": "The box was sent to {destino}.",
 "A chave fica guardada só neste dispositivo, no cofre do sistema. Em outro dispositivo, cadastre de novo.": "The key is stored only on this device, in the system's secure storage. On another device, add it again.",
 "A chave fica guardada só neste navegador. Use num computador pessoal.": "The key is stored only in this browser. Use it on a personal computer.",
 "A conexão é criptografada. O cofre usa criptografia de ponta a ponta (AES-256): nem o suporte consegue ler. O app pode ser bloqueado com senha, desenho ou biometria.": "The connection is encrypted. The vault uses end-to-end encryption (AES-256): not even support can read it. The app can be locked with a password, pattern or biometrics.",
 "A confirmação pelo WhatsApp ainda não foi ligada no servidor.": "WhatsApp confirmation hasn't been turned on on the server yet.",
 "A conta e todos os dados guardados na nuvem: tarefas, anotações, abas, fichas, mensagens, arquivos enviados ao app e configurações. Também são apagados os dados deste dispositivo. Não há como desfazer.": "Your account and all data stored in the cloud: tasks, notes, tabs, records, messages, files sent to the app and settings. Data on this device is also deleted. This cannot be undone.",
 "A cor aparece na barra, nos títulos e nas tarefas ligadas a esta aba.": "The color shows in the bar, in titles and in tasks linked to this tab.",
 "A cor do My Planner é a cor de destaque do app. Cada tarefa pode ter uma cor própria na ficha.": "The My Planner color is the app's accent color. Each task can have its own color in its details.",
 "A data de fim é anterior à de início.": "The end date is before the start date.",
 "A data inicial precisa ser antes da final.": "The start date must be before the end date.",
 "A equipe vai olhar o erro e corrigir numa próxima atualização.": "The team will look at the error and fix it in an upcoming update.",
 "A equipe vê e altera conforme o papel de cada um": "The team sees and edits according to each person's role",
 "A fazer": "To do",
 "A foto passa de 8 MB.": "The photo is over 8 MB.",
 "A foto é grande demais. Instale o app novo para recortar a foto.": "The photo is too large. Install the new app version to crop the photo.",
 "A função \"nuvem\" ainda não foi publicada no servidor. Rode o 32-LIGAR-DRIVE-ONEDRIVE.bat.": "The \"nuvem\" function hasn't been published on the server yet. Run 32-LIGAR-DRIVE-ONEDRIVE.bat.",
 "A função \"nuvem\" ainda não foi publicada no servidor. Rode o 9-LIGAR-DRIVE-ONEDRIVE.bat (veja COMO RODAR, versão 0.15.1).": "The \"nuvem\" function has not been published on the server yet. Run 9-LIGAR-DRIVE-ONEDRIVE.bat (see COMO RODAR, version 0.15.1).",
 "A gravação ainda está sendo preparada. Tente de novo em alguns minutos.": "The recording is still being prepared. Try again in a few minutes.",
 "A hora fica marcada neste fuso. Em outro fuso, o app mostra e avisa no horário convertido.": "The time is set in this time zone. In another time zone, the app shows it and alerts you at the converted time.",
 "A imagem original não está neste dispositivo.": "The original image isn't on this device.",
 "A pagar": "To pay",
 "A pagar: {v}": "To pay: {v}",
 "A permissão da agenda foi retirada. Libere de novo nas configurações do celular.": "Calendar permission was revoked. Allow it again in your phone's settings.",
 "A pessoa sai do grupo e deixa de receber os envios.": "The person leaves the group and stops receiving posts.",
 "A receber": "To receive",
 "A receber: {v}": "To receive: {v}",
 "A reunião ainda está sendo gravada.": "The meeting is still being recorded.",
 "A senha atual não confere.": "The current password is incorrect.",
 "A senha do cofre precisa ter 6 caracteres ou mais.": "The vault password must have 6 characters or more.",
 "A senha precisa ter 8 caracteres ou mais.": "The password must be 8 characters or longer.",
 "A senha precisa ter pelo menos 8 caracteres.": "The password must be at least 8 characters.",
 "A senha é a mesma no celular e no My Planner Web.": "The password is the same on the phone and on My Planner Web.",
 "A sincronização roda ao abrir o app e depois de cada alteração. Tarefas ligadas à agenda mostram 📆.": "Sync runs when you open the app and after every change. Tasks linked to the calendar show 📆.",
 "A sua equipe num lugar só": "Your whole team in one place",
 "A tarefa da casa não entra no My Planner sozinha. \"Enviar para o My Planner\" abre a ficha completa para escolher dia, horário, frequência, pausas e alertas.": "Household tasks don't go into My Planner on their own. \"Send to My Planner\" opens the full form so you can pick the day, time, frequency, breaks and alerts.",
 "A validade não pode ser antes da emissão.": "The expiry date can't be before the issue date.",
 "A versão para iPhone chega em breve na App Store. Enquanto isso, use o My Planner Web.": "The iPhone version is coming soon to the App Store. In the meantime, use My Planner Web.",
 "A versão para iPhone chega em breve na App Store. Enquanto isso, use o My Planner Web: no Safari, toque em Compartilhar > Adicionar à Tela de Início para ele virar um ícone no celular.": "The iPhone version is coming soon to the App Store. Meanwhile, use My Planner Web: in Safari, tap Share > Add to Home Screen to turn it into an icon on your phone.",
 "A4, Carta, A5 ou Ofício, sem cortar nada.": "A4, Letter, A5 or Legal, without cutting anything.",
 "ADICIONAR AMIGO": "ADD FRIEND",
 "AGUARDANDO RESPOSTA": "AWAITING REPLY",
 "AMIGOS": "FRIENDS",
 "ANOTAÇÕES": "NOTES",
 "ANOTAÇÕES RECEBIDAS · {aba}": "RECEIVED NOTES · {aba}",
 "ATIVIDADE": "ACTIVITY",
 "ATIVIDADE FÍSICA": "PHYSICAL ACTIVITY",
 "ATRASADAS": "OVERDUE",
 "Aba": "Tab",
 "Aba bloqueada": "Tab locked",
 "Aba {nome}": "{nome} tab",
 "Abas": "Tabs",
 "Abas liberadas pelo suporte": "Tabs unlocked by support",
 "Abas para comprar": "Tabs to buy",
 "Abas que você já tem": "Tabs you already have",
 "Abastecimento": "Fill-up",
 "Abastecimentos": "Fill-ups",
 "Abdominal": "Crunches",
 "Abertura do prazo da declaração do IR": "Income tax filing period opens",
 "Abra a empresa e toque em \"Buscar notas\" para digitar a senha do cofre.": "Open the company and tap \"Search invoices\" to enter the vault password.",
 "Abra o My Planner Anne e entre com o seu CPF e senha.": "Open My Planner Anne and sign in with your ID number and password.",
 "Abra o My Planner no celular.": "Open My Planner on your phone.",
 "Abra o cofre": "Open the vault",
 "Abra um PDF para começar.": "Open a PDF to get started.",
 "Abra uma matéria e toque em \"Estudar agora\" para cronometrar. Defina metas semanais em cada matéria.": "Open a subject and tap \"Study now\" to start the timer. Set weekly goals for each subject.",
 "Abraço": "Hug",
 "Abre a janela do celular: WhatsApp, e-mail, Google Drive, OneDrive, salvar em Arquivos e outros.": "Opens your phone's share menu: WhatsApp, email, Google Drive, OneDrive, Save to Files and more.",
 "Abre o PDF para ler aqui mesmo.": "Opens the PDF to read right here.",
 "Abre o Scanner PDF (bordas e sombras corrigidas).": "Opens the PDF Scanner (edges and shadows fixed).",
 "Abrir": "Open",
 "Abrir Ajustes": "Open Settings",
 "Abrir PDF": "Open PDF",
 "Abrir PDF do celular, Drive ou OneDrive": "Open PDF from phone, Drive or OneDrive",
 "Abrir a aba": "Open the tab",
 "Abrir a cópia guardada": "Open the saved copy",
 "Abrir a pasta no Drive": "Open the folder in Drive",
 "Abrir com outro app": "Open with another app",
 "Abrir configurações": "Open settings",
 "Abrir em outro app": "Open in another app",
 "Abrir no DJEN": "Open in DJEN",
 "Abrir no modo seguro": "Open in safe mode",
 "Abrir normalmente": "Open normally",
 "Abrir nota fiscal": "Open invoice",
 "Abrir o PDF": "Open the PDF",
 "Abrir o PDF no {nome}": "Open the PDF in {nome}",
 "Abrir o XML": "Open the XML",
 "Abrir o app": "Open the app",
 "Abrir o app My Planner": "Open the My Planner app",
 "Abrir o cartão": "Open card",
 "Abrir o cofre": "Open the vault",
 "Abrir o cofre para ver": "Open the vault to view",
 "Abrir o diário oficial": "Open the official gazette",
 "Abrir ou baixar": "Open or download",
 "Abrir página": "Open page",
 "Abrir site": "Open website",
 "Abrir {nome}": "Open {nome}",
 "Acabamento": "Finishing",
 "Acabou": "Ran out",
 "Academia": "Gym",
 "Aceitar": "Accept",
 "Aceitar, editar ou recusar": "Accept, edit or decline",
 "Aceite os termos para continuar.": "Accept the terms to continue.",
 "Aceito": "Accepted",
 "Aceito com alterações": "Accepted with changes",
 "Acerto de contas": "Settle up",
 "Acerto de contas: {v}": "Settle up: {v}",
 "Acessibilidade": "Accessibility",
 "Acesso ilimitado": "Unlimited access",
 "Acesso ilimitado a todas as funções, sem prazo": "Unlimited access to all features, no expiration",
 "Achatar": "Flatten",
 "Acompanha tudo, inclusive os gastos, e registra no diário.": "Follows everything, including expenses, and writes in the log.",
 "Acompanhamento": "Side dish",
 "Acompanhantes": "Plus-ones",
 "Acrescentar no fim da página": "Add to the end of the page",
 "Adaptador de tomada": "Plug adapter",
 "Adestramento": "Training",
 "Adicionar": "Add",
 "Adicionar amigo": "Add friend",
 "Adicionar amigos do app": "Add friends from the app",
 "Adicionar ao Planner?": "Add to Planner?",
 "Adicionar arquivo": "Add file",
 "Adicionar cômodo": "Add room",
 "Adicionar fotos e vídeos": "Add photos and videos",
 "Adicionar imagem": "Add image",
 "Adicionar item (ex.: 2 ovos mexidos)": "Add item (e.g., 2 scrambled eggs)",
 "Adicionar na página": "Add to page",
 "Adicionar passo": "Add step",
 "Adicionar país": "Add country",
 "Adicionar página": "Add page",
 "Adicionar texto": "Add text",
 "Adicionar {nome}": "Add {nome}",
 "Adicionar à equipe": "Add to team",
 "Adicione um amigo pelo código dele ou mande o seu código para quem você quer.": "Add a friend with their code or send your code to anyone you like.",
 "Admin": "Admin",
 "Administração": "Business Administration",
 "Adubar a cada quantos dias": "Fertilize every how many days",
 "Adubar: {p}": "Fertilize: {p}",
 "Adubei hoje": "Fertilized today",
 "Advogado": "Lawyer",
 "Advogados": "Lawyers",
 "Afundo": "Lunges",
 "Agachamento": "Squats",
 "Agenda do Google": "Google Calendar",
 "Agenda limpa": "Schedule cleared",
 "Agenda não liberada": "Calendar access not allowed",
 "Agenda sincronizada ✓": "Calendar synced ✓",
 "Agenda, anotações, finanças, estudos, mensagens e muito mais num app só.": "Calendar, notes, finances, studies, messages and much more in one app.",
 "Agenda, cadastro dos pacientes e pagamentos, sem o prontuário.": "Schedule, patient records and payments, without medical charts.",
 "Agendado": "Scheduled",
 "Agendado no My Planner": "Scheduled in My Planner",
 "Agendamento no pet shop": "Pet shop appointment",
 "Agendar": "Schedule",
 "Agendar no My Planner": "Schedule in My Planner",
 "Agendar no My Planner (dias e horários)": "Schedule in My Planner (days and times)",
 "Agora não": "Not now",
 "Agora o verso do documento.": "Now the back of the document.",
 "Agora, {hora}": "Now, {hora}",
 "Agora: {ml}": "Now: {ml}",
 "Aguardando o celular · {s}s": "Waiting for the phone · {s}s",
 "Aguarde": "Please wait",
 "Aguarde um pouco": "Please wait a moment",
 "Aguarde...": "Please wait...",
 "Ainda a pagar no mês": "Still to pay this month",
 "Ainda a receber no mês": "Still to receive this month",
 "Ainda não confirmado": "Not confirmed yet",
 "Ainda não disponível: falta configurar no servidor.": "Not available yet: server setup is missing.",
 "Ainda não guardou nada este mês. Que tal separar {v} (10% do que entrou) assim que o dinheiro cair?": "You haven't saved anything this month. How about setting aside {v} (10% of what came in) as soon as the money lands?",
 "Ainda não há feriados deste país para este ano.": "No holidays for this country this year yet.",
 "Ainda não há nada nesta aba para compartilhar. Crie primeiro (ex.: a viagem) e volte aqui.": "There's nothing in this tab to share yet. Create it first (e.g. the trip) and come back here.",
 "Ainda não há outras pessoas no grupo (ou você não vê a lista de membros).": "There's no one else in the group yet (or you can't see the member list).",
 "Ainda não marcado como feito. Toque para abrir.": "Not marked as done yet. Tap to open.",
 "Ainda não sincronizado": "Not synced yet",
 "Ainda sem chave neste dispositivo.": "No key on this device yet.",
 "Airbnb": "Airbnb",
 "Airbnb, Booking ou direto: reservas, limpeza no check-out, receitas, despesas e lucro do mês": "Airbnb, Booking or direct: bookings, check-out cleaning, income, expenses and monthly profit",
 "Ajuda na organização": "Helps organize",
 "Ajudante": "Helper",
 "Ajustar": "Adjust",
 "Ajustar a data final": "Adjust the end date",
 "Ajustar a folha": "Adjust the page",
 "Ajustar tamanho da página": "Adjust page size",
 "Ajuste visual": "Visual adjust",
 "Ajustes": "Settings",
 "Alarme dos remédios": "Medicine alarm",
 "Alarme que insiste até marcar como tomado": "Alarm that keeps ringing until marked as taken",
 "Alemão": "German",
 "Alergia": "Allergy",
 "Alergias": "Allergies",
 "Alergias e alertas": "Allergies and alerts",
 "Alertas": "Alerts",
 "Alertas das tarefas": "Task alerts",
 "Alertas dos compromissos": "Appointment alerts",
 "Algo deu errado, mas o app continua aberto": "Something went wrong, but the app is still open",
 "Alguns arquivos foram guardados em outro dispositivo.": "Some files were saved on another device.",
 "Alguns relógios (como os da Huawei) podem não enviar dados para o Health Connect. Nesse caso, digite à mão.": "Some watches (like Huawei's) may not send data to Health Connect. If so, enter it manually.",
 "Alguém": "Someone",
 "Alguém indicou o app para você?": "Did someone recommend the app to you?",
 "Alimentação": "Food",
 "Alimentação & Despensa": "Food & Pantry",
 "Alimentação {semana}": "Meals {semana}",
 "Alimento": "Food",
 "Alinhamento e balanceamento": "Alignment and balancing",
 "Almoço": "Lunch",
 "Alongamento": "Stretching",
 "Alta": "High",
 "Alterado por último por {nome}": "Last changed by {nome}",
 "Alterar metadados": "Edit metadata",
 "Alterar o valor pago": "Change amount paid",
 "Alterações": "Changes",
 "Alto-falante": "Speaker",
 "Aluga como": "Rent as",
 "Alugar a casa ou um cômodo": "Rent out the house or a room",
 "Aluguel": "Rent",
 "Aluguel & Hospedagem": "Rentals & Stays",
 "Aluguel de carro": "Car rental",
 "Aluno": "Student",
 "Alunos": "Students",
 "Alvará ou licença": "Permit or license",
 "Alvenaria": "Masonry",
 "Alvo": "Target",
 "Alíquota do ISS (%)": "ISS rate (%)",
 "Alíquota do ISS deste serviço (%)": "ISS rate for this service (%)",
 "Amanhã": "Tomorrow",
 "Ambiente": "Environment",
 "Ameno": "Mild",
 "Amigos": "Friends",
 "Amor": "Love",
 "Amortização": "Amortization",
 "Ampliar a foto": "Zoom photo",
 "Amém": "Amen",
 "Analisar com IA": "Analyze with AI",
 "Anamnese e histórico (no cofre)": "History and intake notes (in the vault)",
 "Anexar arquivos": "Attach files",
 "Anexar comprovante": "Attach receipt",
 "Anexar documentos, importar extratos e salvar relatórios, PDFs e cópias de segurança.": "Attach documents, import statements and save reports, PDFs and backups.",
 "Anexos": "Attachments",
 "Anexos guardados aqui no dispositivo: {n}": "Attachments stored on this device: {n}",
 "Animais e natureza": "Animals & nature",
 "Animação": "Animation",
 "Anime": "Anime",
 "Aniversário": "Birthday",
 "Aniversário de Campo Grande": "Campo Grande Anniversary",
 "Aniversário de São Paulo": "São Paulo Anniversary",
 "Ano": "Year",
 "Ano anterior": "Previous year",
 "Ano de lançamento": "Release year",
 "Ano de {ano}": "Year {ano}",
 "Ano passado": "Last year",
 "Anotar pela foto da página": "Take notes from a photo of the page",
 "Anotação": "Note",
 "Anotação de {data}": "Note from {data}",
 "Anotação do professor": "Teacher's note",
 "Anotação à mão": "Handwritten note",
 "Anotações": "Notes",
 "Anotações Rápidas": "Quick Notes",
 "Anotações arquivadas": "Archived notes",
 "Anotações arquivadas ({n})": "Archived notes ({n})",
 "Anote cada reserva com as datas, a origem e os valores. A limpeza do check-out entra sozinha na lista de limpezas.": "Log each booking with dates, source and amounts. The check-out cleaning is added to the cleaning list automatically.",
 "Anote o dia a dia da obra com fotos. Marque as fotos como Antes ou Depois para ver a evolução.": "Log the day-to-day of the project with photos. Mark photos as Before or After to see the progress.",
 "Anote o que emprestou ou pegou emprestado, com foto e prazo. O app avisa no dia da devolução.": "Note what you lent or borrowed, with a photo and a due date. The app reminds you on the return day.",
 "Anote os lugares que quer conhecer. Pesquise no Google Maps ou no Waze, trace a rota passando por todos e coloque no roteiro do dia.": "Write down the places you want to see. Search on Google Maps or Waze, plan a route through all of them and add them to the day's itinerary.",
 "Anteriores ({n})": "Past ({n})",
 "Antes": "Before",
 "Antes de começar, confira o que o app usa e por quê. Você pode mudar tudo depois em Ajustes > Privacidade e termos.": "Before you start, check what the app uses and why. You can change everything later in Settings > Privacy and terms.",
 "Antes de uma data": "Before a date",
 "Antes do início": "Before start",
 "Antes e depois": "Before and after",
 "Antes: {lista}": "Before: {lista}",
 "Antipulgas": "Flea treatment",
 "Anual": "Yearly",
 "Ao ar livre": "Outdoors",
 "Ao cancelar, a aba fica em preto e branco e os vínculos somem das tarefas, mas nada é apagado.": "If you cancel, the tab turns black and white and the links disappear from your tasks, but nothing is deleted.",
 "Ao criar a conta ou continuar usando o app, você concorda com estes termos e com a política de privacidade abaixo.": "By creating an account or continuing to use the app, you agree to these terms and to the privacy policy below.",
 "Ao fechar, a página é salva.": "The page is saved when you close it.",
 "Ao salvar, você cria a senha do cofre. Este campo é criptografado no dispositivo.": "When you save, you create the vault password. This field is encrypted on the device.",
 "Ao tocar em \"Arquivo\" ou \"Foto\" em Estudos e Documentos, o seletor do celular mostra o Google Drive, o OneDrive e o Dropbox (quando os apps estão instalados). Escolha o arquivo direto de lá.": "When you tap \"File\" or \"Photo\" in Studies and Documents, your phone's picker shows Google Drive, OneDrive and Dropbox (when the apps are installed). Pick the file straight from there.",
 "Ao tocar num arquivo anexado, ele abre no app do celular que você escolher (no Android, \"Apenas uma vez\" ou \"Sempre\"). O que você editar lá fica salvo no próprio arquivo.": "Tapping an attached file opens it in the phone app you choose (on Android, \"Just once\" or \"Always\"). What you edit there is saved in the file itself.",
 "Apaga a conta e todos os vencimentos dela.": "Deletes the bill and all its due dates.",
 "Apaga as matérias e páginas deste fichário. As tarefas do planner continuam.": "Deletes the subjects and pages in this binder. Planner tasks are kept.",
 "Apaga as páginas desta matéria. O tempo estudado continua no histórico.": "Deletes the pages of this subject. Time studied stays in the history.",
 "Apaga o cartão e as compras dele.": "Deletes the card and its purchases.",
 "Apaga para sempre a conta e todos os dados na nuvem e neste dispositivo. Não há como desfazer.": "Permanently deletes your account and all data in the cloud and on this device. This cannot be undone.",
 "Apaga todas as tarefas da agenda, passadas e futuras.": "Deletes every task in the schedule, past and future.",
 "Apaga todas as {n} parcelas.": "Deletes all {n} installments.",
 "Apaga todos os meses desta conta.": "Deletes all months of this bill.",
 "Apagar": "Delete",
 "Apagar \"{nome}\"?": "Delete \"{nome}\"?",
 "Apagar a caixa?": "Delete the box?",
 "Apagar a chave": "Delete the key",
 "Apagar a chave deste dispositivo?": "Delete the key from this device?",
 "Apagar a conta?": "Delete account?",
 "Apagar a lista de erros?": "Clear the error list?",
 "Apagar a pasta (os documentos continuam)": "Delete folder (documents are kept)",
 "Apagar as da agenda": "Delete calendar ones",
 "Apagar caixa": "Delete box",
 "Apagar de verdade (as páginas com tarja viram imagem)": "Really erase (pages with black bars become images)",
 "Apagar de vez": "Delete for good",
 "Apagar desenho": "Delete drawing",
 "Apagar envio": "Delete post",
 "Apagar lista": "Clear list",
 "Apagar minha conta": "Delete my account",
 "Apagar minha conta e todos os dados": "Delete my account and all data",
 "Apagar o escritório": "Delete office",
 "Apagar o escritório?": "Delete the office?",
 "Apagar o grupo": "Delete group",
 "Apagar o grupo?": "Delete the group?",
 "Apagar o lançamento?": "Delete the entry?",
 "Apagar para todos": "Delete for everyone",
 "Apagar tudo": "Delete all",
 "Apagar tudo antes de": "Delete everything before",
 "Apague de uma vez as tarefas de hoje, do mês, de um período ou pelo nome. Antes de apagar, o app mostra o que vai sair e pede a sua senha.": "Delete today's tasks, this month's, a date range's or by name, all at once. Before deleting, the app shows what will go and asks for your password.",
 "Aparece na barra quando estiver liberada": "Shows in the bar once unlocked",
 "Aparecem no Planner, junto com os pontos facultativos (Carnaval, Quarta-feira de Cinzas e Corpus Christi).": "They show up in the Planner, along with the optional holidays (Carnival, Ash Wednesday and Corpus Christi).",
 "Aplicar": "Apply",
 "Aponte a câmera do celular para este QR Code.": "Point your phone's camera at this QR code.",
 "Aponte para o QR Code na tela do computador": "Point at the QR code on the computer screen",
 "Apostila": "Handout",
 "Apostilas, listas, slides, vídeos, links e recados. Pelo ⋮ › Enviar para um grupo, cada aluno recebe no app dele.": "Handouts, exercise lists, slides, videos, links and notices. Via ⋮ › Send to a group, each student gets it in their app.",
 "App usado no botão \"Rota\" dos endereços (tarefas, consultas, roteiro da viagem, obras, escola...).": "App used by the \"Route\" button on addresses (tasks, appointments, trip itinerary, renovations, school...).",
 "Apple Saúde": "Apple Health",
 "Apple Watch: já grava tudo no app Saúde do iPhone. Não precisa fazer nada.": "Apple Watch: it already saves everything to the iPhone Health app. Nothing to do.",
 "Apresentação": "Presentation",
 "Aprovação": "Approval",
 "Aqui": "Here",
 "Ar-condicionado": "Air conditioning",
 "Arco-íris": "Rainbow",
 "Arenoso": "Sandy",
 "Armazenamento": "Storage",
 "Armário": "Cabinet",
 "Arquivadas ({n})": "Archived ({n})",
 "Arquivados ({n})": "Archived ({n})",
 "Arquivar": "Archive",
 "Arquivar a caixa de anotações?": "Archive the notes box?",
 "Arquivar conversa": "Archive chat",
 "Arquivo": "File",
 "Arquivo (Drive, OneDrive, Dropbox ou do dispositivo)": "File (Drive, OneDrive, Dropbox or device)",
 "Arquivo OFX ou CSV do banco": "Bank OFX or CSV file",
 "Arquivo adicionado": "File added",
 "Arquivo menor (para WhatsApp e e-mail)": "Smaller file (for WhatsApp and email)",
 "Arquivo menor para WhatsApp e e-mail.": "Smaller file for WhatsApp and email.",
 "Arquivo não encontrado.": "File not found.",
 "Arquivo ou PDF": "File or PDF",
 "Arquivo ou documento": "File or document",
 "Arquivos": "Files",
 "Arquivos (frente, verso, PDF)": "Files (front, back, PDF)",
 "Arquivos (importar e exportar)": "Files (import and export)",
 "Arquivos de {nome}": "Files in {nome}",
 "Arquivos na nuvem e cópias de segurança": "Cloud files and backups",
 "Arrasou!": "Nailed it!",
 "Arraste as bolinhas até as 4 pontas da folha. O app recorta e endireita a página.": "Drag the dots to the 4 corners of the page. The app crops and straightens it.",
 "Arraste o dedo sobre o que quer esconder. Toque numa tarja para tirar.": "Drag your finger over what you want to hide. Tap a bar to remove it.",
 "Arraste para a direita para excluir, ou para a esquerda para enviar a outra aba.": "Swipe right to delete, or left to send to another tab.",
 "Arraste para a direita para excluir.": "Swipe right to delete.",
 "Arraste para mudar a ordem, gire, duplique, apague e ponha página em branco.": "Drag to reorder, rotate, duplicate, delete and add blank pages.",
 "Arraste para ver o resto do quadro. Ele cresce para baixo e para a direita.": "Drag to see the rest of the board. It grows downward and to the right.",
 "Arraste um documento para a direita para excluir.": "Swipe a document to the right to delete it.",
 "Arraste uma caixa para a esquerda para arquivar ou para a direita para excluir.": "Swipe a box left to archive it or right to delete it.",
 "Arraste uma caixa para a esquerda para arquivar ou para a direita para excluir. Segure ⋮⋮ para mudar a ordem.": "Swipe a box left to archive or right to delete. Hold ⋮⋮ to reorder.",
 "Arroz": "Rice",
 "Artes": "Arts",
 "As assinaturas Claude Pro, ChatGPT Plus e Gemini Advanced não podem ser usadas por outros apps. Para ligar a IA aqui, crie uma chave de API na sua conta (o Gemini tem uso gratuito; Claude e ChatGPT cobram por uso, centavos por análise).": "Claude Pro, ChatGPT Plus and Gemini Advanced subscriptions can't be used by other apps. To turn on AI here, create an API key in your account (Gemini has free usage; Claude and ChatGPT charge per use, a few cents per analysis).",
 "As chamadas ainda não foram ligadas no servidor (17-LIGAR-MENSAGENS.bat).": "Calls haven't been turned on on the server yet (17-LIGAR-MENSAGENS.bat).",
 "As compras dele também saem das Finanças.": "Its purchases are also removed from Finance.",
 "As compras parceladas entram com todas as parcelas: as próximas já aparecem nas faturas seguintes.": "Installment purchases are added with all installments: the next ones already show up on the following statements.",
 "As fotos deste documento estão no dispositivo onde ele foi escaneado. Lá dá para editar, compartilhar e ler o texto.": "This document's photos are on the device where it was scanned. You can edit, share and read the text there.",
 "As imagens vão só para a IA que você escolheu, com a sua chave.": "Images go only to the AI you chose, with your own key.",
 "As limpezas dos check-outs aparecem aqui sozinhas, com checklist e fotos de antes e depois.": "Check-out cleanings show up here automatically, with a checklist and before and after photos.",
 "As notas emitidas aqui, as encontradas na busca e os XML importados aparecem nesta lista.": "Invoices issued here, those found in searches and imported XML files appear in this list.",
 "As parcelas aparecem aqui. Anexe o comprovante (foto, PDF ou print do PIX) em cada uma.": "Installments appear here. Attach the receipt (photo, PDF or PIX screenshot) to each one.",
 "As parcelas dos próximos 12 meses já estão no My Planner.": "The installments for the next 12 months are already in My Planner.",
 "As parcelas em aberto são refeitas com o valor, os juros e o prazo atuais do contrato. As pagas não mudam.": "Open installments are recalculated with the contract's current amount, interest and term. Paid ones don't change.",
 "As páginas deste documento estão no dispositivo onde ele foi escaneado. Abra por lá ou use a cópia guardada no Drive ou no OneDrive.": "This document's pages are on the device where it was scanned. Open it there or use the copy saved in Drive or OneDrive.",
 "As páginas viram imagem mais leve: ótimo para PDFs escaneados. O texto deixa de ser pesquisável (use o OCR depois, se precisar).": "Pages become lighter images: great for scanned PDFs. The text is no longer searchable (use OCR afterwards if needed).",
 "As páginas vão só para a IA que você escolheu, com a sua chave.": "Pages are sent only to the AI you chose, with your own key.",
 "As receitas do cardápio já têm tudo na despensa.": "The pantry already has everything for the menu recipes.",
 "As senhas novas não conferem.": "The new passwords don't match.",
 "As senhas não conferem.": "Passwords don't match.",
 "As tarefas continuam no My Planner. Quer apagar também as que vieram da agenda do Google?": "Your tasks stay in My Planner. Do you also want to delete the ones that came from Google Calendar?",
 "As tarefas do cômodo continuam em Minha Casa, sem cômodo.": "The room's tasks stay in My Home, without a room.",
 "As tarefas vinculadas continuam no My Planner.": "Linked tasks stay in My Planner.",
 "Aspirar e passar pano": "Vacuum and mop",
 "Assinada": "Subscribed",
 "Assinar": "Sign",
 "Assinar (simulação de teste)": "Subscribe (test simulation)",
 "Assinar o documento": "Sign the document",
 "Assinatura": "Signature",
 "Assinatura do profissional": "Practitioner's signature",
 "Assinatura e segurança": "Signature and security",
 "Assinaturas (simulação de teste)": "Subscriptions (test simulation)",
 "Assine a aba em Ajustes para enviar anotações para ela.": "Subscribe to the tab in Settings to send notes to it.",
 "Assine a aba em Ajustes para vincular.": "Subscribe to the tab in Settings to link it.",
 "Assine a aba em Ajustes › Compras para enviar anotações para ela.": "Subscribe to the tab in Settings › Purchases to send notes to it.",
 "Assine a aba em Ajustes › Compras para vincular.": "Subscribe to the tab in Settings › Purchases to link it.",
 "Assine a aba para abrir o vínculo.": "Subscribe to the tab to open the link.",
 "Assisti mais uma aula": "Watched another lesson",
 "Assistido": "Watched",
 "Assistindo": "Watching",
 "Assistência técnica (nome)": "Service center (name)",
 "Assistência: {nome}": "Service center: {nome}",
 "Assunto": "Subject",
 "Assunto (ex.: Reunião semanal)": "Subject (e.g.: Weekly meeting)",
 "Atender": "Answer",
 "Atendimento": "Appointment",
 "Atendimentos": "Appointments",
 "Ativar avisos": "Unmute notifications",
 "Ativar monitor": "Turn on monitor",
 "Ativas": "Active",
 "Atividade": "Activity",
 "Atividade do roteiro": "Itinerary activity",
 "Atividade hoje": "Activity today",
 "Atividade: {blocos}": "Activity: {blocos}",
 "Atividades": "Activities",
 "Atividades de hoje": "Today's activities",
 "Atividades e materiais": "Activities and materials",
 "Atividades físicas e saúde": "Fitness and health",
 "Atrasada": "Overdue",
 "Atrasada há {n} dia(s)": "Overdue by {n} day(s)",
 "Atrasadas": "Overdue",
 "Atrasados": "Overdue",
 "Atuais": "Current",
 "Atualidades": "Current affairs",
 "Atualizar": "Update",
 "Atualizar agora": "Update now",
 "Atualizar alarmes no My Planner": "Update alarms in My Planner",
 "Atualizar rega e adubo na agenda": "Update watering and fertilizing in the schedule",
 "Atualização automática disponível no app instalado (APK).": "Automatic updates are available in the installed app (APK).",
 "Atualização baixada. Entra ao reabrir o app ou ao tocar no aviso.": "Update downloaded. It applies when you reopen the app or tap the notice.",
 "Atualização pronta": "Update ready",
 "Atualizações": "Updates",
 "Até": "Until",
 "Audiência": "Court hearing",
 "Aula dada": "Lesson taught",
 "Aula {a} de {n} ({p}%)": "Lesson {a} of {n} ({p}%)",
 "Aulas assistidas": "Lessons watched",
 "Autoajuda": "Self-help",
 "Autor": "Author",
 "Avaliação": "Assessment",
 "Avaliações e notas": "Assessments and grades",
 "Avançado": "Advanced",
 "Aveia": "Oats",
 "Avisar a hora de sair": "Remind me when to leave",
 "Avisar antes de vencer": "Remind me before it expires",
 "Avisar no celular quando alguém incluir algo": "Notify me on my phone when someone adds something",
 "Aviso": "Notice",
 "Aviso com as tarefas do dia": "Notification with the day's tasks",
 "Aviso de teste enviado pelo servidor. Ele chega em alguns segundos; saia do app para ver na barra do celular.": "Test notification sent by the server. It arrives in a few seconds; leave the app to see it in your phone's notification bar.",
 "Aviso enviado": "Notification sent",
 "Aviso {dias} dia(s) antes e no dia": "Reminder {dias} day(s) before and on the day",
 "Avisos no celular": "Phone notifications",
 "Avisos no celular passam pelos serviços da Expo, da Google e da Apple.": "Phone notifications go through Expo, Google and Apple services.",
 "Ação": "Action",
 "Ações": "Stocks",
 "BOLETO E DOCUMENTOS": "BOLETO AND DOCUMENTS",
 "Backup importado.": "Backup imported.",
 "Bairro": "Neighborhood",
 "Baixa": "Low",
 "Baixando atualização...": "Downloading update...",
 "Baixar": "Download",
 "Baixar a versão {v}": "Download version {v}",
 "Baixar agora": "Download now",
 "Baixar o My Planner para Android": "Download My Planner for Android",
 "Baixar o My Planner para Android (versão {v})": "Download My Planner for Android (version {v})",
 "Baixar o My Planner para iPhone": "Download My Planner for iPhone",
 "Baixar o PDF da nota (DANFSe)": "Download the invoice PDF (DANFSe)",
 "Baixar o PDF?": "Download the PDF?",
 "Baixar o XML completo (dá ciência na SEFAZ)": "Download the full XML (acknowledges it with SEFAZ)",
 "Baixe a versão mais recente para Android: {apk}": "Download the latest Android version: {apk}",
 "Baixe aqui a versão mais recente: {link}": "Download the latest version here: {link}",
 "Balança": "Sway",
 "Balanço e relatórios": "Balance sheet and reports",
 "Banana": "Banana",
 "Banco": "Bank",
 "Banco, financeira ou pessoa": "Bank, lender or person",
 "Bandeiras": "Flags",
 "Banheiro": "Bathroom",
 "Banho": "Bath",
 "Banho e tosa": "Bath and grooming",
 "Barra": "Bar",
 "Bateria": "Battery",
 "Batimentos (média)": "Heart rate (avg)",
 "Batizado": "Christening",
 "Bebida": "Drink",
 "Bebê": "Baby",
 "Beijo": "Kiss",
 "Bem": "Asset",
 "Bem clara": "Very light",
 "Bem-Estar": "Wellness",
 "Bem-Estar · Cronograma alimentar": "Wellness · Meal plan",
 "Bens": "Assets",
 "Bichos e diversão": "Pets and fun",
 "Bicicleta": "Bicycle",
 "Bicicleta ergométrica": "Exercise bike",
 "Biografia": "Biography",
 "Biologia": "Biology",
 "Biometria (digital ou rosto)": "Biometrics (fingerprint or face)",
 "Biometria ({tipos})": "Biometrics ({tipos})",
 "Biometria não confirmada.": "Biometrics not confirmed.",
 "Bloqueado": "Blocked",
 "Bloquear": "Block",
 "Bloquear agora": "Lock now",
 "Bloqueio": "Block",
 "Blusas de frio": "Sweaters",
 "Boa noite": "Good night",
 "Boa sorte!": "Good luck!",
 "Boas-vindas ao My Planner": "Welcome to My Planner",
 "Boas-vindas pelo WhatsApp": "WhatsApp welcome",
 "Boleto": "Bank slip (boleto)",
 "Boleto anexado": "Boleto attached",
 "Boleto do banco {b}": "Boleto from bank {b}",
 "Boleto e documentos (foto, PDF ou arquivo)": "Boleto and documents (photo, PDF or file)",
 "Boleto ou conta (foto, PDF ou arquivo)": "Boleto or bill (photo, PDF or file)",
 "Boleto por foto": "Boleto from a photo",
 "Bolinha": "Dot",
 "Bom dia": "Good morning",
 "Bom dia!": "Good morning!",
 "Bom dia! Seu dia no My Planner": "Good morning! Your day in My Planner",
 "Booking": "Booking",
 "Bora!": "Let's go!",
 "Borboleta": "Butterfly",
 "Borracha": "Eraser",
 "Botas para neve": "Snow boots",
 "Brasil": "Brazil",
 "Braços acima da cabeça": "Arms above your head",
 "Brilho": "Sparkle",
 "Brinquedo ou livro para a viagem": "Toy or book for the trip",
 "Busca de notas": "Invoice search",
 "Busca o nome nos diários municipais reunidos pelo Querido Diário (Open Knowledge Brasil). Nem todos os municípios estão incluídos, e os diários oficiais não fazem parte do DJEN.": "Searches for the name in the municipal gazettes collected by Querido Diário (Open Knowledge Brasil). Not all municipalities are included, and official gazettes are not part of DJEN.",
 "Buscando...": "Searching...",
 "Buscar": "Search",
 "Buscar GIF (ex.: parabéns, bom dia)": "Search GIFs (e.g. congrats, good morning)",
 "Buscar cidade, país ou GMT": "Search city, country or GMT",
 "Buscar conversa": "Search chats",
 "Buscar documento, titular ou órgão": "Search document, holder or issuer",
 "Buscar em {nome}": "Search in {nome}",
 "Buscar emoji (ex.: coração, risada)": "Search emoji (e.g. heart, laugh)",
 "Buscar figurinha": "Search stickers",
 "Buscar notas": "Search invoices",
 "Buscar ou digitar um alimento": "Search or type a food",
 "Buscar país": "Search country",
 "Buscar pelo nome ou pelo texto": "Search by name or text",
 "Buscar produto, loja ou observação": "Search product, store or notes",
 "Buscar tarefas": "Search tasks",
 "Buscar: processo, parte, tribunal, palavra...": "Search: case, party, court, word...",
 "CAIXA {n}": "BOX {n}",
 "CARDS DE ANOTAÇÕES": "NOTE CARDS",
 "CARTÕES": "CARDS",
 "CEP": "CEP (ZIP code)",
 "CID (se o paciente pedir na declaração)": "CID (ICD code, if the patient asks for it on the statement)",
 "CID: {c}": "CID: {c}",
 "CNH": "Driver's license (CNH)",
 "CNPJ (se tiver)": "CNPJ (if any)",
 "CNPJ ou CPF": "CNPJ or CPF",
 "COMPROVANTE DE PAGAMENTO": "PAYMENT RECEIPT",
 "COMPROVANTE DE RECEBIMENTO": "PROOF OF RECEIPT",
 "COMPROVANTES ANTERIORES": "PREVIOUS RECEIPTS",
 "CONTAS DO MÊS": "THIS MONTH'S BILLS",
 "CPF": "CPF",
 "CPF (Brasil)": "CPF (Brazil)",
 "CPF de quem paga": "Payer's CPF",
 "CPF do paciente": "Patient's CPF",
 "CPF do pagador": "Payer's CPF",
 "CPF inválido": "Invalid CPF",
 "CPF ou CNPJ de quem recebeu": "CPF or CNPJ of the recipient",
 "CPF ou senha incorretos.": "Incorrect CPF or password.",
 "CRIAR CÔMODO": "CREATE ROOM",
 "CRIAR UM GRUPO": "CREATE A GROUP",
 "CRONOGRAMA ALIMENTAR": "MEAL PLAN",
 "CUIDADOS PESSOAIS": "SELF-CARE",
 "Cabeleireiro": "Hairdresser",
 "Cabelo": "Hair",
 "Cachorro": "Dog",
 "Cactos e suculentas": "Cacti and succulents",
 "Cada aba extra: {n} dias grátis; depois {preco} por ano.": "Each extra tab: {n} days free; then {preco} per year.",
 "Cada arquivo pronto vai para o {nome}. Os PDFs abertos ficam também neste dispositivo, na lista abaixo.": "Each finished file goes to {nome}. Opened PDFs also stay on this device, in the list below.",
 "Cada dia da semana": "Each day of the week",
 "Cada documento novo vai para o {nome} quando você sai dele. As fotos das páginas ficam só neste dispositivo.": "Each new document goes to {nome} when you leave it. Page photos stay only on this device.",
 "Cada pessoa da equipe recebe a reunião em Recebidos e coloca no Planner com um toque, com o alerta.": "Everyone on the team gets the meeting in Received and adds it to the Planner with one tap, alert included.",
 "Cada pessoa do grupo recebe e decide se aceita.": "Each person in the group receives it and decides whether to accept.",
 "Cada página guarda um resumo, aula ou capítulo. Marque como revisada quando terminar.": "Each page holds a summary, lesson or chapter. Mark it as reviewed when you finish.",
 "Cada página vira uma imagem JPG.": "Each page becomes a JPG image.",
 "Cada refeição se repete nos dias dela": "Each meal repeats on its own days",
 "Cadastrar": "Add",
 "Cadastrar cartão de crédito": "Add credit card",
 "Cadastrar pela foto (página do curso, certificado, folheto)": "Add from a photo (course page, certificate, flyer)",
 "Cadastrar pela foto da capa": "Add from a photo of the cover",
 "Cadastre \"Meus dados\" para os recibos saírem com seu nome, conselho e número.": "Fill in \"My details\" so receipts show your name, council and number.",
 "Cadastre RG, CNH, passaporte, contratos e certidões. O app avisa antes de vencer e envia o documento com um toque.": "Add your ID, driver's license, passport, contracts and certificates. The app reminds you before they expire and sends the document with one tap.",
 "Cadastre a empresa (ou você, como profissional) com CNPJ ou CPF, município e regime. Depois ligue o certificado A1 para emitir NFS-e pelo Padrão Nacional e buscar as notas emitidas e recebidas.": "Register the company (or yourself, as a professional) with CNPJ or CPF, city and tax regime. Then connect the A1 certificate to issue NFS-e through the Padrão Nacional and search for issued and received invoices.",
 "Cadastre a obra e, dentro dela, as etapas com orçamento, o diário com fotos, os profissionais e as entregas de material.": "Add the project and, inside it, the stages with budget, the photo log, the professionals and the material deliveries.",
 "Cadastre a viagem e, dentro dela, o roteiro de cada dia, as reservas e a mala. Durante a viagem, o roteiro aparece no My Planner.": "Add the trip and, inside it, each day's itinerary, the bookings and the packing list. During the trip, the itinerary shows in My Planner.",
 "Cadastre apenas o seu próprio nome e a sua OAB.": "Register only your own name and your own OAB number.",
 "Cadastre as crianças: provas, reuniões, consultas e vacinas ficam dentro de cada uma.": "Add the children: tests, meetings, appointments and vaccines are kept inside each one.",
 "Cadastre cada pet: carteira de vacinação, vermífugos, remédios e pet shop ficam dentro dele.": "Add each pet: vaccination record, dewormers, medicines and pet shop are kept inside it.",
 "Cadastre cada planta com luz, solo e de quantos em quantos dias regar e adubar. O app monta o calendário na agenda.": "Add each plant with light, soil and how often to water and fertilize. The app builds the calendar in your schedule.",
 "Cadastre cada veículo. Dentro dele ficam as manutenções (com aviso por km e por data) e os vencimentos de IPVA, licenciamento e seguro.": "Add each vehicle. Inside it you'll find the maintenance (with reminders by mileage and by date) and the IPVA, licensing and insurance due dates.",
 "Cadastre digital ou rosto no aparelho para usar.": "Set up fingerprint or face unlock on the device to use this.",
 "Cadastre o cartão primeiro": "Add the card first",
 "Cadastre o financiamento ou empréstimo com o valor, os juros e o número de parcelas. O app calcula as parcelas, o saldo devedor e avisa os vencimentos.": "Add the financing or loan with the amount, interest and number of installments. The app calculates the installments and the outstanding balance and reminds you of due dates.",
 "Cadastre o imóvel inteiro ou cada quarto que você aluga. Dentro de cada um ficam as reservas, a limpeza e as despesas.": "Add the whole property or each room you rent out. Bookings, cleaning and expenses go inside each one.",
 "Cadastre o livro com o total de páginas e a meta por dia. Toque em ⋮ para somar as páginas lidas.": "Add the book with the total pages and the daily goal. Tap ⋮ to add the pages you've read.",
 "Cadastre o remédio com os horários e toque em ⋮ para colocar na linha do tempo com alarme.": "Add the medicine with its times and tap ⋮ to put it on the timeline with an alarm.",
 "Cadastre os alunos da turma na aba Alunos.": "Add the class's students in the Students tab.",
 "Cadastre os clientes para separar as horas.": "Add clients to split the hours.",
 "Cadastre os clientes que recebem as suas notas. O endereço é opcional (se preencher, informe CEP, código IBGE, rua, número e bairro).": "Add the clients who receive your invoices. The address is optional (if you fill it in, enter CEP, IBGE code, street, number and neighborhood).",
 "Cadastre os serviços que você mais emite, com o código de tributação nacional. Na hora de emitir é só tocar.": "Add the services you issue most often, with the national tax code. When it's time to issue, just tap.",
 "Cadastre primeiro em {nome}.": "First add one in {nome}.",
 "Cadastre seu nome, conselho e número do registro. Eles saem nos recibos e nas declarações.": "Enter your name, council and registration number. They appear on receipts and statements.",
 "Cadastre seus clientes na aba \"Tomadores\" da empresa para escolher aqui.": "Add your clients in the company's \"Customers\" tab to choose them here.",
 "Cadastre seus dados profissionais (nome, conselho e número) em \"Meus dados\" para sair no documento.": "Enter your professional details (name, council and number) in \"My details\" so they appear on the document.",
 "Cadastre seus dados profissionais (nome, conselho e número) em \"Meus dados\" para sair no recibo.": "Enter your professional details (name, council and number) in \"My details\" so they appear on the receipt.",
 "Cadastre seus pacientes. Dentro de cada um ficam os atendimentos com evolução, prescrição, pagamento, recibo e declaração para o plano de saúde.": "Add your patients. Each one holds their appointments with progress notes, prescription, payment, receipt and statement for the health plan.",
 "Cadastre você e cada pessoa da família. Dentro de cada uma ficam consultas, exames, vacinas e remédios. Dados sensíveis vão para o cofre criptografado.": "Add yourself and each family member. Appointments, tests, vaccines and medicines are kept inside each one. Sensitive data goes to the encrypted vault.",
 "Cadastro aguardando liberação: desligue \"Confirm email\" no Supabase (veja COMO RODAR).": "Sign-up awaiting approval: turn off \"Confirm email\" in Supabase (see COMO RODAR).",
 "Cadastro recebido": "Sign-up received",
 "Cadastro: nome, CPF ou e-mail, senha (guardada só em forma protegida) e e-mail de contato.": "Sign-up: name, CPF or email, password (stored only in protected form) and contact email.",
 "Cadastros": "Records",
 "Cadastros e comprovantes": "Records and receipts",
 "Cadeira extensora": "Leg extension",
 "Café": "Coffee",
 "Café da manhã": "Breakfast",
 "Café ou bar": "Café or bar",
 "Café?": "Coffee?",
 "Cafés": "Cafes",
 "Caixa": "Box",
 "Caixa arquivada": "Archived box",
 "Caixa com checklist, lista ou texto livre": "Box with checklist, list or free text",
 "Caixa {n}": "Box {n}",
 "Caixas": "Boxes",
 "Caixas e cronograma da mudança.": "Boxes and moving schedule.",
 "Caixas por cômodo com etiqueta, troca de água, luz e internet, vistorias e o cronograma dos dias.": "Boxes by room with labels, switching water, power and internet, inspections and the day-by-day schedule.",
 "Calculadora": "Calculator",
 "Calculando...": "Calculating...",
 "Calendário": "Calendar",
 "Calendário da planta": "Plant calendar",
 "Calendário do imposto": "Tax calendar",
 "Calendários": "Calendars",
 "Calorias em atividade": "Active calories",
 "Calorias gastas em atividade (kcal)": "Calories burned in activity (kcal)",
 "Calça térmica (segunda pele)": "Thermal leggings (base layer)",
 "Calças ou bermudas": "Pants or shorts",
 "Cama": "Bed",
 "Caminhada": "Walking",
 "Caminhão": "Truck",
 "Camisetas": "T-shirts",
 "Campo Grande": "Campo Grande",
 "Campo Grande (MS)": "Campo Grande (MS)",
 "Campos de formulário": "Form fields",
 "Cancelada": "Canceled",
 "Canceladas": "Canceled",
 "Cancelar": "Cancel",
 "Cancelar a NFS-e": "Cancel the NFS-e",
 "Cancelar a NFS-e {n}?": "Cancel NFS-e {n}?",
 "Cancelar a nota": "Cancel the invoice",
 "Cancelar a reunião \"{nome}\"?": "Cancel the meeting \"{nome}\"?",
 "Cancelar reunião": "Cancel meeting",
 "Caneta": "Pen",
 "Captura automática do servidor: de 2 em 2 horas, das 08h às 20h": "Automatic server capture: every 2 hours, from 08:00 to 20:00",
 "Captura automática: todos os dias às 08h e 12h": "Automatic capture: every day at 8 AM and 12 PM",
 "Card": "Card",
 "Cardápio": "Menu",
 "Cardápio da semana, receitas, lista de compras automática e validade da despensa.": "Weekly menu, recipes, automatic shopping list and pantry expiration dates.",
 "Cardápio só para este dia. Os outros dias continuam com o da semana.": "Menu for this day only. Other days keep the weekly menu.",
 "Carga (kg)": "Weight (kg)",
 "Carimbo": "Stamp",
 "Carnaval": "Carnival",
 "Carne magra": "Lean meat",
 "Carregando feriados...": "Loading holidays...",
 "Carregando...": "Loading...",
 "Carro": "Car",
 "Carta": "Letter",
 "Carteira": "Wallet",
 "Carteira de trabalho": "Work card (employment record)",
 "Carteira profissional (OAB, CRC, CREA...)": "Professional license (OAB, CRC, CREA...)",
 "Cartão": "Card",
 "Cartão de contato das Mensagens: a foto, o telefone, o e-mail e a frase que você mesmo escolher pôr. Só quem conversa com você, os seus amigos e quem divide um grupo do app com você veem.": "Messages contact card: the photo, phone, email and status you choose to add. Only people who chat with you, your friends and people who share an app group with you can see it.",
 "Cartão de crédito": "Credit card",
 "Cartão de débito": "Debit card",
 "Cartão parcelado": "Card installments",
 "Cartões": "Cards",
 "Cartões de visita": "Business cards",
 "Cartões e dinheiro": "Cards and cash",
 "Casa": "Home",
 "Casa e rotina": "Home and routine",
 "Casa, família e veículos": "Home, family and vehicles",
 "Casaco leve": "Light jacket",
 "Casaco pesado": "Heavy coat",
 "Casamento": "Wedding",
 "Castanhas": "Nuts",
 "Categoria": "Category",
 "Categoria de \"{d}\"": "Category of \"{d}\"",
 "Categorias": "Categories",
 "Caução": "Security deposit",
 "Ceia": "Late-night snack",
 "Celular": "Phone",
 "Celular confirmado": "Phone confirmed",
 "Celular e carregador": "Phone and charger",
 "Certidão": "Certificate",
 "Certificado digital": "Digital certificate",
 "Certificado digital A1": "A1 digital certificate",
 "Certificado ligado": "Certificate connected",
 "Chamada": "Attendance",
 "Chamada ainda não feita neste dia. Toque em quem faltou ou confirme todos presentes.": "Attendance not taken for this day yet. Tap who was absent or confirm everyone is present.",
 "Chamada, notas, planos de aula e materiais.": "Attendance, grades, lesson plans and materials.",
 "Chamadas": "Calls",
 "Chamadas de áudio e vídeo passam pelos servidores da LiveKit, só durante a chamada e sem gravação.": "Audio and video calls go through LiveKit's servers, only during the call and without recording.",
 "Chamadas de áudio e vídeo passam pelos servidores da LiveKit, só durante a chamada. Só há gravação nas reuniões do Escritório, quando o administrador grava, e o arquivo vai direto para o armazenamento do app.": "Audio and video calls go through LiveKit's servers, only for the duration of the call. Recording happens only in Office meetings, when the administrator records, and the file goes straight to the app's storage.",
 "Chamando...": "Calling...",
 "Chapéu ou boné": "Hat or cap",
 "Chave da IA não cadastrada neste dispositivo (Ajustes › Inteligência artificial).": "AI key not added on this device (Settings › Artificial intelligence).",
 "Chave de acesso": "Access key",
 "Check-in": "Check-in",
 "Check-in: {d} a partir das {h}": "Check-in: {d} from {h}",
 "Check-in: {h} · {e}": "Check-in: {h} · {e}",
 "Check-out": "Check-out",
 "Check-out: {d} até as {h}": "Check-out: {d} by {h}",
 "Check-out: {h} · {e}": "Check-out: {h} · {e}",
 "Checklist": "Checklist",
 "Chinelo": "Flip-flops",
 "Chá de bebê": "Baby shower",
 "Cidade": "City",
 "Cidade (para a data dos recibos)": "City (for the receipt date line)",
 "Cidade de {nome}": "City of {nome}",
 "Cidades": "Cities",
 "Cifrão": "Dollar sign",
 "Cinza": "Gray",
 "Cirurgia": "Surgery",
 "Ciências": "Science",
 "Clara": "Light",
 "Clareia PDFs escaneados: fundo branco, cinza ou preto e branco.": "Brightens scanned PDFs: white, gray or black and white background.",
 "Claro": "Light",
 "Classificar categorias com IA": "Categorize with AI",
 "Claude, ChatGPT ou Gemini": "Claude, ChatGPT or Gemini",
 "Cliente": "Client",
 "Clientes": "Clients",
 "Clima esperado": "Expected weather",
 "Co-anfitrião": "Co-host",
 "Cobrança": "Charge",
 "Cobranças": "Charges",
 "Coelho": "Rabbit",
 "Cofre (criptografia de ponta a ponta)": "Vault (end-to-end encryption)",
 "Cofre aberto (fecha sozinho em 5 minutos sem uso)": "Vault open (locks itself after 5 minutes of inactivity)",
 "Cofre ainda não criado": "Vault not created yet",
 "Cofre com criptografia para RG, CNH, passaporte, contratos e certidões, com contagem até vencer e envio com um toque.": "Encrypted vault for ID, driver's license, passport, contracts and certificates, with a countdown to expiration and one-tap sharing.",
 "Cofre fechado": "Vault locked",
 "Cofrinho": "Piggy bank",
 "Cole aqui a chave ({ini}...)": "Paste the key here ({ini}...)",
 "Cole o link (https://...)": "Paste the link (https://...)",
 "Cole ou digite o código de barras (ou o Pix copia e cola) no campo do código: o app calcula o valor e o vencimento sozinho. Com a sua IA ligada, ele lê tudo pela foto.": "Paste or type the barcode (or the Pix copy-and-paste code) in the code field: the app works out the amount and due date on its own. With your AI turned on, it reads everything from the photo.",
 "Coloca arquivos dentro do PDF.": "Puts files inside the PDF.",
 "Colocar na agenda": "Add to schedule",
 "Colocar na linha do tempo com alarme": "Put on the timeline with an alarm",
 "Colocar no My Planner": "Add to My Planner",
 "Colocar rega e adubo na agenda": "Add watering and fertilizing to the schedule",
 "Coloque o valor da mensalidade na turma (Editar) ou no aluno. As cobranças deste mês que já existem não se repetem.": "Set the monthly fee on the class (Edit) or on the student. This month's existing charges aren't duplicated.",
 "Coluna": "Column",
 "Colágeno": "Collagen",
 "Com a biometria ligada, ela aparece primeiro. Se falhar, use o desenho ou a senha.": "With biometrics on, it shows up first. If it fails, use the pattern or the password.",
 "Com convênio": "With health plan",
 "Com o código do país e o DDD. Ex.: +55 41 99999-0000": "With country code and area code. E.g.: +55 41 99999-0000",
 "Com outras pessoas": "With others",
 "Com prazo, o app calcula quanto guardar por mês. O dinheiro guardado conta como \"Guardou\" no mês.": "With a deadline, the app works out how much to save per month. Money saved counts as \"Saved\" for the month.",
 "Com quem": "With whom",
 "Com quem pagou, o paciente, a data e o valor de cada atendimento pago. Como pessoa física, lance cada um no app Receita Federal › Receita Saúde; com CNPJ, emita a nota de serviço.": "Who paid, the patient, the date and the amount of each paid appointment. As an individual, enter each one in the Receita Federal app › Receita Saúde; with a CNPJ, issue the service invoice.",
 "Com valor a receber": "With amount to receive",
 "Com vencimento": "With due date",
 "Combinado": "Deal",
 "Combinado 👍": "Deal 👍",
 "Combustível": "Fuel",
 "Comece cadastrando as contas fixas do mês (aluguel, luz, internet) e o seu cartão. Eu aviso antes de cada vencimento.": "Start by adding the month's fixed bills (rent, electricity, internet) and your card. I'll remind you before each due date.",
 "Comecei em": "Started on",
 "Comentários": "Comments",
 "Começa amanhã": "Starts tomorrow",
 "Começa às {hora} (em {m} min)": "Starts at {hora} (in {m} min)",
 "Começar": "Start",
 "Começar com o modelo: café, lanche, almoço, lanche e jantar": "Start with the template: breakfast, snack, lunch, snack and dinner",
 "Começar em": "Start at",
 "Começar o teste grátis": "Start free trial",
 "Comi outros alimentos ou quantidades": "I ate other foods or amounts",
 "Comida": "Food",
 "Comidas e bebidas": "Food & drink",
 "Comido": "Eaten",
 "Comido / alterações": "Eaten / changes",
 "Comido conta as refeições marcadas como feitas (ou com alterações) até hoje.": "Eaten counts the meals marked as done (or with changes) up to today.",
 "Comigo": "With me",
 "Comissão da plataforma": "Platform fee",
 "Como apagar a sua conta e os seus dados": "How to delete your account and your data",
 "Como chegar": "Directions",
 "Como ela está": "How it's doing",
 "Como estou comparado ao mês passado?": "How am I doing compared to last month?",
 "Como funciona": "How it works",
 "Como planejado": "As planned",
 "Compartilhado no grupo": "Shared with the group",
 "Compartilhado no grupo · só leitura": "Shared with the group · read-only",
 "Compartilhamento indisponível neste dispositivo.": "Sharing is not available on this device.",
 "Compartilhar": "Share",
 "Compartilhar PDF": "Share PDF",
 "Compartilhar a limpeza": "Share the cleaning",
 "Compartilhar os dados": "Share the data",
 "Compartilhar os dados com a equipe": "Share the data with the team",
 "Compartilhar os dados com o grupo?": "Share the data with the group?",
 "Compartilhar texto": "Share text",
 "Competência (mês de referência)": "Period (reference month)",
 "Competência {d}": "Period {d}",
 "Complemento": "Address line 2",
 "Complete seus dados": "Complete your details",
 "Compra": "Purchase",
 "Compra e venda de imóveis, veículos e ações, recibos dedutíveis e o calendário do imposto.": "Purchases and sales of property, vehicles and stocks, deductible receipts and the tax calendar.",
 "Compra feita": "Shopping done",
 "Compra no cartão": "Card purchase",
 "Compras": "Purchases",
 "Compras da semana": "Weekly groceries",
 "Comprimir": "Compress",
 "Compromisso": "Appointment",
 "Compromisso da escola": "School event",
 "Comprovante": "Receipt",
 "Comprovante guardado": "Receipt saved",
 "Comprovantes": "Receipts",
 "Computador": "Computer",
 "Comédia": "Comedy",
 "Concedi": "I lent",
 "Concluir": "Complete",
 "Concluir (esquerda)": "Complete (left)",
 "Concluída": "Completed",
 "Concluído": "Done",
 "Concluído (%)": "Done (%)",
 "Concluído!": "Done!",
 "Concordo que meu nome, CPF e e-mail sejam usados apenas para identificar minha conta, e que minhas tarefas e anotações fiquem guardadas nela. Posso apagar a conta e todos os dados a qualquer momento em Ajustes › Segurança.": "I agree that my name, CPF and email will be used only to identify my account, and that my tasks and notes will be stored in it. I can delete the account and all data at any time in Settings › Security.",
 "Concordo que meu nome, CPF e e-mail sejam usados apenas para identificar minha conta, e que minhas tarefas e anotações fiquem guardadas nela. Posso apagar a conta e todos os dados a qualquer momento em Ajustes.": "I agree that my name, CPF and email will be used only to identify my account, and that my tasks and notes will be stored in it. I can delete the account and all data at any time in Settings.",
 "Concordo que meu nome, documento e e-mail sejam usados apenas para identificar minha conta, e que minhas tarefas e anotações fiquem guardadas nela. Posso apagar a conta e todos os dados a qualquer momento em Ajustes › Segurança.": "I agree that my name, ID document and email will be used only to identify my account, and that my tasks and notes will be stored in it. I can delete the account and all data at any time in Settings › Security.",
 "Concursos": "Civil service exams",
 "Condicionador": "Conditioner",
 "Condomínio": "HOA fees",
 "Condomínio e IPTU": "HOA fees and property tax",
 "Conectado": "Connected",
 "Conectando...": "Connecting...",
 "Conectar": "Connect",
 "Conectar navegador": "Connect browser",
 "Conectar o {nome}": "Connect {nome}",
 "Conectar relógio ou app de saúde": "Connect watch or health app",
 "Conectar {nome}": "Connect {nome}",
 "Conecte o {nome} em Ajustes › Google Drive e OneDrive.": "Connect {nome} in Settings › Google Drive and OneDrive.",
 "Conferindo...": "Checking...",
 "Conferir controles, chaves e Wi-Fi": "Check remotes, keys and Wi-Fi",
 "Conferir o prazo no sistema oficial": "Check the deadline in the official system",
 "Confete": "Confetti",
 "Configuração geral": "General settings",
 "Confira a senha da sua conta e tente de novo.": "Check your account password and try again.",
 "Confira as datas oficiais no site da Receita Federal e ajuste se precisar.": "Check the official dates on the Receita Federal website and adjust if needed.",
 "Confira o código. Ele tem 6 letras e números.": "Check the code. It has 6 letters and numbers.",
 "Confira o e-mail ou deixe em branco.": "Check the email or leave it blank.",
 "Confira o e-mail.": "Check the email.",
 "Confira o prazo no sistema oficial.": "Check the deadline in the official system.",
 "Confira os 11 números.": "Check the 11 digits.",
 "Confira os campos antes de salvar.": "Check the fields before saving.",
 "Confira se a sua conta Google está adicionada no celular e com a agenda sincronizando.": "Make sure your Google account is added on your phone and its calendar is syncing.",
 "Confirmada": "Confirmed",
 "Confirmado": "Confirmed",
 "Confirmar": "Confirm",
 "Confirme a declaração sobre a empresa.": "Confirm the statement about the company.",
 "Confirme o seu celular": "Confirm your phone",
 "Confirme para ativar a biometria": "Confirm to turn on biometrics",
 "Confirme para excluir": "Confirm to delete",
 "Confirme sua senha para sincronizar": "Confirm your password to sync",
 "Confraternização": "Get-together",
 "Confraternização Universal": "New Year's Day",
 "Conselho": "Council",
 "Consignado": "Payroll loan",
 "Consulta": "Appointment",
 "Consulta ou vacina": "Appointment or vaccine",
 "Consultas": "Appointments",
 "Consultório": "Practice",
 "Consumo médio: {v} km/L": "Average consumption: {v} km/L",
 "Conta": "Account",
 "Conta a pagar": "Bill to pay",
 "Conta a receber": "Payment to receive",
 "Conta de consumo ou tributo": "Utility bill or tax",
 "Conta os dias em que cada item estava previsto (pelos dias da semana dele) e os que foram marcados como feitos.": "Counts the days each item was scheduled (by its weekdays) and the days it was marked as done.",
 "Conta paga": "Bill paid",
 "Conta recebida": "Payment received",
 "Conta vence hoje": "Bill due today",
 "Conta vencendo": "Bill coming due",
 "Contabilidade": "Accounting",
 "Contando os acompanhantes. Toque no status do convidado para mudar.": "Including plus-ones. Tap a guest's status to change it.",
 "Contando: {cliente}": "Tracking: {cliente}",
 "Contas": "Bills",
 "Contas a pagar": "Bills to pay",
 "Contas a pagar e a receber, gastos do mês, aviso de vencimento e controle do MEI (Mestre Achado).": "Bills to pay and receive, monthly spending, due-date alerts and MEI tracking (Mestre Achado).",
 "Contas a receber": "Payments to receive",
 "Contas fixas": "Fixed bills",
 "Contato": "Contact",
 "Contato de emergência": "Emergency contact",
 "Contato do encarregado de dados:": "Data protection officer contact:",
 "Conte a sua ideia para o app ficar melhor.": "Share your idea to make the app better.",
 "Conte o que está difícil ou não funciona como deveria.": "Tell us what's hard or not working as it should.",
 "Conte o que você fez, o que esperava e o que apareceu. Se tiver uma mensagem de erro, copie aqui.": "Tell us what you did, what you expected and what showed up. If there's an error message, paste it here.",
 "Conte para a gente problemas, erros e ideias de melhoria. Sua mensagem vai direto para a equipe do My Planner.": "Tell us about problems, bugs and ideas for improvement. Your message goes straight to the My Planner team.",
 "Conteúdo": "Content",
 "Conteúdo que você cria: tarefas, anotações, finanças, documentos, fotos, anexos e dados das abas.": "Content you create: tasks, notes, finances, documents, photos, attachments and tab data.",
 "Conteúdo, matéria, tarefa de casa...": "Content, subject, homework...",
 "Continuar": "Continue",
 "Continue usando o My Planner e as Anotações por {preco} por ano. Seus dados continuam guardados.": "Keep using My Planner and Notes for {preco} per year. Your data stays saved.",
 "Contratado": "Hired",
 "Contratado: {v}": "Hired: {v}",
 "Contrato": "Contract",
 "Conversa": "Chat",
 "Conversa do grupo": "Group chat",
 "Conversar": "Chat",
 "Conversar com o Mestre (precisa da sua IA)": "Chat with the Mestre (needs your AI)",
 "Converse com amigos e grupos, e faça chamadas de áudio e vídeo.": "Chat with friends and groups, and make audio and video calls.",
 "Converter de PDF": "Convert from PDF",
 "Converter para PDF": "Convert to PDF",
 "Convidado": "Guest",
 "Convidados": "Guests",
 "Convidados com confirmação de presença, fornecedores e o cronograma do grande dia.": "Guests with RSVP, vendors and the schedule for the big day.",
 "Convidados e cronograma do dia, sem os valores.": "Guests and the day's schedule, without amounts.",
 "Convidar": "Invite",
 "Convidar pelo WhatsApp": "Invite via WhatsApp",
 "Convite": "Invite",
 "Convite copiado. Cole onde quiser enviar.": "Invite copied. Paste it wherever you want to send it.",
 "Convite inválido ou trocado pelo administrador. Peça um link novo.": "Invalid invite, or the admin changed it. Ask for a new link.",
 "Convite para o My Planner": "Invite to My Planner",
 "Convênio": "Health plan",
 "Copiar": "Copy",
 "Copiar a lista para uma tarefa": "Copy the list to a task",
 "Copiar o código": "Copy code",
 "Copiar para hoje": "Copy to today",
 "Copo de outro tamanho": "Different-size glass",
 "Copo {n}": "Glass {n}",
 "Cor": "Color",
 "Cor do fichário": "Binder color",
 "Cor do tema": "Theme color",
 "Cor do tema de cada aba": "Theme color for each tab",
 "Coração": "Heart",
 "Corações": "Hearts",
 "Cores das abas": "Tab colors",
 "Cores das conversas": "Chat colors",
 "Cores e opções desta aba": "Colors and options for this tab",
 "Corpo": "Body",
 "Corporativo": "Corporate",
 "Corpus Christi": "Corpus Christi",
 "Corredor": "Hallway",
 "Correia dentada": "Timing belt",
 "Corrida": "Running",
 "Corta as bordas em branco ou partes da página.": "Trims blank edges or parts of the page.",
 "Cortesia": "Free of charge",
 "Coxa e sobrecoxa": "Chicken thigh and drumstick",
 "Cozinha": "Kitchen",
 "Creatina": "Creatine",
 "Criada em {data}": "Created on {data}",
 "Criado com": "Created with",
 "Criado em": "Created on",
 "Criança": "Child",
 "Crianças": "Children",
 "Criar": "Create",
 "Criar animada": "Create animated",
 "Criar conta": "Create account",
 "Criar do zero": "Create from scratch",
 "Criar documento, planilha ou apresentação": "Create document, spreadsheet or presentation",
 "Criar em outro app": "Create in another app",
 "Criar escritório": "Create office",
 "Criar fichário": "Create binder",
 "Criar figurinha": "Create sticker",
 "Criar grupo": "Create group",
 "Criar grupo e convidar pessoas": "Create group and invite people",
 "Criar minha chave de API": "Create my API key",
 "Criar o cofre": "Create the vault",
 "Criar o grupo e convidar": "Create the group and invite",
 "Criar os prazos do IR de {ano}": "Create the {ano} income tax deadlines",
 "Criar uma meta (viagem, reserva, carro...)": "Create a goal (trip, emergency fund, car...)",
 "Criar uma senha nova": "Create a new password",
 "Criar {n} tarefa(s)": "Create {n} task(s)",
 "Criação do Estado de MS": "Creation of the State of MS",
 "Crie a mudança e o app já monta a lista de transferências (luz, água, internet...). Depois cadastre as caixas por cômodo, as vistorias e o cronograma dos dias.": "Create the move and the app builds the list of transfers (power, water, internet...). Then add the boxes by room, the inspections and the day-by-day schedule.",
 "Crie a pasta de cada cliente, convide o cliente pelo link (ele só vê a pasta dele) e troquem documentos nos dois sentidos: notas, guias, folha, extratos, contratos.": "Create a folder for each client, invite the client by link (they only see their own folder) and exchange documents both ways: invoices, tax slips, payroll, statements, contracts.",
 "Crie a turma (ou grupo de mentoria, treino, curso) e, dentro dela, os alunos, a chamada, as notas, os planos de aula, os materiais e as cobranças.": "Create the class (or mentoring group, training, course) and, inside it, the students, attendance, grades, lesson plans, materials and charges.",
 "Crie a turma e, dentro dela, os alunos, a chamada, as avaliações com notas e os planos de aula.": "Create the class and, inside it, the students, attendance, graded assessments and lesson plans.",
 "Crie as tarefas da casa (limpar banheiro, trocar roupa de cama...) com a frequência. O app avisa quando estão atrasadas, sem encher o My Planner.": "Create household tasks (clean the bathroom, change the bed sheets...) with their frequency. The app lets you know when they're overdue, without cluttering My Planner.",
 "Crie cards com checklist, lista, texto livre ou desenho para esta matéria. Arraste para a direita para excluir e para a esquerda para arquivar.": "Create cards with a checklist, list, free text or drawing for this subject. Swipe right to delete and left to archive.",
 "Crie o escritório, chame a equipe (amigos do app ou convite pelo link) e troquem mensagens e documentos, marquem reuniões e façam reunião de vídeo. Você, que administra, pode gravar as reuniões.": "Create the office, bring in your team (friends from the app or an invite link), and share messages and documents, schedule meetings and hold video meetings. As the admin, you can record the meetings.",
 "Crie o evento e, dentro dele, a lista de convidados com confirmação de presença, os fornecedores e o cronograma do dia.": "Create the event and, inside it, the guest list with RSVP, the vendors and the schedule for the day.",
 "Crie o grupo e mande o link: quem entrar recebe data, local, avisos e tudo o que você enviar, e aceita, edita ou recusa.": "Create the group and send the link: whoever joins gets the date, place, notices and everything you send, and can accept, edit or decline.",
 "Crie o grupo e mande o link: quem entrar vê e participa conforme o papel que você escolher. Só quem administra coloca ou tira pessoas.": "Create the group and send the link: whoever joins sees and takes part according to the role you choose. Only admins add or remove people.",
 "Crie o grupo e mande o link: quem entrar vê tudo o que está aqui dentro e participa (inclui, edita, põe fotos). Só quem administra coloca ou tira pessoas.": "Create the group and send the link: whoever joins sees everything in here and takes part (adds, edits, posts photos). Only admins add or remove people.",
 "Crie sua conta. Seus dados ficam salvos na nuvem e neste dispositivo.": "Create your account. Your data is saved in the cloud and on this device.",
 "Crie um fichário (ex.: Doutorado, Inglês, Concurso) e dentro dele as matérias e páginas.": "Create a binder (e.g., PhD, English, Civil service exam) and add subjects and pages inside it.",
 "Crie um grupo (turma, pacientes, equipe, convidados, clientes), mande o link de convite e envie compromissos, materiais e avisos. Cada pessoa aceita, edita ou recusa o que recebe.": "Create a group (class, patients, team, guests, clients), share the invite link and send appointments, materials and notices. Each person accepts, edits or declines what they receive.",
 "Crie um perfil com nome e, se for advogado, a OAB.": "Create a profile with a name and, if you are a lawyer, your OAB number.",
 "Criptografado no cofre, só neste dispositivo": "Encrypted in the vault, on this device only",
 "Criptomoedas": "Cryptocurrencies",
 "Cronograma": "Schedule",
 "Cronograma alimentar, cuidados pessoais com passo a passo e água do dia.": "Meal plan, step-by-step self-care and daily water.",
 "Cronograma do dia": "Schedule for the day",
 "Cronograma físico-financeiro": "Cost and progress schedule",
 "Cronograma físico-financeiro por etapa, diário da obra com antes e depois, profissionais e entregas.": "Cost and progress schedule by stage, project log with before and after, professionals and deliveries.",
 "Cronômetro de horas": "Hours timer",
 "Crédito empresarial": "Business loan",
 "Créditos": "Credits",
 "Cuida das reservas, da limpeza e das despesas.": "Handles bookings, cleaning and expenses.",
 "Cuidado": "Care",
 "Cuidado pessoal": "Self-care",
 "Cuidados": "Care",
 "Cupom do mercado": "Grocery receipt",
 "Cupom do mercado (foto)": "Grocery receipt (photo)",
 "Cupom lançado": "Receipt added",
 "Curitiba": "Curitiba",
 "Curitiba (PR)": "Curitiba (PR)",
 "Curso": "Course",
 "Cursos": "Courses",
 "Cursos livres e certificações": "Short courses and certifications",
 "Cuscuz": "Corn couscous (cuscuz)",
 "CÓDIGO PARA PAGAR": "PAYMENT CODE",
 "CÔMODOS": "ROOMS",
 "Câmera": "Camera",
 "Câmera e galeria": "Camera and gallery",
 "Câmera não liberada": "Camera not allowed",
 "Código IBGE do município": "City IBGE code",
 "Código IBGE do município (7 números)": "City IBGE code (7 digits)",
 "Código NBS (9 números, opcional)": "NBS code (9 digits, optional)",
 "Código copiado": "Code copied",
 "Código da reserva (localizador)": "Booking code (reference)",
 "Código de barras, linha digitável ou Pix copia e cola (opcional)": "Barcode, typeable line or Pix copy-and-paste (optional)",
 "Código de indicação": "Referral code",
 "Código de indicação (opcional)": "Referral code (optional)",
 "Código de quem convidou você": "Code from the person who invited you",
 "Código de tributação nacional (6 números)": "National tax code (6 digits)",
 "Código de tributação nacional (6 números, ex.: 171901)": "National tax code (6 digits, e.g. 171901)",
 "Código do amigo": "Friend's code",
 "Código do convite": "Invite code",
 "Código do procedimento (TUSS ou do plano)": "Procedure code (TUSS or plan's own)",
 "Código errado. Confira e tente de novo.": "Wrong code. Check it and try again.",
 "Código não encontrado. Confira as letras e os números.": "Code not found. Check the letters and numbers.",
 "Código não reconhecido. Confira os números (boleto: 47 ou 48 números).": "Code not recognized. Check the numbers (boleto: 47 or 48 digits).",
 "Código: {c}": "Code: {c}",
 "Cópia automática toda semana": "Automatic weekly backup",
 "Cópia criada.": "Copy created.",
 "Cópia de segurança": "Backup copy",
 "Cópia feita": "Backup done",
 "Cópia restaurada.": "Backup restored.",
 "Cômodo": "Room",
 "Cômodo ou quarto": "Room",
 "Cômodos da casa e as tarefas de cada um.": "Rooms of the house and the tasks for each one.",
 "DAS de {mes} pago": "DAS for {mes} paid",
 "DAS de {mes}: vence dia {dia}": "DAS for {mes}: due on the {dia}",
 "DAS do MEI": "MEI DAS",
 "DECLARAÇÃO DE ATENDIMENTO": "STATEMENT OF ATTENDANCE",
 "DICA DO MESTRE ACHADO": "MESTRE ACHADO'S TIP",
 "DPS nº {n}, série {s}": "DPS no. {n}, series {s}",
 "Da galeria ou dos arquivos": "From gallery or files",
 "Da meta de passos": "Of step goal",
 "Dados compartilhados": "Shared data",
 "Dados compartilhados com o grupo": "Data shared with the group",
 "Dados compartilhados · seu papel: {p}": "Shared data · your role: {p}",
 "Dados de saúde que você mesmo registra são tratados só para você e para quem você compartilhar, com o seu consentimento (art. 11, I).": "Health data you record yourself is processed only for you and for whoever you share it with, with your consent (art. 11, I).",
 "Dados do dispositivo: idioma, país e fuso horário (para datas, feriados e moeda), modelo do dispositivo e o código para avisos no celular.": "Device data: language, country and time zone (for dates, holidays and currency), device model and the code for phone notifications.",
 "Dados do relógio e de saúde não são usados para publicidade nem repassados a ninguém. Você pode desconectar e revogar a permissão a qualquer momento.": "Watch and health data are never used for advertising or shared with anyone. You can disconnect and revoke permission at any time.",
 "Dança": "Dance",
 "Dar ciência": "Acknowledge",
 "Dar ciência da operação?": "Acknowledge the transaction?",
 "Data": "Date",
 "Data (embarque ou check-in)": "Date (departure or check-in)",
 "Data agendada": "Scheduled date",
 "Data da aplicação": "Date given",
 "Data da compra": "Purchase date",
 "Data da entrega": "Delivery date",
 "Data da venda": "Sale date",
 "Data de nascimento": "Date of birth",
 "Data do empréstimo": "Loan date",
 "Data do pagamento": "Payment date",
 "Data em que foi feita": "Date done",
 "Data sugerida com 2 dias úteis de folga. Confira no sistema oficial.": "Suggested date with a 2-business-day buffer. Check it in the official system.",
 "De": "From",
 "De uma foto": "From a photo",
 "De {de} para {para} ({p}% menor).": "From {de} to {para} ({p}% smaller).",
 "Declaração": "Statement",
 "Declaração de atendimento": "Statement of attendance",
 "Declaração para reembolso (PDF)": "Reimbursement statement (PDF)",
 "Declaro que esta empresa é minha ou de cliente que autorizou o acompanhamento.": "I declare that this company is mine or belongs to a client who authorized the monitoring.",
 "Declaro, para fins de reembolso{conv}, que o(a) paciente {nome}{cpf}{cart} foi atendido(a) por mim em {data}{hora}, em {tipo}.": "I hereby declare, for reimbursement purposes{conv}, that the patient {nome}{cpf}{cart} was seen by me on {data}{hora}, for {tipo}.",
 "Defina a meta de aulas por dia ou por semana em Editar.": "Set the lessons goal per day or per week in Edit.",
 "Defina a meta de páginas por dia em Editar.": "Set the pages-per-day goal in Edit.",
 "Defina um horário": "Set a time",
 "Defina um horário para usar pausas.": "Set a time to use breaks.",
 "Demaquilante ou água micelar": "Makeup remover or micellar water",
 "Demolição": "Demolition",
 "Demonstração": "Demo",
 "Dentista": "Dentist",
 "Dependentes": "Dependents",
 "Depois": "After",
 "Depois da aula": "After class",
 "Depois de apagadas, as tarefas não voltam. Digite a senha da sua conta para confirmar.": "Once deleted, tasks can't be recovered. Enter your account password to confirm.",
 "Depois de baixar, abra o arquivo e toque em Instalar. Se o celular pedir, permita instalar apps desta fonte.": "After downloading, open the file and tap Install. If your phone asks, allow installing apps from this source.",
 "Depois de criar": "After creating",
 "Depois de {nome}. Toque para pular.": "After {nome}. Tap to skip.",
 "Depois é só ajustar horários e o que comer em cada um.": "Then just adjust the times and what to eat at each one.",
 "Desarquivar": "Unarchive",
 "Desbloquear": "Unlock",
 "Desbloquear com": "Unlock with",
 "Desbloquear com biometria": "Unlock with biometrics",
 "Desbloquear o My Planner": "Unlock My Planner",
 "Desbloqueio do app": "App unlock",
 "Descanso": "Rest",
 "Descartadas": "Dismissed",
 "Descartar": "Discard",
 "Descartar este tempo?": "Discard this time?",
 "Descobrir lugares em {d}": "Discover places in {d}",
 "Desconectar": "Disconnect",
 "Desconectar o {nome}?": "Disconnect {nome}?",
 "Desconto": "Discount",
 "Desconto de {v}": "Discount of {v}",
 "Descontos obtidos": "Discounts received",
 "Descrição": "Description",
 "Descrição (cliente, nota fiscal...)": "Description (client, invoice...)",
 "Descrição do serviço (sai na nota)": "Service description (shown on the invoice)",
 "Descrição que sai na nota": "Description shown on the invoice",
 "Desenhar a assinatura": "Draw signature",
 "Desenhar com caneta ou dedo": "Draw with pen or finger",
 "Desenhe a assinatura e escolha a página e o lugar.": "Draw your signature and choose the page and position.",
 "Desenhe a assinatura primeiro.": "Draw your signature first.",
 "Desenhe com o dedo ou com a caneta (S Pen, Apple Pencil ou caneta de tablet).": "Draw with your finger or a stylus (S Pen, Apple Pencil or tablet pen).",
 "Desenhe com o dedo ou com a caneta. Para rolar o quadro, toque em Mover.": "Draw with your finger or a stylus. To scroll the board, tap Move.",
 "Desenhe de novo para confirmar.": "Draw again to confirm.",
 "Desenhe o seu padrão": "Draw your pattern",
 "Desenhe pelo menos uma tarja.": "Draw at least one black bar.",
 "Desenhe um padrão ligando pelo menos 4 pontos.": "Draw a pattern connecting at least 4 dots.",
 "Desenho": "Drawing",
 "Desenho com caneta ou dedo": "Draw with pen or finger",
 "Desenho incorreto": "Wrong pattern",
 "Desenho padrão": "Pattern",
 "Desenho padrão salvo.": "Pattern saved.",
 "Desenvolvimento": "Shoulder press",
 "Desfazer": "Undo",
 "Desfazer amizade": "Unfriend",
 "Desligar": "Turn off",
 "Desligar a sincronização?": "Turn off sync?",
 "Deslize para os lados para ver outros dias (até 60 dias à frente). Toque numa refeição para planejar o cardápio só daquele dia. Arraste para a direita para excluir.": "Swipe sideways to see other days (up to 60 days ahead). Tap a meal to plan the menu for that day only. Swipe right to delete.",
 "Desmarcado": "Canceled",
 "Desmarcar como recebida": "Unmark as received",
 "Desmarcar feita hoje": "Unmark done today",
 "Desmarcar grupo": "Deselect group",
 "Desmarcar pagamento": "Unmark payment",
 "Desodorante": "Deodorant",
 "Despensa": "Pantry",
 "Despesa": "Expense",
 "Despesas": "Expenses",
 "Destino": "Destination",
 "Detalhes": "Details",
 "Devolver até": "Return by",
 "Devolver: {i} ({p})": "Return: {i} ({p})",
 "Devolvido": "Returned",
 "Devolvidos": "Returned",
 "Dia": "Day",
 "Dia a dia": "Everyday",
 "Dia da mudança": "Moving day",
 "Dia de vencimento do DAS": "DAS due day",
 "Dia do Trabalho": "Labor Day",
 "Dia do vencimento": "Due day",
 "Dia em que a fatura fecha": "Day the statement closes",
 "Dia planejado": "Planned day",
 "Dia {d} de {total}": "Day {d} of {total}",
 "Diagnóstico": "Diagnosis",
 "Dias e horários": "Days and times",
 "Dias específicos": "Specific days",
 "Dias úteis": "Weekdays",
 "Dias: {dias}": "Days: {dias}",
 "Dicas e observações": "Tips and notes",
 "Diesel": "Diesel",
 "Diferença": "Difference",
 "Digitado": "Manual",
 "Digitar": "Type",
 "Digitar à mão": "Enter manually",
 "Digite a senha do cofre. Ele fecha sozinho depois de 5 minutos sem uso.": "Enter the vault password. It locks itself after 5 minutes of inactivity.",
 "Digite em minutos (90) ou em horas e minutos (1:30 ou 01:30) e toque em OK.": "Enter minutes (90) or hours and minutes (1:30 or 01:30) and tap OK.",
 "Digite no formato HH:MM, por exemplo 13:30.": "Enter in HH:MM format, for example 13:30.",
 "Digite o código e ganhe 10 dias com todas as abas liberadas. Se não tiver, deixe em branco.": "Enter the code and get 10 days with all tabs unlocked. If you don't have one, leave it blank.",
 "Digite o nome da tarefa.": "Enter the task name.",
 "Dinheiro": "Money",
 "Dinheiro e documentos": "Money and documents",
 "Direita": "Right",
 "Direito": "Law",
 "Direito Administrativo": "Administrative Law",
 "Direito Civil": "Civil Law",
 "Direito Constitucional": "Constitutional Law",
 "Direito Empresarial": "Business Law",
 "Direito Penal": "Criminal Law",
 "Direito Tributário": "Tax Law",
 "Direito do Trabalho": "Labor Law",
 "Direto": "Direct",
 "Disciplina": "Subject",
 "Dispensar": "Dismiss",
 "Dispensar o aviso": "Dismiss",
 "Dispensar todas": "Dismiss all",
 "Disponibilizada em": "Made available on",
 "Disponível no app novo": "Available in the new app",
 "Distância": "Distance",
 "Divida o curso em matérias ou módulos. Em cada uma, marque em que aula parou e crie cards de anotações.": "Split the course into subjects or modules. In each one, mark the lesson you stopped at and create note cards.",
 "Dividir": "Split",
 "Dividir entre (nenhum marcado = todos)": "Split between (none checked = everyone)",
 "Divisão das despesas": "Expense split",
 "Diária": "Nightly rate",
 "Diária padrão": "Default nightly rate",
 "Diário": "Log",
 "Diários municipais": "Municipal gazettes",
 "Do celular, do Google Drive ou do OneDrive": "From phone, Google Drive or OneDrive",
 "Do cliente": "From the client",
 "Do escritório": "From the office",
 "Doações": "Donations",
 "Docs": "Docs",
 "Documento": "Document",
 "Documento (fundo branco)": "Document (white background)",
 "Documento do veículo (CRLV)": "Vehicle registration (CRLV)",
 "Documento pessoal": "Personal document",
 "Documento vence hoje": "Document expires today",
 "Documento vencendo": "Document expiring soon",
 "Documento: {o}": "Document: {o}",
 "Documentos": "Documents",
 "Documentos (contrato, nota, recibo...)": "Documents (contract, invoice, receipt...)",
 "Documentos (passaporte, identidade, carteira de motorista)": "Documents (passport, ID, driver's license)",
 "Documentos e autorização das crianças": "Children's documents and permission",
 "Documentos protegidos, exames, histórico de saúde e outros campos com 🔒 são criptografados aqui no aparelho (AES-256) com a senha do cofre. Nem o suporte consegue ler. Sem a senha, esses dados não podem ser recuperados.": "Protected documents, tests, health history and other fields marked 🔒 are encrypted here on the device (AES-256) with the vault password. Not even support can read them. Without the password, this data cannot be recovered.",
 "Documentos, recibos, cadernos e quadros, com várias páginas": "Documents, receipts, notebooks and whiteboards, multiple pages",
 "Documentos, reuniões e gravações são apagados para todos. A conversa continua no Mensagens.": "Documents, meetings and recordings are deleted for everyone. The chat stays in Messages.",
 "Documentário": "Documentary",
 "Doenças, cirurgias e observações": "Illnesses, surgeries and notes",
 "Dois dedos ou toque duplo para ampliar": "Pinch or double-tap to zoom",
 "Domingo": "Sunday",
 "Dono da obra": "Project owner",
 "Dose": "Dose",
 "Dose (ex.: 1 cápsula, 5 g)": "Dose (e.g. 1 capsule, 5 g)",
 "Dose única": "Single dose",
 "Drama": "Drama",
 "Duplicar": "Duplicate",
 "Duplicar tarefa": "Duplicate task",
 "Duração": "Duration",
 "Duração de cada sessão": "Length of each session",
 "Duração {dur}": "Duration {dur}",
 "Dá para comprar algo de 3 mil em 10 vezes?": "Can I buy something for 3,000 in 10 installments?",
 "Débito automático": "Direct debit",
 "Débito, Pix ou dinheiro": "Debit, Pix or cash",
 "Dê um nome ao cartão.": "Give the card a name.",
 "Dê um nome ao cuidado.": "Give the routine a name.",
 "Dê um nome ao cômodo.": "Give the room a name.",
 "Dê um nome ao fichário.": "Give the binder a name.",
 "Dê um nome ao grupo.": "Give the group a name.",
 "Dê um nome ao suplemento.": "Give the supplement a name.",
 "Dê um nome ao treino.": "Give the workout a name.",
 "Dê um nome à conta.": "Give the bill a name.",
 "Dê um nome à matéria.": "Give the subject a name.",
 "Dê um nome à meta.": "Give the goal a name.",
 "Dê um nome à refeição.": "Give the meal a name.",
 "Dê um nome à tarefa.": "Give the task a name.",
 "E-MAIL (OPCIONAL)": "EMAIL (OPTIONAL)",
 "E-mail": "Email",
 "E-mail (recebe a nota)": "Email (receives the invoice)",
 "E-mail de contato": "Contact email",
 "E-mail do responsável": "Guardian's email",
 "E-mail inválido": "Invalid email",
 "E-mail inválido.": "Invalid email.",
 "E-mail ou WhatsApp para resposta (opcional)": "Email or WhatsApp for a reply (optional)",
 "E-mail para contato (opcional)": "Contact email (optional)",
 "E-mail salvo.": "Email saved.",
 "EM ATRASO": "OVERDUE",
 "ENTRAR COM UM CÓDIGO": "JOIN WITH A CODE",
 "ENVIADOS": "SENT",
 "ESCOLHA AS ATIVIDADES": "CHOOSE THE ACTIVITIES",
 "ESTA SEMANA": "THIS WEEK",
 "EXERCÍCIO FÍSICO": "EXERCISE",
 "Economia": "Economics",
 "Edita tudo": "Edits everything",
 "Edita tudo: etapas, orçamento, diário e entregas.": "Edits everything: stages, budget, log and deliveries.",
 "Editar": "Edit",
 "Editar cartão": "Edit card",
 "Editar compra": "Edit purchase",
 "Editar cômodo": "Edit room",
 "Editar desenho": "Edit drawing",
 "Editar documento": "Edit document",
 "Editar fichário": "Edit binder",
 "Editar garantia": "Edit warranty",
 "Editar matéria": "Edit subject",
 "Editar meta": "Edit goal",
 "Editar perfil": "Edit profile",
 "Editar tarefa": "Edit task",
 "Editar {nome}": "Edit {nome}",
 "Educação": "Education",
 "Educação Física": "Physical Education",
 "Efeito de scanner": "Scanner effect",
 "Ela sai da lista e dos Recebidos da equipe.": "It's removed from the list and from the team's Received.",
 "Ela também fica guardada em \"Minhas figurinhas\" para mandar de novo.": "It's also saved in \"My stickers\" so you can send it again.",
 "Ela vem da aba Empréstimos & Financiamentos. Marque aqui como paga ou abra a aba para ver o contrato.": "It comes from the Loans & Financing tab. Mark it as paid here or open the tab to see the contract.",
 "Ela vem da aba Notas Fiscais. Marque como recebida quando o dinheiro entrar.": "It comes from the Invoices tab. Mark it as received when the money comes in.",
 "Eleitorais": "Electoral",
 "Eletrodoméstico": "Appliance",
 "Eletrodomésticos": "Appliances",
 "Eletrodomésticos, eletrônicos e móveis: nota fiscal, assistência técnica e aviso 15 dias antes de a garantia acabar.": "Appliances, electronics and furniture: receipt, repair service and a reminder 15 days before the warranty ends.",
 "Eletrônico": "Electronics",
 "Elétrica": "Electrical",
 "Elétrico": "Electric",
 "Em Editar, cole o link do calendário (iCal) do anúncio. No Airbnb: Calendário › Disponibilidade › Conectar calendários › Exportar calendário. No Booking: Tarifas e disponibilidade › Sincronizar calendários.": "In Edit, paste the listing's calendar link (iCal). On Airbnb: Calendar › Availability › Connect calendars › Export calendar. On Booking: Rates & availability › Sync calendars.",
 "Em aberto": "Open",
 "Em alta": "Trending",
 "Em andamento": "In progress",
 "Em atraso": "Overdue",
 "Em branco": "Blank",
 "Em casa": "At home",
 "Em cima": "Top",
 "Em construção": "Under construction",
 "Em dia. As melhorias chegam sozinhas quando o app abre.": "Up to date. Improvements arrive automatically when the app opens.",
 "Em limpeza": "Being cleaned",
 "Em quais páginas": "Which pages",
 "Em qual agenda criar os eventos:": "Which calendar to create events in:",
 "Em qual página e onde": "Which page and where",
 "Em tratamento": "In treatment",
 "Em um horário específico": "At a specific time",
 "Em uso: {ia}": "In use: {ia}",
 "Em {n} dia(s)": "In {n} day(s)",
 "Embaixo": "Bottom",
 "Embaixo à esquerda": "Bottom left",
 "Emissão": "Issue date",
 "Emissão +": "Issue date +",
 "Emissão: {data}": "Issued: {data}",
 "Emitida": "Issued",
 "Emitida em {data}": "Issued on {data}",
 "Emitida ou recebida": "Issued or received",
 "Emitidas": "Issued",
 "Emitidas: {v} · Recebidas: {r} · {n} nota(s)": "Issued: {v} · Received: {r} · {n} invoice(s)",
 "Emitir": "Issue",
 "Emitir NFS-e": "Issue NFS-e",
 "Emitir NFS-e pelo Padrão Nacional com o certificado A1, buscar as notas emitidas e recebidas e exportar XML, planilha e PDF.": "Issue NFS-e through the Padrão Nacional with the A1 certificate, search issued and received invoices, and export XML, spreadsheet and PDF.",
 "Emitir a nota de verdade?": "Issue the invoice for real?",
 "Emitir no ambiente de teste?": "Issue in the test environment?",
 "Emojis": "Emojis",
 "Emojis animados": "Animated emojis",
 "Emojis animados: Noto, do Google (CC BY 4.0).": "Animated emojis: Noto, by Google (CC BY 4.0).",
 "Emojis, GIFs e figurinhas": "Emojis, GIFs and stickers",
 "Empresa": "Company",
 "Empresa de mudança": "Moving company",
 "Empresa ou pessoa": "Company or person",
 "Empresa, hotel ou voo": "Company, hotel or flight",
 "Empresas": "Companies",
 "Emprestei": "I lent",
 "Empréstimo": "Loan",
 "Empréstimo entre pessoas": "Loan between people",
 "Empréstimo pessoal": "Personal loan",
 "Empréstimos": "Loans",
 "Empréstimos & Financiamentos": "Loans & Financing",
 "Encaminhada para {nome}.": "Forwarded to {nome}.",
 "Encaminhar": "Forward",
 "Encaminhar para": "Forward to",
 "Encerrar e salvar": "End and save",
 "Encontrada para {perfil}": "Found for {perfil}",
 "Endereço": "Address",
 "Endereço (opcional)": "Address (optional)",
 "Endereço (se for presencial)": "Address (if in person)",
 "Endereço atual": "Current address",
 "Endereço da escola": "School address",
 "Endereço da oficina": "Repair shop address",
 "Endereço de quem está com o item": "Address of who has the item",
 "Endereço do consultório": "Practice address",
 "Endereço do imóvel": "Property address",
 "Endereço do laboratório": "Lab address",
 "Endereço do veterinário": "Vet address",
 "Endereço no trabalho e na escola": "Address at work and school",
 "Endereço nos Correios e entregas": "Address at the post office and for deliveries",
 "Endereço nos bancos e cartões": "Address at banks and cards",
 "Endereço novo": "New address",
 "Endereço ou nome do lugar": "Address or place name",
 "Endereço ou terminal": "Address or terminal",
 "Energia": "Energy",
 "Enfermeiro": "Nurse",
 "Engenharia": "Engineering",
 "Engenheiro ou arquiteto": "Engineer or architect",
 "Enquadre o documento e toque no botão": "Frame the document and tap the button",
 "Enquadre o rosto e toque no botão. 🔄 vira a câmera.": "Frame your face and tap the button. 🔄 flips the camera.",
 "Ensino Fundamental": "Elementary and middle school",
 "Ensino Médio e ENEM": "High school and ENEM",
 "Entendi e concordo em usar o monitor nessas condições.": "I understand and agree to use the monitor under these conditions.",
 "Entra direto no Planner, com horário, dias e a lista de itens. Se o horário já estiver ocupado, você escolhe: substituir, manter as duas ou cancelar.": "Goes straight into the Planner, with time, days and the item list. If the time slot is already taken, you choose: replace, keep both or cancel.",
 "Entrada": "Income",
 "Entrada (imóvel novo)": "Move-in (new home)",
 "Entrada de dinheiro": "Money in",
 "Entrando...": "Signing in...",
 "Entrar": "Sign in",
 "Entrar com CPF e senha": "Sign in with CPF and password",
 "Entrar com outra conta": "Sign in with another account",
 "Entrar de novo": "Sign in again",
 "Entrar na chamada": "Join call",
 "Entrar na reunião": "Join meeting",
 "Entrar na sala online": "Join online room",
 "Entrar no grupo": "Join group",
 "Entrar no navegador?": "Sign in on the browser?",
 "Entre com seu CPF e sua senha.": "Sign in with your CPF and password.",
 "Entre com seu e-mail e sua senha.": "Sign in with your email and password.",
 "Entre na sua conta de novo.": "Please sign in again.",
 "Entre na sua conta para usar as notas fiscais.": "Sign in to your account to use invoices.",
 "Entre no app com o seu e-mail e a senha nova.": "Sign in to the app with your email and new password.",
 "Entrega de material": "Material delivery",
 "Entrega prevista": "Expected delivery",
 "Entregas": "Deliveries",
 "Entregue": "Delivered",
 "Entrou": "In",
 "Entrou no total da semana.": "Added to the week's total.",
 "Enviada": "Sent",
 "Enviado": "Sent",
 "Enviado para o Planner": "Sent to the Planner",
 "Enviado pelo cliente": "Sent by the client",
 "Enviado pelo escritório": "Sent by the office",
 "Enviado por {quem} no grupo {g}": "Sent by {quem} in group {g}",
 "Enviando {f} de {n}...": "Uploading {f} of {n}...",
 "Enviando...": "Sending...",
 "Enviar": "Send",
 "Enviar \"{nome}\"": "Send \"{nome}\"",
 "Enviar \"{nome}\" para…": "Send \"{nome}\" to…",
 "Enviar \"{titulo}\" para": "Send \"{titulo}\" to",
 "Enviar ao grupo": "Send to group",
 "Enviar convite": "Send invite",
 "Enviar convite para {nome}": "Send invitation to {nome}",
 "Enviar convite pelo WhatsApp": "Send invite via WhatsApp",
 "Enviar documento": "Upload document",
 "Enviar instruções ao hóspede": "Send guest instructions",
 "Enviar o convite": "Send the invitation",
 "Enviar ou copiar o código": "Send or copy the code",
 "Enviar ou imprimir a etiqueta": "Send or print the label",
 "Enviar para Estudos": "Send to Studies",
 "Enviar para My Planner": "Send to My Planner",
 "Enviar para a equipe": "Send to the team",
 "Enviar para o My Planner": "Send to My Planner",
 "Enviar para o Planner": "Send to the Planner",
 "Enviar para o grupo": "Send to group",
 "Enviar para o grupo de estudos": "Send to study group",
 "Enviar para o {nome} os {n} arquivo(s) deste dispositivo": "Upload the {n} file(s) on this device to {nome}",
 "Enviar para um grupo": "Send to a group",
 "Enviar para {g}": "Send to {g}",
 "Enviar para…": "Send to…",
 "Enviar por e-mail": "Send by email",
 "Enviar relatório": "Send report",
 "Enviar relatório para a equipe": "Send report to the team",
 "Enviar também as tarefas que já existem (de hoje em diante)": "Also send existing tasks (from today on)",
 "Enviar tarefas do My Planner para a agenda": "Send My Planner tasks to the calendar",
 "Envie guias, notas e relatórios para o cliente, ou veja o que ele mandou. Cada documento aceita fotos, PDFs e links.": "Send tax slips, invoices and reports to the client, or see what they sent. Each document accepts photos, PDFs and links.",
 "Enxaguante": "Mouthwash",
 "Episódio": "Episode",
 "Equipe": "Team",
 "Equipe ({n})": "Team ({n})",
 "Equipe de limpeza": "Cleaning team",
 "Equipe do consultório": "Practice team",
 "Equipe do imóvel (limpeza e co-anfitrião)": "Property team (cleaning and co-host)",
 "Erro": "Bug",
 "Erro na emissão": "Issuing error",
 "Erro: {erro}": "Error: {erro}",
 "Erros registrados neste dispositivo ({n})": "Errors recorded on this device ({n})",
 "Escanear documento": "Scan document",
 "Escanear o verso": "Scan the back",
 "Escanear para PDF": "Scan to PDF",
 "Escaneie documentos, recibos, cadernos e quadros: bordas e sombras corrigidas, várias páginas, identidade frente e verso, assinatura e PDF guardado no celular, no Google Drive ou no OneDrive.": "Scan documents, receipts, notebooks and whiteboards: edges and shadows fixed, multiple pages, ID front and back, signature, and PDF saved on your phone, Google Drive or OneDrive.",
 "Escaneie, deixe a imagem mais clara, organize em pastas e mande o PDF por WhatsApp, e-mail ou Drive. Com a sua IA ligada, o app lê o texto, resume e responde perguntas sobre o documento.": "Scan, make the image clearer, sort into folders and send the PDF via WhatsApp, email or Drive. With your AI turned on, the app reads the text, summarizes it and answers questions about the document.",
 "Escola": "School",
 "Escolha a aba:": "Choose the tab:",
 "Escolha a data do compromisso.": "Choose the appointment date.",
 "Escolha a imagem.": "Choose the image.",
 "Escolha a matéria": "Choose the subject",
 "Escolha a pasta do celular (ex.: Documentos). O app guarda lá sozinho.": "Choose a folder on your phone (e.g. Documents). The app saves there automatically.",
 "Escolha a página": "Choose the page",
 "Escolha ao menos um tribunal ou marque \"Todos os tribunais\".": "Choose at least one court or check \"All courts\".",
 "Escolha ao menos uma agenda.": "Choose at least one calendar.",
 "Escolha o PDF": "Choose the PDF",
 "Escolha o arquivo .pfx (ou .p12) do certificado A1 da empresa e digite a senha dele. Ele fica criptografado no seu cofre.": "Choose the company's A1 certificate file (.pfx or .p12) and enter its password. It is stored encrypted in your vault.",
 "Escolha o arquivo .xml da NFS-e, NF-e ou CT-e.": "Choose the .xml file of the NFS-e, NF-e or CT-e.",
 "Escolha o fichário": "Choose the binder",
 "Escolha o grupo para enviar: {t}": "Choose the group to send to: {t}",
 "Escolha os PDFs": "Choose the PDFs",
 "Escolha os arquivos.": "Choose the files.",
 "Escolha os feriados que aparecem no Planner e no botão 🎉 Feriados.": "Choose the holidays shown in Planner and in the 🎉 Holidays button.",
 "Escolha para quem enviar.": "Choose who to send to.",
 "Escolha pelo menos um dia.": "Choose at least one day.",
 "Escolha pelo menos uma página que exista no PDF (ex.: 1-3, 5).": "Choose at least one page that exists in the PDF (e.g. 1-3, 5).",
 "Escolha quem participa:": "Choose who's in:",
 "Escolher": "Choose",
 "Escolher a imagem": "Choose image",
 "Escolher a pasta": "Choose folder",
 "Escolher agendas": "Choose calendars",
 "Escolher alimento": "Choose food",
 "Escolher arquivo": "Choose file",
 "Escolher arquivos": "Choose files",
 "Escolher arquivos do Drive ou do OneDrive": "Pick files from Drive or OneDrive",
 "Escolher as imagens e criar o PDF": "Choose images and create PDF",
 "Escolher da galeria": "Choose from gallery",
 "Escolher da galeria ou arquivo (foto ou PDF)": "Choose from gallery or file (photo or PDF)",
 "Escolher data": "Choose date",
 "Escolher fuso": "Choose time zone",
 "Escolher hora": "Choose time",
 "Escolher horário": "Choose time",
 "Escolher o certificado": "Choose the certificate",
 "Escolher outro": "Choose another",
 "Escolher pessoas": "Choose people",
 "Escolher tribunais": "Choose courts",
 "Escolher ícone": "Choose icon",
 "Esconder da equipe (só administradores)": "Hide from team (admins only)",
 "Esconder detalhes": "Hide details",
 "Esconder o texto completo": "Hide full text",
 "Escondido de {n} pessoa(s)": "Hidden from {n} person(s)",
 "Escondido de: {n}": "Hidden from: {n}",
 "Escondidos no Planner.": "Hidden in the Planner.",
 "Escova e pasta de dente": "Toothbrush and toothpaste",
 "Escovar os dentes": "Brush your teeth",
 "Escreva aqui": "Write here",
 "Escreva e dê Enter (ex.: lavar a máquina)": "Type and press Enter (e.g., clean the washing machine)",
 "Escreva em uma ou em todas as páginas.": "Write on one page or all of them.",
 "Escreva o motivo em \"Motivo do cancelamento\" na ficha da nota (pelo menos 15 letras) e toque aqui de novo.": "Write the reason in \"Cancellation reason\" on the invoice record (at least 15 letters) and tap here again.",
 "Escreva o resumo, tópicos, dúvidas...": "Write the summary, topics, questions...",
 "Escreva o texto da marca d'água.": "Type the watermark text.",
 "Escreva o texto.": "Type the text.",
 "Escreva o título.": "Enter the title.",
 "Escreva ou cole o texto. Linha começando com \"# \" vira título.": "Type or paste the text. A line starting with \"# \" becomes a heading.",
 "Escreva ou cole um texto e gere o PDF.": "Type or paste text and create the PDF.",
 "Escritório": "Office",
 "Escritório: documentos e reuniões da equipe. Só o administrador do escritório pode gravar uma reunião, e todos na reunião veem o aviso \"Gravando\" enquanto ela é gravada. A gravação fica nos documentos do escritório, visível só para o administrador até ele liberar para a equipe.": "Office: team documents and meetings. Only the office administrator can record a meeting, and everyone in the meeting sees the \"Recording\" notice while it is being recorded. The recording is kept in the office documents, visible only to the administrator until they share it with the team.",
 "Escuro": "Dark",
 "Espanhol": "Spanish",
 "Espaço": "Space",
 "Espaço livre, dados de cada aba e anexos": "Free space, data per tab and attachments",
 "Especialidade": "Specialty",
 "Espécie": "Species",
 "Esquadro": "Set square",
 "Esqueci a senha": "Forgot password",
 "Esquerda": "Left",
 "Esse código é o seu.": "That's your own code.",
 "Esse código é o seu. Use o código de quem indicou o app para você.": "That's your own code. Use the code of the person who recommended the app to you.",
 "Esse endereço não respondeu como servidor de notas. Confira e tente de novo.": "That address didn't respond as an invoice server. Check it and try again.",
 "Esta aba ainda não está no seu plano.": "This tab isn't in your plan yet.",
 "Esta e todas as futuras": "This and all future ones",
 "Esta ferramenta precisa ver as páginas do PDF, o que chega com o app novo (versão 0.50). Use o navegador ou instale o APK novo.": "This tool needs to see the PDF pages, which comes with the new app (version 0.50). Use the browser or install the new APK.",
 "Esta imagem foi guardada em outro dispositivo.": "This image was saved on another device.",
 "Esta janela pode ser fechada.": "You can close this window.",
 "Esta pessoa ainda não preencheu o cartão de contato.": "This person hasn't filled in their contact card yet.",
 "Esta semana: {a} de {m} aulas ({p}%)": "This week: {a} of {m} lessons ({p}%)",
 "Esta senha é de outra conta.": "This password belongs to another account.",
 "Esta tarefa não tem horário: \"No início\" e \"Antes do início\" não se aplicam. Use \"Em um horário específico\".": "This task has no time: \"At start\" and \"Before start\" don't apply. Use \"At a specific time\".",
 "Esta tarefa se repete. O que excluir?": "This task repeats. What do you want to delete?",
 "Esta tela teve um problema": "This screen had a problem",
 "Estado (UF) do registro": "State of registration",
 "Estado de Mato Grosso do Sul": "State of Mato Grosso do Sul",
 "Estado de São Paulo": "State of São Paulo",
 "Estado do Paraná": "State of Paraná",
 "Estados": "States",
 "Estaduais": "State",
 "Estadual": "State",
 "Estas abas aparecem na barra de baixo, nesta ordem. My Planner, Abas e Ajustes ficam sempre. As outras continuam aqui na tela Abas.": "These tabs show in the bottom bar, in this order. My Planner, Tabs and Settings are always there. The others stay here on the Tabs screen.",
 "Estatística": "Statistics",
 "Este CPF já tem cadastro. Use \"Entrar\".": "This CPF is already registered. Use \"Sign in\".",
 "Este PDF está no dispositivo onde foi aberto.": "This PDF is on the device where it was opened.",
 "Este PDF está no dispositivo onde foi aberto. Abra por lá, ou abra de novo a cópia guardada no Drive ou no OneDrive.": "This PDF is on the device where it was opened. Open it there, or reopen the copy saved in Drive or OneDrive.",
 "Este PDF está protegido com senha. Tire a senha no programa onde ele foi criado e tente de novo.": "This PDF is password protected. Remove the password in the program where it was created and try again.",
 "Este PDF não tem campos de formulário. Use \"Adicionar texto\" para escrever nele.": "This PDF has no form fields. Use \"Add text\" to write on it.",
 "Este ano": "This year",
 "Este dispositivo": "This device",
 "Este dispositivo não consegue abrir o arquivo.": "This device can't open the file.",
 "Este dispositivo não consegue compartilhar arquivos.": "This device can't share files.",
 "Este dispositivo não tem dados de saúde. Dá para digitar à mão.": "This device has no health data. You can enter it manually.",
 "Este arquivo foi guardado em outro dispositivo.": "This file was saved on another device.",
 "Este arquivo foi guardado no celular. Abra pelo app no celular.": "This file was saved on your phone. Open it in the app on your phone.",
 "Este arquivo não é um backup do My Planner.": "This file is not a My Planner backup.",
 "Este celular ainda não recebe avisos com o app fechado. Instale o app {v} ou mais novo (APK com os avisos do servidor). Com o app aberto, os avisos já funcionam.": "This phone can't get notifications with the app closed yet. Install app {v} or newer (APK with server notifications). With the app open, notifications already work.",
 "Este certificado é de {doc}, diferente do CNPJ/CPF da empresa ({emp}).": "This certificate belongs to {doc}, which differs from the company's CNPJ/CPF ({emp}).",
 "Este fichário ainda não tem matérias.": "This binder has no subjects yet.",
 "Este grupo já está cheio.": "This group is already full.",
 "Este mês": "This month",
 "Este mês: emitidas {e} · recebidas {r}": "This month: issued {e} · received {r}",
 "Este mês: {h}": "This month: {h}",
 "Este navegador": "This browser",
 "Este país só tem feriados nacionais.": "This country only has national holidays.",
 "Esteira": "Treadmill",
 "Esteticista": "Beautician",
 "Estou usando o My Planner para organizar a agenda, as finanças e muito mais. Baixe o app e, ao criar a sua conta, use o meu código {codigo} para ganhar 10 dias com todas as abas liberadas.": "I'm using My Planner to organize my schedule, finances and much more. Download the app and, when you create your account, use my code {codigo} to get 10 days with all tabs unlocked.",
 "Estratégia": "Strategy",
 "Estrela": "Star",
 "Estudando": "Studying",
 "Estudar agora": "Study now",
 "Estudar {nome}": "Study {nome}",
 "Estudar: {c}": "Study: {c}",
 "Estudo": "Study",
 "Estudos": "Studies",
 "Estudos e exatas": "Studies and sciences",
 "Estudos, lazer e viagens": "Studies, leisure and travel",
 "Está em Patrimônio & IR › Recibos dedutíveis. Abra lá para anexar a foto do recibo e o CPF ou CNPJ de quem recebeu.": "It's in Assets & Income Tax › Deductible receipts. Open it there to attach the receipt photo and the CPF or CNPJ of who received it.",
 "Está na página \"{titulo}\" e em \"Ver arquivos\".": "It's on the page \"{titulo}\" and in \"View files\".",
 "Etanol": "Ethanol",
 "Etapa": "Stage",
 "Etapa do cronograma": "Schedule stage",
 "Etapas": "Stages",
 "Evento": "Event",
 "Eventos": "Events",
 "Eventos & Celebrações": "Events & Celebrations",
 "Evolução (no cofre)": "Progress notes (in the vault)",
 "Ex.: 08:00 e 20:00": "E.g. 08:00 and 20:00",
 "Ex.: 08:00, 14:00 e 20:00": "E.g. 08:00, 14:00 and 20:00",
 "Ex.: 09/2026": "E.g. 09/2026",
 "Ex.: 1 comprimido": "E.g. 1 pill",
 "Ex.: 1-3, 4-10, 11-": "E.g. 1-3, 4-10, 11-",
 "Ex.: 1-3, 5, 8-10": "E.g. 1-3, 5, 8-10",
 "Ex.: 171901 (consultoria), 010101 (programação)": "E.g. 171901 (consulting), 010101 (programming)",
 "Ex.: 40 sacos de cimento": "E.g. 40 bags of cement",
 "Ex.: 4106902 (Curitiba), 5002704 (Campo Grande), 3550308 (São Paulo)": "E.g. 4106902 (Curitiba), 5002704 (Campo Grande), 3550308 (São Paulo)",
 "Ex.: 8º ano B": "E.g. 8th grade B",
 "Ex.: Alongamento lombar, Dieta 1.800 kcal": "E.g.: Lower back stretches, 1,800 kcal diet",
 "Ex.: Aniversário de 30 anos da Ana": "E.g. Ana's 30th birthday",
 "Ex.: Apartamento da praia, Suíte 1, Edícula": "E.g.: Beach apartment, Suite 1, Guest house",
 "Ex.: Apartamento na Rua X, 100 ações PETR4": "E.g. Apartment on X Street, 100 PETR4 shares",
 "Ex.: Aula de revisão, Consulta de retorno": "E.g. Review class, Follow-up appointment",
 "Ex.: Buffet, DJ, decoração, fotógrafo": "E.g. Catering, DJ, decoration, photographer",
 "Ex.: CONFIDENCIAL, CÓPIA, RASCUNHO": "E.g. CONFIDENTIAL, COPY, DRAFT",
 "Ex.: Cardiologista": "E.g. Cardiologist",
 "Ex.: Consultoria mensal": "E.g. Monthly consulting",
 "Ex.: Costela-de-adão da sala": "E.g. Living room monstera",
 "Ex.: DAS de setembro, Extrato do Itaú": "E.g. September DAS, Itaú statement",
 "Ex.: Desmontar os móveis do quarto": "E.g. Take apart the bedroom furniture",
 "Ex.: Disponível · Em aula até 18h · Bora viajar!": "E.g.: Available · In class until 6 pm · Let's travel!",
 "Ex.: Eletricista, loja de material": "E.g. Electrician, building supply store",
 "Ex.: Entrada dos noivos": "E.g. Entrance of the bride and groom",
 "Ex.: Financiamento do carro": "E.g.: Car financing",
 "Ex.: Fisioterapeuta, Nutricionista, Cardiologista": "E.g.: Physiotherapist, Nutritionist, Cardiologist",
 "Ex.: Furadeira, livro, R$ 200": "E.g. Drill, book, $200",
 "Ex.: Hemograma": "E.g. Blood count",
 "Ex.: IPVA 2027, parcela 1": "E.g. IPVA 2027, installment 1",
 "Ex.: Lisboa, Portugal": "E.g. Lisbon, Portugal",
 "Ex.: Mala da Ana": "E.g. Ana's suitcase",
 "Ex.: Mensalidade de outubro, material": "E.g.: October fee, materials",
 "Ex.: Netflix, cinema": "E.g. Netflix, cinema",
 "Ex.: Notas de compra de setembro": "E.g. September purchase invoices",
 "Ex.: Onix 2022": "E.g. Onix 2022",
 "Ex.: Prova 1, Trabalho em grupo": "E.g. Test 1, Group project",
 "Ex.: Prova de matemática": "E.g. Math test",
 "Ex.: Pôr do sol no Tejo": "e.g. Sunset over the Tagus",
 "Ex.: Reforma da cozinha": "E.g. Kitchen remodel",
 "Ex.: TAP TP 108": "E.g. TAP TP 108",
 "Ex.: Torre de Belém": "E.g.: Belém Tower",
 "Ex.: Troca da fiação da sala": "E.g. Rewiring the living room",
 "Ex.: V10, antirrábica": "E.g. 10-in-1, rabies",
 "Ex.: Visita ao Mosteiro dos Jerónimos": "E.g. Visit to the Jerónimos Monastery",
 "Ex.: cerâmica 30 cm": "E.g. 30 cm ceramic tile",
 "Ex.: kg, pacotes, latas": "E.g. kg, packs, cans",
 "Ex.: seg e qua, 07:30": "E.g. Mon and Wed, 07:30",
 "Ex.: troquei o arroz por batata doce": "E.g. swapped rice for sweet potato",
 "Ex.: varanda, sala": "E.g. balcony, living room",
 "Exame": "Test",
 "Exame da OAB": "OAB bar exam",
 "Exames": "Tests",
 "Excel": "Excel",
 "Excluir": "Delete",
 "Excluir \"{nome}\"?": "Delete \"{nome}\"?",
 "Excluir \"{titulo}\"?": "Delete \"{titulo}\"?",
 "Excluir a caixa?": "Delete the box?",
 "Excluir a compra": "Delete purchase",
 "Excluir a compra?": "Delete the purchase?",
 "Excluir a meta \"{m}\"?": "Delete the goal \"{m}\"?",
 "Excluir cartão": "Delete card",
 "Excluir conta": "Delete bill",
 "Excluir cuidado": "Delete routine",
 "Excluir cômodo": "Delete room",
 "Excluir esta página?": "Delete this page?",
 "Excluir fichário": "Delete binder",
 "Excluir matéria": "Delete subject",
 "Excluir o cartão \"{c}\"?": "Delete the card \"{c}\"?",
 "Excluir o documento": "Delete document",
 "Excluir o fichário {nome}": "Delete the binder {nome}",
 "Excluir página": "Delete page",
 "Excluir refeição": "Delete meal",
 "Excluir suplemento": "Delete supplement",
 "Excluir tarefa": "Delete task",
 "Excluir tarefa repetida": "Delete repeating task",
 "Excluir tarefa?": "Delete task?",
 "Excluir treino": "Delete workout",
 "Excluir {nome}?": "Delete {nome}?",
 "Excluídas em definitivo 30 dias depois do descarte.": "Permanently deleted 30 days after being discarded.",
 "Executivo e profissional": "Business and professional",
 "Execução do contrato (art. 7º, V), para entregar o serviço; consentimento (art. 7º, I), para câmera, galeria, microfone e localização; cumprimento de obrigação legal (art. 7º, II); e legítimo interesse (art. 7º, IX), para segurança e prevenção de fraudes.": "Performance of a contract (art. 7, V), to deliver the service; consent (art. 7, I), for camera, gallery, microphone and location; compliance with a legal obligation (art. 7, II); and legitimate interest (art. 7, IX), for security and fraud prevention.",
 "Exemplos: 13:30, 1330, 9:05": "Examples: 13:30, 1330, 9:05",
 "Exercício": "Exercise",
 "Exercício físico": "Exercise",
 "Experimente grátis por {n} dias": "Try it free for {n} days",
 "Explique o motivo (para cancelar)": "Explain the reason (to cancel)",
 "Exportar arquivo": "Export file",
 "Exportar para o contador": "Export for the accountant",
 "Extrair páginas": "Extract pages",
 "Extras (pet, check-in tardio...)": "Extras (pet, late check-in...)",
 "Extrato": "Bank statement",
 "Extrato bancário": "Bank statement",
 "Extrato do banco (foto ou PDF)": "Bank statement (photo or PDF)",
 "Extrato importado": "Statement imported",
 "Extrato por foto": "Statement from photo",
 "FRASE": "STATUS",
 "FRÁGIL": "FRAGILE",
 "Fabricante ou estendida: {n} meses": "Manufacturer or extended: {n} months",
 "Facultativo": "Optional",
 "Falar com a limpeza": "Contact the cleaner",
 "Fale conosco": "Contact us",
 "Falta": "Absent",
 "Falta XML": "XML missing",
 "Falta ligar o servidor de notas: no computador, dê dois cliques em 13-LIGAR-NOTAS.bat e cole aqui o endereço que ele mostrar.": "The invoice server isn't on yet: on the computer, double-click 13-LIGAR-NOTAS.bat and paste here the address it shows.",
 "Falta o Health Connect, o app do Google que junta os dados dos relógios e apps de saúde.": "Health Connect is missing. It's the Google app that gathers data from watches and health apps.",
 "Faltam": "To visit",
 "Faltam {ml} ({n} copo(s))": "{ml} to go ({n} glass(es))",
 "Faltam {n} dia(s) do seu período grátis": "{n} day(s) left in your free period",
 "Faltam {n} dias": "{n} days to go",
 "Faltou": "No-show",
 "Família": "Family",
 "Fantasia": "Fantasy",
 "Fatura": "Statement",
 "Fatura com vencimento em {d}.": "Statement due on {d}.",
 "Fatura de {mes}": "{mes} statement",
 "Fatura de {mes}: vence {data}": "{mes} statement: due {data}",
 "Fatura do cartão (foto ou PDF)": "Card statement (photo or PDF)",
 "Fatura importada": "Statement imported",
 "Fatura paga (toque para desfazer)": "Statement paid (tap to undo)",
 "Fatura {c}": "{c} statement",
 "Faturamento em {ano}: {v} de {lim}": "Revenue in {ano}: {v} of {lim}",
 "Faturas dos cartões": "Card statements",
 "Fazer agora, passo a passo": "Do it now, step by step",
 "Fazer com este PDF": "Do with this PDF",
 "Fazer cópia agora": "Back up now",
 "Fecha dia {f} · vence dia {v}": "Closes on the {f} · due on the {v}",
 "Fecha {f} · vence {v}": "Closes {f} · due {v}",
 "Fechar": "Close",
 "Fechar o cofre": "Lock the vault",
 "Feche e abra o app de novo": "Close and reopen the app",
 "Federais": "Federal",
 "Feijão": "Beans",
 "Feita em {data}": "Done on {data}",
 "Feita hoje": "Done today",
 "Feitas": "Done",
 "Feitas (não se repetem) · {n}": "Done (one-time) · {n}",
 "Feito": "Done",
 "Feito!": "Done!",
 "Feliz aniversário": "Happy birthday",
 "Feminino": "Female",
 "Feminino e suave": "Feminine and soft",
 "Feriado escolar": "School holiday",
 "Feriado estadual": "State holiday",
 "Feriado estadual: {nome}": "State holiday: {nome}",
 "Feriado municipal": "Municipal holiday",
 "Feriado municipal: {nome}": "Municipal holiday: {nome}",
 "Feriado nacional": "National holiday",
 "Feriado nacional: {nome}": "National holiday: {nome}",
 "Feriado regional": "Regional holiday",
 "Feriado regional: {nome}": "Regional holiday: {nome}",
 "Feriados": "Holidays",
 "Feriados nacionais": "National holidays",
 "Feriados no planner": "Holidays in the planner",
 "Feriados, cotações, sugestões da inteligência artificial e leituras automáticas de boletos e notas podem ter erros. Confira antes de usar.": "Holidays, exchange rates, AI suggestions and automatic readings of bills and invoices may contain errors. Check before using them.",
 "Ferramenta": "Tool",
 "Ferramentas": "Tools",
 "Ficha de cada planta, replantio e calendário de rega e adubo na agenda.": "Profile for each plant, repotting and a watering and fertilizing calendar in your schedule.",
 "Ficha preenchida": "Form filled in",
 "Fichários, matérias e páginas, cronômetro de estudo e metas por semana.": "Binders, subjects and pages, study timer and weekly goals.",
 "Ficção": "Fiction",
 "Figurinha": "Sticker",
 "Figurinhas": "Stickers",
 "Filme": "Movie",
 "Filme ou série": "Movie or series",
 "Filmes e séries": "Movies and series",
 "Filosofia": "Philosophy",
 "Filtros": "Filters",
 "Fim": "End",
 "Fim (vazio = uso contínuo)": "End (empty = ongoing)",
 "Fim da garantia": "Warranty ends",
 "Fim da garantia:": "Warranty ends:",
 "Fim da pausa. Continue: {tarefa}": "Break is over. Continue: {tarefa}",
 "Fim de semana": "Weekend",
 "Fim previsto": "Expected end",
 "Fina": "Thin",
 "Finados": "All Souls' Day",
 "Finalizador": "Styling product",
 "Financeiro": "Finances",
 "Financeiro: {gasto} de {orcado} ({p}%)": "Spending: {gasto} of {orcado} ({p}%)",
 "Financiamento": "Financing",
 "Financiamento de veículo": "Vehicle financing",
 "Financiamento imobiliário": "Mortgage",
 "Financiamentos": "Financing",
 "Financiamentos e empréstimos": "Financing and loans",
 "Financiamentos e empréstimos com parcelas, juros, saldo devedor e comprovantes; objetos emprestados com foto e aviso da devolução.": "Financing and loans with installments, interest, outstanding balance and receipts; lent items with a photo and a return reminder.",
 "Finanças": "Finance",
 "Finanças {p}": "Finance {p}",
 "Finanças · {p}": "Finance · {p}",
 "Fins de semana": "Weekends",
 "Fio dental": "Dental floss",
 "Flex": "Flex",
 "Flexão de braço": "Push-ups",
 "Flor": "Flower",
 "Flutua": "Float",
 "Foguete": "Rocket",
 "Fogão": "Stove",
 "Foi no cartão de crédito? Lançar como compra no cartão": "Was it on a credit card? Add it as a card purchase",
 "Foi para {destino}.": "Sent to {destino}.",
 "Foi para {destino}. Quer tirar daqui?": "Sent to {destino}. Remove it from here?",
 "Folha de pagamento": "Payroll",
 "Fone": "Earpiece",
 "Fone de ouvido": "Headphones",
 "Fontes: Brasil, calculado no app a partir da portaria federal de feriados e das leis de cada estado. Outros países: base pública Nager.Date (date.nager.at), baixada pela internet e guardada no aparelho.": "Sources: Brazil, calculated in the app from the federal holiday ordinance and each state's laws. Other countries: Nager.Date (date.nager.at) public database, downloaded over the internet and stored on the device.",
 "Fontes: Brasil, calculado no app a partir da portaria federal de feriados, das leis de cada estado e dos calendários oficiais das capitais. Outros países: base pública Nager.Date (date.nager.at), baixada pela internet e guardada no dispositivo.": "Sources: Brazil, calculated in the app from the federal holiday ordinance, each state's laws and the capitals' official calendars. Other countries: Nager.Date public database (date.nager.at), downloaded over the internet and stored on the device.",
 "Forma": "Method",
 "Forma das parcelas": "Installment type",
 "Forma de pagamento": "Payment method",
 "Forma de pagamento: {f}.": "Payment method: {f}.",
 "Formas": "Shapes",
 "Formato": "Format",
 "Formatos": "Formats",
 "Formatura": "Graduation",
 "Fornecedor": "Vendor",
 "Fornecedores": "Vendors",
 "Forte": "Strong",
 "Foto": "Photo",
 "Foto da galeria": "Photo from gallery",
 "Foto do contato": "Contact photo",
 "Foto inteira": "Whole photo",
 "Foto ou PDF (lido pela sua IA)": "Photo or PDF (read by your AI)",
 "Fotografe cada cômodo na vistoria de saída e na de entrada. As fotos protegem você na hora de devolver o imóvel.": "Photograph each room at the move-out and move-in inspections. The photos protect you when you hand back the property.",
 "Fotografe cada recibo de médico, dentista, escola e previdência assim que pagar. No fim do ano está tudo pronto.": "Photograph every receipt from doctors, dentists, school and pension as soon as you pay. At year end everything is ready.",
 "Fotos": "Photos",
 "Fotos JPG, PNG e outras viram um PDF.": "JPG, PNG and other photos become a PDF.",
 "Fotos de {d}": "Photos from {d}",
 "Fotos do espaço pronto": "Photos of the space ready",
 "Fotos e arquivos desta ficha também vão para a pasta do grupo, para quem participa abrir.": "Photos and files from this record also go to the group folder, so members can open them.",
 "Fotos e arquivos ficam guardados só neste dispositivo. Os dados do documento vão para a sua conta, protegidos.": "Photos and files are stored only on this device. The document details go to your account, protected.",
 "Fotos e arquivos ficam neste dispositivo (e no seu Drive ou OneDrive, se estiver ligado em Ajustes).": "Photos and files stay on this device (and on your Drive or OneDrive, if connected in Settings).",
 "Fotos e notas": "Photos and notes",
 "Fotos e vídeos": "Photos and videos",
 "Fotos, arquivos e links": "Photos, files and links",
 "Fraldas e lenços": "Diapers and wipes",
 "Francês": "French",
 "Frango com osso": "Bone-in chicken",
 "Frango sem osso": "Boneless chicken",
 "Frase (opcional, ex.: Bom dia!)": "Phrase (optional, e.g. Good morning!)",
 "Freelancer & Projetos": "Freelancer & Projects",
 "Freezer": "Freezer",
 "Freios": "Brakes",
 "Frente": "Front",
 "Frente do documento": "Front of document",
 "Frente e verso na mesma folha": "Front and back on one page",
 "Frente pronta": "Front done",
 "Frequência": "Frequency",
 "Frio": "Cold",
 "Fruta": "Fruit",
 "Frágil": "Fragile",
 "Fundação e estrutura": "Foundation and structure",
 "Fundo": "Background",
 "Fundos e renda fixa": "Funds and fixed income",
 "Fuso": "Time zone",
 "Fuso horário": "Time zone",
 "Fuso horário do destino": "Destination time zone",
 "Futebol": "Soccer",
 "Física": "Physics",
 "Físico (obra pronta): {p}%": "Physical (work done): {p}%",
 "GASTOS POR CATEGORIA": "SPENDING BY CATEGORY",
 "GIF guardado nos seus GIFs.": "GIF saved to your GIFs.",
 "Garagem": "Garage",
 "Garantia": "Warranty",
 "Garantia até {data}.": "Under warranty until {data}.",
 "Garantia legal": "Legal warranty",
 "Garantia vencendo": "Warranty expiring",
 "Garantias": "Warranties",
 "Garrafa de água": "Water bottle",
 "Gasolina": "Gasoline",
 "Gasto": "Expense",
 "Gasto até agora": "Spent so far",
 "Gasto de {v} lançado. {n} preço(s) guardado(s) para a sua lista de compras.": "Expense of {v} added. {n} price(s) saved for your shopping list.",
 "Gasto neste mês: {v}": "Spent this month: {v}",
 "Gasto: {v}": "Spent: {v}",
 "Gastos": "Expenses",
 "Gastos por categoria": "Spending by category",
 "Gato": "Cat",
 "Geladeira": "Fridge",
 "Geografia": "Geography",
 "Gerado por": "Produced by",
 "Gerando QR Code...": "Generating QR code...",
 "Gerar PDF": "Create PDF",
 "Gerar as cobranças do mês": "Create this month's charges",
 "Gerar as parcelas": "Create installments",
 "Gerar lista da mala": "Generate packing list",
 "Gerar pelo cardápio e pela despensa": "Generate from the menu and pantry",
 "Gesso e forro": "Drywall and ceiling",
 "Gira todas as páginas ou só as escolhidas.": "Rotates all pages or only the chosen ones.",
 "Girar": "Rotate",
 "Google Drive e OneDrive": "Google Drive and OneDrive",
 "Google Drive, OneDrive e agenda do Google: só se você conectar, e só para guardar os seus arquivos e eventos.": "Google Drive, OneDrive and Google Calendar: only if you connect them, and only to store your files and events.",
 "Gorro, cachecol e luvas": "Beanie, scarf and gloves",
 "Gota": "Drop",
 "Graduação e Pós": "College and grad school",
 "Grande": "Large",
 "Gravando": "Recording",
 "Gravar lembretes e anotações por voz quando você pedir. O microfone só liga com o seu toque.": "Record voice reminders and notes when you ask. The microphone only turns on when you tap.",
 "Gravar reunião": "Record meeting",
 "Gravação de áudio": "Audio recording",
 "Gravações das reuniões": "Meeting recordings",
 "Grossa": "Thick",
 "Grupo": "Group",
 "Grupo com convite (turma, equipe, convidados)": "Group with invite (class, team, guests)",
 "Grupo criado": "Group created",
 "Grupo da família": "Family group",
 "Grupo da mudança (família e ajudantes)": "Moving group (family and helpers)",
 "Grupo da obra (equipe)": "Project group (crew)",
 "Grupo da turma (convidar alunos)": "Class group (invite students)",
 "Grupo da viagem (convidar quem vai)": "Trip group (invite who's going)",
 "Grupo de cuidado (família ou profissional)": "Care group (family or caregiver)",
 "Grupo de estudos (convidar colegas)": "Study group (invite classmates)",
 "Grupo de leitura (convidar)": "Reading group (invite)",
 "Grupo do cliente": "Client group",
 "Grupo do evento (convidar)": "Event group (invite)",
 "Grupos": "Groups",
 "Grupos de estudo": "Study groups",
 "Grupos de {aba}": "{aba} groups",
 "Grupos desta aba: {n}": "Groups in this tab: {n}",
 "Grupos e convites": "Groups & invites",
 "Grátis no lançamento": "Free at launch",
 "Guarda-chuva": "Umbrella",
 "Guardada nas suas figurinhas.": "Saved to your stickers.",
 "Guardado": "Saved",
 "Guardado até agora: {v}": "Saved so far: {v}",
 "Guardado em outro dispositivo": "Saved on another device",
 "Guardado na pasta \"{pasta}\" do celular.": "Saved in the \"{pasta}\" folder on your phone.",
 "Guardado no cofre, com criptografia de ponta a ponta.": "Stored in the vault, with end-to-end encryption.",
 "Guardado no {nome}.": "Saved to {nome}.",
 "Guardado {onde} em {quando}": "Saved {onde} on {quando}",
 "Guardando...": "Saving...",
 "Guardar": "Save",
 "Guardar como recibo do IR": "Save as income tax receipt",
 "Guardar dinheiro": "Save money",
 "Guardar e enviar": "Save and send",
 "Guardar na meta": "Add to goal",
 "Guardar nas minhas figurinhas": "Save to my stickers",
 "Guardar nos meus GIFs": "Save to my GIFs",
 "Guardar o PDF {onde}": "Save PDF {onde}",
 "Guardar os PDFs em": "Save PDFs to",
 "Guardar os arquivos prontos em": "Save finished files to",
 "Guardar sozinho cada arquivo pronto": "Auto-save each finished file",
 "Guarde as prescrições e orientações que você usa sempre. No atendimento, toque em ⋮ › Usar modelo.": "Save the prescriptions and instructions you always use. In the appointment, tap ⋮ › Use template.",
 "Guarde seus documentos num lugar só": "Keep all your documents in one place",
 "Guarde {v} por mês até {d}": "Save {v} a month until {d}",
 "Guardou": "Saved",
 "Guia de imposto": "Tax payment slip",
 "Gás": "Gas",
 "Gênero ou categoria": "Genre or category",
 "HISTÓRICO DOS DADOS": "DATA HISTORY",
 "HOJE": "TODAY",
 "Hall de entrada": "Entryway",
 "Halteres": "Dumbbells",
 "Hexágono": "Hexagon",
 "Hidratante": "Moisturizer",
 "Hidratante labial": "Lip balm",
 "Hidráulica": "Plumbing",
 "Higiene bucal": "Oral hygiene",
 "Higienizar": "Sanitize",
 "História": "History",
 "Histórico": "History",
 "Histórico da família, exames protegidos, vacinas, consultas e alarme dos remédios na linha do tempo.": "Family history, protected tests, vaccines, appointments and medicine alarms on the timeline.",
 "Hmm...": "Hmm...",
 "Hoje": "Today",
 "Hoje: {a} de {m} aulas ({p}%)": "Today: {a} of {m} lessons ({p}%)",
 "Hoje: {n} página(s)": "Today: {n} page(s)",
 "Hora": "Time",
 "Hora da pausa": "Break time",
 "Hora de voltar": "Time to get back",
 "Hora de voltar!": "Time to get back!",
 "Hora do check-in": "Check-in time",
 "Hora do check-out": "Check-out time",
 "Horas": "Hours",
 "Horas de sono": "Sleep hours",
 "Horário": "Time",
 "Horário de check-in": "Check-in time",
 "Horário de check-out": "Check-out time",
 "Horário do lembrete": "Reminder time",
 "Horário inválido": "Invalid time",
 "Horário ocupado": "Time slot taken",
 "Horários": "Times",
 "Horários (remédio diário)": "Times (daily medicine)",
 "Hospedados agora": "Staying now",
 "Hospedagem": "Lodging",
 "Hospital ou pronto-socorro de referência": "Reference hospital or ER",
 "Hotel": "Hotel",
 "Há uma versão nova do My Planner Web. Recarregue para usar.": "A new version of My Planner Web is available. Reload to use it.",
 "Híbrido": "Hybrid",
 "Hóspede": "Guest",
 "Hóspede ({c})": "Guest ({c})",
 "Hóspedes (máximo)": "Guests (max)",
 "IA ligada": "AI on",
 "IA não ligada": "AI off",
 "IA não ligada. Ligue em Ajustes › Inteligência artificial.": "AI is off. Turn it on in Settings › Artificial intelligence.",
 "IPVA": "IPVA",
 "ISS": "ISS",
 "ISS %": "ISS %",
 "ISS retido pelo tomador": "ISS withheld by the customer",
 "Ida": "Departure",
 "Identidade": "ID card",
 "Idioma": "Language",
 "Idiomas": "Languages",
 "Ilimitados": "Unlimited",
 "Imagem": "Image",
 "Imagem escolhida (trocar)": "Image chosen (change)",
 "Imagem guardada no {nome}. Toque para abrir.": "Image saved to {nome}. Tap to open.",
 "Imagens para PDF": "Images to PDF",
 "Imagens {data}": "Images {data}",
 "Imperdíveis": "Must-sees",
 "Imperdível": "Must-see",
 "Importar": "Import",
 "Importar XML de nota": "Import invoice XML",
 "Importar arquivo": "Import file",
 "Importar backup?": "Import backup?",
 "Importar extrato": "Import statement",
 "Importar extrato do banco (OFX ou CSV)": "Import bank statement (OFX or CSV)",
 "Importar fatura": "Import statement",
 "Importar fotos": "Import photos",
 "Importar reservas do Airbnb, Booking...": "Import bookings from Airbnb, Booking...",
 "Importar {n} lançamento(s)": "Import {n} entry(ies)",
 "Imóveis e espaços": "Properties and spaces",
 "Imóvel": "Property",
 "Imóvel inteiro": "Whole property",
 "Imóvel inteiro ou por cômodo: reservas do Airbnb, Booking ou direto, limpeza no check-out, despesas, ocupação e lucro do mês.": "Whole property or by room: bookings from Airbnb, Booking or direct, check-out cleaning, expenses, occupancy and monthly profit.",
 "Inclui {v} das notas fiscais emitidas na aba Notas Fiscais.": "Includes {v} from invoices issued in the Invoices tab.",
 "Independência do Brasil": "Brazilian Independence Day",
 "Indicação": "Referral",
 "Indique e ganhe": "Refer and earn",
 "Indique o My Planner para amigos e família. Quem criar a conta com o seu código ganha 10 dias com todas as abas liberadas.": "Recommend My Planner to friends and family. Anyone who creates an account with your code gets 10 days with all tabs unlocked.",
 "Infantil": "Children",
 "Informações do PDF": "PDF info",
 "Informe a descrição e o valor.": "Enter the description and amount.",
 "Informe de quantos em quantos dias regar ou adubar.": "Enter how often to water or fertilize, in days.",
 "Informe o nome do produto.": "Enter the product name.",
 "Informe o rótulo e o nome.": "Enter the label and the name.",
 "Informe o total de aulas da matéria em Editar.": "Enter the subject's total lessons in Edit.",
 "Informe o valor.": "Enter the amount.",
 "Informe os horários": "Enter the times",
 "Informe quanto quer juntar.": "Enter how much you want to save.",
 "Informe seu nome.": "Enter your name.",
 "Informática": "Computer Science",
 "Inglês": "English",
 "Ingredientes (um por linha)": "Ingredients (one per line)",
 "Inscrição municipal (se tiver)": "Municipal registration (if any)",
 "Inspeção": "Inspection",
 "Instalar ou atualizar o Health Connect": "Install or update Health Connect",
 "Instruções, receita, observações...": "Instructions, recipe, notes...",
 "Insumos (papel, sabonete, café)": "Supplies (paper, soap, coffee)",
 "Inteligência artificial": "Artificial intelligence",
 "Inteligência artificial (Claude, ChatGPT ou Gemini): só se você ligar, com a sua própria chave, que fica apenas no dispositivo. O texto da pergunta vai direto para o serviço escolhido.": "Artificial intelligence (Claude, ChatGPT or Gemini): only if you turn it on, with your own key, which stays only on the device. The text of your question goes straight to the service you chose.",
 "Intensidade": "Intensity",
 "Internação": "Hospital stay",
 "Internet": "Internet",
 "Intimação": "Court notice",
 "Intimação com prazo": "Court notice with deadline",
 "Investimento": "Investment",
 "Investimentos": "Investing",
 "Início": "Start",
 "Início {ini} · Fim {fim} · Duração {dur}": "Start {ini} · End {fim} · Duration {dur}",
 "Iogurte": "Yogurt",
 "Ir para Ajustes (exportar meus dados)": "Go to Settings (export my data)",
 "Ir para hoje": "Go to today",
 "Ir para o My Planner Web": "Go to My Planner Web",
 "Italiano": "Italian",
 "Item": "Item",
 "Item da despensa": "Pantry item",
 "Item protegido: fotos e arquivos ficam criptografados no cofre, só neste dispositivo (não vão para o Drive ou OneDrive).": "Protected item: photos and files are encrypted in the vault, on this device only (they do not go to Drive or OneDrive).",
 "Itens": "Items",
 "Itens de higiene (xampu, sabonete)": "Toiletries (shampoo, soap)",
 "Jantar": "Dinner",
 "Japonês": "Japanese",
 "Jaqueta impermeável": "Waterproof jacket",
 "Jogo": "Game",
 "Jovem e divertido": "Young and fun",
 "Juntar PDFs": "Merge PDFs",
 "Juros": "Interest",
 "Juros ainda por vir: {v}": "Interest still to come: {v}",
 "Juros ao mês": "Monthly interest",
 "JÁ RESPONDIDOS": "ALREADY ANSWERED",
 "Já aberta na casa nova": "Already opened in the new home",
 "Já enviado para a turma": "Already sent to the class",
 "Já está compacto": "Already compact",
 "Já está no Planner": "Already in Planner",
 "Já está pago": "Already paid",
 "Já há horários deste item no My Planner": "This item already has times in My Planner",
 "Já pago: {v}": "Already paid: {v}",
 "Já tenho o app: abrir nele": "I have the app: open in it",
 "Já tenho o app: abrir o convite nele": "I have the app: open the invite in it",
 "Já visitei": "Visited it",
 "Kit de primeiros socorros": "First aid kit",
 "Kkkk": "Haha",
 "Kkkkk": "Hahaha",
 "Km de hoje no painel": "Today's odometer reading",
 "Km no dia": "Mileage on the day",
 "Km no painel": "Odometer reading",
 "LANÇAMENTOS": "ENTRIES",
 "LINHA DO TEMPO": "TIMELINE",
 "Laboratório": "Lab",
 "Lanche": "Snack",
 "Lanche da manhã": "Morning snack",
 "Lanche da tarde": "Afternoon snack",
 "Lanches e água": "Snacks and water",
 "Lançamentos": "Transactions",
 "Lavanderia": "Laundry room",
 "Lavanderia, insumos, manutenção, contas e taxas. Entram no lucro do mês.": "Laundry, supplies, maintenance, bills and fees. They count toward the monthly profit.",
 "Lavar o rosto com sabonete facial": "Wash your face with facial cleanser",
 "Lazer": "Leisure",
 "Leg press": "Leg press",
 "Legenda": "Caption",
 "Legislação Específica": "Specific Legislation",
 "Legumes": "Vegetables",
 "Leia hoje para começar uma sequência": "Read today to start a streak",
 "Leite": "Milk",
 "Leitura": "Reading",
 "Leitura automática do texto": "Automatic text reading",
 "Leitura da IA": "AI reading",
 "Leitura, Cursos & Mídia": "Reading, Courses & Media",
 "Lembrete": "Reminder",
 "Lembrete de hoje": "Today's reminder",
 "Lembrete de renovação no Planner": "Renewal reminder in Planner",
 "Lembrete no Planner": "Reminder in Planner",
 "Lembrete no planner": "Reminder in the planner",
 "Lembrete pelo WhatsApp": "WhatsApp reminder",
 "Lembrete: começa às {hora}": "Reminder: starts at {hora}",
 "Lemos todas as mensagens. Se precisar, respondemos pelo seu e-mail.": "We read every message. If needed, we'll reply to your email.",
 "Lendo": "Reading",
 "Lendo a fatura...": "Reading the statement...",
 "Lendo a página": "Reading page",
 "Lendo o boleto...": "Reading the boleto...",
 "Lendo o cupom...": "Reading the receipt...",
 "Lendo o documento...": "Reading the document...",
 "Lendo o extrato...": "Reading the bank statement...",
 "Lendo o relógio...": "Reading the watch...",
 "Lendo o texto": "Reading the text",
 "Ler a fatura": "Read statement",
 "Ler a publicação inteira": "Read the full publication",
 "Ler com a minha IA": "Read with my AI",
 "Ler de novo": "Read again",
 "Ler de novo agora": "Read again now",
 "Ler o texto": "Read text",
 "Ler o texto completo": "Read full text",
 "Ler publicação inteira": "Read full publication",
 "Ler sozinho as publicações novas": "Read new publications automatically",
 "Leve": "Light",
 "Leve (sem perder qualidade)": "Light (no quality loss)",
 "Li e aceito os termos e a política de privacidade": "I have read and accept the terms and the privacy policy",
 "Li mais {n} páginas": "Read {n} more pages",
 "Liberada pelo suporte": "Unlocked by support",
 "Liberar para a equipe": "Share with team",
 "Liberar para a turma em": "Release to the class on",
 "Liberar para o grupo": "Unlock for the group",
 "Liberações e créditos são vinculados ao seu CPF. Atualiza ao sincronizar.": "Unlocks and credits are linked to your CPF. Updates when you sync.",
 "Libere a câmera para o My Planner nas configurações do celular para ler o QR Code.": "Allow camera access for My Planner in your phone settings to scan the QR code.",
 "Libere a câmera para o My Planner nas configurações do celular.": "Allow camera access for My Planner in your phone settings.",
 "Libere outras abas em Ajustes › Compras.": "Unlock other tabs in Settings › Purchases.",
 "Licenciamento": "Licensing",
 "Lidas hoje": "Read today",
 "Lido": "Read",
 "Ligando. Toque para atender.": "Calling. Tap to answer.",
 "Ligar": "Call",
 "Ligar certificado": "Connect certificate",
 "Ligar para a assistência": "Call the service center",
 "Ligar para {nome}": "Call {nome}",
 "Ligue a sua IA em Ajustes › Inteligência artificial (Claude, ChatGPT ou Gemini) para usar esta ferramenta.": "Turn on your AI in Settings › Artificial intelligence (Claude, ChatGPT or Gemini) to use this tool.",
 "Ligue a sua IA em Ajustes › Inteligência artificial para ler o texto, resumir e perguntar sobre o documento.": "Turn on your AI in Settings › Artificial intelligence to read the text, summarize and ask about the document.",
 "Ligue a sua IA em Ajustes › Inteligência artificial.": "Turn on your AI in Settings › Artificial intelligence.",
 "Ligue o certificado A1 da empresa primeiro.": "Connect the company's A1 certificate first.",
 "Ligue o seu Google Drive ou OneDrive para guardar fotos e arquivos (que passam a abrir em qualquer dispositivo) e para ter cópias de segurança completas.": "Connect your Google Drive or OneDrive to store photos and files (so they open on any device) and to get full backups.",
 "Ligue para o grupo trabalhar nos mesmos dados (obra, viagem, turma, imóvel, consultório), cada pessoa com o seu papel.": "Turn it on so the group works on the same data (construction, trip, class, property, practice), each person with their own role.",
 "Ligue pelo menos 4 pontos.": "Connect at least 4 dots.",
 "Limite anual editável em Ajustes › Abas › Aba Finanças. Confira sempre com o seu contador.": "Annual limit can be edited in Settings › Tabs › Finance tab. Always check with your accountant.",
 "Limite de consultas atingido. Tente de novo em 1 minuto.": "Query limit reached. Try again in 1 minute.",
 "Limite de energia por dia": "Daily energy limit",
 "Limite de faturamento anual do MEI (confira o valor vigente com o seu contador).": "MEI annual revenue limit (check the current amount with your accountant).",
 "Limite de mensagens por hoje atingido. Tente amanhã.": "Daily message limit reached. Try again tomorrow.",
 "Limite diário": "Daily limit",
 "Limite livre: {v} de {l}": "Available limit: {v} of {l}",
 "Limite total (opcional)": "Total limit (optional)",
 "Limpar": "Clear",
 "Limpar a agenda": "Clear schedule",
 "Limpar banheiro": "Clean bathroom",
 "Limpar cozinha e louça": "Clean kitchen and dishes",
 "Limpar feitos": "Clear done",
 "Limpeza": "Cleaning",
 "Limpeza após {h}": "Cleaning after {h}",
 "Limpeza final": "Final cleaning",
 "Limpeza · {e}": "Cleaning · {e}",
 "Limpeza: {e}": "Cleaning: {e}",
 "Limpezas": "Cleanings",
 "Linha do tempo, tarefas, energia e alertas.": "Timeline, tasks, energy and alerts.",
 "Link": "Link",
 "Link (Drive, OneDrive, Dropbox)": "Link (Drive, OneDrive, Dropbox)",
 "Link copiado. Cole onde quiser enviar.": "Link copied. Paste it wherever you want to send it.",
 "Link da aula ou reunião online (opcional)": "Class or online meeting link (optional)",
 "Link da nota fiscal (Drive ou OneDrive)": "Invoice link (Drive or OneDrive)",
 "Link da pasta no Drive ou OneDrive (opcional)": "Drive or OneDrive folder link (optional)",
 "Link da reserva": "Booking link",
 "Link da sala online (Meet, Zoom...)": "Online room link (Meet, Zoom...)",
 "Link de outro calendário (iCal)": "Another calendar link (iCal)",
 "Link do calendário do Airbnb (iCal)": "Airbnb calendar link (iCal)",
 "Link do calendário do Booking (iCal)": "Booking calendar link (iCal)",
 "Link inválido": "Invalid link",
 "Links de materiais (Drive, vídeos, PDFs), um por linha": "Material links (Drive, videos, PDFs), one per line",
 "Links: {n}": "Links: {n}",
 "Lista": "List",
 "Lista da mala": "Packing list",
 "Lista de compras": "Shopping list",
 "Lista de exercícios": "Exercise list",
 "Lista rápida": "Quick list",
 "Listas rápidas e caixas que viram tarefa ou vão para outra aba.": "Quick lists and boxes that become tasks or go to another tab.",
 "Literatura": "Literature",
 "Litros": "Liters",
 "Livre": "Available",
 "Livro": "Book",
 "Livros": "Books",
 "Local": "Location",
 "Local ou endereço": "Place or address",
 "Local: {l}": "Place: {l}",
 "Localização (país e fuso horário)": "Location (country and time zone)",
 "Logo, foto ou rubrica nas páginas.": "Logo, photo or initials on the pages.",
 "Loja (opcional)": "Store (optional)",
 "Lote": "Batch",
 "Lua": "Moon",
 "Lugar": "Place",
 "Lugar para visitar": "Place to visit",
 "Lugares": "Places",
 "Luz": "Light",
 "Luz indireta": "Indirect light",
 "Luz, água, gás e internet": "Electricity, water, gas and internet",
 "Lápis": "Pencil",
 "Língua Portuguesa": "Portuguese",
 "MAIS ADIANTE": "LATER",
 "MAIS USADOS": "MOST USED",
 "ME ou EPP do Simples": "Simples ME or EPP",
 "MEI": "MEI",
 "MEI: faturamento em {ano} de {v} (limite {l}).": "MEI: {ano} revenue of {v} (limit {l}).",
 "MEMBROS ({n})": "MEMBERS ({n})",
 "METAS": "GOALS",
 "MS": "MS",
 "Mais": "More",
 "Mais abas": "More tabs",
 "Mais cidades entram nas próximas versões.": "More cities are coming in future versions.",
 "Mais emojis": "More emojis",
 "Mais ferramentas": "More tools",
 "Mais figurinhas animadas (KLIPY)": "More animated stickers (KLIPY)",
 "Mais opções desta aba chegam nas próximas versões.": "More options for this tab are coming in future versions.",
 "Mais uma": "One more",
 "Mala": "Packing",
 "Mala ({clima}, {n} dias)": "Packing ({clima}, {n} days)",
 "Mamadeiras e leite": "Bottles and milk",
 "Mandamos um código de 6 números no WhatsApp do número {tel}.": "We sent a 6-digit code to the WhatsApp of {tel}.",
 "Mandar as orientações pelo WhatsApp": "Send the instructions via WhatsApp",
 "Mandar de novo": "Resend",
 "Mandar e-mail": "Send email",
 "Mandar lembrete": "Send reminder",
 "Mandar meu código": "Send my code",
 "Mandar o acerto para o grupo": "Send the settlement to the group",
 "Mandar para quem limpa (WhatsApp)": "Send to the cleaner (WhatsApp)",
 "Mandarim": "Mandarin",
 "Mande um e-mail pedindo a exclusão, com o CPF da conta. Respondemos em até 15 dias.": "Send an email asking for deletion, with the account's ID number. We reply within 15 days.",
 "Manter": "Keep",
 "Manter ambas": "Keep both",
 "Manter ambos": "Keep both",
 "Manter aqui também": "Keep it here too",
 "Manter tarefas": "Keep tasks",
 "Manutenção": "Maintenance",
 "Manutenções": "Maintenance",
 "Mapas (Apple)": "Apple Maps",
 "Marca d'água": "Watermark",
 "Marca-texto": "Highlighter",
 "Marcado": "Checked",
 "Marcado como feito hoje.": "Marked as done today.",
 "Marcar como concluída ({dia})": "Mark as completed ({dia})",
 "Marcar como devolvido": "Mark as returned",
 "Marcar como feita hoje": "Mark as done today",
 "Marcar como lido": "Mark as read",
 "Marcar como paga": "Mark as paid",
 "Marcar como pago": "Mark as paid",
 "Marcar como quitado": "Mark as paid off",
 "Marcar como recebida": "Mark as received",
 "Marcar como recebida?": "Mark as received?",
 "Marcar como recebido": "Mark as received",
 "Marcar como visto": "Mark as seen",
 "Marcar e avisar a equipe": "Schedule and notify team",
 "Marcar esta conta como paga?": "Mark this bill as paid?",
 "Marcar fatura como paga": "Mark statement as paid",
 "Marcar grupo": "Select group",
 "Marcar reunião": "Schedule meeting",
 "Marcenaria": "Carpentry",
 "Margem": "Margin",
 "Marketing": "Marketing",
 "Marque as fotos do diário como Antes ou Depois para montar a galeria.": "Mark log photos as Before or After to build the gallery.",
 "Marque os dias em que você estuda e o horário de cada dia. Cada dia vira uma tarefa que se repete toda semana, ligada a este item.": "Check the days you study and the time for each day. Each day becomes a task that repeats every week, linked to this item.",
 "Marque um ou mais estados.": "Select one or more states.",
 "Martelo": "Hammer",
 "Masculino": "Male",
 "Masculino e minimalista": "Masculine and minimalist",
 "Matemática": "Math",
 "Materiais": "Materials",
 "Material": "Material",
 "Matrícula, placa, código ou CNPJ": "Registration, plate, code or CNPJ",
 "Matéria ou material": "Subject or material",
 "Matéria ou módulo": "Subject or module",
 "Matérias": "Subjects",
 "Meia-sombra": "Partial shade",
 "Melhorando a imagem...": "Enhancing image...",
 "Melhorias novas já foram baixadas. Leva só alguns segundos e seus dados continuam.": "New improvements have been downloaded. It only takes a few seconds and your data stays.",
 "Membros": "Members",
 "Menos de 1 minuto": "Less than 1 minute",
 "Mensagem": "Message",
 "Mensagem apagada": "Message deleted",
 "Mensagem enviada. Obrigado!": "Message sent. Thank you!",
 "Mensagem ou observações": "Message or notes",
 "Mensagens": "Messages",
 "Mensagens que você envia em Fale conosco.": "Messages you send through Contact us.",
 "Mensagens: a sua lista de amigos, as conversas, as fotos e os arquivos enviados ficam guardados no servidor para chegar aos outros dispositivos. As chamadas de áudio e vídeo não são gravadas.": "Messages: your friends list, chats, and the photos and files you send are stored on the server so they can reach other devices. Audio and video calls are not recorded.",
 "Mensalidade de {m}": "{m} fee",
 "Mensalidade ou valor por aluno": "Monthly fee or price per student",
 "Mensalidades, aulas avulsas e materiais. Em ⋮ da turma, \"Gerar as cobranças do mês\" cria uma para cada aluno.": "Monthly fees, single classes and materials. In the class's ⋮, \"Create this month's charges\" creates one for each student.",
 "Mercado": "Groceries",
 "Mesa flexora": "Lying leg curl",
 "Mestre Achado": "Mestre Achado",
 "Mestre de obras": "Site foreman",
 "Meta": "Goal",
 "Meta 100% batida": "Goal 100% reached",
 "Meta atingida": "Goal reached",
 "Meta atingida!": "Goal reached!",
 "Meta da semana: {dur}": "Weekly goal: {dur}",
 "Meta de aulas": "Lessons goal",
 "Meta de aulas batida": "Lessons goal reached",
 "Meta de copos por dia": "Daily glass goal",
 "Meta de páginas por dia": "Daily page goal",
 "Meta de páginas, progresso e resumos dos livros, filmes e séries para ver e aulas dos cursos.": "Page goals, progress and notes for books, movies and series to watch, and course lessons.",
 "Meta diária": "Daily goal",
 "Meta por dia": "Daily goal",
 "Meta por semana:": "Weekly goal:",
 "Meta {meta} · copo de {copo} · {n} copos": "Goal {meta} · {copo} glass · {n} glasses",
 "Metas": "Goals",
 "Metodologia Científica": "Research Methodology",
 "Meu caderno": "My notebook",
 "Meu cartão de contato": "My contact card",
 "Meu plano": "My plan",
 "Meus GIFs ({n})": "My GIFs ({n})",
 "Meus PDFs": "My PDFs",
 "Meus dados": "My details",
 "Meus dados profissionais": "My professional details",
 "Microchip": "Microchip",
 "Microfone": "Microphone",
 "Microscópio": "Microscope",
 "Militares estaduais": "State military",
 "Minha Casa": "My Home",
 "Minha conta": "My account",
 "Minhas anotações do livro": "My book notes",
 "Minhas figurinhas": "My stickers",
 "Minutos": "Minutes",
 "Minutos de exercício": "Exercise minutes",
 "Mirante": "Viewpoint",
 "Mirantes": "Viewpoints",
 "Modelo": "Model",
 "Modelo de prescrição": "Prescription template",
 "Modelos": "Templates",
 "Modificado em": "Modified on",
 "Modo": "Mode",
 "Modo de preparo": "Directions",
 "Modo seguro: tarefas automáticas desligadas até abrir o app de novo": "Safe mode: automatic tasks off until you reopen the app",
 "Moeda": "Currency",
 "Moeda: {m}": "Currency: {m}",
 "Moedas": "Coins",
 "Momento do evento": "Event moment",
 "Monitor do Diário de Justiça Eletrônico (DJEN) por nome e OAB.": "Monitor of the Electronic Court Gazette (DJEN) by name and OAB number.",
 "Monitor ou co-professor": "Teaching assistant or co-teacher",
 "Montando o PDF: página {n} de {total}...": "Building PDF: page {n} of {total}...",
 "Montar a mala pelo clima ({n} dias)": "Pack for the weather ({n} days)",
 "Monte o cronograma alimentar para ver o relatório.": "Set up your meal schedule to see the report.",
 "Monte o roteiro dia a dia. No período da viagem, ele aparece na linha do tempo do My Planner.": "Build the itinerary day by day. During the trip, it shows on the My Planner timeline.",
 "Monte seu cronograma alimentar e seus cuidados abaixo. O que for de hoje aparece aqui para marcar.": "Build your meal plan and self-care routines below. Whatever is for today shows up here to check off.",
 "Monte seu cronograma alimentar, cuidados, treinos e suplementos abaixo. O que for de hoje aparece aqui para marcar.": "Set up your meal schedule, care routines, workouts and supplements below. Whatever is for today shows up here to check off.",
 "Monte seus treinos com atividades prontas: aparelhos da academia, exercícios em casa, caminhada, corrida, yoga, pilates...": "Build your workouts from ready-made activities: gym machines, home exercises, walking, running, yoga, pilates...",
 "Mostrando as 120 mais recentes.": "Showing the 120 most recent.",
 "Mostrando só o roteiro. {n} tarefa(s) do dia escondida(s).": "Showing only the itinerary. {n} task(s) for the day hidden.",
 "Mostrar datas, horários, moeda e feriados certos para onde você está. Não usamos o GPS.": "Show the right dates, times, currency and holidays for where you are. We don't use GPS.",
 "Mostrar menos": "Show less",
 "Mostrar só o roteiro durante a viagem": "Show only the itinerary during the trip",
 "Motivo do cancelamento": "Cancellation reason",
 "Moto": "Motorcycle",
 "Mover": "Move",
 "Mover para hoje": "Move to today",
 "Mudança": "Moving",
 "Mudança: {para}": "Move: {para}",
 "Mudanças": "Moves",
 "Mudar e-mail": "Change email",
 "Mudar o nome": "Rename",
 "Mudar senha": "Change password",
 "Mudo": "Mute",
 "Muitas tentativas": "Too many attempts",
 "Muitas tentativas erradas. Tente de novo em {s} segundos.": "Too many wrong attempts. Try again in {s} seconds.",
 "Muitas tentativas. Aguarde alguns minutos.": "Too many attempts. Wait a few minutes.",
 "Muito bem: já guardou {v} este mês. Constância vale mais que valor alto.": "Well done: you've already saved {v} this month. Consistency beats big amounts.",
 "Multa": "Fine",
 "Multa e juros": "Late fees and interest",
 "Multa e juros de {v}": "Late fees and interest of {v}",
 "Multa e juros estimados: {v}": "Estimated fine and interest: {v}",
 "Multas e juros pagos": "Late fees and interest paid",
 "Mundo": "World",
 "Municipal": "Municipal",
 "Município da prestação (IBGE), se for outro": "City where the service was provided (IBGE), if different",
 "Município da prestação (código IBGE, 7 números)": "City where the service was provided (IBGE code, 7 digits)",
 "Mural": "Notice board",
 "Museu": "Museum",
 "Museus": "Museums",
 "My Planner (vira tarefa)": "My Planner (becomes a task)",
 "My Planner bloqueado": "My Planner locked",
 "Máxima": "Maximum",
 "Média": "Medium",
 "Média para aprovação": "Passing average",
 "Média · repouso {n}": "Average · resting {n}",
 "Médico": "Doctor",
 "Médico ou clínica": "Doctor or clinic",
 "Médio": "Medium",
 "Mês": "Month",
 "Mês a mês": "Month by month",
 "Mês atual": "This month",
 "Mês passado": "Last month",
 "Móveis e enxoval": "Furniture and linens",
 "Móvel": "Furniture",
 "Música": "Music",
 "NAS ABAS": "IN TABS",
 "NF-e: a SEFAZ pede 1 hora entre as buscas. Próxima a partir das {h}.": "NF-e: SEFAZ requires 1 hour between searches. Next one from {h}.",
 "NF-e: informe a UF da empresa para buscar as notas de produtos.": "NF-e: enter the company's state (UF) to search for product invoices.",
 "NFS-e emitida": "NFS-e issued",
 "NFS-e: {m}": "NFS-e: {m}",
 "Na (opcional):": "On (optional):",
 "Na agenda": "Scheduled",
 "Na agenda em {data}": "Scheduled on {data}",
 "Na barra": "In bar",
 "Na demonstração não há servidor de notas. Use o app com a sua conta.": "The demo has no invoice server. Use the app with your account.",
 "Na hora": "Immediately",
 "Na hora da pausa aparece um aviso grande na tela, com contagem regressiva.": "At break time, a large notice appears on the screen with a countdown.",
 "Na linha do tempo, tocar no temporizador também abre esta página.": "On the timeline, tapping the timer also opens this page.",
 "Na pasta \"{pasta}\" do celular. Cada arquivo pronto vai para lá.": "In the \"{pasta}\" folder on your phone. Each finished file goes there.",
 "Na pasta \"{pasta}\" do celular. Cada documento novo vai para lá quando você sai dele.": "In the \"{pasta}\" folder on your phone. Each new document goes there when you leave it.",
 "Na prévia de demonstração não há chamadas de verdade.": "There are no real calls in the demo preview.",
 "Na prévia de demonstração não há gravação de verdade.": "There's no real recording in the demo preview.",
 "Na prévia de demonstração os arquivos não abrem.": "Files don't open in the demo preview.",
 "Na versão das lojas, a compra será pela Google Play ou pela App Store. Por enquanto a chave simula a assinatura para testes.": "In the store version, purchases will go through Google Play or the App Store. For now, the switch simulates the subscription for testing.",
 "Na versão das lojas, este botão abre a compra da Google Play ou da App Store.": "In the store version, this button opens the Google Play or App Store purchase.",
 "Nacional": "National",
 "Nada a gerar": "Nothing to create",
 "Nada encontrado.": "Nothing found.",
 "Nada entra na agenda de ninguém sem autorização: cada pessoa aceita, edita ou recusa.": "Nothing goes into anyone's schedule without permission: each person accepts, edits or declines.",
 "Nada foi registrado.": "Nothing was recorded.",
 "Nada lançado neste mês.": "Nothing recorded this month.",
 "Nada no mês": "Nothing this month",
 "Nada no roteiro deste dia.": "Nothing on the itinerary for this day.",
 "Nada para apagar com esse filtro.": "Nothing to delete with this filter.",
 "Nada para comprar": "Nothing to buy",
 "Nada para enviar.": "Nothing to send.",
 "Nada planejado para este dia": "Nothing planned for this day",
 "Nada planejado para hoje. Bom dia!": "Nothing planned for today. Good morning!",
 "Nada por aqui.": "Nothing here.",
 "Nada recebido ainda.": "Nothing received yet.",
 "Nas conversas, cada pessoa vê o seu nome e o que você manda ali. Você pode apagar uma mensagem para todos, sair de um grupo ou bloquear alguém.": "In chats, each person sees your name and what you send there. You can delete a message for everyone, leave a group or block someone.",
 "Nascimento": "Birth",
 "Natal": "Christmas",
 "Natação": "Swimming",
 "Navegador conectado": "Browser connected",
 "Negrito": "Bold",
 "Negócios": "Business",
 "Nenhum": "None",
 "Nenhum XML neste período (ou foram guardados em outro dispositivo).": "No XML in this period (or they were saved on another device).",
 "Nenhum amigo para adicionar. Convide pelo WhatsApp ou adicione amigos no Mensagens (código do amigo).": "No friends to add. Invite via WhatsApp or add friends in Messages (friend code).",
 "Nenhum arquivo, imagem ou link nas páginas desta matéria.": "No files, images or links in this subject's pages.",
 "Nenhum arquivo.": "No files.",
 "Nenhum atendimento pago neste mês.": "No paid appointments this month.",
 "Nenhum cartão": "No cards",
 "Nenhum comprovante guardado ainda. Ao pagar uma conta, toque nela e anexe a foto, o PDF ou o print do comprovante.": "No receipts saved yet. When you pay a bill, tap it and attach the photo, PDF or screenshot of the receipt.",
 "Nenhum cômodo ainda": "No rooms yet",
 "Nenhum dia": "No days",
 "Nenhum documento ainda.": "No documents yet.",
 "Nenhum documento neste filtro.": "No documents in this filter.",
 "Nenhum e-mail cadastrado": "No email registered",
 "Nenhum erro registrado. Se o app fechar sozinho ou uma tela der problema, o erro aparece aqui para você mandar para a equipe.": "No errors recorded. If the app closes on its own or a screen has a problem, the error shows up here so you can send it to the team.",
 "Nenhum feriado neste ano.": "No holidays this year.",
 "Nenhum fichário ainda": "No binders yet",
 "Nenhum grupo ainda.": "No groups yet.",
 "Nenhum item em {nome}": "No items in {nome}",
 "Nenhum lançamento encontrado": "No entries found",
 "Nenhum país encontrado.": "No country found.",
 "Nenhum selecionado": "None selected",
 "Nenhuma (plano gratuito)": "None (free plan)",
 "Nenhuma aba encontrada.": "No tabs found.",
 "Nenhuma aba fixada além do My Planner.": "No tabs pinned besides My Planner.",
 "Nenhuma aba liberada para receber": "No unlocked tab can receive it",
 "Nenhuma agenda encontrada": "No calendars found",
 "Nenhuma agenda para trazer": "No calendars to import",
 "Nenhuma audiência ou prazo encontrado nesta publicação.": "No court hearing or deadline found in this publication.",
 "Nenhuma caixa arquivada. Arraste uma caixa para a esquerda para arquivar.": "No archived boxes. Swipe a box left to archive it.",
 "Nenhuma compra encontrada": "No purchases found",
 "Nenhuma compra nesta fatura.": "No purchases on this statement.",
 "Nenhuma conta a pagar cadastrada.": "No bills to pay added.",
 "Nenhuma conta a receber cadastrada.": "No payments to receive added.",
 "Nenhuma conta neste mês. Toque em + para cadastrar (aluguel, luz, cartão...).": "No bills this month. Tap + to add one (rent, electricity, card...).",
 "Nenhuma cópia de segurança ainda.": "No backups yet.",
 "Nenhuma cópia encontrada.": "No backups found.",
 "Nenhuma garantia ativa. Cadastre com o +.": "No active warranties. Add one with +.",
 "Nenhuma garantia vencida.": "No expired warranties.",
 "Nenhuma mensagem ainda. Diga oi! 👋": "No messages yet. Say hi! 👋",
 "Nenhuma nota neste período.": "No invoices in this period.",
 "Nenhuma opção ainda.": "No options yet.",
 "Nenhuma publicação nova.": "No new publications.",
 "Nenhuma refeição neste dia.": "No meals on this day.",
 "Nenhuma reunião marcada.": "No meetings scheduled.",
 "Nesse ritmo, termina em {d}": "At this pace, you finish on {d}",
 "Nesta fase de lançamento, todas as abas estão liberadas e grátis.": "During this launch phase, all tabs are unlocked and free.",
 "Nesta fase de testes, a senha é redefinida pelo suporte. Escreva para {email} informando seu CPF ou e-mail.": "During this testing phase, passwords are reset by support. Write to {email} with your CPF or email.",
 "Nesta fase de testes, a senha é redefinida pelo suporte. Escreva para {email} informando seu CPF.": "During this testing phase, passwords are reset by support. Write to {email} with your CPF.",
 "Neve": "Snow",
 "Ninguém deve nada a ninguém.": "Nobody owes anybody anything.",
 "Ninguém entrou ainda. Envie o convite.": "No one has joined yet. Send the invite.",
 "Ninguém usou o seu código ainda.": "No one has used your code yet.",
 "No Android, o app guarda só o atalho do arquivo escolhido: ele continua onde está (Drive, OneDrive, Downloads) e abre no app do celular. Nada é copiado. Esta opção vale para as fotos tiradas pela câmera.": "On Android, the app keeps only a shortcut to the chosen file: it stays where it is (Drive, OneDrive, Downloads) and opens in the phone's app. Nothing is copied. This option applies to photos taken with the camera.",
 "No Google Drive ou OneDrive: {n}": "On Google Drive or OneDrive: {n}",
 "No Google Drive, o app só enxerga os arquivos que ele mesmo criou na pasta My Planner. O uso das informações recebidas das APIs do Google segue a Política de Dados do Usuário dos Serviços de API do Google, inclusive as regras de Uso Limitado: nada é vendido, usado para publicidade ou lido por pessoas, salvo com a sua autorização ou por obrigação legal.": "In Google Drive, the app can only see the files it created itself in the My Planner folder. Use of information received from Google APIs follows the Google API Services User Data Policy, including the Limited Use requirements: nothing is sold, used for advertising or read by people, except with your permission or where required by law.",
 "No app do seu relógio (Samsung Health, Garmin Connect, Mi Fitness, Zepp, Fitbit, Amazfit, Google Fit...), ligue a opção \"Health Connect\" ou \"Sincronizar com o Health Connect\".": "In your watch's app (Samsung Health, Garmin Connect, Mi Fitness, Zepp, Fitbit, Amazfit, Google Fit...), turn on \"Health Connect\" or \"Sync with Health Connect\".",
 "No app novo (versão 0.49), o celular acha as bordas da folha sozinho. Nesta versão, ajuste os 4 cantos com o dedo.": "In the new app (version 0.49), your phone finds the page edges by itself. In this version, adjust the 4 corners with your finger.",
 "No centro": "Center",
 "No computador, abra {url}, toque no botão acima e aponte a câmera para o QR Code da tela.": "On the computer, open {url}, tap the button above and point the camera at the QR code on the screen.",
 "No dia (opcional):": "On day (optional):",
 "No iPhone, o app abre \"Salvar em Arquivos\" para você escolher a pasta (pode ser o iCloud Drive).": "On iPhone, the app opens \"Save to Files\" so you can choose the folder (iCloud Drive works too).",
 "No início": "At start",
 "No modo seguro o app abre sem as tarefas automáticas (avisos, agenda do Google, publicações, mensagens e relógio). Os seus dados não mudam e tudo volta ao normal na próxima vez que abrir.": "In safe mode the app opens without automatic tasks (alerts, Google Calendar, publications, messages and watch). Your data does not change and everything goes back to normal the next time you open it.",
 "No navegador, as páginas ficam só enquanto esta página estiver aberta.": "In the browser, pages are kept only while this page is open.",
 "No navegador, cole o link do arquivo do Drive, OneDrive ou Dropbox (em Estudos ou Documentos, opção Link). No celular, o botão de arquivo já mostra o Drive e o OneDrive.": "In the browser, paste the file link from Drive, OneDrive or Dropbox (in Studies or Documents, Link option). On your phone, the file button already shows Drive and OneDrive.",
 "No navegador, o PDF é baixado para o computador.": "In the browser, the PDF is downloaded to your computer.",
 "No navegador, só dá para guardar imagens pequenas (até 200 KB). Para outros arquivos, adicione um link do Drive, OneDrive ou Dropbox, ou use o app no celular.": "In the browser, you can only save small images (up to 200 KB). For other files, add a Drive, OneDrive or Dropbox link, or use the app on your phone.",
 "No outro app, copie o link do arquivo (Compartilhar › Copiar link) e cole no bloco de link que ficou nesta página.": "In the other app, copy the file link (Share › Copy link) and paste it into the link block added to this page.",
 "No ritmo atual, o ano fecha em {v}.": "At the current pace, the year will close at {v}.",
 "No seu fuso: {hora}{dia}": "In your time zone: {hora}{dia}",
 "Nome": "Name",
 "Nome (cliente ou fornecedor)": "Name (client or supplier)",
 "Nome (ex.: 8º ano B, Pacientes da clínica, Aniversário da Ana)": "Name (e.g. 8th grade B, Clinic patients, Ana's birthday)",
 "Nome (ex.: Almoço)": "Name (e.g., Lunch)",
 "Nome (ex.: Aluguel recebido, Cliente X)": "Name (e.g., Rent received, Client X)",
 "Nome (ex.: Aluguel, Luz, Internet)": "Name (e.g., Rent, Electricity, Internet)",
 "Nome (ex.: Doutorado UFPR)": "Name (e.g., PhD at UFPR)",
 "Nome (ex.: Nubank, Itaú Visa)": "Name (e.g. Nubank, Itaú Visa)",
 "Nome (ex.: Skincare da noite)": "Name (e.g., Night skincare)",
 "Nome (ex.: Treino A)": "Name (e.g. Workout A)",
 "Nome (ex.: Viagem de férias, Reserva de emergência)": "Name (e.g. Vacation trip, Emergency fund)",
 "Nome (ex.: Vitamina C)": "Name (e.g. Vitamin C)",
 "Nome (opcional)": "Name (optional)",
 "Nome (opcional, ex.: CNH do Walter)": "Name (optional, e.g. Walter's license)",
 "Nome (pode editar, ex.: \"Suco de uva\")": "Name (editable, e.g. \"Grape juice\")",
 "Nome completo": "Full name",
 "Nome curto": "Short name",
 "Nome da lista": "List name",
 "Nome da matéria": "Subject name",
 "Nome da obra": "Project name",
 "Nome da pasta (ex.: Recibos, Contratos)": "Folder name (e.g. Receipts, Contracts)",
 "Nome da tarefa": "Task name",
 "Nome da tarefa (ex.: Academia)": "Task name (e.g. Gym)",
 "Nome da tarefa (ex.: Limpar o banheiro)": "Task name (e.g. Clean the bathroom)",
 "Nome do PDF (opcional)": "PDF name (optional)",
 "Nome do conselho": "Council name",
 "Nome do cômodo": "Room name",
 "Nome do documento": "Document name",
 "Nome do escritório (ex.: Ravasco Contabilidade)": "Office name (e.g.: Ravasco Contabilidade)",
 "Nome do evento": "Event name",
 "Nome do grupo (ex.: Família)": "Group name (e.g. Family)",
 "Nome do modelo": "Template name",
 "Nome ou modelo": "Name or model",
 "Nome ou razão social": "Name or company name",
 "Nome, subtarefa ou anotação": "Name, subtask or note",
 "Nos grupos, cada pessoa responde pelo que inclui. Quem administra o grupo decide quem participa.": "In groups, each person is responsible for what they add. The group admin decides who takes part.",
 "Nossa Senhora Aparecida": "Our Lady of Aparecida",
 "Nossa Senhora da Luz dos Pinhais": "Our Lady of Light of the Pines",
 "Nota cancelada": "Invoice canceled",
 "Nota fiscal": "Invoice",
 "Nota fiscal emitida": "Invoice issued",
 "Nota fiscal, certificado de garantia e fotos": "Receipt, warranty certificate and photos",
 "Nota importada": "Invoice imported",
 "Notas": "Invoices",
 "Notas Fiscais": "Invoices",
 "Notebook e carregador": "Laptop and charger",
 "Nova avaliação": "New assessment",
 "Nova caixa (ex.: Compras, Ideias)": "New box (e.g., Groceries, Ideas)",
 "Nova conversa": "New chat",
 "Nova garantia": "New warranty",
 "Nova matéria": "New subject",
 "Nova meta": "New goal",
 "Nova pasta": "New folder",
 "Nova página": "New page",
 "Nova página com esta caixa": "New page with this box",
 "Nova refeição": "New meal",
 "Nova tarefa": "New task",
 "Nova tarefa da casa": "New household task",
 "Nova tarefa neste cômodo": "New task in this room",
 "Novas": "New",
 "Novo": "New",
 "Novo alerta:": "New alert:",
 "Novo cartão": "New card",
 "Novo cartão de crédito": "New credit card",
 "Novo cuidado": "New routine",
 "Novo documento": "New document",
 "Novo e-mail": "New email",
 "Novo fichário": "New binder",
 "Novo grupo": "New group",
 "Novo item": "New item",
 "Novo perfil": "New profile",
 "Novo suplemento": "New supplement",
 "Novo treino": "New workout",
 "Novo: {nome}": "New: {nome}",
 "Novos": "New",
 "Num período": "In a date range",
 "Numere cada caixa e diga o cômodo e o conteúdo. Use a busca para achar onde está cada coisa.": "Number each box and note the room and contents. Use search to find where everything is.",
 "Nº": "No.",
 "Não": "No",
 "Não achei o total no cupom. Tente uma foto mais nítida.": "Couldn't find the total on the receipt. Try a sharper photo.",
 "Não consegue entrar?": "Can't sign in?",
 "Não consegui abrir \"{nome}\". Tente a ferramenta Reparar PDF.": "Couldn't open \"{nome}\". Try the Repair PDF tool.",
 "Não consegui conectar a chamada. Confira a internet e tente de novo.": "Couldn't connect the call. Check your internet and try again.",
 "Não deu certo: {msg}": "That didn't work: {msg}",
 "Não deu para diminuir mais este PDF ({tam}).": "Couldn't shrink this PDF any further ({tam}).",
 "Não dá para tirar todas as páginas.": "You can't remove all pages.",
 "Não encontrei texto neste PDF.": "No text found in this PDF.",
 "Não encontrei texto neste documento.": "No text found in this document.",
 "Não foi possível": "Couldn't complete",
 "Não foi possível abrir": "Couldn't open",
 "Não foi possível abrir o certificado guardado. Ligue o certificado de novo.": "Couldn't open the stored certificate. Connect the certificate again.",
 "Não foi possível abrir.": "Couldn't open.",
 "Não foi possível baixar os feriados deste país. Confira a internet.": "Couldn't download this country's holidays. Check your internet connection.",
 "Não foi possível conectar": "Couldn't connect",
 "Não foi possível conectar o {nome}": "Couldn't connect {nome}",
 "Não foi possível consultar o DJEN agora.": "Couldn't check DJEN right now.",
 "Não foi possível continuar": "Couldn't continue",
 "Não foi possível criar um evento na agenda: {msg}": "Couldn't create an event in the calendar: {msg}",
 "Não foi possível entrar.": "Couldn't sign in.",
 "Não foi possível enviar": "Couldn't send",
 "Não foi possível enviar.": "Couldn't send.",
 "Não foi possível guardar: {erro}": "Couldn't save: {erro}",
 "Não foi possível ler o arquivo.": "Couldn't read the file.",
 "Não foi possível ler o calendário. Confira o link em Editar.": "Couldn't read the calendar. Check the link in Edit.",
 "Não foi possível procurar agora. Tenta de novo sozinho mais tarde.": "Couldn't search right now. It will try again on its own later.",
 "Não foi possível reiniciar sozinho.": "Could not restart automatically.",
 "Não foi possível sincronizar com a agenda: {msg}": "Couldn't sync with the calendar: {msg}",
 "Não foi possível trocar a foto": "Couldn't change the photo",
 "Não há garantia de aviso com o app fechado. A verificação ocorre ao abrir o app (a cada 6 horas) ou em \"Verificar agora\".": "Notifications are not guaranteed while the app is closed. Checks run when the app opens (every 6 hours) or when you tap \"Check now\".",
 "Não identificado": "Not identified",
 "Não marcada como feita": "Not marked as done",
 "Não optante pelo Simples": "Not in Simples",
 "Não se repete": "Doesn't repeat",
 "Não use o app para atividades ilegais, para guardar conteúdo de terceiros sem autorização ou para tentar acessar dados de outras pessoas.": "Don't use the app for illegal activities, to store third-party content without permission or to try to access other people's data.",
 "Não vai": "Not going",
 "Não vence": "No expiry",
 "Não vendemos seus dados e não usamos o seu conteúdo para publicidade.": "We don't sell your data and we don't use your content for advertising.",
 "Não é possível adicionar esta pessoa.": "This person can't be added.",
 "Não é um XML de nota fiscal": "Not an invoice XML",
 "Número": "Number",
 "Número (opcional)": "Number (optional)",
 "Número da OAB": "OAB number",
 "Número da caixa": "Box number",
 "Número da carteirinha": "Member card number",
 "Número da guia do convênio": "Health plan authorization number",
 "Número da parcela": "Installment number",
 "Número de hóspedes": "Number of guests",
 "Número de parcelas": "Number of installments",
 "Número do contrato": "Contract number",
 "Número do registro": "Registration number",
 "Número na chamada": "Roll number",
 "Número {n}. O XML ficou guardado na nota. Toque nela para ver o PDF.": "Number {n}. The XML was saved with the invoice. Tap it to see the PDF.",
 "Número, órgão emissor e observações ficam criptografados (AES-256) no aparelho antes de ir para a nuvem.": "Number, issuing authority and notes are encrypted (AES-256) on the device before going to the cloud.",
 "Número, órgão emissor, observações, fotos e PDFs ficam criptografados (AES-256) no dispositivo. Os arquivos protegidos ficam só neste dispositivo.": "Number, issuing authority, notes, photos and PDFs are encrypted (AES-256) on the device. Protected files stay on this device only.",
 "Número: {n}": "Number: {n}",
 "Números de página": "Page numbers",
 "O ChatGPT não lê PDF por aqui. Tire uma foto ou um print da página, ou use o Claude ou o Gemini em Ajustes › Inteligência artificial.": "ChatGPT can't read PDFs here. Take a photo or a screenshot of the page, or use Claude or Gemini in Settings › Artificial intelligence.",
 "O DAS vence dia {dia}. Marque como pago em Finanças.": "The DAS is due on the {dia}. Mark it as paid in Finance.",
 "O Escritório ainda não foi ligado no servidor. No computador, rode o 29-SERVIDOR-0.45.bat (uma vez só).": "The Office hasn't been enabled on the server yet. On the computer, run 29-SERVIDOR-0.45.bat (just once).",
 "O Mestre Achado cuida do seu dinheiro: contas, cartões e faturas, orçamento por categoria, metas, extrato e cupom pela foto, relatório e MEI.": "Mestre Achado looks after your money: bills, cards and statements, budget by category, goals, bank statements and receipts from photos, reports and MEI.",
 "O Mestre está pensando...": "The Mestre is thinking...",
 "O My Planner cria a pasta \"My Planner\" no seu Drive e só enxerga o que ele mesmo guardou lá.": "My Planner creates a \"My Planner\" folder in your Drive and only sees what it saved there itself.",
 "O My Planner já abriu no computador, com os seus dados.": "My Planner is now open on the computer, with your data.",
 "O My Planner lê os dados do relógio pelo {fonte}, onde o relógio e os apps de saúde e de exercício guardam tudo.": "My Planner reads your watch data through {fonte}, where your watch and health and fitness apps store everything.",
 "O My Planner organiza a sua agenda, tarefas, finanças, documentos e outras áreas da vida. É oferecido por Walter Ravasco da Costa, que é o controlador dos dados pessoais tratados no app.": "My Planner organizes your schedule, tasks, finances, documents and other areas of your life. It is offered by Walter Ravasco da Costa, who is the controller of the personal data processed in the app.",
 "O My Planner usa só a pasta Aplicativos › My Planner do seu OneDrive.": "My Planner only uses the Apps › My Planner folder in your OneDrive.",
 "O PDF e as imagens saem deste dispositivo e da nuvem.": "The PDF and images will be removed from this device and the cloud.",
 "O PDF passou de 15 MB. Se o WhatsApp ou o e-mail recusar, ligue \"Arquivo menor\".": "The PDF is over 15 MB. If WhatsApp or email rejects it, turn on \"Smaller file\".",
 "O QUE COMER": "WHAT TO EAT",
 "O QUE OS MEMBROS PODEM": "WHAT MEMBERS CAN DO",
 "O QUE VOCÊ MANDA": "WHAT YOU SEND",
 "O QUE VOCÊ RECEBE": "WHAT YOU RECEIVE",
 "O acesso continua sendo pelo CPF. O e-mail serve para o suporte falar com você.": "You still sign in with your CPF. The email lets support get in touch with you.",
 "O administrador do grupo poderá enviar compromissos, materiais e avisos. Nada entra na sua agenda sem você aceitar.": "The group admin will be able to send appointments, materials and notices. Nothing goes into your schedule unless you accept it.",
 "O alarme toca de novo a cada 2 minutos (até 4 vezes) enquanto o remédio não for marcado como tomado.": "The alarm rings again every 2 minutes (up to 4 times) until the medicine is marked as taken.",
 "O app ajuda a organizar, mas não substitui orientação de médicos, advogados, contadores ou outros profissionais. Confira prazos, valores e datas importantes.": "The app helps you get organized, but it doesn't replace advice from doctors, lawyers, accountants or other professionals. Double-check important deadlines, amounts and dates.",
 "O app avisa 3 dias antes e no dia do vencimento, às 9h.": "The app alerts you 3 days before and on the due date, at 9 AM.",
 "O app consulta o serviço público do CNJ (DJEN) com os nomes e a OAB que você cadastrar. Esses dados são enviados a esse serviço a cada verificação.": "The app queries the CNJ public service (DJEN) using the names and OAB numbers you register. This data is sent to that service at each check.",
 "O app e o servidor do My Planner consultam o serviço público do CNJ (DJEN) com os nomes e as OABs que você cadastrar e, se você marcar, o Querido Diário (diários oficiais municipais). Esses dados são enviados a esses serviços a cada verificação.": "The My Planner app and server query the CNJ public service (DJEN) with the names and OABs you register and, if you check it, Querido Diário (municipal official gazettes). This data is sent to these services on every check.",
 "O app fechou sozinho {n} vezes seguidas": "The app closed on its own {n} times in a row",
 "O app instalado neste aparelho é a versão {v}. Para fazer chamadas de áudio e vídeo, instale o app 0.35 ou mais novo (APK novo). As mensagens já funcionam.": "The app installed on this device is version {v}. To make audio and video calls, install app 0.35 or newer (new APK). Messages already work.",
 "O app não fechou e os seus dados continuam salvos. Tente de novo ou mande o relatório para a equipe corrigir.": "The app did not close and your data is still saved. Try again or send the report so the team can fix it.",
 "O app pede o desbloqueio ao abrir e ao voltar do segundo plano.": "The app asks you to unlock when it opens and when it comes back from the background.",
 "O app pede o desbloqueio ao abrir. Trocar de app ou de tela rapidinho não pede de novo; se o celular ficar travado ou o app ficar fora da tela por mais tempo que o prazo abaixo, pede.": "The app asks to unlock when it opens. Quickly switching apps or screens doesn't ask again; if the phone is locked or the app stays off screen for longer than the time below, it does.",
 "O app só lê (passos, distância, calorias, exercício, batimentos e sono) e nunca altera os seus dados de saúde. Os totais de cada dia ficam na sua conta para aparecer também no site e no outro celular.": "The app only reads (steps, distance, calories, exercise, heart rate and sleep) and never changes your health data. Daily totals are saved to your account so they also show on the website and your other phone.",
 "O app volta a pedir a senha para desbloquear.": "The app will ask for the password to unlock again.",
 "O app é feito para maiores de 18 anos. Dados de crianças só podem ser registrados pelos pais ou responsáveis.": "The app is intended for people over 18. Children's data can only be entered by parents or guardians.",
 "O arquivo ficou só neste dispositivo. Não foi possível guardar no {nome}: {erro}": "The file was kept on this device only. Couldn't save to {nome}: {erro}",
 "O arquivo não está mais nesse lugar (foi apagado ou movido).": "The file is no longer there (it was deleted or moved).",
 "O arquivo não está mais nesse lugar (foi apagado, movido ou o app dele tirou a permissão). Anexe de novo.": "The file is no longer there (it was deleted, moved or its app removed the permission). Attach it again.",
 "O arquivo passa de 15 MB.": "The file is larger than 15 MB.",
 "O arquivo passa de 15 MB. Ligue \"Arquivo menor\" e tente de novo.": "The file is over 15 MB. Turn on \"Smaller file\" and try again.",
 "O arquivo passa de 25 MB.": "The file is larger than 25 MB.",
 "O arquivo passa de 50 MB.": "The file is over 50 MB.",
 "O arquivo sai deste celular. As cópias que você salvou no Drive, OneDrive ou mandou para alguém continuam lá.": "The file leaves this phone. Copies you saved to Drive, OneDrive or sent to someone stay there.",
 "O arquivo sai do escritório para todos.": "The file is removed from the office for everyone.",
 "O aviso chega às 9h, e de novo no dia do vencimento.": "The reminder arrives at 9 AM, and again on the expiry date.",
 "O banco ainda não foi preparado. Rode o arquivo supabase/schema.sql no Supabase.": "The database hasn't been set up yet. Run the supabase/schema.sql file in Supabase.",
 "O cartão {c} está com {p}% do limite tomado. Evite parcelar coisa nova nele por enquanto.": "Card {c} is at {p}% of its limit. Avoid new installment purchases on it for now.",
 "O celular não avisa o app quando a tela é travada, por isso o app conta o tempo fora. Com 1 minuto, travar o celular e voltar depois pede a biometria; responder uma mensagem rápida, não.": "The phone doesn't tell the app when the screen is locked, so the app counts the time away. With 1 minute, locking the phone and coming back later asks for biometrics; replying to a quick message doesn't.",
 "O celular serve só para confirmar que a conta é sua (código pelo WhatsApp no cadastro e ao trocar de número). Um número por conta.": "Your phone is only used to confirm the account is yours (code via WhatsApp when signing up and when changing numbers). One number per account.",
 "O compartilhamento ainda não foi ligado no servidor. No computador, abra a pasta C:\\MyPlanner e dê dois cliques em 12-LIGAR-COMPARTILHAMENTO.bat (uma vez só).": "Sharing hasn't been turned on on the server yet. On the computer, open the C:\\MyPlanner folder and double-click 12-LIGAR-COMPARTILHAMENTO.bat (just once).",
 "O computador vai abrir o My Planner com a sua conta. Faça isso só em computadores de confiança.": "The computer will open My Planner with your account. Only do this on trusted computers.",
 "O convite leva o link do app e do APK mais recente. Quem entra pelo link cai direto no escritório.": "The invite includes the link to the app and the latest APK. Anyone who joins through the link goes straight into the office.",
 "O código de indicação vale só nos primeiros 30 dias da conta.": "The referral code is only valid in the account's first 30 days.",
 "O desenho fica guardado só neste dispositivo, protegido. A senha continua valendo se você esquecer o desenho.": "The pattern is stored only on this device, protected. Your password still works if you forget the pattern.",
 "O dinheiro gasto está à frente do andamento da obra.": "Spending is ahead of the work progress.",
 "O documento não tem páginas.": "The document has no pages.",
 "O extrato é lido aqui no aparelho. Contas a pagar com o mesmo valor e data próxima recebem baixa automática.": "The statement is read right here on your device. Bills to pay with the same amount and a close date are marked as paid automatically.",
 "O extrato é lido aqui no dispositivo. Contas a pagar com o mesmo valor e data próxima recebem baixa automática. O pagamento da fatura do cartão não conta duas vezes.": "The statement is read here on the device. Bills to pay with the same amount and a close date are marked as paid automatically. The card statement payment isn't counted twice.",
 "O governo recusou a nota": "The government rejected the invoice",
 "O governo recusou a nota.": "The government rejected the invoice.",
 "O idioma vale para este dispositivo. Os dados que você digitou não são traduzidos.": "The language applies to this device. Data you have typed is not translated.",
 "O item vinculado foi apagado ou movido.": "The linked item was deleted or moved.",
 "O item vinculado foi apagado ou movido. Edite a tarefa para escolher outro.": "The linked item was deleted or moved. Edit the task to choose another one.",
 "O link antigo deixa de funcionar.": "The old link will stop working.",
 "O link antigo deixa de funcionar. Quem já está no grupo continua.": "The old link stops working. Anyone already in the group stays.",
 "O link deve começar com https://": "The link must start with https://",
 "O navegador não deixa ler o calendário das plataformas. Importe pelo app no celular.": "The browser can't read the platforms' calendars. Import through the phone app.",
 "O plano básico e os períodos de teste das abas seguem as regras mostradas em Ajustes > Compras. Benefícios de indicação valem uma vez por conta.": "The basic plan and the tab trial periods follow the rules shown in Settings > Purchases. Referral benefits apply once per account.",
 "O que acontece": "What happens",
 "O que apagar": "What to delete",
 "O que comprou": "What you bought",
 "O que fazer": "What to do",
 "O que foi comido:": "What was eaten:",
 "O que foi feito": "What was done",
 "O que foi visto": "What was covered",
 "O que funcionou, o que ajustar, metodologias, resumos...": "What worked, what to adjust, methods, summaries...",
 "O que já foi guardado continua nos lançamentos como investimento.": "What's already been saved stays in the transactions as an investment.",
 "O que levar ou estudar": "What to bring or study",
 "O que o app pode usar": "What the app may use",
 "O que o médico disse": "What the doctor said",
 "O que os seus grupos enviaram. Compromissos aceitos vão para o My Planner; materiais e avisos vão para as Anotações.": "What your groups sent. Accepted appointments go to My Planner; materials and notices go to Notes.",
 "O que precisa": "What's needed",
 "O que tem dentro": "What's inside",
 "O que você emprestou ou pegou emprestado: foto, com quem está e aviso da devolução.": "What you lent or borrowed: photo, who has it and a return reminder.",
 "O que é apagado": "What is deleted",
 "O quê": "What",
 "O seletor mostra o Google Drive, o OneDrive e o Dropbox quando esses apps estão instalados no celular. O app guarda só o atalho: o arquivo continua onde está e abre no app do celular.": "The picker shows Google Drive, OneDrive and Dropbox when those apps are installed on the phone. The app keeps only a shortcut: the file stays where it is and opens in the phone's app.",
 "O seletor mostra o Google Drive, o OneDrive e o Dropbox quando esses apps estão instalados no celular. O arquivo escolhido fica guardado neste dispositivo.": "The picker shows Google Drive, OneDrive and Dropbox when those apps are installed on your phone. The chosen file is saved on this device.",
 "O servidor ainda não buscou para os seus perfis.": "The server hasn't searched for your profiles yet.",
 "O servidor ainda não está preparado para as mensagens. Rode o 17-LIGAR-MENSAGENS.bat.": "The server isn't ready for messages yet. Run 17-LIGAR-MENSAGENS.bat.",
 "O servidor ainda não está preparado para indicações. Tente de novo mais tarde.": "The server isn't ready for referrals yet. Try again later.",
 "O servidor ainda não está preparado para o cartão de contato. Rode o 19-LIGAR-CONTATO.bat.": "The server isn't set up for contact cards yet. Run 19-LIGAR-CONTATO.bat.",
 "O servidor ainda não foi preparado para dados compartilhados. No computador, abra a pasta C:\\MyPlanner e dê dois cliques em 15-LIGAR-GRUPOS-COLABORATIVOS.bat (uma vez só).": "The server isn't set up for shared data yet. On the computer, open the folder C:\\MyPlanner and double-click 15-LIGAR-GRUPOS-COLABORATIVOS.bat (only once).",
 "O servidor ainda não foi preparado para o Drive e o OneDrive (veja COMO RODAR, versão 0.14).": "The server isn't set up for Drive and OneDrive yet (see COMO RODAR, version 0.14).",
 "O servidor ainda não foi preparado para o acesso pela web (rode supabase/migracao-0.6.sql).": "The server hasn't been set up for web access yet (run supabase/migracao-0.6.sql).",
 "O servidor ainda não tem a função \"qr-login\". Veja o passo da versão 0.6 no COMO RODAR.": "The server doesn't have the \"qr-login\" function yet. See the version 0.6 step in COMO RODAR.",
 "O servidor de chamadas recusou a chave do LiveKit. No computador do administrador, rode o 30-CONSERTAR-CHAMADAS.bat.": "The call server rejected the LiveKit key. On the admin's computer, run 30-CONSERTAR-CHAMADAS.bat.",
 "O servidor de notas respondeu algo inesperado (HTTP {s}). Confira o endereço.": "The invoice server returned something unexpected (HTTP {s}). Check the address.",
 "O servidor faz a captura automática de 2 em 2 horas, das 08h às 20h (horário de Brasília), mesmo com o app fechado. As publicações capturadas aparecem quando você abre o app. Também dá para usar \"Verificar agora\".": "The server captures automatically every 2 hours, from 08:00 to 20:00 (Brasília time), even with the app closed. Captured publications show up when you open the app. You can also use \"Check now\".",
 "O servidor faz a captura automática todos os dias às 08h e 12h (horário de Brasília), mesmo com o app fechado. As publicações capturadas aparecem quando você abre o app. Também dá para usar \"Verificar agora\".": "The server runs the automatic capture every day at 8 AM and 12 PM (Brasília time), even with the app closed. Captured publications appear when you open the app. You can also use \"Check now\".",
 "O servidor recusou o acesso: na função \"nuvem\" do Supabase, desligue \"Verify JWT\" (o 32-LIGAR-DRIVE-ONEDRIVE.bat já faz isso).": "The server denied access: in the Supabase \"nuvem\" function, turn off \"Verify JWT\" (32-LIGAR-DRIVE-ONEDRIVE.bat already does this).",
 "O servidor recusou o acesso: na função \"nuvem\" do Supabase, desligue \"Verify JWT\" (o 9-LIGAR-DRIVE-ONEDRIVE.bat já faz isso).": "The server refused access: in the Supabase \"nuvem\" function, turn off \"Verify JWT\" (9-LIGAR-DRIVE-ONEDRIVE.bat already does this).",
 "O seu papel no grupo não permite incluir aqui.": "Your role in the group doesn't allow adding here.",
 "O site deve começar com https://": "The website must start with https://",
 "O tamanho padrão do copo ({copo}) muda em Ajustar, no quadro da água.": "The default glass size ({copo}) can be changed under Adjust, in the water panel.",
 "O tema muda as cores das abas (os ícones continuam os mesmos) e vale nos modos claro e escuro. Depois você ainda pode trocar a cor de uma aba em Ajustes > Abas.": "The theme changes the tab colors (the icons stay the same) and applies in both light and dark mode. You can still change a tab's color later in Settings > Tabs.",
 "O temporizador se enche de cor conforme o tempo da tarefa passa. Tocar nele abre o vínculo da tarefa.": "The timer fills with color as the task's time passes. Tapping it opens the task's link.",
 "O teste grátis terminou": "The free trial has ended",
 "O texto": "The text",
 "O texto do PDF num arquivo .docx para editar.": "The PDF text in a .docx file to edit.",
 "O texto também vai escondido dentro do PDF: dá para buscar e copiar no leitor de PDF.": "The text is also hidden inside the PDF: you can search and copy it in your PDF reader.",
 "O tom escolhido fica para os próximos emojis.": "The chosen tone is kept for your next emojis.",
 "O total aparece no topo do My Planner. Se passar do limite, o raio fica vermelho. Tarefas \"Relaxar\" valem 0.": "The total appears at the top of My Planner. If it goes over the limit, the lightning bolt turns red. \"Relax\" tasks count as 0.",
 "OAB (opcional, para advogados)": "OAB (optional, for lawyers)",
 "OBS": "NOTES",
 "OCR: texto pesquisável": "OCR: searchable text",
 "OK": "OK",
 "OU ESCOLHER CÔMODO…": "OR CHOOSE A ROOM…",
 "Objetivos": "Objectives",
 "Objeto": "Item",
 "Objetos": "Objects",
 "Objetos e valores": "Items and money",
 "Obra": "Project",
 "Obras": "Projects",
 "Obras & Reformas": "Construction & Renovation",
 "Obrigado": "Thanks",
 "Obrigado!": "Thank you!",
 "Observações": "Notes",
 "Observações (alergias, ração...)": "Notes (allergies, food...)",
 "Observações (chave Pix, conta para depósito...)": "Notes (Pix key, account for deposit...)",
 "Observações (código de barras, chave Pix...)": "Notes (barcode, Pix key...)",
 "Observações (dados bancários, PIX...)": "Notes (bank details, PIX...)",
 "Observações (estado do item...)": "Notes (item condition...)",
 "Observações (garantia, seguro, CET...)": "Notes (guarantee, insurance, APR...)",
 "Observações (nº de série, modelo...)": "Notes (serial number, model...)",
 "Observações (onde está o original, categoria da CNH...)": "Notes (where the original is, license class...)",
 "Observações (recibo de entrega, número...)": "Notes (delivery receipt, number...)",
 "Observações (restrição alimentar...)": "Notes (dietary restrictions...)",
 "Ocultar texto (tarja)": "Hide text (black bar)",
 "Ocupado": "Occupied",
 "Oficina": "Mechanic",
 "Ofício": "Legal",
 "Oi!": "Hi!",
 "Oi! Tudo certo para sábado?": "Hi! All set for Saturday?",
 "Oi, {pessoa}! Ainda estou com o(a) {coisa} que você me emprestou. Quando fica bom para eu devolver?": "Hi, {pessoa}! I still have the {coisa} you lent me. When is a good time for me to return it?",
 "Oi, {pessoa}! Tudo bem? Passando para lembrar do(a) {coisa} que te emprestei em {data}. Consegue devolver {quando}?": "Hi, {pessoa}! How are you? Just a reminder about the {coisa} I lent you on {data}. Could you return it {quando}?",
 "Oi?!": "What?!",
 "Olá!": "Hi!",
 "Olá! Eu sou o Mestre Achado. Pergunte sobre os seus gastos, contas, cartões e metas: eu respondo com os seus números.": "Hi! I'm Mestre Achado. Ask about your spending, bills, cards and goals: I answer with your numbers.",
 "Olá! Passando para lembrar do pagamento de {ref} ({v}), com vencimento em {d}. Obrigado(a)!": "Hi! Just a reminder about the payment for {ref} ({v}), due on {d}. Thank you!",
 "Olá! Preciso de assistência técnica para: {item}": "Hi! I need technical support for: {item}",
 "Olá, {nome}!": "Hi, {nome}!",
 "Olá, {nome}! Seja bem-vindo(a).": "Hi, {nome}! Welcome.",
 "Ombros: girar para trás": "Shoulders: roll backward",
 "Omelete": "Omelette",
 "Onde": "Where",
 "Onde a IA ajuda: Publicações (audiências e prazos), Documentos (preencher a ficha pela foto) e Anotações (transformar uma caixa em tarefas).": "Where AI helps: Publications (court hearings and deadlines), Documents (fill in the form from a photo) and Notes (turn a box into tasks).",
 "Onde assistir": "Where to watch",
 "Onde eu mais gastei este mês?": "Where did I spend the most this month?",
 "Onde fica": "Location",
 "Onde guardar fotos e arquivos novos": "Where to store new photos and files",
 "Onde na página": "Where on the page",
 "Ontem": "Yesterday",
 "Organizar": "Organize",
 "Organizar barra": "Arrange bar",
 "Organizar com IA": "Organize with AI",
 "Organizar com IA (vira tarefas)": "Organize with AI (turns into tasks)",
 "Organizar páginas": "Organize pages",
 "Orgulho e vibrante": "Pride and vibrant",
 "Origem": "Source",
 "Origem da reserva": "Booking source",
 "Original": "Original",
 "Orquídeas": "Orchids",
 "Orçado": "Budgeted",
 "Orçamento": "Budget",
 "Orçamento do mês": "Monthly budget",
 "Orçamento por categoria": "Budget by category",
 "Orçamento total": "Total budget",
 "Orçamento: {v}": "Budget: {v}",
 "Os alertas precisam de um horário.": "Alerts need a time.",
 "Os anexos que ficam só no dispositivo não aparecem nos outros dispositivos e se perdem se o celular for trocado. Ligue o Google Drive ou o OneDrive em Ajustes para guardar uma cópia.": "Attachments kept only on the device don't show up on your other devices and are lost if you change phones. Turn on Google Drive or OneDrive in Settings to keep a copy.",
 "Os arquivos e cópias que já estão lá continuam lá. O My Planner só deixa de guardar coisas novas.": "Files and backups already there stay there. My Planner just stops saving new things.",
 "Os arquivos guardados neste dispositivo também serão apagados.": "Files stored on this device will also be deleted.",
 "Os arquivos que estão no seu Google Drive, OneDrive ou no celular continuam com você. Registros que a lei obriga a guardar (como os de acesso) podem ficar guardados pelo prazo legal e depois são apagados.": "Files in your Google Drive, OneDrive or on your phone stay with you. Records the law requires us to keep (such as access logs) may be kept for the legal period and then deleted.",
 "Os avisos do grupo ainda não foram ligados no servidor. No computador, dê dois cliques em 15-LIGAR-GRUPOS-COLABORATIVOS.bat (uma vez só).": "Group notifications haven't been turned on on the server yet. On the computer, double-click 15-LIGAR-GRUPOS-COLABORATIVOS.bat (just once).",
 "Os avisos estão desligados para o My Planner. Toque em Abrir configurações e ligue as notificações.": "Notifications are turned off for My Planner. Tap Open settings and turn notifications on.",
 "Os avisos no celular funcionam no app instalado (Android ou iPhone).": "Phone notifications work in the installed app (Android or iPhone).",
 "Os campos do formulário viram parte da página.": "Form fields become part of the page.",
 "Os dados atuais serão substituídos pelos do arquivo, aqui e na nuvem.": "Current data will be replaced by the file's data, here and in the cloud.",
 "Os dados continuam salvos na nuvem.": "Your data remains saved in the cloud.",
 "Os dados da aba ainda são só seus": "This tab's data is still only yours",
 "Os dados da aba {aba} passam a ser vistos pela equipe, cada pessoa conforme o papel que você escolher.": "The data in the {aba} tab becomes visible to the team, each person according to the role you choose.",
 "Os dados deste grupo ainda não foram liberados. Peça para quem criou o grupo abrir o My Planner atualizado: o app libera sozinho.": "This group's data hasn't been unlocked yet. Ask the person who created the group to open the updated My Planner: the app unlocks it automatically.",
 "Os dados deste grupo ainda não foram liberados. Peça para quem criou o grupo atualizar o My Planner e abrir o grupo: lá aparece o botão para liberar.": "This group's data hasn't been unlocked yet. Ask the person who created the group to update My Planner and open the group: the unlock button appears there.",
 "Os dados do cofre são criptografados aqui no dispositivo (AES-256) antes de ir para a nuvem. Nem o suporte consegue ler. Se esquecer a senha do cofre, esses dados não podem ser recuperados.": "Vault data is encrypted here on the device (AES-256) before going to the cloud. Not even support can read it. If you forget the vault password, this data cannot be recovered.",
 "Os dados ficam guardados enquanto a conta existir. Ao apagar a conta, os dados são apagados, salvo o que a lei obrigar a manter.": "Data is kept for as long as the account exists. When you delete the account, the data is deleted, except what the law requires us to keep.",
 "Os desenhos não conferem. Comece de novo.": "The patterns don't match. Start over.",
 "Os dias estão no app ou na fatura do banco. Compras feitas depois do fechamento caem na fatura seguinte.": "The days are in the app or on the bank statement. Purchases made after the closing date go on the next statement.",
 "Os emojis que você usar aparecem aqui.": "Emojis you use show up here.",
 "Os grupos ainda não foram ligados no servidor. No computador, abra a pasta C:\\MyPlanner e dê dois cliques em 11-LIGAR-GRUPOS.bat (uma vez só).": "Groups haven't been set up on the server yet. On the computer, open the C:\\MyPlanner folder and double-click 11-LIGAR-GRUPOS.bat (just once).",
 "Os grupos ainda não foram ligados no servidor. Rode o supabase\\migracao-0.21.sql no Supabase (veja o COMO RODAR).": "Groups haven't been enabled on the server yet. Run supabase\\migracao-0.21.sql in Supabase (see COMO RODAR).",
 "Os lugares abrem no Google Maps, no Waze ou no Mapas, como escolhido em Ajustes.": "Places open in Google Maps, Waze or Maps, as chosen in Settings.",
 "Os membros sempre veem os administradores e só recebem o que foi enviado para eles.": "Members always see the admins and only receive what was sent to them.",
 "Os outros membros deixam de ver os dados (a cópia some do dispositivo deles). Tudo continua com você.": "Other members stop seeing the data (the copy is removed from their devices). Everything stays with you.",
 "Os perfis e os resultados ficam na sua conta do My Planner.": "Profiles and results are stored in your My Planner account.",
 "Os perfis, as OABs e os tribunais ficam dentro da aba Publicações. A busca automática roda no servidor às 08h e às 12h (horário de Brasília).": "Profiles, OAB numbers and courts are inside the Publications tab. The automatic search runs on the server at 08:00 and 12:00 (Brasília time).",
 "Os preços ficam guardados e aparecem na lista de Compras da aba Alimentação & Despensa como o preço da última compra.": "Prices are saved and show up in the Shopping list of the Food & Pantry tab as the last purchase price.",
 "Os resultados deste perfil também serão apagados.": "This profile's results will also be deleted.",
 "Os termos foram atualizados": "The terms have been updated",
 "Ou digite (ex.: 2 ovos mexidos)": "Or type (e.g. 2 scrambled eggs)",
 "Ou escreva o prato": "Or type the dish",
 "Ou escreva o seu": "Or type your own",
 "Outra": "Other",
 "Outra aba…": "Another tab…",
 "Outra atividade (digite e dê Enter)": "Other activity (type and press Enter)",
 "Outro": "Other",
 "Outro (ml)": "Other (ml)",
 "Outro valor": "Other amount",
 "Outros": "Other",
 "Outros países": "Other countries",
 "Outros relógios (Garmin, Samsung, Xiaomi, Amazfit...): no app do relógio, ligue a opção de enviar os dados para o app Saúde (Apple Health).": "Other watches (Garmin, Samsung, Xiaomi, Amazfit...): in the watch's app, turn on the option to send data to the Health app (Apple Health).",
 "Ovo": "Egg",
 "PAGO, RECEBIDO, CONFIDENCIAL, APROVADO ou o seu texto, com a data.": "PAID, RECEIVED, CONFIDENTIAL, APPROVED or your own text, with the date.",
 "PARA ACERTAR": "TO SETTLE",
 "PARA QUEM": "SEND TO",
 "PARA {refeicao}": "FOR {refeicao}",
 "PASSO A PASSO": "STEP BY STEP",
 "PASSO {n}": "STEP {n}",
 "PDF": "PDF",
 "PDF Edit": "PDF Edit",
 "PDF com texto digital: sai na hora no navegador. PDF escaneado (foto): a sua IA lê cada página.": "PDF with digital text: done instantly in the browser. Scanned PDF (photo): your AI reads each page.",
 "PDF grande": "Large PDF",
 "PDF guardado na pasta \"{pasta}\" do celular.": "PDF saved in the \"{pasta}\" folder on your phone.",
 "PDF guardado no {nome}.": "PDF saved to {nome}.",
 "PDF numa página só": "PDF on a single page",
 "PDF para Word": "PDF to Word",
 "PDF para imagens": "PDF to images",
 "PDF para texto": "PDF to text",
 "PDFs arquivados ({n})": "Archived PDFs ({n})",
 "PDFs juntados {data}": "Merged PDFs {data}",
 "PEDIDOS RECEBIDOS": "RECEIVED REQUESTS",
 "PIX": "PIX",
 "PIX COPIA E COLA": "PIX COPY AND PASTE",
 "PRÓXIMAS FATURAS (JÁ COMPROMETIDO)": "UPCOMING STATEMENTS (ALREADY COMMITTED)",
 "Paciente": "Patient",
 "Paciente ou aluno": "Patient or student",
 "Pacientes": "Patients",
 "Padrão": "Default",
 "Padrão da aba": "Tab default",
 "Paga": "Paid",
 "Paga (toque para desfazer)": "Paid (tap to undo)",
 "Pagador": "Payer",
 "Pagamento já contado": "Payment already counted",
 "Pagar": "Pay",
 "Pagar parcela {n}/{t} · {c}": "Pay installment {n}/{t} · {c}",
 "Pagas": "Paid",
 "Pago": "Paid",
 "Pago com": "Paid with",
 "Pago: {p} · Falta pagar: {f}": "Paid: {p} · Left to pay: {f}",
 "Pagos": "Paid",
 "Pagou {v}? Se teve desconto, multa ou juros, informe o valor pago. Quer guardar o comprovante agora?": "Paid {v}? If you got a discount or paid late fees or interest, enter the amount paid. Save the receipt now?",
 "Paguei outro valor (desconto, multa ou juros)": "I paid a different amount (discount, late fees or interest)",
 "Paixão de Cristo": "Good Friday",
 "Palavras-chave (separe com vírgula)": "Keywords (separate with commas)",
 "Para a meta \"{m}\" chegar no prazo, seriam {v} por mês. Vale esticar o prazo ou começar com um valor menor.": "For the goal \"{m}\" to arrive on time, it would take {v} a month. Consider extending the deadline or starting with a smaller amount.",
 "Para clareza, firmo o presente.": "In witness whereof, I sign this document.",
 "Para comprar": "To buy",
 "Para continuar, digite a senha do app.": "To continue, enter the app password.",
 "Para conversar, ligue a sua IA em Ajustes › Inteligência artificial (Claude, ChatGPT ou Gemini).": "To chat, turn on your AI in Settings › Artificial intelligence (Claude, ChatGPT or Gemini).",
 "Para dividir as despesas, escreva em \"Quem vai\" os nomes separados por vírgula (edite a viagem).": "To split expenses, write the names separated by commas in \"Who's going\" (edit the trip).",
 "Para emitir e buscar notas, ligue uma vez o servidor de notas: no computador, dê dois cliques em 13-LIGAR-NOTAS.bat e cole aqui o endereço que ele mostrar (termina em .netlify.app).": "To issue and search invoices, turn on the invoice server once: on the computer, double-click 13-LIGAR-NOTAS.bat and paste here the address it shows (it ends in .netlify.app).",
 "Para exercer seus direitos, use Fale conosco no app ou escreva para o e-mail abaixo. Respondemos em até 15 dias.": "To exercise your rights, use Contact us in the app or write to the email below. We reply within 15 days.",
 "Para fazer chamadas de áudio e vídeo, instale a versão nova do app (0.35). As mensagens já funcionam.": "To make audio and video calls, install the new version of the app (0.35). Messages already work.",
 "Para fazer o app funcionar: guardar e sincronizar seus dados entre dispositivos, mandar alertas, compartilhar com os grupos que você escolheu e dar suporte.": "To make the app work: store and sync your data across devices, send alerts, share with the groups you chose and provide support.",
 "Para guardar os PDFs no {nome}, conecte a sua conta em Ajustes › Google Drive e OneDrive.": "To save PDFs to {nome}, connect your account in Settings › Google Drive and OneDrive.",
 "Para hoje": "For today",
 "Para ler foto ou PDF, ligue a sua IA em Ajustes › Inteligência artificial (Claude, ChatGPT ou Gemini). O extrato em OFX ou CSV funciona sem IA.": "To read a photo or PDF, turn on your AI in Settings › Artificial intelligence (Claude, ChatGPT or Gemini). OFX or CSV statements work without AI.",
 "Para ler o relógio automaticamente, instale a versão nova do app (0.33). Enquanto isso, dá para digitar à mão.": "To read your watch automatically, install the new app version (0.33). Meanwhile, you can enter it manually.",
 "Para ler o relógio, conecte pelo app no celular. Os números aparecem aqui também.": "To read your watch, connect through the app on your phone. The numbers show up here too.",
 "Para ler o relógio, libere os dados de atividade para o My Planner.": "To read your watch, allow My Planner to access activity data.",
 "Para ler o texto, resumir e perguntar, ligue a sua IA em Ajustes › Inteligência artificial (Claude, ChatGPT ou Gemini).": "To read the text, summarize and ask questions, turn on your AI in Settings › Artificial intelligence (Claude, ChatGPT or Gemini).",
 "Para ligar, use o app no celular (Ajustes > Agenda do Google). Depois, tudo aparece aqui também.": "To turn it on, use the app on your phone (Settings > Google Calendar). Then everything shows up here too.",
 "Para ligar, use o app no celular (Ajustes › Configuração geral › Agenda do Google). Depois, tudo aparece aqui também.": "To turn it on, use the app on your phone (Settings › General settings › Google Calendar). Then everything shows up here too.",
 "Para monitorar a OAB, informe o número e a UF.": "To monitor an OAB number, enter the number and the state.",
 "Para não perguntar mais, escolha o app em Ajustes › Configuração geral.": "To stop asking, choose the app in Settings › General settings.",
 "Para profissionais de saúde: pacientes, evolução no cofre, prescrições com modelos, financeiro, recibo e declaração para reembolso em PDF.": "For health professionals: patients, progress notes in the vault, prescriptions with templates, finances, receipt and reimbursement statement in PDF.",
 "Para profissionais de saúde: pacientes, evolução, prescrições com modelos, financeiro com convênio, recibo e declaração para reembolso.": "For health professionals: patients, progress notes, prescriptions with templates, finances with health plans, receipt and reimbursement statement.",
 "Para proteger a sua conta, confirmamos o seu celular uma vez, com um código pelo WhatsApp. Ele só é pedido de novo se você trocar de número.": "To protect your account, we confirm your phone once, with a code via WhatsApp. It's only requested again if you change your number.",
 "Para quem aluga o imóvel ou um cômodo por temporada (Airbnb, Booking ou direto): reservas, limpeza, despesas e o lucro de cada mês.": "For anyone renting out a property or a room short-term (Airbnb, Booking or direct): bookings, cleaning, expenses and each month's profit.",
 "Para receber a agenda, o local e os avisos do evento no celular, entre no grupo: {link}": "To get the event's schedule, place and notices on your phone, join the group: {link}",
 "Para sincronizar, libere o acesso à agenda para o My Planner nas configurações do celular.": "To sync, allow My Planner to access your calendar in your phone's settings.",
 "Para tirar uma permissão que você já deu ao sistema (câmera, fotos, microfone), use também os ajustes do celular.": "To remove a permission you've already given the system (camera, photos, microphone), also use your phone's settings.",
 "Para uma leitura mais completa, ligue a sua IA em Ajustes › Inteligência artificial.": "For a more complete reading, turn on your AI in Settings › Artificial intelligence.",
 "Parabéns": "Congrats",
 "Parabéns!": "Congrats!",
 "Parada": "Still",
 "Parar": "Stop",
 "Parar de compartilhar?": "Stop sharing?",
 "Parar e salvar": "Stop and save",
 "Parar gravação": "Stop recording",
 "Parcela": "Installment",
 "Parcela de financiamento": "Financing installment",
 "Parcela {n}/{t}": "Installment {n}/{t}",
 "Parcela {n}/{t} · {c}": "Installment {n}/{t} · {c}",
 "Parcelas": "Installments",
 "Parcelas a pagar nos próximos meses": "Installments due in the coming months",
 "Parcelas recalculadas": "Installments recalculated",
 "Parece que foi impresso e escaneado.": "Looks like it was printed and scanned.",
 "Parei": "Stopped",
 "Parei na aula": "Stopped at lesson",
 "Parei na aula...": "Stopped at lesson...",
 "Pares de meia": "Pairs of socks",
 "Parque ou natureza": "Park or nature",
 "Parques": "Parks",
 "Parte": "Party",
 "Partes": "Parties",
 "Participa": "Participant",
 "Participantes": "Participants",
 "Participação em empresa": "Stake in a company",
 "Passa do limite do MEI: fale com seu contador.": "Exceeds the MEI limit: talk to your accountant.",
 "Passaporte": "Passport",
 "Passe o dedo sobre o desenho para apagar só aquele pedaço.": "Drag your finger over the drawing to erase just that part.",
 "Passeio": "Tour",
 "Passeios": "Tours",
 "Passo a passo": "Step by step",
 "Passos": "Steps",
 "Passos, exercício, calorias, batimentos e sono": "Steps, exercise, calories, heart rate and sleep",
 "Passou do orçamento": "Over budget",
 "Passou do orçamento em {v}": "Over budget by {v}",
 "Pasta": "Folder",
 "Patrimônio": "Assets",
 "Patrimônio & Imposto de Renda": "Assets & Income Tax",
 "Patrimônio pelo valor de compra: {v}": "Assets at purchase price: {v}",
 "Pausa (s)": "Rest (s)",
 "Pausa de {m} min": "{m} min break",
 "Pausado": "Paused",
 "Pausar": "Pause",
 "Pausas": "Breaks",
 "Pausas de estudo": "Study breaks",
 "Pauta (opcional)": "Agenda (optional)",
 "Paz": "Peace",
 "Pediatra": "Pediatrician",
 "Pedido": "Request",
 "Pedido enviado para {nome}. Quando aceitar, vocês já podem conversar.": "Request sent to {nome}. Once they accept, you can start chatting.",
 "Pedido enviado. Quando a pessoa aceitar, vocês já podem conversar.": "Request sent. Once the person accepts, you can start chatting.",
 "Pedidos de documentos": "Document requests",
 "Pedir de novo depois de": "Ask again after",
 "Peguei emprestado": "I borrowed",
 "Peito de frango": "Chicken breast",
 "Peixe": "Fish",
 "Pela última compra: cerca de {v}": "Based on the last purchase: about {v}",
 "Pelas contas que ainda vencem este mês, vão faltar {v}. Veja o que dá para adiar ou cortar antes de assumir gasto novo.": "With the bills still due this month, you'll be short {v}. See what you can postpone or cut before taking on new spending.",
 "Pendente": "Pending",
 "Pensão alimentícia": "Child support",
 "Pequena": "Small",
 "Pequeno": "Small",
 "Percentual de tributos do Simples (para sair na nota)": "Simples tax percentage (shown on the invoice)",
 "Perguntar ao Mestre": "Ask the Mestre",
 "Perguntar sempre": "Always ask",
 "Pergunte ao Mestre...": "Ask the Mestre...",
 "Pergunte sobre o documento (ex.: qual o prazo?)": "Ask about the document (e.g. what's the deadline?)",
 "Permissões": "Permissions",
 "Personalizado": "Custom",
 "Perto do limite do orçamento": "Close to budget limit",
 "Período": "Date range",
 "Período da meta": "Goal period",
 "Pescoço: inclinar para os lados": "Neck: tilt side to side",
 "Peso": "Weight",
 "Peso na média": "Weight in average",
 "Pesquisar no mapa": "Search on map",
 "Pessoa": "Person",
 "Pessoa de contato": "Contact person",
 "Pessoas dos seus grupos veem só o que for compartilhado no grupo.": "People in your groups only see what is shared in the group.",
 "Pet": "Pet",
 "Pet & Família": "Pets & Family",
 "Pet shop": "Pet shop",
 "Pet shop ou clínica": "Pet shop or clinic",
 "Pets": "Pets",
 "Peça documentos ao cliente com prazo. Ele recebe, anexa e marca como entregue.": "Request documents from the client with a deadline. They receive it, attach the files and mark it as delivered.",
 "Pijamas": "Pajamas",
 "Pilates": "Pilates",
 "Pintura": "Painting",
 "Pix copia e cola": "Pix copy and paste",
 "Placa": "License plate",
 "Planejado": "Planned",
 "Planejado e comido": "Planned and eaten",
 "Planilha": "Spreadsheet",
 "Planilha (Excel)": "Spreadsheet (Excel)",
 "Planilha do mês para o Receita Saúde": "Monthly spreadsheet for Receita Saúde",
 "Planner": "Planner",
 "Plano básico: My Planner + Anotações": "Basic plan: My Planner + Notes",
 "Plano de aula": "Lesson plan",
 "Plano de saúde": "Health insurance",
 "Planos de aula": "Lesson plans",
 "Planta": "Plant",
 "Plantas": "Plants",
 "Plantas & Jardim": "Plants & Garden",
 "Plataforma ou escola": "Platform or school",
 "Pneus novos": "New tires",
 "Podcast": "Podcast",
 "Pode confirmar sua presença respondendo esta mensagem?": "Can you confirm your attendance by replying to this message?",
 "Polichinelo": "Jumping jacks",
 "Polo ativo": "Plaintiff",
 "Polo passivo": "Defendant",
 "Política de privacidade (LGPD)": "Privacy policy (LGPD)",
 "Política de privacidade, LGPD e permissões": "Privacy policy, LGPD and permissions",
 "Política de privacidade, LGPD e termos": "Privacy policy, LGPD and terms",
 "Ponha aqui as fotos e os vídeos da viagem. No grupo, todos veem e todos podem pôr as suas.": "Put the trip's photos and videos here. In the group, everyone sees them and everyone can add their own.",
 "Ponte de glúteos": "Glute bridge",
 "Ponto facultativo": "Optional holiday",
 "Ponto facultativo: {nome}": "Optional holiday: {nome}",
 "Ponto turístico": "Attraction",
 "Pontos turísticos": "Tourist attractions",
 "Por dia": "Per day",
 "Por faixas": "By ranges",
 "Por mês": "Per month",
 "Por nome": "By name",
 "Por semana": "Per week",
 "Portal": "Portal",
 "Portal do Cliente": "Client Portal",
 "Portal do cliente (convidar o cliente)": "Client portal (invite the client)",
 "Português": "Português",
 "Porão": "Basement",
 "Porções": "Servings",
 "Pouco espaço livre: fotos e anexos novos podem não ser salvos. Libere espaço ou guarde os anexos no Google Drive ou OneDrive.": "Low free space: new photos and attachments may not be saved. Free up space or store attachments on Google Drive or OneDrive.",
 "Praia": "Beach",
 "Prancha": "Plank",
 "Prato do cardápio": "Menu dish",
 "Prato principal": "Main course",
 "Prazo": "Deadline",
 "Prazo (pagamento ou entrega)": "Deadline (payment or delivery)",
 "Prazo até {fim} · fazer em {dia}": "Deadline {fim} · do it on {dia}",
 "Prazo final: {fim}": "Final deadline: {fim}",
 "Prazo: {d}": "Deadline: {d}",
 "Prazo: {t}": "Deadline: {t}",
 "Prazos criados": "Deadlines created",
 "Precisa da sua IA": "Needs your AI",
 "Preencha a descrição, o código de tributação nacional (6 números) e o valor.": "Fill in the description, the national tax code (6 digits) and the amount.",
 "Preenche os campos do PDF e, se quiser, trava.": "Fills in the PDF fields and, if you want, locks them.",
 "Preencher formulário": "Fill form",
 "Preencher pela foto com a minha IA": "Fill in from photo with my AI",
 "Preencher pela nota fiscal com a minha IA": "Fill in from the receipt with my AI",
 "Preparando a conversa da equipe...": "Setting up the team chat...",
 "Preparando a página {n} de {total}...": "Preparing page {n} of {total}...",
 "Preparando o arquivo": "Preparing file",
 "Prescrição, conduta e orientações": "Prescription, plan and instructions",
 "Presente": "Present",
 "Presença": "Attendance",
 "Pressione e segure o código para copiar, ou toque em Enviar e escolha \"Copiar\".": "Press and hold the code to copy it, or tap Send and choose \"Copy\".",
 "Pressione e segure o código para copiar.": "Press and hold the code to copy it.",
 "Pressione e segure um lançamento para apagar.": "Press and hold an entry to delete it.",
 "Pressione e segure um perfil para removê-lo.": "Press and hold a profile to remove it.",
 "Preto e branco": "Black and white",
 "Previdência privada": "Private pension",
 "Preço ou ingresso": "Price or ticket",
 "Price": "Fixed payment (Price)",
 "Primeira": "First",
 "Primeira cota ou cota única do IR": "First or single income tax installment",
 "Primeira parcela na fatura de {mes}, que vence {data}.": "First installment on the {mes} statement, due {data}.",
 "Prioridade": "Priority",
 "Privacidade": "Privacy",
 "Privacidade e termos": "Privacy and terms",
 "Privacidade: o texto ou a imagem analisada vai direto deste dispositivo para a empresa da IA escolhida, com a sua chave. O My Planner não guarda cópia.": "Privacy: the text or image analyzed goes straight from this device to the chosen AI company, using your key. My Planner keeps no copy.",
 "Problema": "Problem",
 "Problemas, erros e sugestões": "Problems, bugs and suggestions",
 "Procedimento": "Procedure",
 "Procedimento: {c}": "Procedure: {c}",
 "Processo": "Case",
 "Processo Civil": "Civil Procedure",
 "Processo Penal": "Criminal Procedure",
 "Processo do Trabalho": "Labor Procedure",
 "Processo não informado": "Case number not provided",
 "Proclamação da República": "Republic Proclamation Day",
 "Procurando a folha...": "Looking for the page...",
 "Procurando atualização...": "Checking for updates...",
 "Procurar aba": "Search tabs",
 "Procurar atualização agora": "Check for updates now",
 "Procurar documento": "Search documents",
 "Procurar ferramenta (ex.: juntar, assinar, comprimir)": "Search tools (e.g. merge, sign, compress)",
 "Produto": "Product",
 "Produto (ex.: Geladeira)": "Product (e.g., Refrigerator)",
 "Produtos, notas fiscais, assistência técnica e aviso antes de vencer.": "Products, invoices, service centers and alerts before expiration.",
 "Produção (vale de verdade)": "Production (legally valid)",
 "Produção restrita (teste)": "Restricted production (test)",
 "Produção restrita (teste, não vale)": "Restricted production (test, not valid)",
 "Produção restrita: ambiente de teste do governo. As notas não valem. Teste tudo aqui antes de mudar para Produção (em Editar).": "Restricted production: the government's test environment. Invoices aren't valid. Test everything here before switching to Production (in Edit).",
 "Produção: as notas emitidas valem de verdade e vão para a prefeitura e a Receita.": "Production: issued invoices are legally valid and go to the city hall and the Federal Revenue.",
 "Produção: vale de verdade": "Production: legally valid",
 "Professor": "Teacher",
 "Professor & Mentoria": "Teaching & Mentoring",
 "Professor(a)": "Teacher",
 "Profissionais": "Professionals",
 "Profissional": "Professional",
 "Profissional assistente": "Assistant professional",
 "Profissional ou fornecedor": "Professional or vendor",
 "Profissional ou local": "Professional or place",
 "Profissão ou especialidade": "Profession or specialty",
 "Profissões": "Professions",
 "Programação": "Programming",
 "Progresso geral": "Overall progress",
 "Projeto e licenças": "Design and permits",
 "Projetos": "Projects",
 "Prontas": "Ready-made",
 "Pronto": "Done",
 "Pronto! Todas as abas estão liberadas até {data}.": "Done! All tabs are unlocked until {data}.",
 "Pronto. Bloqueie a tela e espere 1 minuto: o aviso deve aparecer com som.": "Done. Lock the screen and wait 1 minute: the alert should appear with sound.",
 "Prontuário, evolução e prescrições, sem o financeiro.": "Medical records, progress notes and prescriptions, without finances.",
 "Protegendo a chave...": "Protecting the key...",
 "Proteger no cofre": "Protect in the vault",
 "Protegido": "Protected",
 "Protegido no cofre": "Protected in the vault",
 "Protegidos pelo cofre: {n}": "Protected by the vault: {n}",
 "Protetor solar": "Sunscreen",
 "Protocolo": "Protocol number",
 "Prova": "Test",
 "Próxima": "Next",
 "Próxima até a data": "Next by date",
 "Próxima com quantos km": "Next at mileage",
 "Próxima dose": "Next dose",
 "Próxima: {data}": "Next: {data}",
 "Próxima: {d} · {v}": "Next: {d} · {v}",
 "Próximas": "Upcoming",
 "Próximo": "Next",
 "Próximo ano": "Next year",
 "Próximo número da DPS": "Next DPS number",
 "Próximos 7 dias": "Next 7 days",
 "Próximos vencimentos ({n})": "Upcoming due dates ({n})",
 "Publicação": "Publication",
 "Publicações": "Publications",
 "Pula": "Jump",
 "Pulsa": "Pulse",
 "Punho": "Fist",
 "Puxada frontal": "Lat pulldown",
 "PÁGINAS": "PAGES",
 "PÔR NA BARRA": "ADD TO BAR",
 "Pág. {n}": "Pg. {n}",
 "Página": "Page",
 "Página 1": "Page 1",
 "Página 1 de 10": "Page 1 of 10",
 "Página em branco no fim": "Blank page at the end",
 "Página em que estou": "Page I'm on",
 "Página escaneada": "Page scanned",
 "Página inteira": "Full page",
 "Página {a} de {n}": "Page {a} of {n}",
 "Página {n}": "Page {n}",
 "Página {n} de {total}": "Page {n} of {total}",
 "Página: {titulo}": "Page: {titulo}",
 "Páginas": "Pages",
 "Páginas, tamanho, autor, datas e campos.": "Pages, size, author, dates and fields.",
 "Pássaro": "Bird",
 "Pão francês": "Bread roll",
 "Pão integral": "Whole wheat bread",
 "Pôr a data de hoje": "Add today's date",
 "Pôr as parcelas no My Planner": "Add installments to My Planner",
 "Pôr na barra": "Add to bar",
 "Pôr no roteiro da viagem": "Add to trip itinerary",
 "Pôr uma foto": "Add a photo",
 "Quadro": "Board",
 "Quadro Kanban, cronômetro de horas por cliente e prazos no My Planner.": "Kanban board, hours timer per client and deadlines in My Planner.",
 "Quais contas vencem nos próximos dias?": "Which bills are due in the next few days?",
 "Quais páginas ficam no PDF novo": "Which pages go in the new PDF",
 "Quais páginas sair": "Which pages to remove",
 "Qual IA": "Which AI",
 "Qualidade alta": "High quality",
 "Qualidade boa (menor)": "Good quality (smaller)",
 "Quantidade": "Quantity",
 "Quanto cortar de cada lado (% da página)": "How much to trim from each side (% of page)",
 "Quanto já tem guardado (opcional)": "Amount already saved (optional)",
 "Quanto paga por limpeza": "Pay per cleaning",
 "Quanto preciso guardar por mês para as minhas metas?": "How much do I need to save per month for my goals?",
 "Quanto quer juntar": "How much you want to save",
 "Quanto você quer gastar, no máximo, em cada categoria por mês. Deixe em branco para não controlar.": "The most you want to spend in each category per month. Leave blank to not track it.",
 "Quarta": "Wednesday",
 "Quarta-feira de Cinzas (até 14h)": "Ash Wednesday (until 2 PM)",
 "Quarto": "Bedroom",
 "Quarto das crianças": "Kids' room",
 "Quarto de casal": "Master bedroom",
 "Quarto de hóspedes": "Guest room",
 "Quarto infantil": "Kids' room",
 "Queijo": "Cheese",
 "Queixa principal": "Main complaint",
 "Quem abrir o link baixa o My Planner (ou usa no navegador), entra na conta e passa a fazer parte do grupo.": "Whoever opens the link downloads My Planner (or uses it in the browser), signs in and joins the group.",
 "Quem criar a conta com o seu código já vira seu amigo aqui, sem precisar pedir.": "Anyone who signs up with your code becomes your friend here automatically, no request needed.",
 "Quem enviou": "Sent by",
 "Quem está num grupo do app com você (turma, família, viagem...) já pode conversar sem ser amigo. Segure um amigo para desfazer a amizade ou bloquear.": "Anyone in an app group with you (class, family, trip...) can already chat without being friends. Press and hold a friend to unfriend or block.",
 "Quem faz a limpeza": "Who cleans",
 "Quem paga, se não for o paciente (mãe, pai, responsável)": "Who pays, if not the patient (mother, father, guardian)",
 "Quem pagou": "Who paid",
 "Quem recebeu (médico, escola...)": "Recipient (doctor, school...)",
 "Quem vai": "Who's going",
 "Quem vai limpar": "Who will clean",
 "Quem vê: só quem conversa com você, os seus amigos e quem está num grupo do app com você. Deixe em branco o que não quiser mostrar.": "Who can see it: only people who chat with you, your friends and people in an app group with you. Leave blank anything you don't want to show.",
 "Quente": "Hot",
 "Quer escanear mais uma página?": "Scan another page?",
 "Quer guardar o comprovante agora? Foto, PDF ou print do Pix.": "Save the receipt now? Photo, PDF or Pix screenshot.",
 "Quer mandar um print da tela? Envie por e-mail e anexe a imagem.": "Want to send a screenshot? Send it by email and attach the image.",
 "Quer trocar pelos novos ou manter os dois?": "Replace them with the new ones or keep both?",
 "Quero assistir": "Want to watch",
 "Quero ir": "Want to go",
 "Quero ler": "Want to read",
 "Quero ver": "Want to watch",
 "Quilometragem atual": "Current mileage",
 "Quilometragem: {km}": "Mileage: {km}",
 "Quinta": "Thursday",
 "Quintal": "Backyard",
 "Quitado": "Paid off",
 "Quitados": "Paid off",
 "Química": "Chemistry",
 "RECIBO": "RECEIPT",
 "RG / Carteira de identidade": "ID card (RG)",
 "RG, CNH, passaporte, contratos e certidões, com aviso antes de vencer e envio com um toque.": "ID, driver's license, passport, contracts and certificates, with reminders before they expire and one-tap sending.",
 "Raciocínio Lógico": "Logical Reasoning",
 "Razão social ou nome": "Company name or name",
 "Razão social ou nome do consultório": "Company or practice name",
 "Razão social ou nome fantasia": "Company name or trade name",
 "Raça": "Breed",
 "Realizado": "Done",
 "Recado": "Message",
 "Recalcular": "Recalculate",
 "Recalcular as parcelas em aberto": "Recalculate open installments",
 "Recalcular as parcelas?": "Recalculate installments?",
 "Receber": "Receive",
 "Receber de volta: {i} ({p})": "Get back: {i} ({p})",
 "Receber o código no WhatsApp": "Get the code on WhatsApp",
 "Receber parcela {n}/{t} · {c}": "Receive installment {n}/{t} · {c}",
 "Recebeu um convite?": "Got an invite?",
 "Recebeu um código?": "Got a code?",
 "Recebi de {pagador}{doc}, a quantia de {valor}{extenso}, referente a {tipo} realizado(a) em {data}{paciente}.": "I received from {pagador}{doc} the sum of {valor}{extenso}, for {tipo} held on {data}{paciente}.",
 "Recebi outro valor": "I received a different amount",
 "Recebida": "Received",
 "Recebida (toque para desfazer)": "Received (tap to undo)",
 "Recebidas": "Received",
 "Recebido": "Received",
 "Recebido: {v}": "Received: {v}",
 "Recebidos": "Received",
 "Recebidos dos grupos": "Received from groups",
 "Recebimento": "Payment received",
 "Receita": "Recipe",
 "Receitas": "Recipes",
 "Recibo": "Receipt",
 "Recibo em PDF": "PDF receipt",
 "Recibo emitido": "Receipt issued",
 "Recibo guardado": "Receipt saved",
 "Recibos dedutíveis": "Deductible receipts",
 "Recomendada": "Recommended",
 "Recomeçar": "Start over",
 "Recortar": "Crop",
 "Recortar margens": "Crop margins",
 "Recortar, girar e os filtros chegam com o app novo (versão 0.49).": "Crop, rotate and filters come with the new app (version 0.49).",
 "Recusada": "Declined",
 "Recusado": "Declined",
 "Recusar": "Decline",
 "Redação": "Essay Writing",
 "Refazer": "Redo",
 "Refeição": "Meal",
 "Refeições, exercícios, cuidados e suplementos marcados para hoje": "Meals, workouts, care and supplements scheduled for today",
 "Referente a": "For",
 "Referência": "Reference",
 "Reforço": "Booster",
 "Regar a cada quantos dias": "Water every how many days",
 "Regar hoje": "Water today",
 "Regar: {p}": "Water: {p}",
 "Regional": "Regional",
 "Registra o diário, as etapas e as entregas, sem ver os valores.": "Writes the log, stages and deliveries, without seeing amounts.",
 "Registrar venda/serviço do MEI": "Record MEI sale/service",
 "Registre cada atendimento: a evolução fica no cofre, com criptografia. A prescrição pode vir de um modelo.": "Log each appointment: progress notes stay in the vault, encrypted. The prescription can come from a template.",
 "Registre compras e vendas de imóveis, veículos e investimentos com os comprovantes. Ajuda muito na hora do imposto.": "Record purchases and sales of property, vehicles and investments with the receipts. It helps a lot at tax time.",
 "Registre o que foi diferente do cronograma (trocou um alimento, mudou a refeição). Entra no relatório da semana.": "Log what was different from the schedule (swapped a food, changed the meal). It goes into the weekly report.",
 "Registro": "Entry",
 "Registro clínico": "Medical record",
 "Registro de horas": "Time entry",
 "Registro do diário": "Log entry",
 "Regiões com feriado próprio (marque as suas):": "Regions with their own holidays (select yours):",
 "Regras da casa": "House rules",
 "Regras da casa:": "House rules:",
 "Reguei": "Watered",
 "Reguei hoje": "Watered today",
 "Reiniciar": "Restart",
 "Reiniciar o app": "Restart the app",
 "Relatório": "Report",
 "Relatório da semana": "Weekly report",
 "Relatório em PDF ou Excel": "PDF or Excel report",
 "Relatório enviado. Obrigado!": "Report sent. Thank you!",
 "Relatórios": "Reports",
 "Relatórios do Bem-Estar": "Wellness reports",
 "Relatórios gerados ({n})": "Generated reports ({n})",
 "Relaxar": "Relax",
 "Religião": "Religion",
 "Relógio": "Clock",
 "Relógio e apps de saúde": "Watch and health apps",
 "Remada baixa": "Seated cable row",
 "Remover": "Remove",
 "Remover \"{nome}\"?": "Remove \"{nome}\"?",
 "Remover anotações": "Remove annotations",
 "Remover este bloco?": "Remove this block?",
 "Remover páginas": "Remove pages",
 "Remover vínculo": "Remove link",
 "Remover {nome}?": "Remove {nome}?",
 "Remédio": "Medicine",
 "Remédio contínuo": "Ongoing medicine",
 "Remédio na linha do tempo": "Medicine on the timeline",
 "Remédios": "Medicines",
 "Remédios de uso contínuo": "Regular medicines",
 "Renavam ou chassi": "Renavam or chassis number",
 "Renegociado": "Renegotiated",
 "Renomear": "Rename",
 "Renomear com IA": "Rename with AI",
 "Renomear ou trocar ícone": "Rename or change icon",
 "Renomear pasta": "Rename folder",
 "Renomear, ícone ou cor": "Rename, icon or color",
 "Renovar: {nome}": "Renew: {nome}",
 "Reorganiza o arquivo por dentro. Ajuda pouco em PDFs com fotos.": "Reorganizes the file internally. Helps little with photo PDFs.",
 "Reparar PDF": "Repair PDF",
 "Repelente": "Insect repellent",
 "Repete": "Repeats",
 "Repetir a cada quantos dias": "Repeat every how many days",
 "Repetições": "Reps",
 "Repita a senha": "Repeat password",
 "Repita a senha do cofre": "Repeat the vault password",
 "Repita a senha nova": "Repeat the new password",
 "Replantio": "Repotting",
 "Replantios": "Repottings",
 "Repor papel higiênico, sabonete e café": "Restock toilet paper, soap and coffee",
 "Representatividade": "Representation",
 "Reserva": "Booking",
 "Reservas": "Bookings",
 "Reservas, limpeza, receitas e despesas na aba Aluguel & Hospedagem": "Bookings, cleaning, income and expenses in the Rentals & Stays tab",
 "Respirar fundo 5 vezes": "Take 5 deep breaths",
 "Respondendo a {nome}": "Replying to {nome}",
 "Responder": "Reply",
 "Responsável": "In charge",
 "Responsável (imobiliária, vistoriador)": "In charge (agency, inspector)",
 "Resposta da SEFAZ": "SEFAZ response",
 "Resta {tempo}": "{tempo} left",
 "Restam {ml} = {n} copo(s) de {copo}": "{ml} left = {n} glass(es) of {copo}",
 "Restaurante": "Restaurant",
 "Restaurantes": "Restaurants",
 "Restaurar": "Restore",
 "Restaurar esta cópia?": "Restore this backup?",
 "Restaurar troca TODOS os dados atuais pelos da cópia, aqui e na sua conta.": "Restoring replaces ALL current data with the backup's, here and in your account.",
 "Restaurar uma cópia": "Restore a backup",
 "Resultado": "Result",
 "Resultado nas vendas: {v}": "Gain/loss on sales: {v}",
 "Resumir": "Summarize",
 "Resumir e perguntar": "Summarize and ask",
 "Resumo": "Summary",
 "Resumo (falta o XML completo)": "Summary (full XML missing)",
 "Resumo da manhã": "Morning summary",
 "Resumo da pasta": "Folder summary",
 "Resumo e opinião": "Summary and review",
 "Resumo, gastos por categoria, contas, faturas, metas e todos os lançamentos. Bom para mandar ao contador ou guardar para o IR.": "Summary, spending by category, bills, statements, goals and all transactions. Good to send to your accountant or keep for income tax.",
 "Retirar": "Withdraw",
 "Retirar da meta": "Withdraw from goal",
 "Retorno": "Follow-up",
 "Reunião": "Meeting",
 "Reunião agora": "Meet now",
 "Reunião de equipe": "Team meeting",
 "Reuniões": "Meetings",
 "Revestimento e pisos": "Tiling and flooring",
 "Revisão": "Service",
 "Revolução Constitucionalista": "Constitutionalist Revolution",
 "Rico em matéria orgânica": "Rich in organic matter",
 "Rodízio de pneus": "Tire rotation",
 "Roedor": "Rodent",
 "Romance": "Romance",
 "Rosca direta": "Barbell curl",
 "Rota": "Route",
 "Rota passando pelos {n} lugares que faltam": "Route through the {n} places left",
 "Rotas e mapas": "Routes & maps",
 "Roteiro": "Itinerary",
 "Roteiro por dia que entra na linha do tempo durante a viagem, mala pelo clima, reservas e fusos.": "Daily itinerary that goes on the timeline during the trip, weather-based packing, bookings and time zones.",
 "Rotina": "Routine",
 "Rotinas com passo a passo: skincare, alongamento, cabelo... Toque em \"+ Cuidado\" para escolher um modelo ou criar o seu.": "Step-by-step routines: skincare, stretching, hair... Tap \"+ Routine\" to choose a template or create your own.",
 "Roupa": "Clothes",
 "Roupa social": "Formal wear",
 "Roupas de banho": "Swimwear",
 "Roupas extras das crianças": "Extra clothes for the kids",
 "Roupas íntimas": "Underwear",
 "Rua": "Street",
 "Rua, número, bairro, cidade (ou o nome do lugar)": "Street, number, neighborhood, city (or place name)",
 "Régua": "Ruler",
 "Réptil": "Reptile",
 "Rótulo (ex.: Meu nome, Empresa do cliente)": "Label (e.g., My name, Client's company)",
 "SAC": "Fixed principal (SAC)",
 "SEM HORÁRIO": "NO TIME SET",
 "SEU MÊS EM NÚMEROS": "YOUR MONTH IN NUMBERS",
 "SEU TREINO": "YOUR WORKOUT",
 "SEUS GRUPOS DO APP": "YOUR APP GROUPS",
 "SP": "SP",
 "SUBTAREFA": "SUBTASK",
 "SUBTAREFAS": "SUBTASKS",
 "SUPLEMENTAÇÃO": "SUPPLEMENTS",
 "Sabonete facial": "Facial cleanser",
 "Sabão para lavar roupa": "Laundry detergent",
 "Sacada": "Balcony",
 "Sai só da lista deste app. A cópia guardada no Drive, no OneDrive ou na pasta do celular continua lá.": "Only removes it from this app's list. The copy saved in Drive, OneDrive or your phone folder stays there.",
 "Sai só da lista. O arquivo continua onde foi salvo.": "Only removed from the list. The file stays where it was saved.",
 "Sair": "Sign out",
 "Sair da conta?": "Sign out?",
 "Sair do escritório": "Leave office",
 "Sair do escritório?": "Leave the office?",
 "Sair do grupo": "Leave group",
 "Sair do grupo?": "Leave the group?",
 "Sair sem baixar": "Leave without downloading",
 "Saiu": "Out",
 "Sala": "Room",
 "Sala de estar": "Living room",
 "Sala de jantar": "Dining room",
 "Sala virtual": "Virtual room",
 "Salada": "Salad",
 "Saldo": "Balance",
 "Saldo depois desta parcela": "Balance after this installment",
 "Saldo devedor: {v}": "Outstanding balance: {v}",
 "Saldo do mês": "Monthly balance",
 "Salvar": "Save",
 "Salvar backup do My Planner": "Save My Planner backup",
 "Salvar cuidado": "Save routine",
 "Salvar cômodo": "Save room",
 "Salvar e colocar no My Planner": "Save and add to My Planner",
 "Salvar e sincronizar": "Save and sync",
 "Salvar e testar": "Save and test",
 "Salvar endereço": "Save address",
 "Salvar no My Planner": "Save to My Planner",
 "Salvar refeição": "Save meal",
 "Salvar suplemento": "Save supplement",
 "Salvar tarefa": "Save task",
 "Salvar treino": "Save workout",
 "Sanduíche natural": "Light sandwich",
 "Santo Antônio": "Saint Anthony",
 "Sapato confortável": "Comfortable shoes",
 "Saudade": "Miss you",
 "Saída (imóvel antigo)": "Move-out (old home)",
 "Saída de praia": "Beach cover-up",
 "Saúde": "Health",
 "Saúde & Prontuário": "Health & Medical Records",
 "Saúde (médicos, dentistas, exames, plano)": "Health (doctors, dentists, tests, health plan)",
 "Saúde e bem-estar": "Health and wellness",
 "Scanner": "Scanner",
 "Scanner PDF": "PDF Scanner",
 "Sci-Fi": "Sci-Fi",
 "Se alguma coisa não responder, reinicie o app. Os seus dados estão salvos.": "If something does not respond, restart the app. Your data is saved.",
 "Se der tempo": "If there's time",
 "Se esta política mudar de forma importante, o app avisa e pede o seu aceite de novo.": "If this policy changes in an important way, the app will let you know and ask for your acceptance again.",
 "Se este aviso apareceu, os alertas dos compromissos estão funcionando.": "If this alert showed up, your appointment alerts are working.",
 "Se existir uma conta com {email}, enviamos um link para criar uma senha nova. Confira também o spam.": "If an account exists for {email}, we sent a link to create a new password. Check your spam folder too.",
 "Se o alerta atrasar ou não aparecer: nas configurações do app, deixe as notificações ligadas, a bateria \"sem restrição\" e permita \"Alarmes e lembretes\".": "If the alert is late or doesn't show up: in the app settings, keep notifications on, set battery to \"Unrestricted\" and allow \"Alarms & reminders\".",
 "Se o relógio estiver conectado, os números dele entram por cima dos digitados quando ele tiver o dado.": "If your watch is connected, its numbers replace the manual ones whenever it has the data.",
 "Se você conectar o relógio: totais de cada dia de passos, distância, calorias, exercício, batimentos e sono, lidos do Health Connect (Android) ou do app Saúde (iPhone). O app só lê e nunca altera esses dados.": "If you connect your watch: daily totals of steps, distance, calories, exercise, heart rate and sleep, read from Health Connect (Android) or the Health app (iPhone). The app only reads and never changes this data.",
 "Se você já usou esta aba, nada foi apagado: tudo volta como estava ao assinar.": "If you've used this tab before, nothing was deleted: everything comes back as it was when you subscribe.",
 "Secretária ou recepção": "Secretary or reception",
 "Seg a sex": "Mon to Fri",
 "Seguir": "Next",
 "Segunda": "Monday",
 "Segurança": "Security",
 "Segure e arraste para mudar a ordem. ↻ gira, ⧉ duplica e ✕ tira a página.": "Hold and drag to reorder. ↻ rotates, ⧉ duplicates and ✕ removes the page.",
 "Segure um GIF numa conversa e toque em \"Guardar\" para ele aparecer aqui.": "Hold a GIF in a chat and tap \"Save\" to make it appear here.",
 "Segure um cômodo para mudar de lugar. Com o cômodo aberto, segure uma tarefa e solte em outro cômodo para levá-la.": "Hold a room to move it. With a room open, hold a task and drop it on another room to move it there.",
 "Segure um fichário, uma matéria ou uma página para mudar a ordem. Solte uma matéria em outro fichário para levá-la para lá.": "Hold a binder, subject or page to reorder it. Drop a subject on another binder to move it there.",
 "Segure uma conversa para silenciar ou arquivar. Arquivada continua recebendo e enviando, mas sem aviso.": "Press and hold a chat to mute or archive it. Archived chats still receive and send, but without notifications.",
 "Seguro": "Insurance",
 "Seguro da casa": "Home insurance",
 "Seguro viagem": "Travel insurance",
 "Selecionar": "Select",
 "Sem": "None",
 "Sem alerta": "No alert",
 "Sem categoria": "No category",
 "Sem comprovante": "No receipt",
 "Sem conexão com o servidor de notas. Confira a internet e o endereço do servidor.": "No connection to the invoice server. Check your internet and the server address.",
 "Sem conexão com o servidor. Confira a internet.": "No connection to the server. Check your internet.",
 "Sem conexão com os GIFs agora.": "Can't connect to GIFs right now.",
 "Sem cômodo": "No room",
 "Sem data de fim": "No end date",
 "Sem exercícios": "No exercises",
 "Sem fatura em {mes}": "No statement in {mes}",
 "Sem fim": "No end",
 "Sem horário": "No time set",
 "Sem internet ou servidor ainda não preparado.": "No internet or server not ready yet.",
 "Sem internet. Envia quando voltar.": "No internet. Sends when you're back online.",
 "Sem internet. Tente de novo.": "No internet. Try again.",
 "Sem isso, a tarja só cobre: o texto por baixo continua no arquivo e dá para copiar.": "Without this, the bar only covers: the text underneath stays in the file and can be copied.",
 "Sem itens": "No items",
 "Sem juros": "Interest-free",
 "Sem limite": "No limit",
 "Sem link de calendário": "No calendar link",
 "Sem margem": "No margin",
 "Sem nome": "No name",
 "Sem número na primeira página (capa)": "No number on the first page (cover)",
 "Sem pasta": "No folder",
 "Sem pausas": "No breaks",
 "Sem permissão": "No permission",
 "Sem prazo": "No deadline",
 "Sem recibo": "No receipt",
 "Sem tarefas": "No tasks",
 "Sem texto.": "No text.",
 "Sem tomador identificado": "No customer identified",
 "Sem título": "Untitled",
 "Sem validade": "No expiry",
 "Semana": "Week",
 "Semana completa": "Full week",
 "Semana de {de} a {ate}": "Week of {de} to {ate}",
 "Semanal": "Weekly",
 "Semanal · dias úteis": "Weekly · weekdays",
 "Semanal · todos os dias": "Weekly · every day",
 "Semanal · {dias}": "Weekly · {dias}",
 "Sempre aparecem, junto com os pontos facultativos (Carnaval, Quarta-feira de Cinzas e Corpus Christi).": "Always shown, along with the optional holidays (Carnival, Ash Wednesday and Corpus Christi).",
 "Senha": "Password",
 "Senha (8 caracteres ou mais)": "Password (8 characters or more)",
 "Senha alterada.": "Password changed.",
 "Senha atual": "Current password",
 "Senha atual do cofre": "Current vault password",
 "Senha da conta": "Account password",
 "Senha do certificado": "Certificate password",
 "Senha do cofre": "Vault password",
 "Senha do cofre alterada.": "Vault password changed.",
 "Senha do cofre incorreta.": "Wrong vault password.",
 "Senha incorreta": "Incorrect password",
 "Senha incorreta.": "Incorrect password.",
 "Senha nova (8 caracteres ou mais)": "New password (8 characters or more)",
 "Senha nova do cofre (6 caracteres ou mais)": "New vault password (6 characters or more)",
 "Senha, biometria, bloqueio e privacidade": "Password, biometrics, lock and privacy",
 "Senha, e-mail e formas de desbloquear": "Password, email and ways to unlock",
 "Separar informes de rendimentos (bancos, empregador, corretoras)": "Gather income statements (banks, employer, brokers)",
 "Servidor de notas": "Invoice server",
 "Servidor não configurado (lib/config.ts).": "Server not configured (lib/config.ts).",
 "Servidor não configurado.": "Server not configured.",
 "Servidor não configurado: faltam os dados do Supabase em lib/config.ts.": "Server not configured: Supabase details are missing in lib/config.ts.",
 "Serviço": "Service",
 "Serviço não prestado": "Service not provided",
 "Serviços": "Services",
 "Será excluída em 1 dia": "Will be deleted in 1 day",
 "Será excluída em {n} dias": "Will be deleted in {n} days",
 "Será excluída hoje": "Will be deleted today",
 "Sessão": "Session",
 "Seu acesso ainda precisa ser liberado. Tente entrar em alguns instantes.": "Your access still needs to be approved. Try signing in again in a few moments.",
 "Seu código": "Your code",
 "Seu código de amigo": "Your friend code",
 "Seu código para amigos ganharem 10 dias com todas as abas": "Your code for friends to get 10 days with all tabs",
 "Seu nome": "Your name",
 "Seu papel: {p}": "Your role: {p}",
 "Seu papel: {p}. {d}": "Your role: {p}. {d}",
 "Seu scanner de bolso": "Your pocket scanner",
 "Seus dados continuam salvos na nuvem.": "Your data remains saved in the cloud.",
 "Seus dados na nuvem do My Planner": "Your data in the My Planner cloud",
 "Seus dados são seus: não vendemos e não usamos para publicidade. Você pode exportar ou apagar tudo quando quiser.": "Your data is yours: we don't sell it or use it for advertising. You can export or delete everything whenever you want.",
 "Seus {n} meses grátis terminaram": "Your {n} free months have ended",
 "Sexta": "Friday",
 "Sextou": "TGIF",
 "Sextou!": "TGIF!",
 "Shampoo": "Shampoo",
 "Show ou passeio": "Show or tour",
 "Silenciar avisos": "Mute notifications",
 "Sim": "Yes",
 "Simples Nacional": "Simples Nacional",
 "Sincronizado em {data}": "Synced on {data}",
 "Sincronizando pelo dispositivo {nome}": "Syncing from device {nome}",
 "Sincronizando...": "Syncing...",
 "Sincronizar agora": "Sync now",
 "Sincronização parada: confirme sua senha. Nada se perde.": "Sync paused: confirm your password. Nothing is lost.",
 "Site da assistência": "Service center website",
 "Site da assistência (https://...)": "Service center website (https://...)",
 "Site ou ingresso online": "Website or online ticket",
 "Situação": "Status",
 "Situação agora": "Status now",
 "Skincare da manhã": "Morning skincare",
 "Skincare da noite": "Night skincare",
 "Slides": "Slides",
 "Smileys e pessoas": "Smileys & people",
 "Sobremesa": "Dessert",
 "Sobrou no mês": "Left over this month",
 "Sociologia": "Sociology",
 "Sofá": "Sofa",
 "Sol": "Sun",
 "Sol pleno": "Full sun",
 "Solo ou substrato": "Soil or substrate",
 "Solte numa matéria para mover a página para lá:": "Drop on a subject to move the page there:",
 "Soma a garantia legal e a do fabricante. Confira no termo de garantia. Avisa 15 e 3 dias antes.": "Adds the legal warranty and the manufacturer's warranty. Check the warranty terms. Alerts 15 and 3 days before.",
 "Sombra": "Shade",
 "Somente esta tarefa": "Only this task",
 "Sono": "Sleep",
 "Sono da noite": "Last night's sleep",
 "Sopa": "Soup",
 "Sou MEI": "I'm an MEI",
 "Status": "Status",
 "Sua conexão com a nuvem venceu (acontece quando o app fica muito tempo sem abrir ou a senha foi trocada em outro dispositivo). Nada se perde: o que está aqui é enviado assim que você confirmar.": "Your cloud connection expired (this happens when the app hasn't been opened for a long time or the password was changed on another device). Nothing is lost: what's here is sent as soon as you confirm.",
 "Sua equipe num lugar só: conversa, documentos, reuniões de vídeo com gravação e convite pelo link.": "Your team in one place: chat, documents, recorded video meetings and link invites.",
 "Sua rotina em um só lugar": "Your routine in one place",
 "Sua senha": "Your password",
 "Suas abas": "Your tabs",
 "Substituir": "Replace",
 "Substrato usado": "Substrate used",
 "Subtarefa {n}": "Subtask {n}",
 "Suco": "Juice",
 "Sugerir nome": "Suggest name",
 "Sugestão": "Suggestion",
 "Sugestões de {categoria}": "{categoria} suggestions",
 "Supabase: guarda a conta e os dados sincronizados, como operador. Os servidores podem ficar fora do Brasil, com as garantias do art. 33 da LGPD.": "Supabase: stores the account and synced data, as a processor. The servers may be outside Brazil, with the safeguards of art. 33 of the LGPD.",
 "Superiores": "Superior",
 "Supino reto": "Bench press",
 "Suplemento": "Supplement",
 "Suspense": "Thriller",
 "Suíte": "En-suite bedroom",
 "Sábado": "Saturday",
 "São Paulo": "São Paulo",
 "São Paulo (SP)": "São Paulo (SP)",
 "São mais de 60 arquivos. Use \"A cada N páginas\".": "That's more than 60 files. Use \"Every N pages\".",
 "Série": "Series",
 "Série da DPS": "DPS series",
 "Série e turma": "Grade and class",
 "Séries": "Sets",
 "Sérum": "Serum",
 "Símbolos": "Symbols",
 "Só a equipe do escritório vê. Até 50 MB por arquivo.": "Only the office team can see it. Up to 50 MB per file.",
 "Só acompanha": "View only",
 "Só acompanha, sem valores": "View only, no amounts",
 "Só administradores": "Admins only",
 "Só em {data}": "Only on {data}",
 "Só leitura": "Read-only",
 "Só mandar para a aba Estudos (sem escolher página)": "Just send to the Studies tab (no page)",
 "Só neste dispositivo": "This device only",
 "Só neste dispositivo: {n}": "Only on this device: {n}",
 "Só o código": "Code only",
 "Só o dia {data}": "Only {data}",
 "Só os dados (texto)": "Details only (text)",
 "Só os totais das Finanças vão para a sua IA. Não é recomendação de investimento.": "Only the Finance totals go to your AI. This is not investment advice.",
 "Só seu: estudos, estratégias pedagógicas e o que funcionou ou não em cada aula. Os alunos não veem.": "Just for you: studies, teaching strategies and what worked or didn't in each class. Students can't see it.",
 "Só um celular sincroniza com a agenda. Para passar para este, toque abaixo.": "Only one phone syncs with the calendar. To switch to this one, tap below.",
 "Só uma vez": "Just once",
 "Só uma vez (abrir a ficha da tarefa)": "Just once (open the task card)",
 "Só áudio": "Audio only",
 "Sótão": "Attic",
 "TAREFAS DA CASA": "HOUSEHOLD TASKS",
 "TELEFONE (OPCIONAL)": "PHONE (OPTIONAL)",
 "TRAZER PARA O MY PLANNER": "BRING INTO MY PLANNER",
 "TV por assinatura": "Cable TV",
 "Tabela": "Table",
 "Talvez": "Maybe",
 "Tamanho": "Size",
 "Tamanho da foto": "Photo size",
 "Tamanho da página": "Page size",
 "Tamanho das páginas": "Page size",
 "Tamanho do arquivo": "File size",
 "Tamanho do copo": "Glass size",
 "Também procurar nos Diários Oficiais dos municípios": "Also search the municipal Official Gazettes",
 "Também serão excluídos {n} item(ns) dentro dele.": "{n} item(s) inside it will also be deleted.",
 "Tapioca": "Tapioca crepe",
 "Tarefa": "Task",
 "Tarefa da casa": "Household task",
 "Tarefa de casa": "Homework",
 "Tarefa duplicada": "Task duplicated",
 "Tarefa ou entrega": "Task or deliverable",
 "Tarefa para {nome}": "Task for {nome}",
 "Tarefas da casa": "Household tasks",
 "Tarefas e itens de todas as abas": "Tasks and items from all tabs",
 "Tarefas novas do My Planner vão para: {agenda}": "New My Planner tasks go to: {agenda}",
 "Tarefas que se repetem e passam do período continuam nos outros dias; só os dias escolhidos saem.": "Repeating tasks that run past the range continue on the other days; only the chosen days are removed.",
 "Tarjas pretas sobre CPF, valores e nomes. Apaga de verdade.": "Black bars over CPF, amounts and names. Really erases.",
 "Tartaruga": "Turtle",
 "Taxa de limpeza": "Cleaning fee",
 "Taxa de limpeza cobrada do hóspede": "Cleaning fee charged to the guest",
 "Taxas e anúncios": "Fees and listings",
 "Te amo": "Love you",
 "Tecnologia": "Technology",
 "Tela cheia": "Full screen",
 "Teleconsulta": "Telehealth",
 "Telefone": "Phone",
 "Telefone da assistência": "Service center phone",
 "Telefone da empresa": "Company phone",
 "Telefone da escola": "School phone",
 "Telefone da limpeza": "Cleaner's phone",
 "Telefone de emergência": "Emergency phone",
 "Telefone do veterinário": "Vet phone",
 "Telhado": "Roof",
 "Tem anexos": "Has attachments",
 "Tem certeza?": "Are you sure?",
 "Tem {n} conta(s) em atraso somando {v}. Pague primeiro as que cobram juros mais altos, como o cartão e o cheque especial.": "You have {n} overdue bill(s) totaling {v}. Pay the ones with the highest interest first, like the card and the overdraft.",
 "Tema": "Topic",
 "Tempo de preparo": "Prep time",
 "Temporada": "Season",
 "Temporizador (direita)": "Timer (right)",
 "Tenta consertar um PDF que não abre direito.": "Tries to fix a PDF that won't open properly.",
 "Tentar de novo": "Try again",
 "Tente uma foto mais nítida, com a página inteira.": "Try a sharper photo showing the whole page.",
 "Termina às {hora}": "Ends at {hora}",
 "Terminar até": "Finish by",
 "Terminei em": "Finished on",
 "Terminou": "Ended",
 "Terminou em {data}. Nada foi apagado: tudo volta como estava ao assinar.": "Ended on {data}. Nothing was deleted: everything comes back as it was when you subscribe.",
 "Termos de uso": "Terms of use",
 "Termos de uso e privacidade": "Terms of use and privacy",
 "Terror": "Horror",
 "Terça": "Tuesday",
 "Testando...": "Testing...",
 "Testar alerta (1 minuto)": "Test alert (1 minute)",
 "Testar aviso": "Test notification",
 "Teste de alerta do Planner": "Planner alert test",
 "Teste grátis até {data} ({n} dia(s))": "Free trial until {data} ({n} day(s))",
 "Teste grátis: {n} dia(s)": "Free trial: {n} day(s)",
 "Teste terminado": "Trial ended",
 "Teste terminou em {data}": "Trial ended on {data}",
 "Teste: aviso feito pelo próprio celular.": "Test: notification sent by this phone itself.",
 "Texto": "Text",
 "Texto completo": "Full text",
 "Texto copiado. Cole onde quiser enviar.": "Text copied. Paste it wherever you want to send it.",
 "Texto do documento": "Document text",
 "Texto extra do convite (traje, presentes...)": "Extra invitation text (dress code, gifts...)",
 "Texto livre": "Free text",
 "Texto ou recado": "Text or notice",
 "Texto para PDF": "Text to PDF",
 "Texto {data}": "Text {data}",
 "Tipo": "Type",
 "Tipo sanguíneo": "Blood type",
 "Tira as páginas que você não quer.": "Removes the pages you don't want.",
 "Tira autor, programas, comandos escondidos e anexos.": "Removes author, programs, hidden scripts and attachments.",
 "Tira comentários, destaques e desenhos de outros programas.": "Removes comments, highlights and drawings from other programs.",
 "Tira o texto do PDF (arquivo .txt).": "Pulls the text out of the PDF (.txt file).",
 "Tiradentes": "Tiradentes",
 "Tirar": "Remove",
 "Tirar a assinatura": "Remove signature",
 "Tirar a foto": "Remove photo",
 "Tirar a foto agora": "Take the photo now",
 "Tirar admin": "Remove admin",
 "Tirar alarmes do My Planner": "Remove alarms from My Planner",
 "Tirar arquivos anexados": "Remove attached files",
 "Tirar comentários, destaques e links": "Remove comments, highlights and links",
 "Tirar da agenda": "Remove from schedule",
 "Tirar da barra": "Remove from bar",
 "Tirar daqui": "Remove from here",
 "Tirar das minhas figurinhas?": "Remove from my stickers?",
 "Tirar de administrador": "Remove as admin",
 "Tirar do escritório": "Remove from office",
 "Tirar dos meus GIFs?": "Remove from my GIFs?",
 "Tirar este copo": "Remove this glass",
 "Tirar foto": "Take photo",
 "Tirar fotos de boletos, cupons e documentos e escolher fotos e vídeos da galeria.": "Take photos of bills, receipts and documents and choose photos and videos from the gallery.",
 "Tirar o desenho padrão?": "Remove the pattern?",
 "Tirar o lixo": "Take out the trash",
 "Tire a foto e a sua IA preenche a ficha": "Take the photo and your AI fills in the record",
 "Titular (de quem é o documento)": "Holder (whose document it is)",
 "Titular: {nome}": "Holder: {nome}",
 "Toalha de praia": "Beach towel",
 "Tocar os pés": "Touch your toes",
 "Toda a agenda": "Entire schedule",
 "Toda semana": "Every week",
 "Todas": "All",
 "Todas (passadas, esta e futuras)": "All (past, this and future)",
 "Todas ({n})": "All ({n})",
 "Todas as abas liberadas até {data}.": "All tabs unlocked until {data}.",
 "Todas as capitais. Marque uma ou mais cidades.": "All capitals. Select one or more cities.",
 "Todas as ferramentas de PDF: juntar, dividir, organizar, assinar, carimbo, tarja, números de página, formulários, comprimir, converter, OCR e IA. Guarda no celular, no Google Drive ou no OneDrive.": "All PDF tools: merge, split, organize, sign, stamp, redact, page numbers, forms, compress, convert, OCR and AI. Saves to your phone, Google Drive or OneDrive.",
 "Todas as ferramentas ficam na tela da aba.": "All tools are on the tab's screen.",
 "Todas as fotos da viagem ficam aqui: as que você puser no álbum e as do roteiro, dos lugares e das reservas.": "All the trip's photos live here: the ones you add to the album and the ones from the itinerary, places and bookings.",
 "Todas as plantas estão regadas.": "All plants are watered.",
 "Todas as páginas, uma embaixo da outra.": "All pages, one below the other.",
 "Todo ano": "Every year",
 "Todo dia": "Every day",
 "Todo dia no horário escolhido: quantas tarefas o dia tem, a primeira e a energia total.": "Every day at the chosen time: how many tasks the day has, the first one and the total energy.",
 "Todo mês": "Every month",
 "Todo mês · dia {d}": "Every month · day {d}",
 "Todo o histórico": "Full history",
 "Todos": "All",
 "Todos ({n})": "All ({n})",
 "Todos do grupo": "Everyone in the group",
 "Todos do grupo veem": "Everyone in the group can see",
 "Todos na reunião veem o aviso \"Gravando\". O arquivo vai para os Documentos do escritório, visível só para você até você liberar para a equipe.": "Everyone in the meeting sees the \"Recording\" notice. The file goes to the office Documents, visible only to you until you share it with the team.",
 "Todos os cuidados": "All care routines",
 "Todos os dias": "Every day",
 "Todos os suplementos": "All supplements",
 "Todos os treinos": "All workouts",
 "Todos os tribunais": "All courts",
 "Todos presentes": "All present",
 "Todos saem do grupo. O que cada pessoa já aceitou continua na agenda dela.": "Everyone leaves the group. What each person has already accepted stays in their schedule.",
 "Todos trabalham nos mesmos dados, cada um conforme o papel. Toque no papel de cada pessoa em Membros para trocar.": "Everyone works on the same data, each according to their role. Tap each person's role in Members to change it.",
 "Tomador": "Customer",
 "Tomador (quem contratou)": "Customer (who hired you)",
 "Tomadores": "Customers",
 "Tomei": "I borrowed",
 "Toque aqui ou no + para criar uma tarefa": "Tap here or on + to create a task",
 "Toque em \"Apagar minha conta e todos os dados\" e confirme.": "Tap \"Delete my account and all data\" and confirm.",
 "Toque em + › Novo cartão de crédito e informe os dias de fechamento e de vencimento.": "Tap + › New credit card and enter the closing and due days.",
 "Toque em Ajustes e depois em Segurança.": "Tap Settings, then Security.",
 "Toque em Conectar e, na tela da Apple, ligue os itens que o My Planner pode ler.": "Tap Connect and, on the Apple screen, turn on the items My Planner can read.",
 "Toque em Conectar e, na tela do Health Connect, permita que o My Planner leia os dados.": "Tap Connect and, on the Health Connect screen, allow My Planner to read the data.",
 "Toque em quem NÃO deve ver esta ficha (e o que está dentro dela). Ex.: o presente surpresa.": "Tap whoever should NOT see this record (and what's inside it). E.g. the surprise gift.",
 "Toque em uma aba para abrir. As bloqueadas mostram como assinar.": "Tap a tab to open it. Locked ones show how to subscribe.",
 "Toque em uma aba para abrir. Cada aba extra pode ser testada de graça por 10 dias.": "Tap a tab to open it. Each extra tab can be tried free for 10 days.",
 "Toque em uma aba para abrir. Toque em 📌 para pôr ou tirar a aba da barra de baixo. Cada aba extra pode ser testada de graça por 10 dias.": "Tap a tab to open it. Tap 📌 to add or remove the tab from the bottom bar. Each extra tab can be tried for free for 10 days.",
 "Toque em uma área para abrir. As bloqueadas mostram como assinar.": "Tap an area to open it. Locked ones show how to subscribe.",
 "Toque no desenho para continuar desenhando.": "Tap the drawing to keep drawing.",
 "Toque no que este grupo vai compartilhar. Tudo o que está dentro (roteiro, fotos, reservas...) vai junto e todos participam.": "Tap what this group will share. Everything inside (itinerary, photos, bookings...) goes along and everyone takes part.",
 "Toque nos PDFs na ordem em que devem ficar.": "Tap the PDFs in the order they should go.",
 "Toque num copo para mudar o volume; segure o + para um copo de outro tamanho.": "Tap a glass to change its volume; hold + for a different-size glass.",
 "Toque num feriado para adicioná-lo ao Planner.": "Tap a holiday to add it to Planner.",
 "Toque num lançamento para trocar a categoria, guardar o recibo no IR ou apagar.": "Tap a transaction to change the category, save the receipt for income tax or delete it.",
 "Toque num lançamento para trocar a categoria. Pressione e segure para apagar.": "Tap an entry to change its category. Press and hold to delete.",
 "Toque num perfil para editar. Pressione e segure para removê-lo.": "Tap a profile to edit it. Press and hold to remove it.",
 "Toque num texto, desenho ou checklist e arraste para qualquer lugar da folha.": "Tap a text, drawing or checklist and drag it anywhere on the sheet.",
 "Toque numa página para recortar, girar ou mudar o filtro. Segure e arraste para mudar a ordem.": "Tap a page to crop, rotate or change the filter. Press and hold, then drag to reorder.",
 "Toque numa tarefa para copiar ou mover para hoje.": "Tap a task to copy or move it to today.",
 "Toque onde quer a checklist.": "Tap where you want the checklist.",
 "Toque onde quer escrever.": "Tap where you want to write.",
 "Toque para abrir": "Tap to open",
 "Toque para abrir no app do celular. Arraste para a direita para tirar da lista.": "Tap to open in the phone's app. Swipe right to remove from the list.",
 "Toque para abrir, segure para mudar o nome. Arraste para a esquerda para arquivar ou para a direita para excluir.": "Tap to open, hold to rename. Swipe left to archive or right to delete.",
 "Toque para abrir. Arraste para a direita para tirar da lista.": "Tap to open. Swipe right to remove from the list.",
 "Toque para aceitar ou recusar.": "Tap to accept or decline.",
 "Toque para aceitar, editar ou recusar.": "Tap to accept, edit or decline.",
 "Toque para aplicar agora. Ou ela entra sozinha ao reabrir o app.": "Tap to apply now. Or it applies on its own when you reopen the app.",
 "Toque para baixar e instalar por cima. Seus dados continuam.": "Tap to download and install over the current version. Your data stays.",
 "Toque para conversar": "Tap to chat",
 "Toque para enviar o emoji animado": "Tap to send the animated emoji",
 "Toque para enviar. Segure para guardar ou tirar das suas.": "Tap to send. Hold to save or remove from yours.",
 "Toque para escolher": "Tap to choose",
 "Toque para fechar": "Tap to close",
 "Toque para gerar um novo QR Code": "Tap to generate a new QR code",
 "Tornar admin": "Make admin",
 "Tornar administrador": "Make admin",
 "Tosa": "Grooming",
 "Totais por alimento": "Totals by food",
 "Total": "Total",
 "Total bruto": "Gross total",
 "Total das reservas: {v}": "Bookings total: {v}",
 "Total de aulas": "Total lessons",
 "Total de capítulos": "Total chapters",
 "Total de módulos": "Total modules",
 "Total de páginas": "Total pages",
 "Total de recibos: {v}": "Receipts total: {v}",
 "Total: {n}. Cada aba pode ter até {lim} de texto (fotos e arquivos não contam: ficam no dispositivo ou no seu Drive).": "Total: {n}. Each tab can hold up to {lim} of text (photos and files don't count: they stay on the device or in your Drive).",
 "Total: {v}": "Total: {v}",
 "Trabalhando...": "Working...",
 "Trabalho": "Labor",
 "Traga os compromissos da sua agenda do Google para o My Planner e edite por aqui: as mudanças voltam para a agenda.": "Bring your Google Calendar events into My Planner and edit them here: changes go back to the calendar.",
 "Trans": "Trans",
 "Transferir: {s}": "Transfer: {s}",
 "Transferência": "Transfer",
 "Transferências": "Transfers",
 "Transporte": "Transportation",
 "Tratamento": "Treatment",
 "Travar depois de preencher": "Lock after filling",
 "Trazer todas para hoje": "Bring all to today",
 "Trazer tudo para hoje?": "Bring everything to today?",
 "Trecho ou ideia": "Quote or idea",
 "Treino": "Workout",
 "Trem ou ônibus": "Train or bus",
 "Treme": "Shake",
 "Tribunais": "Courts",
 "Trilha": "Hiking",
 "Triste": "Sad",
 "Triângulo": "Triangle",
 "Troca de óleo": "Oil change",
 "Troca de óleo, rodízio de pneus, revisões por km, IPVA, licenciamento e seguro.": "Oil change, tire rotation, mileage-based services, IPVA, licensing and insurance.",
 "Trocador portátil": "Portable changing pad",
 "Trocar": "Change",
 "Trocar a categoria": "Change category",
 "Trocar a foto": "Change photo",
 "Trocar a pasta": "Change folder",
 "Trocar a senha do cofre": "Change the vault password",
 "Trocar número": "Change number",
 "Trocar o certificado": "Change the certificate",
 "Trocar o código": "Change code",
 "Trocar o código?": "Change the code?",
 "Trocar o desenho": "Change pattern",
 "Trocar o emoji": "Change emoji",
 "Trocar o modelo": "Change model",
 "Trocar o número": "Change the number",
 "Trocar o número do celular": "Change phone number",
 "Trocar por:": "Change to:",
 "Trocar roupa de cama e toalhas": "Change bed linen and towels",
 "Tríceps na polia": "Triceps pushdown",
 "Tubo de ensaio": "Test tube",
 "Tudo": "All",
 "Tudo certo": "All good",
 "Tudo em dia por aqui. Lance os gastos do dia a dia para eu enxergar para onde o dinheiro vai.": "All up to date here. Log your day-to-day spending so I can see where the money goes.",
 "Tudo já fica salvo na sua conta. O arquivo é uma cópia extra que você guarda onde quiser.": "Everything is already saved in your account. The file is an extra copy you can keep wherever you want.",
 "Tudo o que está dentro de \"{nome}\" passa a ser visto pelo grupo, cada pessoa conforme o papel que você escolher (quem entra começa com o papel mais limitado).": "Everything inside \"{nome}\" becomes visible to the group, each person according to the role you choose (newcomers start with the most limited role).",
 "Tudo! Já comprei os ingressos.": "Yes! I already bought the tickets.",
 "Turma": "Class",
 "Turma (opcional)": "Class (optional)",
 "Turmas": "Classes",
 "Turmas e grupos (aulas, mentoria, treino): alunos, chamada, notas, planos, materiais, cobranças e o seu caderno.": "Classes and groups (lessons, mentoring, training): students, attendance, grades, plans, materials, charges and your notebook.",
 "Turmas, alunos, chamada, notas e planos de aula.": "Classes, students, attendance, grades and lesson plans.",
 "Turmas, pacientes, equipes e convidados": "Classes, patients, teams and guests",
 "Técnico": "Technical",
 "Título": "Title",
 "Título (ex.: Capítulo 3)": "Title (e.g., Chapter 3)",
 "Título (opcional)": "Title (optional)",
 "Título da caixa": "Box title",
 "Título de eleitor": "Voter ID card",
 "Título, autor, assunto e palavras-chave.": "Title, author, subject and keywords.",
 "Tô chegando": "On my way",
 "Tônico": "Toner",
 "UF": "UF",
 "Uau": "Wow",
 "Uhuul!": "Woohoo!",
 "Um PDF novo só com as páginas escolhidas.": "A new PDF with only the chosen pages.",
 "Um texto clarinho na diagonal de todas as páginas.": "A faint diagonal text across every page.",
 "Uma pasta para cada cliente: vocês trocam documentos nos dois sentidos e cada cliente só vê a pasta dele.": "One folder for each client: you exchange documents both ways and each client only sees their own folder.",
 "Uma página por arquivo": "One page per file",
 "Uma página por arquivo, a cada N páginas ou por faixas.": "One page per file, every N pages or by ranges.",
 "Unicórnio": "Unicorn",
 "Unidade": "Unit",
 "Universal": "All-purpose",
 "União": "Unity",
 "Usa a conta Google que já está no celular. Nenhuma senha do Google é pedida pelo My Planner.": "Uses the Google account already on your phone. My Planner never asks for your Google password.",
 "Usado: {u} · livre: {v} · limite {l}": "Used: {u} · available: {v} · limit {l}",
 "Usar": "Use",
 "Usar \"{nome}\"": "Use \"{nome}\"",
 "Usar biometria": "Use biometrics",
 "Usar desenho padrão": "Use pattern",
 "Usar este celular": "Use this phone",
 "Usar este nome": "Use this name",
 "Usar modelo: {m}": "Use template: {m}",
 "Usar no navegador (My Planner Web)": "Use in the browser (My Planner Web)",
 "Usar o arquivo já anexado ({nome})": "Use the file already attached ({nome})",
 "Usar o código": "Use the code",
 "Usar senha": "Use password",
 "Usar {ia}": "Use {ia}",
 "Use a senha nova da próxima vez que entrar, aqui e no My Planner Web.": "Use the new password next time you sign in, here and on My Planner Web.",
 "Use a senha para desbloquear.": "Use the password to unlock.",
 "Use a sua própria IA para ler publicações, documentos e anotações e sugerir agendamentos. Você sempre confirma antes de qualquer coisa entrar no Planner.": "Use your own AI to read publications, documents and notes and suggest appointments. You always confirm before anything goes into the Planner.",
 "Use este código ao criar a sua conta e ganhe 10 dias com todas as abas liberadas.": "Use this code when creating your account and get 10 days with all tabs unlocked.",
 "Use o extrato em OFX (o mais indicado) ou CSV, baixado no app ou site do seu banco.": "Use an OFX statement (recommended) or CSV, downloaded from your bank app or website.",
 "Use o seu planner no computador, sincronizado com o celular.": "Use your planner on the computer, synced with your phone.",
 "Use um link https do Google Drive, Google Docs, OneDrive ou SharePoint.": "Use an https link from Google Drive, Google Docs, OneDrive or SharePoint.",
 "Uso": "Usage",
 "Uso próprio": "Own use",
 "VRBO": "VRBO",
 "Vacina": "Vaccine",
 "Vacina {nome}: {pet}": "{nome} vaccine: {pet}",
 "Vacina: {nome}": "Vaccine: {nome}",
 "Vacinas": "Vaccines",
 "Vacinas e remédios dos pets, pet shop e a rotina da escola e da saúde das crianças.": "Pets' vaccines and medicines, pet shop, and the kids' school and health routine.",
 "Vai na viagem": "Goes on the trip",
 "Vale até {d}": "Valid until {d}",
 "Vale para Estudos e Documentos. Na nuvem, o arquivo abre em qualquer dispositivo e no My Planner Web (até 15 MB por arquivo).": "Applies to Studies and Documents. In the cloud, the file opens on any device and in My Planner Web (up to 15 MB per file).",
 "Vale quantos pontos": "Worth how many points",
 "Vale só para você. No máximo um aviso a cada 3 minutos por pessoa, mesmo que ela inclua várias coisas.": "Applies only to you. At most one notification every 3 minutes per person, even if they add several things.",
 "Vale uma vez, nos primeiros 30 dias da sua conta.": "Valid once, in your account's first 30 days.",
 "Validade": "Expiry date",
 "Validade do certificado A1": "A1 certificate expiry",
 "Validade: {data}": "Expires: {data}",
 "Valor": "Amount",
 "Valor ({m})": "Amount ({m})",
 "Valor a pagar": "Amount to pay",
 "Valor combinado": "Agreed amount",
 "Valor combinado por atendimento": "Agreed fee per appointment",
 "Valor da hora": "Hourly rate",
 "Valor da parcela (1ª)": "Installment amount (1st)",
 "Valor da venda": "Sale price",
 "Valor de costume": "Usual amount",
 "Valor do atendimento: {v}{pago}.": "Appointment fee: {v}{pago}.",
 "Valor emprestado ou financiado": "Amount borrowed or financed",
 "Valor final definido pela Google Play ou pela App Store, já na moeda do seu país.": "Final price set by Google Play or the App Store, in your country's currency.",
 "Valor maior que o guardado nesta meta.": "Amount is more than what's saved in this goal.",
 "Valor padrão da consulta ou sessão": "Default fee per consultation or session",
 "Valor pago": "Amount paid",
 "Valor pago (com multa ou desconto)": "Amount paid (with late fee or discount)",
 "Valor pago (opcional)": "Amount paid (optional)",
 "Valor pago: {v}": "Amount paid: {v}",
 "Valor que este aluno paga (se for diferente)": "Amount this student pays (if different)",
 "Valor recebido": "Amount received",
 "Valor recebido: {v}": "Amount received: {v}",
 "Valor total da compra": "Total purchase amount",
 "Valores e dados clínicos só aparecem para quem o papel permitir. Você pode desligar quando quiser: os dados continuam com você.": "Amounts and clinical data only appear to those whose role allows it. You can turn it off anytime: the data stays with you.",
 "Valores para conferir com o seu contador. As regras de dedução mudam a cada ano.": "Amounts to check with your accountant. Deduction rules change every year.",
 "Vamos conversar pelo My Planner? Me adicione como amigo com o código {codigo} (aba Mensagens > Amigos).": "Shall we chat on My Planner? Add me as a friend with the code {codigo} (Messages tab > Friends).",
 "Vaso": "Pot",
 "Veja os planos em Ajustes › Compras.": "See the plans in Settings › Purchases.",
 "Vem da aba Empréstimos & Financiamentos": "From the Loans & Financing tab",
 "Vence em {data}.": "Expires on {data}.",
 "Vence em {fim} (data informada na publicação).": "Due on {fim} (date stated in the publication).",
 "Vence em {n} dia(s)": "Expires in {n} day(s)",
 "Vence hoje": "Expires today",
 "Vence {data}": "Due {data}",
 "Vencendo": "Expiring",
 "Venceu há {n} dia(s)": "Expired {n} day(s) ago",
 "Vencidas": "Expired",
 "Vencidos": "Expired",
 "Vencimento": "Due date",
 "Vencimento (guias e boletos)": "Due date (tax slips and bank slips)",
 "Vencimento da 1ª parcela": "1st installment due date",
 "Vencimentos": "Due dates",
 "Venda": "Sale",
 "Venda/serviço do MEI": "MEI sale/service",
 "Vendidos": "Sold",
 "Ver": "View",
 "Ver a lista de membros": "See the member list",
 "Ver a rota": "View route",
 "Ver arquivos": "View files",
 "Ver detalhes do erro": "See error details",
 "Ver e editar": "View and edit",
 "Ver em Compras": "See in Purchases",
 "Ver mais": "See more",
 "Ver mais páginas": "Show more pages",
 "Ver no My Planner": "View in My Planner",
 "Ver o dia": "View day",
 "Ver os feriados do ano": "See the year's holidays",
 "Ver participantes": "View participants",
 "Ver páginas": "View pages",
 "Ver todos": "See all",
 "Ver todos ({n})": "See all ({n})",
 "Ver {nome}": "View {nome}",
 "Verificar agora": "Check now",
 "Vermífugo": "Dewormer",
 "Vermífugo ou remédio": "Dewormer or medicine",
 "Vermífugos e remédios": "Dewormers and medicines",
 "Verso": "Back",
 "Verso do documento": "Back of document",
 "Versão do PDF": "PDF version",
 "Versão instalada": "Installed version",
 "Versão {versao} disponível": "Version {versao} available",
 "Versão {v}": "Version {v}",
 "Veterinário": "Vet",
 "Veterinário ou clínica": "Vet or clinic",
 "Veículo": "Vehicle",
 "Veículo e acessórios": "Vehicle and accessories",
 "Veículos": "Vehicles",
 "Veículos & Manutenção": "Vehicles & Maintenance",
 "Vi mais um episódio": "Watched another episode",
 "Viagem": "Trip",
 "Viagens": "Trips",
 "Viagens & Lazer": "Travel & Leisure",
 "Viagens e lugares": "Travel & places",
 "Vida noturna": "Nightlife",
 "Vidros e esquadrias": "Windows and frames",
 "Vigente": "Active",
 "Vigentes": "Active",
 "Virar": "Flip",
 "Virar a câmera": "Flip camera",
 "Virar tarefa (levar à assistência)": "Make it a task (take to service center)",
 "Visita domiciliar": "Home visit",
 "Visitados": "Visited",
 "Visto": "Watched",
 "Vistoria": "Inspection",
 "Vistoria: {i}": "Inspection: {i}",
 "Vistorias": "Inspections",
 "Visualizar feriados": "View holidays",
 "Vitamina": "Vitamin",
 "Vitamina D": "Vitamin D",
 "Vitaminas, whey, creatina... com a frequência de cada um. O que for de hoje aparece em \"Hoje\" para marcar.": "Vitamins, whey, creatine... each with its own frequency. Whatever is for today shows up in \"Today\" to check off.",
 "Você": "You",
 "Você aceitou os termos em {data}.": "You accepted the terms on {data}.",
 "Você ainda não tem amigos no app. Adicione pelo código.": "You don't have any friends in the app yet. Add them by code.",
 "Você ainda não tem fichários. Crie um na aba Estudos.": "You don't have any binders yet. Create one in the Studies tab.",
 "Você deixa de ver a conversa, os documentos e as reuniões.": "You'll no longer see the chat, documents and meetings.",
 "Você deve: {v}": "You owe: {v}",
 "Você entrou no grupo": "You joined the group",
 "Você entrou no grupo \"{nome}\".": "You joined the group \"{nome}\".",
 "Você está convidado(a) para: {evento}": "You're invited to: {evento}",
 "Você foi convidado para o My Planner": "You've been invited to My Planner",
 "Você foi convidado para o grupo": "You've been invited to the group",
 "Você juntou {v} para \"{m}\".": "You saved {v} for \"{m}\".",
 "Você já tem todas as abas.": "You already have all the tabs.",
 "Você já usou um código de indicação nesta conta.": "You've already used a referral code on this account.",
 "Você ligou": "You called",
 "Você mesmo pode apagar a conta a qualquer momento, pelo app no celular ou pelo site:": "You can delete your account at any time, in the phone app or on the website:",
 "Você não tem permissão para isso neste grupo.": "You don't have permission to do that in this group.",
 "Você não vê os outros membros deste grupo.": "You can't see the other members of this group.",
 "Você pode apagar a conta a qualquer momento em Ajustes > Segurança. Isso apaga para sempre os dados na nuvem e no dispositivo.": "You can delete your account at any time in Settings > Security. This permanently deletes the data in the cloud and on the device.",
 "Você pode: confirmar se tratamos seus dados, acessar, corrigir, pedir a portabilidade (exportar o arquivo em Ajustes > Configuração geral), pedir a exclusão, saber com quem compartilhamos, revogar o consentimento e reclamar na ANPD.": "You can: confirm whether we process your data, access it, correct it, request portability (export the file in Settings > General settings), request deletion, find out who we share it with, withdraw your consent and file a complaint with the ANPD.",
 "Você recebe (líquido)": "You receive (net)",
 "Você é responsável pela sua senha e pelo que é feito na sua conta. Use dados verdadeiros no cadastro.": "You're responsible for your password and for what is done in your account. Use accurate information when signing up.",
 "Volta": "Return",
 "Volta ou check-out": "Return or check-out",
 "Volta às {hora}": "Back at {hora}",
 "Voltar": "Back",
 "Voltar ao cardápio da semana neste dia": "Go back to the weekly menu on this day",
 "Voltar ao cálculo": "Back to calculation",
 "Voltar ao foco": "Back to focus",
 "Voltar ao padrão": "Reset to default",
 "Voltar ao planejado": "Back to planned",
 "Voltar para Anotações": "Back to Notes",
 "Voltar para as cores do My Planner": "Back to My Planner colors",
 "Voltar para novas": "Back to new",
 "Voltar para o QR Code": "Back to QR code",
 "Volte para o app My Planner no celular. A tela de Ajustes atualiza sozinha.": "Go back to the My Planner app on your phone. The Settings screen updates on its own.",
 "Voo": "Flight",
 "Voos, hotéis, carro e passeios num lugar só, com o código e o comprovante.": "Flights, hotels, car and tours in one place, with the code and the confirmation.",
 "Vá em Ajustes e toque em \"Conectar navegador\".": "Go to Settings and tap \"Connect browser\".",
 "Vá em Ajustes › Configuração geral e toque em \"Conectar navegador\".": "Go to Settings › General settings and tap \"Connect browser\".",
 "Várias páginas por folha": "Multiple pages per sheet",
 "Vários PDFs num só, na ordem que você escolher.": "Several PDFs in one, in the order you choose.",
 "Vê as aulas e os materiais liberados.": "Sees released lessons and materials.",
 "Vê as etapas e registra o diário.": "Sees the stages and writes in the log.",
 "Vê e altera tudo, inclusive os valores.": "Sees and edits everything, including amounts.",
 "Vê e envia os documentos da própria pasta e responde aos pedidos.": "Sees and sends documents in their own folder and replies to requests.",
 "Vê o andamento, sem os valores e sem alterar.": "Sees progress, without amounts and without editing.",
 "Vê os check-ins e check-outs e marca a limpeza feita, sem valores.": "Sees check-ins and check-outs and marks cleaning as done, no amounts.",
 "Vê tudo e lança gastos, lugares, roteiro e mala.": "Sees everything and adds expenses, places, itinerary and packing list.",
 "Vê tudo, inclui, edita, comenta e põe fotos. Só não coloca nem tira pessoas do grupo.": "Sees everything, adds, edits, comments and posts photos. Just can't add or remove people from the group.",
 "Vê tudo, inclusive os valores, sem alterar.": "Sees everything, including amounts, without editing.",
 "Vídeo": "Video",
 "Vínculo": "Link",
 "Vínculo perdido": "Link lost",
 "WhatsApp da assistência": "Support WhatsApp",
 "Whey": "Whey",
 "Wi-Fi (rede e senha)": "Wi-Fi (network and password)",
 "Yoga": "Yoga",
 "Zumbi e Consciência Negra": "Zumbi and Black Consciousness Day",
 "Zzz": "Zzz",
 "a cada {n} dias": "every {n} days",
 "a pagar": "to pay",
 "a receber": "to receive",
 "a receber {v}": "{v} to receive",
 "a reserva": "the booking",
 "a última execução falhou; avise o suporte": "the last run failed; contact support",
 "abr": "Apr",
 "abril": "April",
 "acabou": "ran out",
 "achatado": "flattened",
 "administra": "admin",
 "ago": "Aug",
 "agosto": "August",
 "ajustado": "adjusted",
 "algo novo": "something new",
 "alterou": "changed",
 "amanhã": "tomorrow",
 "anual": "yearly",
 "apagou": "deleted",
 "aplicada em {d}": "given on {d}",
 "app {v} · atualização {p} de {data}": "app {v} · update {p} from {data}",
 "assinado": "signed",
 "atrasada": "overdue",
 "atrasada há {n} dia(s)": "overdue by {n} day(s)",
 "até": "to",
 "até {data}": "until {data}",
 "até {d}": "until {d}",
 "aula {a} de {n}": "lesson {a} of {n}",
 "avisos silenciados": "notifications muted",
 "caixa": "box",
 "colher(es)": "spoon(s)",
 "coluna": "column",
 "com anexos": "with attachments",
 "com imagem": "with image",
 "com tarjas": "redacted",
 "com texto": "with text",
 "com {p}": "with {p}",
 "como planejado": "as planned",
 "comprado em {data}": "purchased on {data}",
 "comprado em {d} por {v}": "bought on {d} for {v}",
 "comprimido": "compressed",
 "comprovante": "receipt",
 "concha(s)": "ladle(s)",
 "confirmados": "confirmed",
 "consulta recusada": "query rejected",
 "contratado": "hired",
 "contínuo": "ongoing",
 "copo(s)": "glass(es)",
 "corridos": "calendar",
 "criou o grupo": "created the group",
 "de": "of",
 "de Anotações": "from Notes",
 "de {meta} passos": "of {meta} steps",
 "de {n}": "of {n}",
 "de {p}": "from {p}",
 "dentro / fora do planejado": "on / off plan",
 "desconto {v}": "discount {v}",
 "desfazer": "undo",
 "destino": "destination",
 "deve {v}": "owes {v}",
 "devolvido em {d}": "returned on {d}",
 "dez": "Dec",
 "dezembro": "December",
 "dia": "day",
 "dias": "days",
 "dias com a meta batida": "days goal reached",
 "dias com a meta de passos": "days with step goal reached",
 "digital": "fingerprint",
 "diária média": "average daily rate",
 "do cliente": "from the client",
 "do escritório": "from the office",
 "dom": "Sun",
 "domingo": "Sunday",
 "e mais {n}": "and {n} more",
 "em aberto": "open",
 "em atraso": "overdue",
 "em {n} dias": "in {n} days",
 "emitida": "issued",
 "entregue": "delivered",
 "entrou no escritório": "joined the office",
 "enviado": "sent",
 "escaneado": "scanned",
 "escolha": "choose",
 "este": "this one",
 "este dispositivo": "this device",
 "este item": "this item",
 "exercícios concluídos": "exercises completed",
 "falta {v}": "{v} left",
 "faltam {km}": "{km} to go",
 "fatia(s)": "slice(s)",
 "faturamento": "revenue",
 "feita em {d}": "done on {d}",
 "feito {dur}": "done {dur}",
 "fev": "Feb",
 "fevereiro": "February",
 "frequência {p}%": "attendance {p}%",
 "gasto {v}": "spent {v}",
 "girado": "rotated",
 "guardado": "saved",
 "higienizado": "sanitized",
 "hoje": "today",
 "hora fixa no dia": "fixed time of day",
 "há {n} dias": "{n} days ago",
 "iPhone ou computador: {link}": "iPhone or computer: {link}",
 "incluiu": "added",
 "jan": "Jan",
 "janeiro": "January",
 "jul": "Jul",
 "julho": "July",
 "jun": "Jun",
 "junho": "June",
 "já importado": "already imported",
 "liberar em {d}": "release on {d}",
 "ligou o compartilhamento": "turned on sharing",
 "linha": "row",
 "lucro líquido": "net profit",
 "mai": "May",
 "maio": "May",
 "mar": "Mar",
 "marca d'água": "watermark",
 "marcada por {nome}": "scheduled by {nome}",
 "março": "March",
 "menos de 1 ano": "less than 1 year",
 "mensalidade": "monthly fee",
 "meta batida!": "goal reached!",
 "metadados": "metadata",
 "min": "min",
 "min antes": "min before",
 "min antes do início": "min before start",
 "min · {de} às {ate}": "min · {de} to {ate}",
 "multa e juros {v}": "late fees and interest {v}",
 "média {m}": "average {m}",
 "mês(es)": "month(s)",
 "na nuvem": "in the cloud",
 "na pasta \"{pasta}\"": "in the \"{pasta}\" folder",
 "na pasta escolhida": "in the chosen folder",
 "neste dispositivo": "on this device",
 "neste celular": "on this phone",
 "no Planner": "in Planner",
 "no {nome}": "to {nome}",
 "nos próximos dias": "in the coming days",
 "nov": "Nov",
 "novembro": "November",
 "numerado": "numbered",
 "nunca verificado": "never checked",
 "não vão": "not going",
 "o documento mudou depois disso: guarde de novo": "the document changed since then: save it again",
 "ocupação": "occupancy",
 "ontem": "yesterday",
 "organizado": "organized",
 "orçando": "getting quotes",
 "out": "Oct",
 "outubro": "October",
 "paga": "paid",
 "paga em {d}": "paid on {d}",
 "pago": "paid",
 "pago em {d}": "paid on {d}",
 "pago por {p}": "paid by {p}",
 "pagou {v}": "paid {v}",
 "parcela {a} de {n}": "installment {a} of {n}",
 "parece já lançado": "looks already added",
 "parte {n}": "part {n}",
 "passos por dia (média)": "steps per day (avg.)",
 "passou {km}": "{km} over",
 "pausa {p}": "rest {p}",
 "pausado": "paused",
 "peso {n}": "weight {n}",
 "pesquisável": "searchable",
 "por dia": "per day",
 "por dia (média)": "per day (avg.)",
 "por dia disponível": "per available day",
 "por semana": "per week",
 "por {p}": "by {p}",
 "porção(ões)": "serving(s)",
 "preenchido": "filled",
 "primeira às {hora}: {tarefa}": "first at {hora}: {tarefa}",
 "produção": "production",
 "próxima em {data}": "next on {data}",
 "próxima rega {d}": "next watering {d}",
 "publicação": "publication",
 "página de estudo": "study page",
 "página única": "single page",
 "páginas": "pages",
 "páginas {p}": "pages {p}",
 "qua": "Wed",
 "quarta": "Wednesday",
 "quarta-feira": "Wednesday",
 "qui": "Thu",
 "quinta": "Thursday",
 "quinta-feira": "Thursday",
 "quitada": "settled",
 "recebe {v}": "gets {v}",
 "recebida": "received",
 "reconhecimento facial": "face recognition",
 "recortado": "cropped",
 "refeições feitas": "meals eaten",
 "rega a cada {n} dias": "water every {n} days",
 "regar hoje": "water today",
 "reparado": "repaired",
 "retorno {d}": "follow-up {d}",
 "saldo {v}": "balance {v}",
 "seg": "Mon",
 "segunda": "Monday",
 "segunda-feira": "Monday",
 "sem anotações": "no annotations",
 "sem as páginas {p}": "without pages {p}",
 "sem cliente": "no client",
 "sem dias previstos": "no days scheduled",
 "sem horário": "no time",
 "sem meta": "no goal",
 "sem resposta": "no reply",
 "sem tempo": "no time",
 "semana(s)": "week(s)",
 "set": "Sep",
 "setembro": "September",
 "seu@email.com": "you@email.com",
 "sex": "Fri",
 "sexta": "Friday",
 "sexta-feira": "Friday",
 "sáb": "Sat",
 "sábado": "Saturday",
 "talvez": "maybe",
 "tarefa da casa": "home task",
 "tarefa: {t}": "task: {t}",
 "taxas e despesas": "fees and expenses",
 "ter": "Tue",
 "termina em {d}": "ends on {d}",
 "terça": "Tuesday",
 "terça-feira": "Tuesday",
 "teste": "test",
 "todas": "all",
 "todo ano em {d}": "every year on {d}",
 "todo dia {d}": "monthly on day {d}",
 "todos": "everyone",
 "toque para abrir": "tap to open",
 "toque para pausar": "tap to pause",
 "toque para ver o contato": "tap to view contact",
 "toque para voltar a hoje": "tap to go back to today",
 "treinos concluídos": "workouts completed",
 "uma vez em {d}": "once on {d}",
 "unidade(s)": "unit(s)",
 "vale {n}": "worth {n}",
 "vence em {n} dias": "due in {n} days",
 "vence {d}": "due {d}",
 "venceu em {data}": "expired on {data}",
 "vencido": "overdue",
 "vendido com ganho de {v}": "sold at a gain of {v}",
 "vendido com perda de {v}": "sold at a loss of {v}",
 "verificado {quando}": "checked {quando}",
 "você": "you",
 "você administra": "you're admin",
 "xícara(s)": "cup(s)",
 "{aba} bloqueada": "{aba} locked",
 "{aba} está bloqueada": "{aba} is locked",
 "{aba}, em \"Anotações recebidas\"": "{aba}, in \"Received notes\"",
 "{a} aula(s) feita(s)": "{a} lesson(s) done",
 "{a} de {n} aulas": "{a} of {n} lessons",
 "{c} chegou a {p}% do orçamento ({g} de {l}).": "{c} reached {p}% of the budget ({g} of {l}).",
 "{c} confirmados de {n} convidados": "{c} confirmed of {n} guests",
 "{c} está em {p}% do orçamento do mês. Ainda faltam {dias} dia(s) para o mês acabar.": "{c} is at {p}% of the monthly budget. There are still {dias} day(s) left in the month.",
 "{c} já está {v} acima do mês passado inteiro. Confira se foi algo fora do comum.": "{c} is already {v} above all of last month. Check whether it was something unusual.",
 "{c} já passou do orçamento: {g} de {l}. Segure esse gasto até o mês virar.": "{c} is already over budget: {g} of {l}. Hold off on this spending until next month.",
 "{c} passou do orçamento: {g} de {l}.": "{c} went over budget: {g} of {l}.",
 "{de} paga {v} para {para}": "{de} pays {v} to {para}",
 "{de} às {ate}": "{de} to {ate}",
 "{dia}, {d} de {mes} de {a}": "{dia}, {mes} {d}, {a}",
 "{dia}, {d} {mes}": "{dia}, {mes} {d}",
 "{dia}, {d}/{m}": "{dia}, {m}/{d}",
 "{dur} na semana": "{dur} this week",
 "{dur} registrados": "{dur} recorded",
 "{d}/{n} notas": "{d}/{n} grades",
 "{feito} de {meta}": "{feito} of {meta}",
 "{fonte} · {data}": "{fonte} · {data}",
 "{f} de {n} feitas": "{f} of {n} done",
 "{f}/{n} transferências feitas": "{f}/{n} transfers done",
 "{hora} em {fuso}": "{hora} in {fuso}",
 "{h} este mês": "{h} this month",
 "{h} h": "{h} h",
 "{h} h {m} min": "{h} h {m} min",
 "{h} no seu relógio": "{h} on your clock",
 "{ia} conectado. {n} modelo(s) disponível(is) na sua conta.": "{ia} connected. {n} model(s) available in your account.",
 "{ia}: chave de API inválida ou sem permissão.": "{ia}: invalid API key or missing permission.",
 "{ia}: limite de uso atingido. Confira o saldo ou o limite da sua conta de API.": "{ia}: usage limit reached. Check the balance or limit of your API account.",
 "{item}: em {n} dias ({data}).": "{item}: in {n} days ({data}).",
 "{item}: hoje ({data}).": "{item}: today ({data}).",
 "{item}: termina em {n} dias ({data}).": "{item}: ends in {n} days ({data}).",
 "{item}: vence em {n} dias ({data}).": "{item}: expires in {n} days ({data}).",
 "{item}: vence hoje ({data}).": "{item}: expires today ({data}).",
 "{item}: venceu em {data} e ainda não foi marcado como feito.": "{item}: was due on {data} and hasn't been marked as done yet.",
 "{livre} livres de {total}": "{livre} free of {total}",
 "{m} min": "{m} min",
 "{nome} agora é seu amigo. Já podem conversar.": "{nome} is now your friend. You can start chatting.",
 "{nome} conectado!": "{nome} connected!",
 "{nome} ligou": "{nome} called",
 "{novas} nova(s), {atualizadas} atualizada(s), {enviadas} enviada(s), {removidas} removida(s)": "{novas} new, {atualizadas} updated, {enviadas} sent, {removidas} removed",
 "{n} ITEM(NS)": "{n} ITEM(S)",
 "{n} aba(s) no seu plano · cores e opções de cada uma": "{n} tab(s) in your plan · colors and options for each",
 "{n} aba(s) para comprar": "{n} tab(s) to buy",
 "{n} adicionada(s)": "{n} added",
 "{n} alerta(s) agendado(s) neste celular para os próximos dias.": "{n} alert(s) scheduled on this phone for the coming days.",
 "{n} aluno(s)": "{n} student(s)",
 "{n} anexo(s)": "{n} attachment(s)",
 "{n} ano(s)": "{n} yr(s)",
 "{n} arquivo(s)": "{n} file(s)",
 "{n} atendimento(s)": "{n} appointment(s)",
 "{n} atrasada(s)": "{n} overdue",
 "{n} atrasado(s)": "{n} overdue",
 "{n} caixa(s)": "{n} box(es)",
 "{n} caixa(s) frágil(eis)": "{n} fragile box(es)",
 "{n} caixa(s) · {a} já aberta(s) na casa nova": "{n} box(es) · {a} already opened in the new home",
 "{n} cancelada(s).": "{n} canceled.",
 "{n} cartão(ões) abertos": "{n} open card(s)",
 "{n} cobrança(s) criada(s) com vencimento em {d}.": "{n} charge(s) created, due on {d}.",
 "{n} com vencimento": "{n} with due date",
 "{n} compra(s) no cartão {c}. As parcelas futuras já aparecem nas próximas faturas.": "{n} purchase(s) on card {c}. Future installments already show up on the next statements.",
 "{n} conta(s) marcada(s) como paga(s) automaticamente.": "{n} bill(s) automatically marked as paid.",
 "{n} copo(s), {ml} de {meta}": "{n} glass(es), {ml} of {meta}",
 "{n} de {meta} copos": "{n} of {meta} glasses",
 "{n} de {total}": "{n} of {total}",
 "{n} de {total} dias": "{n} of {total} days",
 "{n} de {total} hoje": "{n} of {total} today",
 "{n} de {t} item(ns) com preço, dos cupons lidos em Finanças.": "{n} of {t} item(s) with a price, from receipts read in Finance.",
 "{n} dia(s)": "{n} day(s)",
 "{n} dia(s) seguido(s) lendo": "{n} day(s) in a row reading",
 "{n} dia(s) tirado(s) de tarefas que se repetem": "{n} day(s) removed from repeating tasks",
 "{n} dias": "{n} days",
 "{n} dias grátis": "{n} days free",
 "{n} dias grátis para testar": "{n} days free to try",
 "{n} dias {tipo}: publicada em {pub}, contagem a partir de {ini}, vence em {fim}.": "{n} {tipo} days: published on {pub}, counted from {ini}, due on {fim}.",
 "{n} documento(s)": "{n} document(s)",
 "{n} em atraso": "{n} overdue",
 "{n} etapa(s) atrasada(s)": "{n} stage(s) behind schedule",
 "{n} exclusão(ões) esperando o celular sincronizar.": "{n} deletion(s) waiting for the phone to sync.",
 "{n} falta(s)": "{n} absence(s)",
 "{n} ficha(s) no grupo. Escolha o papel de cada pessoa em Membros.": "{n} record(s) in the group. Choose each person's role in Members.",
 "{n} foto(s) e vídeo(s) da viagem, de todos do grupo. Fotos do roteiro, dos lugares e das reservas também aparecem aqui.": "{n} trip photo(s) and video(s), from everyone in the group. Photos from the itinerary, places and bookings also show up here.",
 "{n} item(ns) adicionado(s).": "{n} item(s) added.",
 "{n} item(ns) com outras pessoas": "{n} item(s) with others",
 "{n} item(ns) no Planner.": "{n} item(s) in the Planner.",
 "{n} lançamento(s) encontrado(s)": "{n} entry(ies) found",
 "{n} lançamento(s) novo(s).": "{n} new entry(ies).",
 "{n} lembrete(s) colocado(s) no My Planner.": "{n} reminder(s) added to My Planner.",
 "{n} livro(s) lido(s) este ano": "{n} book(s) read this year",
 "{n} marcado(s)": "{n} selected",
 "{n} matéria(s)": "{n} subject(s)",
 "{n} membro(s) · abrir a conversa do grupo": "{n} member(s) · open the group chat",
 "{n} meses grátis a partir da criação da conta; depois {preco} por ano.": "{n} months free from account creation; then {preco} per year.",
 "{n} min": "{n} min",
 "{n} min antes": "{n} min before",
 "{n} módulo(s)": "{n} module(s)",
 "{n} noite(s)": "{n} night(s)",
 "{n} nota(s) nova(s).": "{n} new invoice(s).",
 "{n} nota(s) sem XML neste dispositivo ficaram de fora.": "{n} invoice(s) without XML on this device were left out.",
 "{n} nota(s) · emitidas {e} · recebidas {r}": "{n} invoice(s) · issued {e} · received {r}",
 "{n} nova(s)": "{n} new",
 "{n} novo(s) do cliente": "{n} new from the client",
 "{n} novo(s) para aceitar, editar ou recusar.": "{n} new to accept, edit or decline.",
 "{n} parcela(s) colocada(s) no My Planner.": "{n} installment(s) added to My Planner.",
 "{n} parcela(s) em aberto refeitas. As pagas ficaram como estavam.": "{n} open installment(s) recalculated. Paid ones stayed as they were.",
 "{n} parcela(s) em atraso": "{n} overdue installment(s)",
 "{n} parcela(s) em atraso: {v}": "{n} overdue installment(s): {v}",
 "{n} participantes · toque para ver": "{n} participants · tap to view",
 "{n} passo(s)": "{n} step(s)",
 "{n} pausa(s)": "{n} break(s)",
 "{n} pedido(s) de amizade": "{n} friend request(s)",
 "{n} pedido(s) em aberto": "{n} open request(s)",
 "{n} pessoa(s)": "{n} person(s)",
 "{n} pessoa(s) já entraram com o seu código.": "{n} person(s) have already joined with your code.",
 "{n} pessoas": "{n} people",
 "{n} por folha": "{n} per sheet",
 "{n} porções": "{n} servings",
 "{n} publicação(ões) nova(s).": "{n} new publication(s).",
 "{n} publicações novas": "{n} new publications",
 "{n} página(s)": "{n} page(s)",
 "{n} página(s) · {r} revisada(s)": "{n} page(s) · {r} reviewed",
 "{n} páginas": "{n} pages",
 "{n} recebido(s) dos seus grupos": "{n} received from your groups",
 "{n} recebido(s) para responder": "{n} received to answer",
 "{n} refeição(ões), com o cardápio daquele dia": "{n} meal(s), with that day's menu",
 "{n} reserva(s) nova(s) ou alterada(s).": "{n} new or changed booking(s).",
 "{n} resultado(s) em todas as publicações": "{n} result(s) across all publications",
 "{n} selecionado(s): {lista}": "{n} selected: {lista}",
 "{n} tarefa(s)": "{n} task(s)",
 "{n} tarefa(s) apagada(s) por inteiro": "{n} task(s) fully deleted",
 "{n} tarefa(s) criada(s)": "{n} task(s) created",
 "{n} tarefa(s) da casa saíram do My Planner e agora ficam só em Minha Casa. Para levar uma delas ao Planner, abra a tarefa e toque em \"Enviar para o My Planner\".": "{n} household task(s) left My Planner and now live only in My Home. To bring one back to the Planner, open the task and tap \"Send to My Planner\".",
 "{n} tarefa(s) de ontem sem concluir": "{n} task(s) from yesterday not completed",
 "{n} tarefa(s) dos últimos dias sem concluir": "{n} task(s) from the last few days not completed",
 "{n} tarefa(s) hoje": "{n} task(s) today",
 "{n} tarefa(s) pendente(s) vão para a lista de hoje.": "{n} pending task(s) will move to today's list.",
 "{n} tarjas no documento": "{n} black bars in the document",
 "{n} treino(s), cada um nos dias dele": "{n} workout(s), each on its own days",
 "{n} tribunais": "{n} courts",
 "{n}x de {v}": "{n}x {v}",
 "{n}º alerta": "Alert {n}",
 "{n}× {item}": "{n}× {item}",
 "{ok} enviado(s), {falhas} com erro. Tente de novo mais tarde.": "{ok} uploaded, {falhas} failed. Try again later.",
 "{ok} enviado(s).": "{ok} uploaded.",
 "{o} de {d} noites ocupadas. Reservas que passam de um mês para outro são divididas pelas noites.": "{o} of {d} nights booked. Bookings spanning two months are split by night.",
 "{preco} por ano": "{preco} per year",
 "{p} de {t} parcelas pagas ({pct}%)": "{p} of {t} installments paid ({pct}%)",
 "{p} presentes · {f} faltas": "{p} present · {f} absent",
 "{p}% da meta de {m} páginas": "{p}% of the {m}-page goal",
 "{p}% feito": "{p}% done",
 "{p}% ocupado no mês": "{p}% occupied this month",
 "{p}% pronta": "{p}% complete",
 "{p}/{t} pagas": "{p}/{t} paid",
 "{quem} convidou você para o grupo \"{grupo}\" no My Planner. Toque no link para entrar (o app é gratuito para começar): {link}\nCódigo do convite: {codigo}": "{quem} invited you to the group \"{grupo}\" on My Planner. Tap the link to join (the app is free to start): {link}\nInvite code: {codigo}",
 "{quem} e outros incluíram {n} itens no grupo.": "{quem} and others added {n} items to the group.",
 "{quem} incluiu {item} no grupo.": "{quem} added {item} to the group.",
 "{servico} do veículo": "Vehicle {servico}",
 "{s} de {a}": "{s} of {a}",
 "{tarefa}: volte às {hora}": "{tarefa}: back at {hora}",
 "{tipo}: {p}": "{tipo}: {p}",
 "{titulo} (cópia)": "{titulo} (copy)",
 "{uso} usados de {total} reservados para o site": "{uso} used of {total} reserved for the site",
 "{v} · atualização de {data}": "{v} · update from {data}",
 "{v}/hora": "{v}/hour",
 "À direita": "Right",
 "À vista": "Paid in full",
 "Às": "At",
 "Às {hora}": "At {hora}",
 "ÁGUA": "WATER",
 "Ácido": "Acidic",
 "Água": "Water",
 "Água hoje": "Water today",
 "Área externa": "Outdoor area",
 "Áreas": "Areas",
 "Áudio": "Audio",
 "É um auxílio e não substitui o acompanhamento das intimações nos canais oficiais. Prazos devem ser conferidos no sistema oficial.": "This is an aid and does not replace monitoring court notices through official channels. Deadlines must be checked in the official system.",
 "Ética Profissional": "Professional Ethics",
 "Ícone e aba": "Icon and tab",
 "Óculos de sol": "Sunglasses",
 "Órgão emissor (ex.: DETRAN-MS, Polícia Federal)": "Issuing authority (e.g. DETRAN-MS, Federal Police)",
 "Órgão emissor: {nome}": "Issued by: {nome}",
 "Ômega 3": "Omega-3",
 "Última": "Last",
 "Última adubação": "Last fertilizing",
 "Última aplicação": "Last dose",
 "Última busca do servidor para você: {quando}": "Last server search for you: {quando}",
 "Última cópia de segurança: {data}": "Last backup: {data}",
 "Última rega": "Last watering",
 "Última sincronização: {quando}": "Last sync: {quando}",
 "Última: {data}": "Last: {data}",
 "Último dia para entregar a declaração do IR": "Last day to file the income tax return",
 "Último erro: {m}": "Last error: {m}",
 "Últimos 30 dias": "Last 30 days",
 "Últimos 7 dias": "Last 7 days",
 "íris": "iris",
 "última vez em {data}": "last done on {data}",
 "último em {d}": "last on {d}",
 "úteis": "business",
 "★ é a cor do My Planner. A escolha vale para todas as conversas deste dispositivo e da sua conta.": "★ is the My Planner color. Your choice applies to all chats on this device and in your account.",
 "🎥 {nome} está ligando (vídeo)": "🎥 {nome} is calling (video)",
 "📆 Conectar a agenda deste celular": "📆 Connect this phone's calendar",
 "📞 {nome} está ligando (áudio)": "📞 {nome} is calling (audio)",
 "Link bloqueado por segurança.": "Link blocked for security.",
 "Este arquivo não é uma imagem válida.": "This file is not a valid image.",
 "A busca automática do servidor acompanha os 5 primeiros perfis. Os outros entram quando você toca em \"Verificar agora\".": "Automatic server search follows the first 5 profiles. The others are checked when you tap \"Check now\".",
 "Esta tela mostra a linha do tempo da viagem, com as atividades e os lugares que têm dia marcado. Para adicionar ou editar as informações completas de um lugar, use a aba Lugares.": "This screen shows the trip timeline, with the activities and places that have a set day. To add or edit a place's full details, use the Places tab.",
 "Para a viagem {d}": "For the trip {d}",
 "sem nome": "untitled",
 "Foi para a viagem {d}.": "Moved to the trip {d}.",
 "Orçamento total (se não for detalhar)": "Total budget (if not itemizing)",
 "Monte o roteiro dia a dia. Os lugares com dia marcado entram aqui sozinhos. No período da viagem, o roteiro aparece na linha do tempo do My Planner.": "Plan the itinerary day by day. Places with a set day show up here automatically. During the trip, the itinerary appears on the My Planner timeline.",
 "Marque o dia e o horário no lugar para ele aparecer sozinho no Roteiro.": "Set a day and time on the place so it shows up in the Itinerary automatically.",
 "No roteiro": "In itinerary",
 "\"{nome}\" está no roteiro de {data}. Para mudar o dia ou o horário, edite o lugar.": "\"{nome}\" is in the itinerary for {data}. To change the day or time, edit the place.",
 "Para o roteiro desta viagem": "For this trip's itinerary",
 "Orçamento e gastos": "Budget and expenses",
 "Parada (cidade)": "Stop (city)",
 "Item da categoria": "Category item",
 "Orçamento da viagem inteira": "Budget for the whole trip",
 "Orçamento geral da viagem": "Overall trip budget",
 "Previsto {p} · gasto {g}": "Planned {p} · spent {g}",
 "Aqui ficam os custos da viagem que não são de uma parada (ex.: passagens, seguro). Cada parada tem o seu orçamento.": "Trip costs that don't belong to a stop go here (e.g. tickets, insurance). Each stop has its own budget.",
 "Coloque quanto pretende gastar em cada categoria. Ao lançar os gastos, o app mostra quanto já foi usado.": "Enter how much you plan to spend in each category. As you log expenses, the app shows how much has been used.",
 "Orçamento por parada": "Budget per stop",
 "Vai passar por mais de uma cidade? Cadastre as paradas (aba Paradas): cada uma ganha o seu orçamento e os gastos daquelas datas entram nela sozinhos.": "Visiting more than one city? Add the stops (Stops tab): each one gets its own budget, and expenses from those dates go into it automatically.",
 "Coloque o valor do gasto.": "Enter the expense amount.",
 "Orçamento de {c}": "{c} budget",
 "Lançar um gasto nesta parada": "Log an expense at this stop",
 "Lançar gasto": "Log expense",
 "Orçamento e gastos da parada": "Stop budget and expenses",
 "Gastos lançados ({n})": "Logged expenses ({n})",
 "Para corrigir ou apagar um gasto, use a aba Orçamento e gastos da viagem.": "To fix or delete an expense, use the trip's Budget and expenses tab.",
 "Paradas": "Stops",
 "Cidade ou lugar": "City or place",
 "Ex.: Porto": "E.g. Porto",
 "Chegada": "Arrival",
 "Saída": "Departure",
 "Onde vai ficar": "Where you'll stay",
 "gasto {g} de {p}": "spent {g} of {p}",
 "Vai passar por mais de uma cidade? Cadastre cada parada com as datas. Cada uma ganha o seu orçamento (hospedagem, refeições, transporte...) e os gastos daquelas datas entram nela sozinhos.": "Visiting more than one city? Add each stop with its dates. Each one gets its own budget (lodging, meals, transportation...) and expenses from those dates go into it automatically.",
 "Café da tarde": "Afternoon coffee",
 "Outros / Lanches": "Other / Snacks",
 "Gasto {v}": "Spent {v}",
 "Gasto {g} de {p} · {a} acima": "Spent {g} of {p} · {a} over",
 "Gasto {g} de {p}": "Spent {g} of {p}",
 "Tirar \"{nome}\" do orçamento?": "Remove \"{nome}\" from the budget?",
 "Os gastos já lançados nela continuam na lista de gastos.": "Expenses already logged in it stay in the expense list.",
 "Previsto para {nome}": "Planned for {nome}",
 "Tirar {nome}": "Remove {nome}",
 "Nome do item (ex.: Jantar especial)": "Item name (e.g. Special dinner)",
 "Adicionar item": "Add item",
 "Detalhar em itens": "Break down into items",
 "Nova categoria (ex.: Seguro, Presentes)": "New category (e.g. Insurance, Gifts)",
 "Voltar às categorias sugeridas?": "Go back to the suggested categories?",
 "Os valores previstos desta lista serão apagados. Os gastos lançados continuam.": "The planned amounts in this list will be deleted. Logged expenses stay.",
 "Voltar às categorias sugeridas": "Go back to suggested categories",
 "Previsto": "Planned",
 "Ainda pode gastar": "Left to spend",
 "Passou do previsto": "Over the plan",
 "Não foi possível buscar o câmbio": "Couldn't get the exchange rate",
 "Sem internet ou a moeda {m} não está na tabela. Edite a viagem e coloque o câmbio à mão.": "No internet, or {m} isn't in the table. Edit the trip and enter the rate by hand.",
 "Câmbio de {m} ainda não definido": "{m} exchange rate not set yet",
 "Câmbio de hoje": "Today's rate",
 "Atualizado em {d}": "Updated on {d}",
 "Valor em {m}": "Amount in {m}",
 "Moeda do destino": "Destination currency",
 "Câmbio: quanto vale 1 da moeda do destino na sua moeda": "Exchange rate: how much 1 unit of the destination currency is worth in yours",
 "Sem dia marcado": "No day set",
 "Valor na moeda do destino": "Amount in destination currency",
 "Tirar só desta lista ou excluir de vez?": "Remove only from this list or delete it for good?",
 "Excluir de vez": "Delete for good",
 "Relatório da viagem (PDF)": "Trip report (PDF)",
 "Planilha da viagem (Excel)": "Trip spreadsheet (Excel)",
 "Geral da viagem": "Whole trip",
 "Viagem {d}": "Trip {d}",
 "Quem vai: {p}": "Who is going: {p}",
 "Outros gastos": "Other expenses",
 "Orçamento · {n}": "Budget · {n}",
 "Código": "Code",
 "Pagou": "Paid by",
 "Permissão internacional para dirigir": "International driving permit",
 "Vacina (certificado)": "Vaccine (certificate)",
 "Autorização de viagem de menor": "Travel authorization for minor",
 "Vence antes da volta": "Expires before the return",
 "Vence menos de 6 meses depois da volta (muitos países não aceitam)": "Expires less than 6 months after the return (many countries don't accept it)",
 "A lista básica já está aqui.": "The basic checklist is already here.",
 "{n} documento(s) com validade que pode atrapalhar a viagem": "{n} document(s) with an expiry date that may affect the trip",
 "Lista básica: passaporte de cada um e seguro viagem": "Basic checklist: passport for each person and travel insurance",
 "Lista básica: identidade de cada um": "Basic checklist: ID for each person",
 "Ponha a validade de cada documento: o app avisa antes de vencer e confere se o passaporte vale por 6 meses depois da volta. As fotos dos documentos ficam protegidas no cofre.": "Add the expiry date of each document: the app warns you before it expires and checks that the passport is valid for 6 months after the return. Document photos stay protected in the vault.",
 "De quem": "Whose",
 "Número (protegido no cofre)": "Number (protected in the vault)",
 "Está em mãos": "In hand",
 "Válido até {d}": "Valid until {d}",
 "Passaporte, visto, seguro viagem, vacina, autorização de menor... com a validade e a foto. Marque quando estiver em mãos.": "Passport, visa, travel insurance, vaccine, minor authorization... with expiry date and photo. Mark it when you have it in hand.",
 "acerto entre os viajantes (não entra no orçamento)": "settlement between travelers (not in the budget)",
 "Só gastos": "Expenses only",
 "Acertos": "Settlements",
 "Marcar como pago?": "Mark as paid?",
 "{de} já pagou {v} para {para}?": "Has {de} already paid {v} to {para}?",
 "Já pagou": "Already paid",
 "Acerto: {de} pagou {para}": "Settlement: {de} paid {para}",
 "Conferir minhas assinaturas": "Check my subscriptions",
 "Gerenciar ou cancelar assinaturas na loja": "Manage or cancel subscriptions in the store",
 "Restaurar compras": "Restore purchases",
 "Procurando...": "Searching...",
 "{n} assinatura(s) encontrada(s) e liberada(s).": "{n} subscription(s) found and unlocked.",
 "Assinatura anual, renova sozinha. Cancele quando quiser nas assinaturas da loja, até 24 horas antes da renovação.": "Yearly subscription, renews automatically. Cancel anytime in the store's subscriptions, up to 24 hours before renewal.",
 "Assinaturas da loja": "Store subscriptions",
 "Gerenciar assinaturas (App Store)": "Manage subscriptions (App Store)",
 "Gerenciar assinaturas (Google Play)": "Manage subscriptions (Google Play)",
 "A assinatura é feita no app do celular (Google Play ou App Store) e vale também aqui no site.": "You subscribe in the phone app (Google Play or App Store) and it also works here on the website.",
 "Esta assinatura ainda não está disponível na loja. Tente de novo mais tarde.": "This subscription is not available in the store yet. Please try again later.",
 "Assinatura feita": "Subscribed",
 "Já assinei no celular: conferir": "I already subscribed on my phone: check",
 "Nenhuma assinatura encontrada nesta conta da loja.": "No subscription found in this store account.",
 "Confira a internet e tente de novo. Nada foi cobrado.": "Check your internet and try again. Nothing was charged.",
 "{aba} liberada. Vale também nos seus outros dispositivos e no site.": "{aba} unlocked. It also works on your other devices and on the website.",
 "Para assinar, atualize o My Planner pela Google Play ou pela App Store.": "To subscribe, update My Planner from Google Play or the App Store.",
 "Assinada, renova em {data}": "Subscribed, renews on {data}",
 "Não deu para assinar agora": "Couldn't subscribe right now",
 "Assinar por {preco} por ano": "Subscribe for {preco} per year",
 "\"{nome}\" foi para o Mural, em Conquistas.": "\"{nome}\" moved to the Board, under Achievements.",
 "\"{nome}\" já faz parte da sua rotina. Foi para o Mural, em Conquistas.": "\"{nome}\" is now part of your routine. It moved to the Board, under Achievements.",
 "\"{nome}\" voltou para o lugar.": "\"{nome}\" is back in place.",
 "1 ano": "1 year",
 "1 mês": "1 month",
 "A IA não achou o valor no comprovante.": "The AI couldn't find the amount on the receipt.",
 "A cada {n} dias": "Every {n} days",
 "A carta está vazia": "The letter is empty",
 "A carta fica trancada até {d}. Até lá não dá para reler nem editar. Para mudar algo, escreva outra carta.": "The letter stays locked until {d}. Until then you can't reread or edit it. To change something, write another letter.",
 "A lixeira está vazia.": "The trash is empty.",
 "A mesma do app e do celular": "Same as the app and the phone",
 "A mesma forma de desbloqueio do app e do celular": "Same unlock method as the app and the phone",
 "A senha do diário precisa ter 6 caracteres ou mais.": "The diary password must be at least 6 characters.",
 "A senha precisa ter 6 caracteres ou mais.": "The password must be at least 6 characters.",
 "A turma ainda não tem grupo": "The class doesn't have a group yet",
 "AS 4 BOLINHAS DE COR": "THE 4 COLOR DOTS",
 "Aberta em {d}": "Opened on {d}",
 "Abra a aba para poder restaurar": "Open the tab to restore it",
 "Abra o diário primeiro": "Open the diary first",
 "Abre com a biometria, o reconhecimento facial ou a senha do app. A senha do diário só é pedida na primeira vez em cada aparelho.": "Opens with biometrics, face recognition or the app password. The diary password is only asked the first time on each device.",
 "Abre em {d}": "Opens on {d}",
 "Abrir carta para o futuro": "Open letter to the future",
 "Abrir em {aba}": "Open in {aba}",
 "Abrir o Diário": "Open the Diary",
 "Abrir o diário": "Open the diary",
 "Abrir {aba}": "Open {aba}",
 "Acompanha o imóvel, as reservas, a ocupação, as despesas e o lucro, sem alterar nada.": "Follows the property, bookings, occupancy, expenses and profit, without changing anything.",
 "Adicionar foto": "Add photo",
 "Apaga tudo o que está no quadro desta página.": "Erases everything on this page's board.",
 "Apagar o desenho?": "Delete the drawing?",
 "Apagar o diário": "Delete the diary",
 "Apagar para todos?": "Delete for everyone?",
 "Aplicar a todas as páginas desta matéria": "Apply to all pages in this subject",
 "Aplicar a todas as páginas desta pasta": "Apply to all pages in this folder",
 "Apostilas, listas, slides, vídeos, links e recados. Pelo ⋮ › Enviar para a turma, cada aluno recebe no app dele.": "Handouts, worksheets, slides, videos, links and notices. Via ⋮ › Send to the class, each student gets it in their app.",
 "Aquarela": "Watercolor",
 "Aqui aparece, sem custo, o que os grupos compartilharam com você. Para usar a aba com os seus próprios dados, assine a aba.": "Here you see, at no cost, what groups have shared with you. To use the tab with your own data, subscribe to the tab.",
 "Arquivados": "Archived",
 "Arraste para a direita para excluir, ou para a esquerda para arquivar.": "Swipe right to delete, or left to archive.",
 "As cobranças desta aula extra já existem.": "The charges for this extra class already exist.",
 "As notas vão só para cada aluno. Para isso, o nome da pessoa no grupo precisa ser igual ao nome do aluno ou do responsável no cadastro.": "Grades go only to each student. For this, the person's name in the group must match the student's or guardian's name in the records.",
 "Atestado": "Medical certificate",
 "Atestados": "Medical certificates",
 "Até quando (opcional)": "Until when (optional)",
 "Até {d}": "Until {d}",
 "Aula extra": "Extra class",
 "Aula extra (fora dos dias de aula)": "Extra class (outside class days)",
 "Aula extra de {d}": "Extra class on {d}",
 "Avaliação de {d}": "Assessment on {d}",
 "Avaliação salva": "Assessment saved",
 "Avançar": "Next",
 "Aviso da revisão do mês": "Monthly review reminder",
 "Aviso no último dia do mês: \"Que tal revisar o seu mês? ✨\"": "Reminder on the last day of the month: \"How about reviewing your month? ✨\"",
 "Aviso sem nenhum conteúdo do diário: \"Como foi o seu dia? ✍️\"": "Reminder with no diary content: \"How was your day? ✍️\"",
 "Avulsa": "One-off",
 "Avulsas": "One-off items",
 "Azul": "Blue",
 "Baixar na App Store": "Download on the App Store",
 "Baixar na Google Play": "Get it on Google Play",
 "Baixe o My Planner na loja: Android {android} · iPhone {iphone}": "Get My Planner from the store: Android {android} · iPhone {iphone}",
 "Biometria, reconhecimento facial ou a senha do app. A senha do diário fica guardada para a primeira vez em cada aparelho.": "Biometrics, face recognition or the app password. The diary password is kept for the first time on each device.",
 "Branco": "White",
 "Buscando o clima…": "Getting the weather…",
 "Básicas": "Basic",
 "COMO ESTOU": "HOW I'M FEELING",
 "COMO O DIÁRIO ABRE": "HOW THE DIARY OPENS",
 "COR DA FOLHA": "PAGE COLOR",
 "Caixinha no My Planner": "Piggy bank in My Planner",
 "Caixinha {m}": "Piggy bank {m}",
 "Carta de {d}": "Letter from {d}",
 "Carta guardada": "Letter saved",
 "Carta para o futuro": "Letter to the future",
 "Carta trancada": "Locked letter",
 "Cartas abertas podem ser lidas, mas não editadas.": "Opened letters can be read, but not edited.",
 "Cartas para o Futuro": "Letters to the Future",
 "Cartões arquivados": "Archived cards",
 "Chegou uma carta da {nome} de {tempo} atrás 💌": "A letter from {nome} from {tempo} ago has arrived 💌",
 "Chegou! Toque para abrir 💌": "It's here! Tap to open 💌",
 "Cinza-escuro": "Dark gray",
 "Clara (segue o tema)": "Light (follows the theme)",
 "Claras e pastel (boas para folha escura)": "Light and pastel (good for a dark page)",
 "Clima (toque para preencher)": "Weather (tap to fill in)",
 "Clima automático": "Automatic weather",
 "Clima do dia": "Today's weather",
 "Cobrar a aula extra": "Charge for the extra class",
 "Cobrar a aula extra dos presentes": "Charge attendees for the extra class",
 "Cobrar a turma toda": "Charge the whole class",
 "Cole um link que comece com https://": "Paste a link starting with https://",
 "Coloque o valor da aula extra na turma (Editar).": "Set the extra class price on the class (Edit).",
 "Coloque o valor.": "Enter the amount.",
 "Colunas": "Columns",
 "Com a sua IA ligada (Ajustes › Inteligência artificial), o app lê o valor, a data e a descrição pela foto.": "With your AI turned on (Settings › Artificial intelligence), the app reads the amount, date and description from the photo.",
 "Como cuidei de mim hoje?": "How did I take care of myself today?",
 "Como foi o seu dia? ✍️": "How was your day? ✍️",
 "Compartilhar este projeto (convidar)": "Share this project (invite)",
 "Compartilhar o texto": "Share the text",
 "Completa": "Full",
 "Comprovante (foto, PDF ou print)": "Receipt (photo, PDF or screenshot)",
 "Comprovante anexado": "Receipt attached",
 "Comprovante de pagamento (foto ou PDF)": "Proof of payment (photo or PDF)",
 "Concluído: hábito formado": "Done: habit formed",
 "Concluídos": "Completed",
 "Configurar o Diário": "Set up the Diary",
 "Confirmar pagamento": "Confirm payment",
 "Confirmar recebimento": "Confirm receipt",
 "Conquistas": "Achievements",
 "Contas arquivadas": "Archived accounts",
 "Continuar escrevendo": "Keep writing",
 "Copiado ✓": "Copied ✓",
 "Copiar código": "Copy code",
 "Copiar link": "Copy link",
 "Cor atual": "Current color",
 "Cor {n}": "Color {n}",
 "Creme": "Cream",
 "Criada em {d}": "Created on {d}",
 "Criar as cobranças": "Create the charges",
 "Criar o grupo da turma": "Create the class group",
 "Criar o meu diário": "Create my diary",
 "Crie a senha do diário (6 ou mais)": "Create the diary password (6 or more)",
 "Crie o grupo da turma e mande o convite aos alunos. Depois, o envio vai direto para eles.": "Create the class group and send the invite to the students. After that, sending goes straight to them.",
 "Crie sua primeira meta, objetivo ou sonho com o botão + abaixo.": "Create your first goal, objective or dream with the + button below.",
 "Crie um projeto, convide quem participa e divida os passos. Cada pessoa marca o que fez.": "Create a project, invite the people involved and split up the steps. Each person checks off what they did.",
 "Crie uma senha nova para começar.": "Create a new password to get started.",
 "Cuidados arquivados": "Archived self-care",
 "Cuidados pessoais do dia feitos (Bem-Estar)": "Today's self-care done (Wellness)",
 "Curto prazo": "Short term",
 "Custos": "Costs",
 "Céu estrelado": "Starry sky",
 "Círculo": "Circle",
 "Cômodos arquivados": "Archived rooms",
 "DIAS CUMPRIDOS": "DAYS COMPLETED",
 "Data (opcional)": "Date (optional)",
 "De {d}": "From {d}",
 "Desafixar do topo": "Unpin from top",
 "Desenho mais fraco ou mais forte": "Lighter or stronger drawing",
 "Desfazer \"Concluído\" ({d})": "Undo \"Done\" ({d})",
 "Desligado": "Off",
 "Desmarcar": "Uncheck",
 "Desmarcar como paga?": "Mark as unpaid?",
 "Desmarcar como recebida?": "Mark as not received?",
 "Desmarque o que você não usa: some da tela e deixa a aba mais simples. Dá para mudar depois em Ajustes › Abas › {aba} › Partes desta aba.": "Uncheck what you don't use: it disappears from the screen and makes the tab simpler. You can change it later in Settings › Tabs › {aba} › Parts of this tab.",
 "Dias da semana": "Days of the week",
 "Dias de aula": "Class days",
 "Dias de aula: {d}": "Class days: {d}",
 "Dias escritos": "Days written",
 "Dica: desenhe a forma à mão e segure o dedo no fim do traço para ela ficar perfeita.": "Tip: draw the shape by hand and hold your finger at the end of the stroke to make it perfect.",
 "Ditado": "Dictation",
 "Ditar (falar para escrever)": "Dictate (speak to type)",
 "Diário apagado": "Diary deleted",
 "Diário protegido": "Diary protected",
 "Dom": "Sun",
 "Dê um nome a ele na pasta Hábitos.": "Give it a name in the Habits folder.",
 "EVOLUÇÃO": "OVER TIME",
 "Editada em {d}": "Edited on {d}",
 "Ela abre em {d} ({n} dias). Até lá não dá para reler nem editar.": "It opens on {d} ({n} days). Until then you can't reread or edit it.",
 "Ela abre em {d}. Você vai receber um aviso nesse dia.": "It opens on {d}. You'll get a reminder that day.",
 "Ela fica guardada com a data de hoje para comparar depois.": "It's saved with today's date so you can compare later.",
 "Enorme": "Huge",
 "Enviado ao paciente": "Sent to patient",
 "Enviado em": "Sent on",
 "Enviar \"{t}\" para todos do grupo {g}?": "Send \"{t}\" to everyone in the group {g}?",
 "Enviar a nota para cada aluno": "Send each student their grade",
 "Enviar as notas": "Send the grades",
 "Enviar o arquivo: {nome}": "Send the file: {nome}",
 "Enviar o recado para a turma": "Send the notice to the class",
 "Enviar o título para outra aba": "Send the title to another tab",
 "Enviar para a turma": "Send to the class",
 "Enviar para outra aba": "Send to another tab",
 "Escolha a cor desta bolinha": "Choose this dot's color",
 "Escolha uma data no futuro": "Pick a future date",
 "Escolher qualquer cor": "Choose any color",
 "Esconder a barra": "Hide the bar",
 "Escreva a frase": "Write the phrase",
 "Escreva a que se refere a cobrança.": "Write what the charge is for.",
 "Escreva alguma coisa antes de guardar.": "Write something before saving.",
 "Escreva alguma coisa antes de salvar.": "Write something before saving.",
 "Escreva hoje, abra no futuro": "Write today, open in the future",
 "Escreva o que você quer mudar a partir de hoje": "Write what you want to change from today on",
 "Escreva para você do futuro. A carta fica trancada até o dia de abrir.": "Write to your future self. The letter stays locked until the day it opens.",
 "Escrever uma carta": "Write a letter",
 "Escrita em {e} · abre em {a}": "Written on {e} · opens on {a}",
 "Escuras (boas para folha clara)": "Dark (good for a light page)",
 "Esperado": "Expected",
 "Esperado: {e} · Feito: {f} · Faltou: {fa}": "Expected: {e} · Done: {f} · Missed: {fa}",
 "Esqueceu a senha do diário?": "Forgot the diary password?",
 "Esqueci a senha do diário": "I forgot the diary password",
 "Esta semana": "This week",
 "Este lançamento vem de outra parte do app e não se apaga aqui.": "This entry comes from another part of the app and can't be deleted here.",
 "Estudo: {h}": "Study: {h}",
 "Esvaziar": "Empty",
 "Esvaziar a lixeira": "Empty the trash",
 "Esvaziar a lixeira?": "Empty the trash?",
 "Ex.: Comer uma fruta por dia": "E.g.: Eat a piece of fruit a day",
 "Ex.: Exercícios para casa, Atestado de 2 dias": "E.g.: Homework, 2-day medical certificate",
 "Ex.: Reservar a pousada": "E.g.: Book the guesthouse",
 "Ex.: Viagem em família, juntar para a festa": "E.g.: Family trip, save up for the party",
 "Excluir de vez?": "Delete permanently?",
 "Excluir esta avaliação?": "Delete this assessment?",
 "Excluir este bloco?": "Delete this block?",
 "Excluir este desenho?": "Delete this drawing?",
 "Excluir este item?": "Delete this item?",
 "Excluir {n} item(ns)?": "Delete {n} item(s)?",
 "Exportar como imagem": "Export as image",
 "Exportar em PDF": "Export as PDF",
 "FOTOS": "PHOTOS",
 "FRASE DO DIA": "QUOTE OF THE DAY",
 "FREQUÊNCIA": "FREQUENCY",
 "Falta o valor": "Amount missing",
 "Feriado": "Holiday",
 "Feriado: {f}": "Holiday: {f}",
 "Fica 30 dias na lixeira.": "It stays in the trash for 30 days.",
 "Ficam 30 dias na lixeira.": "They stay in the trash for 30 days.",
 "Fichários arquivados": "Archived binders",
 "Fixar no topo": "Pin to top",
 "Floral": "Floral",
 "Folha": "Page",
 "Folha, tema e cores das páginas com escrita": "Paper, theme and colors of writing pages",
 "Folhas e plantas": "Leaves and plants",
 "Foto adicionada": "Photo added",
 "Foto do sonho": "Dream photo",
 "Fotos do dia": "Photos of the day",
 "Frase": "Quote",
 "Frase do dia (aparece no topo do Meu Dia)": "Quote of the day (shows at the top of My Day)",
 "Frases, textos, vídeos e fotos que motivam": "Quotes, texts, videos and photos that motivate you",
 "Geométrico": "Geometric",
 "Gerar": "Generate",
 "Gravar lembretes e anotações por voz e ditar textos (🎤) quando você pedir. O microfone só liga com o seu toque, e o áudio do ditado não é guardado.": "Record reminders and notes by voice and dictate text (🎤) when you ask. The microphone only turns on when you tap, and dictation audio isn't stored.",
 "Guardar e trancar": "Save and lock",
 "Guardar e trancar?": "Save and lock?",
 "Guarde aqui o que te motiva: frases, textos seus, vídeos e fotos.": "Keep what motivates you here: quotes, your own texts, videos and photos.",
 "Guarde bem esta senha: sem ela o diário não pode ser recuperado.": "Keep this password safe: without it the diary can't be recovered.",
 "Hoje é feriado: {f}. Registrar mesmo assim?": "Today is a holiday: {f}. Record anyway?",
 "Humor do mês": "Mood of the month",
 "Humor do período": "Mood for the period",
 "HÁBITOS LIGADOS": "LINKED HABITS",
 "Há itens grandes na seleção. Eles só podem ser excluídos um por um, com confirmação e senha.": "There are large items in the selection. They can only be deleted one by one, with confirmation and password.",
 "Há um ano": "A year ago",
 "Há um mês": "A month ago",
 "Hábito": "Habit",
 "Hábito criado": "Habit created",
 "Hábitos": "Habits",
 "Hábitos cumpridos": "Habits completed",
 "Hábitos cumpridos: {f} de {n}": "Habits completed: {f} of {n}",
 "Hábitos formados": "Habits formed",
 "INSPIRAÇÃO": "INSPIRATION",
 "Imagem adicionada": "Image added",
 "Imagem não encontrada": "Image not found",
 "Incrível": "Amazing",
 "Informação nutricional": "Nutrition facts",
 "Inserir": "Insert",
 "Inspiração": "Inspiration",
 "Item para o paciente": "Item for the patient",
 "Itens grandes só se excluem um por um.": "Large items can only be deleted one by one.",
 "Junte fotos do que você quer viver. Segure e arraste para organizar.": "Gather photos of what you want to live. Hold and drag to arrange them.",
 "LIGAR A UM SONHO DO PROJETO DE VIDA (OPCIONAL)": "LINK TO A LIFE PLAN DREAM (OPTIONAL)",
 "LIGAR A UMA META (OPCIONAL)": "LINK TO A GOAL (OPTIONAL)",
 "LINKS DE VÍDEO": "VIDEO LINKS",
 "Lance as notas antes de enviar.": "Enter the grades before sending.",
 "Lançamentos arquivados": "Archived entries",
 "Legenda (opcional)": "Caption (optional)",
 "Lembrete diário": "Daily reminder",
 "Lendo o comprovante...": "Reading the receipt...",
 "Ler o comprovante com a minha IA": "Read the receipt with my AI",
 "Ligado": "On",
 "Ligar um texto de motivação (Inspiração)": "Link a motivation text (Inspiration)",
 "Lilás": "Lilac",
 "Limpar a folha inteira?": "Clear the whole page?",
 "Linha reta": "Straight line",
 "Linhas": "Lines",
 "Link do vídeo (YouTube, Instagram...)": "Video link (YouTube, Instagram...)",
 "Lisa": "Plain",
 "Liste os passos do projeto e diga quem faz cada um.": "List the project's steps and say who does each one.",
 "Lixeira": "Trash",
 "Longo prazo": "Long term",
 "MARCAR SOZINHO PELO BEM-ESTAR (OPCIONAL)": "CHECK AUTOMATICALLY FROM WELLNESS (OPTIONAL)",
 "META OU SONHO LIGADO (OPCIONAL)": "LINKED GOAL OR DREAM (OPTIONAL)",
 "Mais opções": "More options",
 "Mal": "Bad",
 "Mandar ao paciente pelo WhatsApp": "Send to the patient via WhatsApp",
 "Marque o que fez em cada dia": "Check off what you did each day",
 "Marque os dias de aula na turma (Editar) para a chamada mostrar só esses dias.": "Mark the class days on the class (Edit) so attendance shows only those days.",
 "Matérias arquivadas": "Archived subjects",
 "Mensalidade": "Monthly fee",
 "Meta de água do Bem-Estar": "Wellness water goal",
 "Metas arquivadas": "Archived goals",
 "Metas e sonhos concluídos": "Goals and dreams completed",
 "Metas em andamento": "Goals in progress",
 "Metas que avançaram": "Goals that moved forward",
 "Metas, objetivos e sonhos, com passos e prazos": "Goals, objectives and dreams, with steps and deadlines",
 "Meu Dia": "My Day",
 "Meu Dia com página livre, projeto de vida, hábitos, quadro dos sonhos, roda da vida, cartas para o futuro e conquistas. Protegido com senha.": "My Day with a free page, life plan, habits, vision board, wheel of life, letters to the future and achievements. Password protected.",
 "Minimalista": "Minimalist",
 "Mostrar as contas antes do vencimento": "Show bills before the due date",
 "Mostrar datas, horários, moeda e feriados certos para onde você está. A localização aproximada do celular só é usada quando você pede o clima do dia no Diário, e não fica guardada.": "Show dates, times, currency and holidays correctly for where you are. The phone's approximate location is only used when you ask for today's weather in the Diary, and it isn't stored.",
 "Muito bem": "Very good",
 "Muito mal": "Very bad",
 "Mural de fotos dos seus sonhos": "Photo board of your dreams",
 "Mural, relatório e revisão do mês": "Board, report and monthly review",
 "Médio prazo": "Medium term",
 "N dias cumpridos no mês": "N days completed in the month",
 "N dias seguidos": "N days in a row",
 "NESTE DIA": "ON THIS DAY",
 "Nada a enviar": "Nothing to send",
 "Nenhum estudo registrado nesta semana.": "No study logged this week.",
 "Nenhum hábito ainda. Ex.: \"Comer uma fruta por dia\", \"Beber 2 L de água\", \"Não pular o café da manhã\".": "No habits yet. E.g.: \"Eat a piece of fruit a day\", \"Drink 2 L of water\", \"Don't skip breakfast\".",
 "Nenhum no período.": "None in this period.",
 "Nenhuma": "None",
 "Nenhuma carta ainda.": "No letters yet.",
 "Nenhuma foto ainda.": "No photos yet.",
 "Neutras e opacas": "Neutral and muted",
 "Ninguém encontrado no grupo": "No one found in the group",
 "No computador: {link}": "On the computer: {link}",
 "No navegador, a senha do diário é pedida sempre.": "In the browser, the diary password is always asked.",
 "No último dia do mês: \"Que tal revisar o seu mês? ✨\"": "On the last day of the month: \"How about reviewing your month? ✨\"",
 "Nome da página (opcional)": "Page name (optional)",
 "Nome de quem faz este passo": "Name of who does this step",
 "Nome do vídeo (opcional)": "Video name (optional)",
 "Normal": "Normal",
 "Nota de 0 a 10 para cada área da vida": "Score from 0 to 10 for each area of life",
 "Nota: {a}": "Score: {a}",
 "Nova caixa": "New box",
 "Nova carta": "New letter",
 "Nova meta, objetivo ou sonho": "New goal, objective or dream",
 "Nova senha (6 caracteres ou mais)": "New password (6 characters or more)",
 "Nova área (ex.: Espiritualidade)": "New area (e.g.: Spirituality)",
 "Novo cômodo": "New room",
 "Novo hábito": "New habit",
 "Não dá para excluir em grupo": "Can't delete in bulk",
 "Não enviados": "Not sent",
 "Não estão no grupo (ou com outro nome): {l}": "Not in the group (or under another name): {l}",
 "Não foi possível exportar": "Couldn't export",
 "Não foi possível ouvir agora ({erro}).": "Couldn't listen right now ({erro}).",
 "Não pede a senha do diário. É a única parte que pode ser compartilhada.": "Doesn't ask for the diary password. It's the only part that can be shared.",
 "Não é dia de aula desta turma. A chamada fica como reposição ou aula extra.": "It's not a class day for this class. Attendance will count as a make-up or extra class.",
 "O app avisa {n} dia(s) antes e no dia do vencimento, às 9h. Dá para mudar em Ajustes › Abas › Finanças.": "The app reminds you {n} day(s) before and on the due date, at 9 AM. You can change this in Settings › Tabs › Finance.",
 "O clima automático usa a localização do celular. Sem permissão, ele fica para preencher aqui.": "Automatic weather uses the phone's location. Without permission, you fill it in here.",
 "O conteúdo desta carta não foi encontrado.": "This letter's content wasn't found.",
 "O ditado chega com a versão nova do app. Atualize o My Planner pela loja (ou instale o APK novo) para usar o microfone.": "Dictation comes with the new app version. Update My Planner from the store (or install the new APK) to use the microphone.",
 "O diário pede a senha sempre que você entra nele, mesmo com o app desbloqueado.": "The diary asks for the password every time you enter it, even with the app unlocked.",
 "O diário só abre com essa senha, sempre.": "The diary only opens with this password, always.",
 "O diário é criptografado: sem a senha, ninguém consegue abrir, nem o suporte. Se quiser, dá para apagar o diário e começar um novo (os Projetos em Grupo continuam).": "The diary is encrypted: without the password, no one can open it, not even support. If you want, you can delete the diary and start a new one (Group Projects are kept).",
 "O que aprendi hoje?": "What did I learn today?",
 "O que este mês te ensinou? O que quer levar para o próximo?": "What did this month teach you? What do you want to take into the next one?",
 "O que fica desmarcado some da tela. Os dados continuam guardados.": "Whatever is unchecked disappears from the screen. The data stays saved.",
 "O que foi bom hoje?": "What was good today?",
 "O que foi excluído nos últimos 30 dias": "What was deleted in the last 30 days",
 "O que quero melhorar amanhã?": "What do I want to improve tomorrow?",
 "O que quero mudar agora": "What I want to change now",
 "O que você escreveu nesta carta vai se perder.": "What you wrote in this letter will be lost.",
 "O que você quer fazer com o arquivo?": "What do you want to do with the file?",
 "Objetivo": "Objective",
 "Oculta": "Hidden",
 "Orientação": "Guidance",
 "Orientações, receitas, atestados e materiais para entregar ao paciente, com arquivos. Só o que está aqui é enviado: o prontuário nunca sai por esta pasta.": "Guidance, prescriptions, medical certificates and materials to give the patient, with files. Only what's here is sent: the medical chart never leaves through this folder.",
 "Os dias com página escrita ficam marcados. Toque num dia para abrir.": "Days with a written page are marked. Tap a day to open it.",
 "Os itens saem de vez e não podem mais ser restaurados.": "The items are removed permanently and can no longer be restored.",
 "Outra data": "Another date",
 "Outras moedas": "Other currencies",
 "Ouvindo…": "Listening…",
 "PASSOS": "STEPS",
 "PDF com seus dados e assinatura": "PDF with your details and signature",
 "POR DIA": "PER DAY",
 "POR MATÉRIA": "PER SUBJECT",
 "PROGRESSO": "PROGRESS",
 "Paciente: {nome}": "Patient: {nome}",
 "Para o paciente": "For the patient",
 "Para trocar a forma de abrir, entre no Diário com a senha dele e volte aqui.": "To change how it opens, enter the Diary with its password and come back here.",
 "Para {nome} de {tempo} depois": "To {nome}, {tempo} later",
 "Parar o ditado": "Stop dictation",
 "Parcelado": "Installments",
 "Partes desta aba": "Parts of this tab",
 "Passo": "Step",
 "Pastas arquivadas": "Archived folders",
 "Pastas arquivadas ({n})": "Archived folders ({n})",
 "Pautada": "Lined",
 "Pautada com margem": "Lined with margin",
 "Pedido de exame": "Test request",
 "Pelo que sou grata hoje?": "What am I grateful for today?",
 "Permita o microfone e o reconhecimento de fala para o My Planner nos ajustes do celular.": "Allow microphone and speech recognition for My Planner in your phone's settings.",
 "Personalizar: tipo, cor e tema da folha e cores das bolinhas, só para esta aba": "Customize: paper type, color and theme, and dot colors, just for this tab",
 "Pontilhada": "Dotted",
 "Posto": "Gas station",
 "Preenche o clima do Meu Dia pela localização do celular.": "Fills in My Day's weather from the phone's location.",
 "Preencher pela foto do comprovante": "Fill in from the receipt photo",
 "Primeira vez neste aparelho: digite a senha do diário.": "First time on this device: enter the diary password.",
 "Projeto": "Project",
 "Projeto de Vida": "Life Plan",
 "Projetos com amigos e família (compartilhados)": "Projects with friends and family (shared)",
 "Projetos em Grupo": "Group Projects",
 "Proprietário / Locador": "Owner / Landlord",
 "Páginas arquivadas": "Archived pages",
 "Páginas desta aba": "Pages in this tab",
 "QUANDO ELA ABRE": "WHEN IT OPENS",
 "Qua": "Wed",
 "Quadriculada": "Grid",
 "Quadro dos Sonhos": "Vision Board",
 "Quais partes você vai usar?": "Which parts will you use?",
 "Quando você concluir uma meta ou formar um hábito, ele aparece aqui para celebrar. 🎉": "When you complete a goal or form a habit, it shows up here to celebrate. 🎉",
 "Quanto você pagou?": "How much did you pay?",
 "Quanto você recebeu?": "How much did you receive?",
 "Que tal revisar o seu mês? ✨": "How about reviewing your month? ✨",
 "Quem faz": "Who does it",
 "Quem fez o meu dia melhor?": "Who made my day better?",
 "Quer guardar o comprovante agora?": "Do you want to save the receipt now?",
 "Qui": "Thu",
 "REFLEXÃO DO MÊS": "MONTHLY REFLECTION",
 "Recebeu {v} a mais": "Received {v} more",
 "Recebeu {v} a menos": "Received {v} less",
 "Receita médica": "Prescription",
 "Receitas médicas": "Prescriptions",
 "Recolher": "Collapse",
 "Refeições arquivadas": "Archived meals",
 "Refeições do cronograma feitas (Bem-Estar)": "Scheduled meals done (Wellness)",
 "Referente a (ex.: material, passeio, inscrição)": "For (e.g.: materials, field trip, registration)",
 "Registrar": "Record",
 "Relacionamentos": "Relationships",
 "Relatório de estudos": "Study report",
 "Relatório de realizações": "Achievements report",
 "Relatório em PDF": "PDF report",
 "Renomear, adicionar ou tirar áreas": "Rename, add or remove areas",
 "Reposição": "Make-up class",
 "Restaurado": "Restored",
 "Resumida": "Summary",
 "Resumida: só uma linha com o total. Completa: mostra os itens do dia. Oculta: não aparece. Nada desta aba vira tarefa sozinho.": "Summary: just one line with the total. Full: shows the day's items. Hidden: doesn't appear. Nothing in this tab becomes a task on its own.",
 "Resumo de {nome}": "Summary of {nome}",
 "Resumo do dia": "Day summary",
 "Retângulo": "Rectangle",
 "Revisar antes": "Review first",
 "Revisão do mês": "Monthly review",
 "Roda da Vida": "Wheel of Life",
 "Rosa": "Pink",
 "Sair sem guardar?": "Leave without saving?",
 "Salvar avaliação de hoje": "Save today's assessment",
 "Salvar ou enviar": "Save or send",
 "Seg": "Mon",
 "Segure e arraste as pastas para mudar a ordem. Arraste para a esquerda para arquivar.": "Hold and drag folders to change the order. Swipe left to archive.",
 "Sem chamada neste dia: cobra todos os alunos.": "No attendance on this day: charges all students.",
 "Sem ideia do que escrever? Toque numa pergunta:": "No idea what to write? Tap a question:",
 "Sem registros de humor.": "No mood records.",
 "Sem tema": "No theme",
 "Semana de {d}": "Week of {d}",
 "Senha atual do diário": "Current diary password",
 "Senha do diário": "Diary password",
 "Senha do diário incorreta.": "Incorrect diary password.",
 "Senha do diário trocada": "Diary password changed",
 "Senha própria só do diário": "A separate password just for the diary",
 "Sequência dos hábitos": "Habit streak",
 "Seta": "Arrow",
 "Seu diário, só seu": "Your diary, yours alone",
 "Seu texto de motivação": "Your motivation text",
 "Sex": "Fri",
 "Sonho": "Dream",
 "Suplementos arquivados": "Archived supplements",
 "Sáb": "Sat",
 "Só abre com a senha do diário.": "Only opens with the diary password.",
 "TEMA DECORATIVO": "DECORATIVE THEME",
 "TIPO DE FOLHA": "PAPER TYPE",
 "Tarefas arquivadas": "Archived tasks",
 "Ter": "Tue",
 "Texto para o paciente": "Text for the patient",
 "Tipo, cor e tema da folha": "Paper type, color and theme",
 "Tirar a área \"{a}\"?": "Remove the area \"{a}\"?",
 "Tirar da frase do dia": "Remove from quote of the day",
 "Tirar do arquivo": "Unarchive",
 "Tirar esta foto do quadro?": "Remove this photo from the board?",
 "Tirar esta pergunta?": "Remove this question?",
 "Tirar este vídeo?": "Remove this video?",
 "Todo dia às {h}: \"Como foi o seu dia? ✍️\"": "Every day at {h}: \"How was your day? ✍️\"",
 "Todos os alunos já têm uma cobrança com esta referência.": "All students already have a charge with this reference.",
 "Toque de novo para \"Outros\" (dispensado, atestado...): não conta como falta nem como aula.": "Tap again for \"Other\" (excused, medical certificate...): doesn't count as an absence or as a class.",
 "Toque no círculo para marcar o que fez hoje. Os hábitos não vão para o My Planner sozinhos: use Enviar, no menu ⋮.": "Tap the circle to check off what you did today. Habits don't go to My Planner on their own: use Send, in the ⋮ menu.",
 "Toque num dia para marcar ou desmarcar.": "Tap a day to check or uncheck it.",
 "Toque numa bolinha para trocar a cor. Na página, segurar a bolinha faz o mesmo.": "Tap a dot to change its color. On the page, holding the dot does the same.",
 "Toque para abrir. Arraste para a esquerda para arquivar ou duplicar, ou para a direita para excluir.": "Tap to open. Swipe left to archive or duplicate, or right to delete.",
 "Treino do dia feito (Bem-Estar)": "Today's workout done (Wellness)",
 "Treinos arquivados": "Archived workouts",
 "Trocar a senha do diário": "Change the diary password",
 "Tudo o que você escrever no diário fica criptografado neste dispositivo antes de ir para a sua conta. Ninguém mais consegue ler, nem o suporte.": "Everything you write in the diary is encrypted on this device before going to your account. No one else can read it, not even support.",
 "Tudo o que você exclui fica aqui por 30 dias. Depois disso sai de vez.": "Everything you delete stays here for 30 days. After that it's gone for good.",
 "Título (ex.: Ter uma boa alimentação)": "Title (e.g.: Eat healthy)",
 "Uma cobrança avulsa para cada um dos {n} aluno(s). Para cobrar só um aluno, toque em +.": "A one-off charge for each of the {n} student(s). To charge just one student, tap +.",
 "Uma senha própria, só do diário": "A separate password, just for the diary",
 "Usar a senha do diário": "Use the diary password",
 "Usar como frase do dia": "Use as quote of the day",
 "Usar este valor": "Use this amount",
 "Usar o padrão do app": "Use the app default",
 "Vale para os valores de todas as abas (Finanças, aluguel, mensalidades...).": "Applies to amounts in all tabs (Finance, rent, monthly fees...).",
 "Vale para todas as páginas com escrita (Estudos, Anotações, Diário, Documentos...). Cada aba pode ter o próprio padrão em Ajustes › Abas, e cada página pode mudar a folha no ⋮ › Folha.": "Applies to all writing pages (Studies, Notes, Diary, Documents...). Each tab can have its own default in Settings › Tabs, and each page can change its paper in ⋮ › Page.",
 "Valor da aula extra (por aluno)": "Extra class price (per student)",
 "Valor por aluno": "Price per student",
 "Valor previsto: {v}": "Expected amount: {v}",
 "Vencimento: {d}": "Due: {d}",
 "Ver o comprovante": "View receipt",
 "Verde": "Green",
 "Visualizar": "Preview",
 "Você está como convidado": "You're a guest",
 "Voltar a acompanhar este hábito": "Track this habit again",
 "Voltar ao início da folha": "Back to the top of the page",
 "Voltar ao padrão inicial (folha pautada; preto, azul, vermelho e verde)": "Reset to default (lined paper; black, blue, red and green)",
 "Voltar para a nova avaliação": "Back to the new assessment",
 "Vídeos": "Videos",
 "X vezes por semana": "X times a week",
 "abre em {n} dias": "opens in {n} days",
 "agradável": "pleasant",
 "arquivo": "file",
 "aula extra": "extra class",
 "calor": "hot",
 "chuva": "rain",
 "concluído": "done",
 "céu limpo": "clear sky",
 "de {n} planejados": "of {n} planned",
 "dentro de {p}": "within {p}",
 "enviado em {d}": "sent on {d}",
 "estudados na semana": "studied this week",
 "excluído em {d}": "deleted on {d}",
 "falta 1 dia": "1 day left",
 "faltam {n} dias": "{n} days left",
 "feito {dur} na semana": "done {dur} this week",
 "fresco": "cool",
 "frio": "cold",
 "garoa": "drizzle",
 "hoje não está planejado": "not planned for today",
 "hábito formado ✨": "habit formed ✨",
 "incorreta": "incorrect",
 "neblina": "fog",
 "neve": "snow",
 "nublado": "cloudy",
 "não enviado": "not sent",
 "parcela {k}/{n}": "installment {k}/{n}",
 "passou há {n} dias": "{n} days overdue",
 "pelo Bem-Estar": "via Wellness",
 "poucas nuvens": "few clouds",
 "reposição": "make-up class",
 "sai de vez em {n} dia(s)": "permanently removed in {n} day(s)",
 "sem registros": "no records",
 "tempestade": "storm",
 "tracejado: {d}": "dashed: {d}",
 "ver mais": "see more",
 "ver menos": "see less",
 "{aluno}: {n} de {max}": "{aluno}: {n} of {max}",
 "{d} é feriado: {f}. Registrar mesmo assim?": "{d} is a holiday: {f}. Record anyway?",
 "{f} de {n} passos feitos": "{f} of {n} steps done",
 "{f}/{n} passos": "{f}/{n} steps",
 "{nome} daqui a 1 ano": "{nome} 1 year from now",
 "{nome} daqui a 10 anos": "{nome} 10 years from now",
 "{nome} daqui a 6 meses": "{nome} 6 months from now",
 "{n} aluno(s) recebem só a própria nota de \"{a}\".": "{n} student(s) will get only their own grade for \"{a}\".",
 "{n} aluno(s) receberam a nota.": "{n} student(s) received the grade.",
 "{n} aluno(s) · {v} cada": "{n} student(s) · {v} each",
 "{n} anos": "{n} years",
 "{n} dia(s) antes": "{n} day(s) before",
 "{n} dia(s) cumprido(s) no mês": "{n} day(s) completed in the month",
 "{n} dia(s) registrado(s) · média {e}": "{n} day(s) logged · average {e}",
 "{n} dia(s) registrado(s), média {m} de 6": "{n} day(s) logged, average {m} of 6",
 "{n} dia(s) seguido(s)": "{n} day(s) in a row",
 "{n} dispensada(s) hoje": "{n} skipped today",
 "{n} meses": "{n} months",
 "{n} outro(s)": "{n} other(s)",
 "{n} selecionado(s)": "{n} selected",
 "{n} tarefa(s) concluída(s) no My Planner": "{n} task(s) completed in My Planner",
 "{n} vez(es) por semana": "{n} time(s) a week",
 "{n}x": "{n}x",
 "Água: {a} de {m} ml": "Water: {a} of {m} ml",
 "ÚLTIMAS 8 SEMANAS": "LAST 8 WEEKS",
 "Última parcela em {d}": "Last installment on {d}",
 "é hoje!": "is today!",
 "A mesma do app": "Same as the app",
 "Abrir com o código": "Open with the code",
 "Ainda não criado": "Not created yet",
 "Ao criar, o app mostra um código de recuperação para você guardar.": "When you create it, the app shows a recovery code for you to keep.",
 "Apagar o diário e começar de novo": "Delete the diary and start over",
 "Biometria ou código do dispositivo": "Biometrics or device passcode",
 "Biometria, PIN do dispositivo ou a senha do app. Não precisa criar outra senha.": "Biometrics, device PIN or the app password. No need to create another password.",
 "Bloquear o app": "Lock the app",
 "Cadastre digital, rosto ou um código de bloqueio no dispositivo para usar.": "Set up a fingerprint, face or screen lock code on the device to use this.",
 "Com a biometria ligada, ela aparece primeiro. Se falhar, a mesma janela oferece o código/PIN/padrão do dispositivo; a senha do app continua valendo.": "With biometrics on, it shows up first. If it fails, the same window offers the device passcode/PIN/pattern; the app password still works.",
 "Com ele você recupera o diário se esquecer a senha ou trocar de dispositivo.": "With it you can recover the diary if you forget the password or change devices.",
 "Com este código você recupera o diário se esquecer a senha ou trocar de dispositivo. Guarde em lugar seguro e não mostre a ninguém.": "With this code you can recover the diary if you forget the password or change devices. Keep it somewhere safe and don't show it to anyone.",
 "Como funciona a Roda da Vida": "How the Wheel of Life works",
 "Como o diário abre": "How the diary opens",
 "Crie a senha que vai abrir o diário.": "Create the password that will open the diary.",
 "Crie o PIN do diário (4 a 6 números)": "Create the diary PIN (4 to 6 digits)",
 "Crie o diário de novo para começar.": "Create the diary again to get started.",
 "Código aceito. Crie uma senha nova para o diário.": "Code accepted. Create a new password for the diary.",
 "Código de recuperação": "Recovery code",
 "Código de recuperação (ex.: ABCD-EFGH-...)": "Recovery code (e.g. ABCD-EFGH-...)",
 "Código de recuperação incorreto.": "Incorrect recovery code.",
 "Cômodos": "Rooms",
 "Depois de 1 minuto": "After 1 minute",
 "Depois de {n} minutos": "After {n} minutes",
 "Desenhe o padrão do diário": "Draw the diary pattern",
 "Dias no mês": "Days this month",
 "Dias seguidos": "Days in a row",
 "Digite o seu PIN": "Enter your PIN",
 "Diário ainda não criado": "Diary not created yet",
 "Dê uma nota de 0 a 10 para como você se sente hoje em cada área da vida. O desenho mostra onde a sua vida está equilibrada e onde precisa de atenção. Salve a avaliação e repita de tempos em tempos (por exemplo, todo mês) para comparar e ver a sua evolução. Você pode renomear, adicionar ou tirar áreas.": "Rate how you feel today in each area of life from 0 to 10. The chart shows where your life is balanced and where it needs attention. Save the assessment and repeat it from time to time (for example, every month) to compare and see your progress. You can rename, add or remove areas.",
 "Entre na aba Diário para criar o seu diário.": "Go to the Diary tab to create your diary.",
 "Entre no Diário (com a senha dele ou o desbloqueio do app) e volte aqui.": "Open the Diary (with its password or the app unlock) and come back here.",
 "Esconder a senha": "Hide password",
 "Gerar novo código": "Generate new code",
 "Gerar um código de recuperação novo?": "Generate a new recovery code?",
 "Guarde este código": "Keep this code",
 "Já guardei": "I've saved it",
 "Ligar um hábito que já existe": "Link an existing habit",
 "Mostrar a senha": "Show password",
 "Mudar como o diário abre": "Change how the diary opens",
 "My Planner · Código de recuperação do Diário": "My Planner · Diary recovery code",
 "Não foi possível abrir com a chave deste dispositivo. Use a senha do diário ou o código de recuperação.": "Couldn't open with this device's key. Use the diary password or the recovery code.",
 "O Caps Lock parece estar ligado.": "Caps Lock seems to be on.",
 "O PIN fica guardado só neste dispositivo, protegido. A senha continua valendo se você esquecer o PIN.": "The PIN is stored only on this device, protected. Your password still works if you forget the PIN.",
 "O PIN precisa ter de 4 a 6 números.": "The PIN must have 4 to 6 digits.",
 "O código anterior deixa de valer. Por segurança, o código não fica guardado no app: só dá para ver na hora em que é gerado.": "The previous code will stop working. For security, the code isn't stored in the app: you can only see it when it's generated.",
 "O código não fica guardado em lugar nenhum que o suporte possa ver. Sem a senha e sem o código, o diário não pode ser recuperado.": "The code isn't stored anywhere support can see. Without the password and the code, the diary can't be recovered.",
 "O diário agora abre só com a senha dele.": "The diary now opens only with its own password.",
 "O reconhecimento de rosto deste dispositivo não pode ser usado por apps. Use a digital ou o código/PIN do dispositivo.": "This device's face recognition can't be used by apps. Use your fingerprint or the device passcode/PIN.",
 "O tempo conta a partir do momento em que o app sai da tela (outro app, tela inicial ou tela apagada). Puxar as notificações, a janela da biometria, um pedido de permissão ou escolher uma foto ou arquivo não contam.": "The time counts from the moment the app leaves the screen (another app, home screen or screen off). Pulling down notifications, the biometrics window, a permission request or picking a photo or file don't count.",
 "Os PINs não conferem.": "The PINs don't match.",
 "PIN": "PIN",
 "PIN (4 a 6 números)": "PIN (4 to 6 digits)",
 "PIN (só números, 4 a 6)": "PIN (digits only, 4 to 6)",
 "PIN do diário": "Diary PIN",
 "PIN incorreto": "Wrong PIN",
 "PIN salvo.": "PIN saved.",
 "Padrão do app": "App default",
 "Para apagar, confirme com a senha do app, biometria ou PIN do dispositivo. Isso apaga o Meu Dia, metas, hábitos, cartas e fotos do diário. Projetos em Grupo continuam.": "To delete, confirm with the app password, biometrics or device PIN. This deletes My Day, goals, habits, letters and photos in the diary. Group Projects are kept.",
 "Para continuar, digite a senha do app ou use a biometria/o código do dispositivo.": "To continue, enter the app password or use biometrics/the device passcode.",
 "Para recuperar o diário se esquecer a senha ou trocar de dispositivo.": "To recover the diary if you forget the password or change devices.",
 "Pastas": "Folders",
 "Pedir a senha de novo": "Ask for the password again",
 "Personalizada": "Custom",
 "Primeira vez neste dispositivo: digite a senha do diário ou use o código de recuperação.": "First time on this device: enter the diary password or use the recovery code.",
 "Primeira vez neste dispositivo: digite o código de recuperação do diário.": "First time on this device: enter the diary recovery code.",
 "Reconhecimento de rosto": "Face recognition",
 "Repita o PIN": "Repeat the PIN",
 "Salvar a senha nova": "Save new password",
 "Salvar em arquivo / no Drive": "Save to file / Drive",
 "Salvar o código de recuperação": "Save the recovery code",
 "Senha (letras e números)": "Password (letters and numbers)",
 "Senha do app": "App password",
 "Senha nova do diário": "New diary password",
 "Senha própria": "Own password",
 "Senha própria do diário": "Diary's own password",
 "Tarefas": "Tasks",
 "Trocar o PIN": "Change PIN",
 "Usar a senha": "Use password",
 "Usar o PIN": "Use PIN",
 "Usar o código de recuperação": "Use the recovery code",
 "Usar o desbloqueio do app": "Use the app unlock",
 "Use a biometria ou o código/PIN/padrão do dispositivo.": "Use biometrics or the device passcode/PIN/pattern.",
 "Use o código de recuperação que apareceu quando o diário foi criado. Sem a senha e sem o código, ninguém consegue abrir o diário, nem o suporte.": "Use the recovery code that appeared when the diary was created. Without the password and the code, no one can open the diary, not even support.",
 "Voltar a usar só a senha?": "Go back to using only the password?",
 "incorreto": "incorrect",
 "1 h": "1 h",
 "12 horas (2:30 PM)": "12-hour (2:30 PM)",
 "15 min": "15 min",
 "24 horas (14:30)": "24-hour (14:30)",
 "30 min": "30 min",
 "A lixeira tem itens grandes. Confirme com a senha do app, a biometria ou o código do dispositivo.": "The trash has large items. Confirm with the app password, biometrics or the device passcode.",
 "A semana começa na": "The week starts on",
 "Abra o Diário primeiro": "Open the Diary first",
 "Abrir configurações do celular": "Open phone settings",
 "Agenda e mapas": "Calendar & maps",
 "Agora: {m}": "Now: {m}",
 "Ajuda e sobre": "Help & about",
 "Alarme (som)": "Alarm (sound)",
 "Alarme ou vibração das pausas": "Break alarm or vibration",
 "Apaga para sempre a conta e todos os dados na nuvem e neste dispositivo. Pede a sua senha antes.": "Permanently deletes the account and all data in the cloud and on this device. Asks for your password first.",
 "Apagar todas ({n})": "Delete all ({n})",
 "Apagar {n} selecionada(s)": "Delete {n} selected",
 "Aparência": "Appearance",
 "App das rotas": "Navigation app",
 "Ardósia": "Slate",
 "Arrastar para a direita": "Swipe right",
 "Arrastar para a esquerda": "Swipe left",
 "As contas de Finanças aparecem no My Planner com essa antecedência.": "Finance bills show up in My Planner this far in advance.",
 "Atualizações e sobre": "Updates & about",
 "Avisar antes do vencimento": "Remind before due date",
 "Aviso marcado": "Reminder set",
 "Aviso no começo e no fim de cada pausa": "Notice at the start and end of each break",
 "Avisos desta aba": "Notifications for this tab",
 "Avisos e alarmes": "Notifications & alarms",
 "Avisos silenciosos": "Silent notifications",
 "Avisos: som e vibração": "Notifications: sound and vibration",
 "Avisos: só som": "Notifications: sound only",
 "Avisos: só vibração": "Notifications: vibration only",
 "Azul elétrico": "Electric blue",
 "Azul-aço": "Steel blue",
 "Azul-bebê": "Baby blue",
 "Azul-marinho": "Navy blue",
 "Baixar meus dados": "Download my data",
 "Baixar todos os meus dados": "Download all my data",
 "Baixar todos os meus dados e excluir a conta (LGPD)": "Download all my data and delete the account (LGPD)",
 "Biometria": "Biometrics",
 "Bissexual": "Bisexual",
 "Brilhante": "Bright",
 "Buscar abas": "Search tabs",
 "Buscar nos ajustes": "Search settings",
 "Cancelar aviso": "Cancel reminder",
 "Cinza-chumbo": "Charcoal gray",
 "Cofre": "Vault",
 "Coloque pelo menos uma matéria.": "Add at least one subject.",
 "Como usar": "How to use",
 "Conexões": "Connections",
 "Cor da aba": "Tab color",
 "Cor de destaque": "Accent color",
 "Crie uma matéria primeiro": "Create a subject first",
 "Cítrico": "Citrus",
 "Cópia de segurança em arquivo": "Backup file",
 "Dados de paciente e prontuário. Confirme com a senha do app, a biometria ou o código do dispositivo.": "Patient data and medical records. Confirm with the app password, biometrics or the device passcode.",
 "Desligadas": "Off",
 "Digite a senha da sua conta para confirmar.": "Enter your account password to confirm.",
 "Duração padrão de uma tarefa nova": "Default length of a new task",
 "Editar sessão": "Edit session",
 "Ela se repete sem data de fim: aparecem as vezes até {data}. Com todas marcadas, sai a tarefa inteira.": "It repeats with no end date: occurrences up to {data} are shown. If all are checked, the whole task is removed.",
 "Em atividade": "Active",
 "Em pausa": "On break",
 "Emoji da pausa": "Break emoji",
 "Encerrar": "End",
 "Encerrar a sessão?": "End the session?",
 "Entra no modo seleção, para escolher vários itens de uma vez.": "Enters selection mode, to choose several items at once.",
 "Escolha um horário no futuro.": "Choose a time in the future.",
 "Escolher a matéria": "Choose the subject",
 "Esconde os valores em dinheiro (R$ •••)": "Hides money amounts (R$ •••)",
 "Esconder o CPF": "Hide CPF",
 "Esconder os valores": "Hide amounts",
 "Esta e as próximas": "This and following",
 "Esta tarefa se repete. Onde aplicar a mudança?": "This task repeats. Where should the change apply?",
 "Este item tem muita coisa dentro. Confirme com a senha do app, a biometria ou o código do dispositivo.": "This item has a lot inside it. Confirm with the app password, biometrics or the device passcode.",
 "Exclui o item (pede confirmação). Depois dá para desfazer ou restaurar pela Lixeira.": "Deletes the item (asks for confirmation). You can then undo or restore it from the Trash.",
 "Excluir minha conta": "Delete my account",
 "Ficha protegida": "Protected record",
 "Formato da hora": "Time format",
 "Foto do Quadro dos Sonhos": "Vision Board photo",
 "Geral": "General",
 "Gestos": "Gestures",
 "Google Drive, OneDrive e arquivo de cópia": "Google Drive, OneDrive and backup file",
 "Grafite": "Graphite",
 "Guardar em": "Save to",
 "Hábito do Diário": "Diary habit",
 "Idioma e moeda": "Language & currency",
 "Inspiração do Diário": "Diary inspiration",
 "Intenso": "Intense",
 "Item arquivado": "Item archived",
 "Item excluído": "Item deleted",
 "Lavanda": "Lavender",
 "Ligadas": "On",
 "Limite de energia": "Energy limit",
 "Lésbica": "Lesbian",
 "Marque as vezes que vão ser apagadas.": "Check the occurrences that will be deleted.",
 "Matéria": "Subject",
 "Me avise em…": "Remind me in…",
 "Menta": "Mint",
 "Menu ⋮": "Menu ⋮",
 "Meta do Diário": "Diary goal",
 "Modo discreto": "Discreet mode",
 "Monte a sessão uma vez (matérias, tempo de cada uma e pausas) e repita nos outros dias tocando em Começar. O tempo estudado entra sozinho na meta.": "Set up the session once (subjects, time for each and breaks) and repeat it on other days by tapping Start. The time studied counts toward the goal automatically.",
 "Mostra Arquivar e Duplicar.": "Shows Archive and Duplicate.",
 "Mostrar feriados no topo": "Show holidays at the top",
 "Mostrar os valores": "Show amounts",
 "Muda a ordem dos itens.": "Changes the order of items.",
 "Muda só a cor do My Planner. A cor de destaque do app fica em Ajustes > Aparência. Cada tarefa pode ter uma cor própria na ficha.": "Changes only the My Planner color. The app's accent color is in Settings > Appearance. Each task can have its own color in its details.",
 "Nada encontrado nos ajustes.": "Nothing found in settings.",
 "Nenhuma sessão salva ainda.": "No saved sessions yet.",
 "Neon": "Neon",
 "Nesse horário o app não toca nem vibra. Os avisos continuam chegando, em silêncio.": "During this time the app won't ring or vibrate. Notifications still arrive, silently.",
 "No menu ⋮ de qualquer item: o celular avisa na hora escolhida, sem criar tarefa no My Planner.": "In the ⋮ menu of any item: your phone reminds you at the chosen time, without creating a task in My Planner.",
 "Nome (ex.: Sessão do mestrado)": "Name (e.g., Master's session)",
 "Nova sessão": "New session",
 "Nuvem e cópias de segurança": "Cloud & backups",
 "Não perturbe": "Do not disturb",
 "Não perturbe {de}–{ate}": "Do not disturb {de}–{ate}",
 "Não-binário": "Non-binary",
 "O botão 🎉 Feriados no topo do My Planner. O país e a lista de feriados ficam em Ajustes > Feriados.": "The 🎉 Holidays button at the top of My Planner. The country and the holiday list are in Settings > Holidays.",
 "O celular avisa às {h}.": "Your phone will remind you at {h}.",
 "O que sai do Diário fica cifrado na lixeira. Entre no Diário e depois volte aqui para restaurar.": "Whatever leaves the Diary stays encrypted in the trash. Open the Diary and then come back here to restore.",
 "O que sair fica na Lixeira por 30 dias. Digite a senha da sua conta para confirmar.": "Whatever is removed stays in the Trash for 30 days. Enter your account password to confirm.",
 "O que saiu fica na Lixeira por 30 dias.": "What was removed stays in the Trash for 30 days.",
 "O tema muda as cores das abas, a cor de destaque e um toque leve no fundo, nos modos claro e escuro. Para trocar a cor de uma aba só, vá em Ajustes > Abas.": "The theme changes the tab colors, the accent color and a light tint in the background, in light and dark modes. To change the color of a single tab, go to Settings > Tabs.",
 "O tempo estudado até agora entra na meta.": "The time studied so far counts toward the goal.",
 "Oliva": "Olive",
 "Orgulho": "Pride",
 "Os avisos funcionam no app instalado, com as notificações ligadas.": "Notifications work in the installed app, with notifications turned on.",
 "Os gestos do app": "The app's gestures",
 "Outro (escolher a hora)": "Other (choose the time)",
 "Pansexual": "Pansexual",
 "Para ligar, use o app no celular (Ajustes › Agenda e mapas › Agenda do Google). Depois, tudo aparece aqui também.": "To turn it on, use the app on your phone (Settings › Calendar & maps › Google Calendar). After that, everything shows up here too.",
 "Para não perguntar mais, escolha o app em Ajustes › Agenda e mapas.": "To stop being asked, choose the app in Settings › Calendar & maps.",
 "Pausa": "Break",
 "Petróleo": "Petrol blue",
 "Pink elétrico": "Electric pink",
 "Preto total": "Pure black",
 "Progresso": "Progress",
 "Pêssego": "Peach",
 "Quantos dias antes as contas aparecem fica em Ajustes > Avisos e alarmes.": "How many days in advance bills show up is set in Settings > Notifications & alarms.",
 "Rosa-chá": "Tea rose",
 "Roxo-profundo": "Deep purple",
 "Segurança e dados": "Security & data",
 "Segurar e arrastar": "Hold and drag",
 "Segurar e soltar": "Hold and release",
 "Selecionar todas": "Select all",
 "Semana começa na {dia}": "Week starts on {dia}",
 "Sessão de estudo": "Study session",
 "Sessão encerrada": "Session ended",
 "Sessão pausada": "Session paused",
 "Som e vibração": "Sound & vibration",
 "Suave": "Soft",
 "Só esta semana": "This week only",
 "Só hoje": "Today only",
 "Só neste dia ({data})": "Only on this day ({data})",
 "Tamanho das caixas": "Box size",
 "Tamanho do texto": "Text size",
 "Tarefa nova": "New task",
 "Tela inicial": "Home screen",
 "Tema e cor de destaque": "Theme & accent color",
 "Testar alerta": "Test alert",
 "Testar alerta, \"Não perturbe\" e as configurações do celular ficam em Ajustes > Avisos e alarmes.": "Test alert, \"Do not disturb\" and phone settings are in Settings > Notifications & alarms.",
 "Testar e conferir": "Test and check",
 "Todas as opções do item: editar, mover, compartilhar, arquivar, excluir...": "All the item's options: edit, move, share, archive, delete...",
 "Toque numa cor do tema {tema} para usar nos botões, no botão + e no item selecionado.": "Tap a color from the {tema} theme to use on buttons, the + button and the selected item.",
 "Total: {dur}": "Total: {dur}",
 "Tropical": "Tropical",
 "Turquesa": "Turquoise",
 "Um arquivo com todos os seus dados do My Planner, para guardar ou levar para outro lugar (portabilidade, LGPD).": "A file with all your My Planner data, to keep or take somewhere else (portability, LGPD).",
 "Usar no computador, pelo navegador": "Use on a computer, in the browser",
 "Usar o padrão": "Use default",
 "Usar o padrão ({emoji})": "Use default ({emoji})",
 "Use o app no celular para baixar o arquivo.": "Use the app on your phone to download the file.",
 "Vale para todas as abas. Cada aba pode ter o seu em Ajustes > Abas.": "Applies to all tabs. Each tab can have its own in Settings > Tabs.",
 "Valem para as tarefas com pausas. Cada tarefa pode mudar o alarme e o emoji na própria ficha.": "Apply to tasks with breaks. Each task can change the alarm and emoji in its own details.",
 "Ver lista": "View list",
 "Ver o CPF inteiro": "Show full CPF",
 "Verde-floresta": "Forest green",
 "Verde-água": "Aquamarine",
 "Vibração": "Vibration",
 "Vinho": "Wine",
 "Você pediu para ser avisado agora.": "You asked to be reminded now.",
 "Você pode: confirmar se tratamos seus dados, acessar, corrigir, pedir a portabilidade (baixar os seus dados em Ajustes > Meus dados), pedir a exclusão, saber com quem compartilhamos, revogar o consentimento e reclamar na ANPD.": "You can: confirm whether we process your data, access it, correct it, request portability (download your data in Settings > My details), request deletion, find out who we share it with, withdraw consent and file a complaint with the ANPD.",
 "Voltar ao filtro": "Back to filter",
 "Voltar à lista": "Back to list",
 "Vá em Ajustes › My Planner Web e toque em \"Conectar navegador\".": "Go to Settings › My Planner Web and tap \"Connect browser\".",
 "atividade {n} de {total}": "activity {n} of {total}",
 "matéria {n} de {t}": "subject {n} of {t}",
 "padrão": "default",
 "pausa em {n} min": "break in {n} min",
 "pausa {n} de {total}": "break {n} of {total}",
 "termina em {n} min": "ends in {n} min",
 "todas as vezes": "all occurrences",
 "troca em {n} min": "switches in {n} min",
 "volta em {n} min": "back in {n} min",
 "{nome} · {n} dia(s)": "{nome} · {n} day(s)",
 "{n} de {total} vezes": "{n} of {total} occurrences",
 "{n} itens arquivados": "{n} items archived",
 "{n} itens excluídos": "{n} items deleted",
 "{n} marcada(s)": "{n} checked",
 "{n} vezes": "{n} times",
 "{rotulo}: {feito} min / {total}": "{rotulo}: {feito} min / {total}",
 "📔 Diário": "📔 Diary",
 "Agendados": "Scheduled",
 "Atrasado": "Overdue",
 "Atrasado: {v}": "Overdue: {v}",
 "Atualizar o a receber": "Update receivables",
 "Até (fim do contrato, se houver)": "Until (end of contract, if any)",
 "Clínica": "Clinic",
 "Conta cada dia com chamada feita ou com plano de aula marcado como \"Aula dada\".": "Counts each day with attendance taken or with a lesson plan marked as \"Class taught\".",
 "Data do recebimento": "Date received",
 "Data prevista do pagamento": "Expected payment date",
 "Desmarcar como recebido": "Unmark as received",
 "Dia do pagamento": "Payday",
 "Diferença: {v} (juros/multa)": "Difference: {v} (interest/penalty)",
 "Diferença: {v} (taxas/descontos)": "Difference: {v} (fees/deductions)",
 "Escolas, universidades e cursos que pagam você. Com salário fixo, o app gera o a receber de todo mês; por hora-aula, soma as aulas dadas nas turmas ligadas à instituição.": "Schools, universities and courses that pay you. With a fixed salary, the app creates each month's receivable; per class-hour, it adds up the classes taught in the classes linked to the institution.",
 "Escolha o tipo de pagamento (Editar) para o app calcular o que você tem a receber.": "Choose the payment type (Edit) so the app can calculate what you're owed.",
 "Este valor vem da parte \"Onde trabalho\" da aba {aba}. Marque aqui como recebido ou abra a aba para ver a instituição.": "This amount comes from the \"Where I work\" section of the {aba} tab. Mark it as received here or open the tab to see the institution.",
 "Ex.: Colégio Estadual, Universidade Federal": "E.g.: State High School, Federal University",
 "Ex.: Hospital Santa Casa, Clínica Vida": "E.g.: Santa Casa Hospital, Vida Clinic",
 "Ex.: Salário de outubro, 13º, férias": "E.g.: October salary, 13th salary, vacation pay",
 "Feitos": "Done",
 "Horas-aula de cada aula": "Class-hours per class",
 "Hospitais e clínicas que pagam você. Com salário fixo, o app gera o a receber de todo mês; por plantão ou atendimento, marque os feitos e o app calcula.": "Hospitals and clinics that pay you. With a fixed salary, the app creates each month's receivable; per shift or appointment, mark the ones done and the app calculates.",
 "Hospital": "Hospital",
 "Instituição": "Institution",
 "Instituição (Onde trabalho)": "Institution (Where I work)",
 "Ligue as turmas a esta instituição (na turma, Editar › Instituição) para o app somar as aulas dadas.": "Link classes to this institution (in the class, Edit › Institution) so the app can add up the classes taught.",
 "Marque cada plantão ou atendimento como feito: o app soma e calcula o valor do mês.": "Mark each shift or appointment as done: the app adds them up and calculates the month's amount.",
 "Marque cada plantão ou atendimento feito nesta instituição. O app soma e calcula o valor a receber do mês.": "Mark each shift or appointment done at this institution. The app adds them up and calculates the month's amount to receive.",
 "Nome da instituição": "Institution name",
 "O que a instituição tem a pagar a você, mês a mês. Marque como recebido quando o dinheiro entrar: vai junto para a aba Finanças.": "What the institution owes you, month by month. Mark as received when the money comes in: it also goes to the Finances tab.",
 "Onde trabalho": "Where I work",
 "Plantão": "Shift",
 "Plantão ou atendimento": "Shift or appointment",
 "Plantões e atendimentos": "Shifts and appointments",
 "Por atendimento ou procedimento": "Per appointment or procedure",
 "Por hora-aula": "Per class-hour",
 "Por plantão": "Per shift",
 "Previsto: {v}": "Expected: {v}",
 "Previsão do mês: {v}": "Month forecast: {v}",
 "Quantidade (aulas, plantões ou atendimentos)": "Quantity (classes, shifts or appointments)",
 "Recebe no mês seguinte ao trabalhado": "Paid the month after the work",
 "Receber: {t}": "Receive: {t}",
 "Recebimentos": "Payments received",
 "Salário": "Salary",
 "Salário (valor do mês)": "Salary (monthly amount)",
 "Salário fixo": "Fixed salary",
 "Telefone (RH ou financeiro)": "Phone (HR or finance)",
 "Tipo de pagamento": "Payment type",
 "Universidade": "University",
 "Valor da hora-aula": "Class-hour rate",
 "Valor de cada um (se for diferente)": "Amount for each (if different)",
 "Valor do plantão": "Shift rate",
 "Valor por atendimento ou procedimento": "Amount per appointment or procedure",
 "Valor previsto": "Expected amount",
 "feito": "done",
 "recebido em {d}": "received on {d}",
 "{n} aula(s) dada(s)": "{n} class(es) taught",
 "{n} hora(s)-aula": "{n} class-hour(s)",
 "{n} plantão(ões)": "{n} shift(s)",
 "Abas do My Planner Anne": "My Planner Anne tabs",
 "Acesso ao Não perturbe": "Do Not Disturb access",
 "Alarme dos remédios (mesmo no silencioso)": "Medication alarm (even on silent)",
 "Algodão-doce": "Cotton candy",
 "Aplicar tema": "Apply theme",
 "As cores próprias de cada tema: floral rosado, folhas verdes, céu azul...": "Each theme's own colors: pink floral, green leaves, blue sky...",
 "Assim ficam as letras no app.": "This is how text looks in the app.",
 "Automática": "Automatic",
 "Baht tailandês": "Thai baht",
 "Boliviano": "Bolivian boliviano",
 "Bolívar venezuelano": "Venezuelan bolívar",
 "Botão": "Button",
 "Buscar moeda": "Search currency",
 "Cor do desenho": "Drawing color",
 "Coroa dinamarquesa": "Danish krone",
 "Coroa norueguesa": "Norwegian krone",
 "Coroa sueca": "Swedish krona",
 "Coroa tcheca": "Czech koruna",
 "Crepúsculo": "Twilight",
 "Crescente": "Rising",
 "Curta": "Short",
 "Despesas em outra moeda (fora do lucro): {v}": "Expenses in another currency (not in profit): {v}",
 "Dirham dos Emirados Árabes Unidos": "UAE dirham",
 "Dirham marroquino": "Moroccan dirham",
 "Do seu país": "From your country",
 "Dong vietnamita": "Vietnamese dong",
 "Dupla": "Double",
 "Dólar americano": "US dollar",
 "Dólar australiano": "Australian dollar",
 "Dólar canadense": "Canadian dollar",
 "Dólar de Hong Kong": "Hong Kong dollar",
 "Dólar de Singapura": "Singapore dollar",
 "Dólar neozelandês": "New Zealand dollar",
 "Envia todos os itens desta lista, inclusive os novos que forem criados depois.": "Sends all items in this list, including new ones created later.",
 "Enviar todos para a equipe": "Send all to the team",
 "Escolha se o alarme deste remédio deve tocar mesmo com o celular no silencioso.": "Choose whether this medication's alarm should ring even when your phone is on silent.",
 "Euro": "Euro",
 "Exemplo": "Example",
 "Falta uma resposta": "One answer missing",
 "Folha, tema e cores da caneta e das letras": "Page, theme, and pen and text colors",
 "Franco suíço": "Swiss franc",
 "Guarani paraguaio": "Paraguayan guaraní",
 "Hryvnia ucraniana": "Ukrainian hryvnia",
 "Iene japonês": "Japanese yen",
 "Kwanza angolano": "Angolan kwanza",
 "Libra egípcia": "Egyptian pound",
 "Libra esterlina": "Pound sterling",
 "Lira turca": "Turkish lira",
 "Longa": "Long",
 "Mais usadas": "Most used",
 "Metical moçambicano": "Mozambican metical",
 "Na página, segurar a bolinha faz o mesmo.": "On the page, holding the dot does the same.",
 "Naira nigeriana": "Nigerian naira",
 "Nenhuma moeda encontrada": "No currency found",
 "No Android, para o alarme do remédio tocar com o \"Não perturbe\" ligado, o celular precisa permitir o acesso ao \"Não perturbe\" para o My Planner. Toque em \"Abrir configurações\", procure o My Planner na lista e ligue a permissão.": "On Android, for the medication alarm to ring with \"Do Not Disturb\" on, your phone must allow \"Do Not Disturb\" access for My Planner. Tap \"Open settings\", find My Planner in the list and turn on the permission.",
 "No My Planner": "In My Planner",
 "No iPhone, o silencioso do celular pode impedir o alarme. Deixe o celular no modo normal.": "On iPhone, silent mode may block the alarm. Keep your phone in normal mode.",
 "No iPhone, o ▶ mostra uma ideia de cada tipo. Os avisos de verdade usam a vibração padrão do iPhone.": "On iPhone, ▶ gives an idea of each type. Real alerts use the iPhone's default vibration.",
 "Novo dólar taiwanês": "New Taiwan dollar",
 "Novo shekel israelense": "Israeli new shekel",
 "Ouvir/Sentir": "Hear/Feel",
 "Peso argentino": "Argentine peso",
 "Peso chileno": "Chilean peso",
 "Peso colombiano": "Colombian peso",
 "Peso filipino": "Philippine peso",
 "Peso mexicano": "Mexican peso",
 "Peso uruguaio": "Uruguayan peso",
 "Política de privacidade": "Privacy policy",
 "Pronto. Bloqueie a tela e espere 1 minuto: o aviso deve aparecer em silêncio.": "Done. Lock the screen and wait 1 minute: the alert should appear silently.",
 "Pronto. Bloqueie a tela e espere 1 minuto: o aviso deve aparecer vibrando, sem som.": "Done. Lock the screen and wait 1 minute: the alert should appear with vibration, no sound.",
 "Páginas e canetas": "Pages and pens",
 "Pôr do sol": "Sunset",
 "Rand sul-africano": "South African rand",
 "Real brasileiro": "Brazilian real",
 "Ringgit malaio": "Malaysian ringgit",
 "Riyal saudita": "Saudi riyal",
 "Rublo russo": "Russian ruble",
 "Rupia indiana": "Indian rupee",
 "Rupia indonésia": "Indonesian rupiah",
 "Rupia paquistanesa": "Pakistani rupee",
 "Se o My Planner não aparecer na lista, essa permissão chega na próxima versão do app (atualize pela loja).": "If My Planner isn't in the list, this permission comes in the next app version (update from the store).",
 "Sentir": "Feel",
 "Sol peruano": "Peruvian sol",
 "São as cores rápidas da caneta e das letras nas páginas. A primeira é a cor padrão ao abrir uma página. Toque numa bolinha para trocar a cor dela.": "These are the quick pen and text colors on the pages. The first is the default color when you open a page. Tap a dot to change its color.",
 "Taka bengali": "Bangladeshi taka",
 "Teste grátis por {n} dias": "Free trial for {n} days",
 "Tipo de vibração": "Vibration type",
 "Tirar do My Planner": "Remove from My Planner",
 "Tocar mesmo no silencioso e no Não perturbe": "Ring even on silent and Do Not Disturb",
 "Tocar só se o celular estiver no normal": "Ring only if the phone is in normal mode",
 "Todos os itens desta lista aparecem no My Planner, inclusive os novos.": "All items in this list appear in My Planner, including new ones.",
 "Vaga-lume": "Firefly",
 "Vale para todos os avisos que vibram (Vibração e Som e vibração).": "Applies to all alerts that vibrate (Vibration and Sound and vibration).",
 "Won sul-coreano": "South Korean won",
 "Xelim queniano": "Kenyan shilling",
 "Yuan chinês": "Chinese yuan",
 "Zloty polonês": "Polish złoty",
 "🔕🔇 O alarme deste remédio deve tocar mesmo com o celular no silencioso?": "🔕🔇 Should this medication's alarm ring even when your phone is on silent?",
 "A galeria de fotos chega na próxima versão do app. Por enquanto, use Arquivos ou Tirar foto.": "The photo gallery is coming in the next version of the app. For now, use Files or Take photo.",
 "Abrir o fichário do grupo": "Open the group's binder",
 "Arrastar a barra": "Drag the bar",
 "Assim que o fichário for compartilhado, ele aparece aqui.": "As soon as the binder is shared, it shows up here.",
 "Buscar ícone pelo nome (ex.: livro, casa, café)": "Search icons by name (e.g. book, house, coffee)",
 "Com a aba Estudos você cria seus fichários, usa o cronômetro, acompanha seu relatório e muito mais. ✨": "With the Study tab you create your binders, use the timer, follow your report and much more. ✨",
 "Com a aba {aba} você cria o que é seu e usa todos os recursos. ✨": "With the {aba} tab you create your own things and use every feature. ✨",
 "Conhecer a aba": "Explore the tab",
 "Crie um fichário em Estudos e volte aqui.": "Create a binder in Study and come back here.",
 "Em sessão": "In session",
 "Encerrar e salvar o cronômetro e começar a sessão?": "Stop and save the timer, then start the session?",
 "Encerrar e salvar o cronômetro e continuar a sessão?": "Stop and save the timer, then continue the session?",
 "Enquadre e toque no botão": "Frame it and tap the button",
 "Escolha o fichário que os colegas vão ver na tela (só para ler).": "Choose the binder your classmates will see on screen (read-only).",
 "Esconder": "Hide",
 "Este arquivo está guardado só no dispositivo ou no Drive de quem compartilhou, por isso não aparece aqui.": "This file is stored only on the device or in the Drive of the person who shared it, so it doesn't appear here.",
 "Fichário do grupo": "Group binder",
 "Guia passo a passo do app e de cada aba": "Step-by-step guide to the app and each tab",
 "Há um cronômetro em andamento.": "A timer is running.",
 "Há uma sessão em andamento.": "A session is in progress.",
 "Inserir imagem": "Insert image",
 "Mais ícones": "More icons",
 "Nenhum ícone com esse nome. Tente outra palavra ou escolha numa categoria.": "No icon with that name. Try another word or pick a category.",
 "Nenhuma matéria neste fichário ainda.": "No subjects in this binder yet.",
 "Nenhuma página nesta matéria ainda.": "No pages in this subject yet.",
 "No grupo de estudos, imagens e PDFs abrem aqui na tela. Este tipo de arquivo não tem visualização dentro do app.": "In the study group, images and PDFs open here on screen. This file type can't be previewed in the app.",
 "Não deu para mostrar agora. Confira a internet e tente de novo.": "Couldn't show it right now. Check your internet connection and try again.",
 "O compartilhamento de fichários ainda está sendo preparado. Volte daqui a pouco.": "Binder sharing is still being prepared. Check back in a little while.",
 "O fichário deste grupo está em outro dispositivo seu. Ele continua compartilhado a partir de lá.": "This group's binder is on another one of your devices. It stays shared from there.",
 "OK = Conhecer a aba · Cancelar = Agora não": "OK = Explore the tab · Cancel = Not now",
 "Os colegas deixam de ver o fichário. Tudo continua com você.": "Your classmates will no longer see the binder. Everything stays with you.",
 "Os colegas veem este fichário na tela, só para ler: não editam, não baixam, não imprimem e não compartilham. As suas metas, o cronômetro e as páginas revisadas continuam só seus.": "Your classmates see this binder on screen, read-only: they can't edit, download, print or share it. Your goals, timer and reviewed pages stay yours alone.",
 "Para ver PDFs aqui na tela, instale a versão mais nova do app pela loja.": "To view PDFs here on screen, install the latest version of the app from the store.",
 "Parar de compartilhar": "Stop sharing",
 "Pausar a sessão": "Pause the session",
 "Pausar a sessão e estudar só esta?": "Pause the session and study only this one?",
 "Página em branco.": "Blank page.",
 "Quer estudar com tudo isso?": "Want to study with all of this?",
 "Quer usar tudo isso?": "Want to use all of this?",
 "Selecionar todos": "Select all",
 "Trocar fichário": "Change binder",
 "Você está participando do grupo de {nome}": "You're taking part in {nome}'s group",
 "Você vê na tela o que foi compartilhado neste grupo, para ler e acompanhar.": "You see on screen what was shared in this group, to read and follow along.",
 "abacate, fruta": "avocado, fruit",
 "academia, musculação, treino, peso": "gym, weightlifting, workout, weights",
 "acampamento, camping": "camp, camping",
 "alfinete, fixar, importante": "pin, pushpin, important",
 "almoço, arroz, prato": "lunch, rice, plate",
 "alvo, meta, objetivo, foco": "target, goal, objective, focus",
 "aniversário, bolo": "birthday, cake",
 "anotação, nota, lista, escrever": "note, memo, list, write",
 "arco-íris": "rainbow",
 "avião, viagem, voo": "airplane, travel, flight",
 "balança, direito, justiça, lei, processo": "scales, law, justice, legal, lawsuit",
 "balde, limpeza": "bucket, cleaning",
 "banana, fruta": "banana, fruit",
 "banheira, banho, banheiro": "bathtub, bath, bathroom",
 "barbear, barba, lâmina": "shave, beard, razor",
 "bicicleta, pedalar, bike": "bicycle, cycling, bike",
 "bolo, doce, sobremesa": "cake, dessert, sweets",
 "brilho, mágica": "sparkles, magic",
 "cabelo, cabeleireiro, corte": "hair, hairdresser, haircut",
 "cachorro, cão, pet": "dog, puppy, pet",
 "caderno": "notebook",
 "caderno, fichário, amarelo": "notebook, binder, yellow",
 "café, xícara, pausa": "coffee, cup, break",
 "caixa, pacote, mudança, entrega": "box, package, moving, delivery",
 "calendário, agenda, data": "calendar, schedule, date",
 "cama, quarto": "bed, bedroom",
 "caminhada, caminhar, andar": "walk, walking, stroll",
 "camisa, gravata, roupa, trabalho": "shirt, tie, clothes, work",
 "carne, churrasco": "meat, barbecue",
 "carrinho, mercado, compras, supermercado": "cart, market, shopping, supermarket",
 "carro, dirigir, veículo": "car, drive, vehicle",
 "certo, feito, visto": "check, done, tick",
 "cesto, roupa, lavanderia, lavar roupa": "basket, clothes, laundry, washing",
 "chave de fenda, ferramenta, conserto": "screwdriver, tool, repair",
 "chave, senha": "key, password",
 "chocolate, doce": "chocolate, sweets",
 "chuveiro, banho": "shower, bath",
 "chá, xícara": "tea, cup",
 "compras, sacolas, shopping": "shopping, bags, mall",
 "computador, monitor, tela": "computer, monitor, screen",
 "computador, notebook, informática": "computer, laptop, IT",
 "coração amarelo": "yellow heart",
 "coração azul": "blue heart",
 "coração branco": "white heart",
 "coração laranja": "orange heart",
 "coração roxo": "purple heart",
 "coração verde": "green heart",
 "coração, amor, saúde, vermelho": "heart, love, health, red",
 "corrida, correr": "running, run",
 "creme, hidratante, pele, skincare": "cream, moisturizer, skin, skincare",
 "croissant, pão, café da manhã": "croissant, bread, breakfast",
 "câmera, foto, fotografia": "camera, photo, photography",
 "cérebro, mente, memória, pensar": "brain, mind, memory, think",
 "dado, jogo de tabuleiro": "dice, board game",
 "dente, dentista": "tooth, dentist",
 "despertador, relógio, alarme, acordar": "alarm clock, clock, alarm, wake up",
 "diamante, joia": "diamond, jewel",
 "dinheiro, pagar, conta, pagamento": "money, pay, bill, payment",
 "dormir, sono, descanso": "sleep, sleeping, rest",
 "e-mail, mensagem, carta": "email, message, letter",
 "escada": "stairs",
 "escova de dentes, dentes": "toothbrush, teeth",
 "escrever, redação, caneta": "write, essay, pen",
 "esponja, lavar louça": "sponge, wash dishes",
 "esquadro, régua, geometria, desenho técnico": "set square, ruler, geometry, technical drawing",
 "estrela brilhante, destaque": "glowing star, highlight",
 "estrela, favorito": "star, favorite",
 "etiqueta, marcador": "tag, label",
 "extintor, segurança, incêndio": "fire extinguisher, safety, fire",
 "falar, idioma, inglês, conversa": "speak, language, English, conversation",
 "feito, concluído, certo": "done, completed, check",
 "ferramenta, conserto, manutenção": "tool, repair, maintenance",
 "festa, comemoração": "party, celebration",
 "filme, cinema, série": "movie, cinema, series",
 "fogo, urgente, sequência": "fire, urgent, streak",
 "folha, natureza, erva, chá": "leaf, nature, herb, tea",
 "fone de ouvido, áudio, música, podcast": "headphones, audio, music, podcast",
 "formatura, capelo, faculdade, diploma, universidade": "graduation, cap, college, diploma, university",
 "força, braço, músculo": "strength, arm, muscle",
 "frango, coxa": "chicken, drumstick",
 "frigideira, cozinhar, ovo, cozinha": "frying pan, cook, egg, kitchen",
 "futebol, bola, esporte": "soccer, football, ball, sport",
 "gato, pet": "cat, pet",
 "gelo, geladeira, congelador": "ice, fridge, freezer",
 "gráfico, planilha, finanças, relatório": "chart, spreadsheet, finance, report",
 "ingresso, show, evento": "ticket, show, event",
 "jogo, videogame, game": "game, video game, gaming",
 "lancha, barco": "speedboat, boat",
 "leite, copo": "milk, glass",
 "letras, alfabeto, português": "letters, alphabet, language arts",
 "link, corrente": "link, chain",
 "livro aberto, leitura, ler": "open book, reading, read",
 "livro azul, caderno": "blue book, notebook",
 "livro laranja, caderno": "orange book, notebook",
 "livro verde, caderno": "green book, notebook",
 "livro vermelho, caderno": "red book, notebook",
 "livros, estudo, estudar, biblioteca": "books, study, studying, library",
 "lixo, lixeira": "trash, trash can",
 "lua, noite": "moon, night",
 "lâmpada, ideia, luz": "light bulb, idea, light",
 "macarrão, massa": "noodles, pasta",
 "maleta, trabalho, escritório, negócios": "briefcase, work, office, business",
 "massagem, relaxar": "massage, relax",
 "maçã, fruta": "apple, fruit",
 "microfone, cantar, karaokê, palestra": "microphone, sing, karaoke, talk",
 "microscópio, ciência, biologia": "microscope, science, biology",
 "mochila, escola, filhos": "backpack, school, kids",
 "montanha, trilha": "mountain, trail",
 "mundo, planeta, geografia": "world, planet, geography",
 "médico, consulta, exame, saúde": "doctor, appointment, checkup, health",
 "música, nota musical": "music, musical note",
 "natação, nadar, piscina": "swimming, swim, pool",
 "olho, visão, oftalmologista": "eye, vision, eye doctor",
 "oração, orar, gratidão, igreja": "prayer, pray, gratitude, church",
 "ovo": "egg",
 "pastas, arquivo, fichário, divisórias": "folders, file, binder, dividers",
 "peixe": "fish",
 "pescaria, pescar": "fishing, fish",
 "pessoas, reunião, equipe, grupo": "people, meeting, team, group",
 "piano, teclado musical": "piano, musical keyboard",
 "pintura, arte, desenho": "painting, art, drawing",
 "pipa": "kite",
 "pipoca, cinema": "popcorn, cinema",
 "pizza": "pizza",
 "planta, vaso, regar": "plant, pot, watering",
 "porta, entrada": "door, entrance",
 "praia, férias": "beach, vacation",
 "prato, refeição, louça, jantar": "plate, meal, dishes, dinner",
 "prédio, história, governo, tribunal": "building, history, government, court",
 "pão, padaria": "bread, bakery",
 "pé, podólogo": "foot, podiatrist",
 "pôr do sol, amanhecer": "sunset, sunrise",
 "quebra-cabeça, peça": "puzzle, piece",
 "queijo": "cheese",
 "raio, energia, rápido": "lightning, energy, fast",
 "refrigerante, suco, bebida": "soda, juice, drink",
 "remédio, medicamento, vitamina, farmácia": "medicine, medication, vitamin, pharmacy",
 "sabão, sabonete, lavar": "soap, bar soap, wash",
 "salada, dieta, verdura": "salad, diet, vegetables",
 "sanduíche, lanche": "sandwich, snack",
 "sino, aviso, lembrete": "bell, notice, reminder",
 "skate": "skateboard",
 "sofá, sala": "sofa, living room",
 "sol, manhã, dia": "sun, morning, day",
 "spa, sauna, autocuidado": "spa, sauna, self-care",
 "teatro, máscaras": "theater, masks",
 "telefone, ligação, ligar": "phone, call, calling",
 "tigela, cereal, sopa, mingau": "bowl, cereal, soup, porridge",
 "trevo, sorte": "clover, luck",
 "troféu, conquista, prêmio": "trophy, achievement, award",
 "tubo de ensaio, química, laboratório": "test tube, chemistry, lab",
 "tênis, esporte": "sneakers, sport",
 "unha, manicure": "nail, manicure",
 "vassoura, limpeza, faxina, varrer": "broom, cleaning, housework, sweep",
 "violão, guitarra": "guitar, acoustic guitar",
 "yoga, meditação, alongamento": "yoga, meditation, stretching",
 "{n} selecionada": "{n} selected",
 "{n} selecionadas": "{n} selected",
 "{n} selecionado": "{n} selected",
 "{n} selecionados": "{n} selected",
 "ábaco, matemática, contas, cálculo, contabilidade": "abacus, math, sums, calculation, accounting",
 "água, gota, hidratar": "water, drop, hydrate",
 "árvore, jardim, quintal": "tree, garden, backyard",
 "ônibus, transporte": "bus, transportation",
 "1 dia antes": "1 day before",
 "1 dia depois": "1 day after",
 "A assinatura é feita no app do celular, pela loja de apps, e vale também aqui no site.": "You subscribe in the phone app, through the app store, and it also applies here on the website.",
 "A chave está incompleta (curta demais). Copie de novo pelo botão de copiar da página da chave.": "The key is incomplete (too short). Copy it again using the copy button on the key page.",
 "A chave tem caracteres que não fazem parte de uma chave. Copie de novo, só a chave, sem texto em volta.": "The key contains characters that are not part of a key. Copy it again, just the key, with no text around it.",
 "A galeria chega na próxima atualização do app.": "The gallery is coming in the next app update.",
 "ALERTAS": "ALERTS",
 "Abra uma aba paga e comece o teste grátis. Depois volte aqui.": "Open a paid tab and start the free trial. Then come back here.",
 "Abrir a barra do editor": "Open the editor bar",
 "Agora é horário do Não perturbe do app: o aviso chega em até 5 segundos, sem som nem vibração.": "It is now the app's Do Not Disturb time: the notification arrives within 5 seconds, with no sound or vibration.",
 "Aguardando confirmação": "Awaiting confirmation",
 "Aguardando envio ao My Planner": "Waiting to be sent to My Planner",
 "Alertas de cada fatura": "Alerts for each bill",
 "Alertas do fim da garantia": "Warranty end alerts",
 "Alertas do vencimento": "Due date alerts",
 "Alertas: {campo}": "Alerts: {campo}",
 "Alvorada": "Daybreak",
 "Ao abrir esta aba, o app pede o mesmo desbloqueio do app (senha, biometria ou PIN). Dá para mudar em Ajustes > Abas.": "When you open this tab, the app asks for the same unlock as the app (password, biometrics or PIN). You can change this in Settings > Tabs.",
 "Ao tocar num arquivo anexado, ele abre no app do celular que você escolher (se o celular perguntar, \"Apenas uma vez\" ou \"Sempre\"). O que você editar lá fica salvo no próprio arquivo.": "When you tap an attached file, it opens in the phone app you choose (if the phone asks, \"Just once\" or \"Always\"). Whatever you edit there is saved in the file itself.",
 "App instalado": "App installed",
 "Apple Watch: já grava tudo no app Saúde do celular. Não precisa fazer nada.": "Apple Watch: it already records everything in the phone's Health app. You don't need to do anything.",
 "Arquivados e fixados": "Archived and pinned",
 "Arquivo para ler e guardar, organizado por aba. Gerado em {data}.": "File to read and keep, organized by tab. Generated on {data}.",
 "As notificações do My Planner estão desligadas no celular.": "My Planner notifications are turned off on the phone.",
 "Atualização automática disponível no app instalado.": "Automatic update available in the installed app.",
 "Aurora": "Aurora",
 "Avisos: alarme (som)": "Notifications: alarm (sound)",
 "Baixar o app": "Download the app",
 "Baixar o arquivo técnico": "Download the technical file",
 "Baixar para ler (PDF)": "Download to read (PDF)",
 "Barra do editor (caneta, marca-texto, texto)": "Editor bar (pen, highlighter, text)",
 "Brisa": "Breeze",
 "Campainha": "Doorbell",
 "Canal": "Channel",
 "Cole a chave antes de testar.": "Paste the key before testing.",
 "Começa em": "Starts on",
 "Como avisar": "How to notify",
 "Confira a chave": "Check the key",
 "Conta de teste de compras": "Purchase test account",
 "Conta vencida": "Bill overdue",
 "Copie a chave na hora (ela só aparece uma vez). Começa com \"sk-\".": "Copy the key right away (it is only shown once). It starts with \"sk-\".",
 "Copie a chave na hora (ela só aparece uma vez). Começa com \"sk-ant-\".": "Copy the key right away (it is only shown once). It starts with \"sk-ant-\".",
 "Cristal": "Crystal",
 "Daqui a 1 hora": "In 1 hour",
 "Daqui a 1 semana": "In 1 week",
 "Daqui a 3 dias": "In 3 days",
 "Depois de 5 min fora": "After 5 min away",
 "Depois de 5 minutos fora": "After 5 minutes away",
 "Desligar a senha desta aba": "Turn off this tab's password",
 "Detalhes técnicos": "Technical details",
 "Dia {n} de {t}": "Day {n} of {t}",
 "Dica: a chave é como uma senha. Não mande por mensagem nem publique. Se vazar, apague-a no site e crie outra.": "Tip: the key is like a password. Don't send it in a message or post it. If it leaks, delete it on the website and create another one.",
 "Documento vencido": "Document expired",
 "Ela abre em {d}.": "It opens on {d}.",
 "Ela abre em {d}. Você vai receber avisos: {quando}.": "It opens on {d}. You will receive notifications: {quando}.",
 "Ela abre em {d}. Você vai receber um aviso: {quando}.": "It opens on {d}. You will receive a notification: {quando}.",
 "Em \"API keys\", toque em \"Create key\" (Criar chave) e dê um nome, por exemplo \"My Planner\".": "Under \"API keys\", tap \"Create key\" and give it a name, for example \"My Planner\".",
 "Em \"Billing\" (Cobrança), adicione um cartão e alguns dólares de crédito. A assinatura ChatGPT Plus não vale aqui.": "Under \"Billing\", add a card and a few dollars of credit. The ChatGPT Plus subscription does not apply here.",
 "Em \"Billing\" (Cobrança), compre créditos. A assinatura Claude Pro não vale aqui.": "Under \"Billing\", buy credits. The Claude Pro subscription does not apply here.",
 "Em breve": "Coming soon",
 "Entre com a mesma conta do ChatGPT ou crie uma.": "Sign in with the same account as ChatGPT or create one.",
 "Entre com a sua conta Google (a mesma do Gmail serve).": "Sign in with your Google account (your Gmail account works).",
 "Entre ou crie uma conta (pode ser o mesmo e-mail do Claude).": "Sign in or create an account (you can use the same email as Claude).",
 "Enviados para o My Planner": "Sent to My Planner",
 "Enviar agora": "Send now",
 "Escolha hoje ou uma data futura.": "Choose today or a future date.",
 "Escolhas lembradas": "Remembered choices",
 "Escolher a data": "Choose the date",
 "Escolher células": "Select cells",
 "Escolher quando": "Choose when",
 "Espessura": "Thickness",
 "Esquecer": "Forget",
 "Esta chave é de outro serviço ({servico}). Aqui funcionam só chaves do Claude, do ChatGPT ou do Gemini.": "This key is from another service ({servico}). Only Claude, ChatGPT or Gemini keys work here.",
 "Esta chave é do {ia}, não do {escolhida}.": "This key is for {ia}, not {escolhida}.",
 "Esta conta vê o app como uma conta nova, sem nenhuma aba liberada, para conferir os cadeados, o teste grátis e a compra. As outras contas não mudam.": "This account sees the app as a new account, with no tabs unlocked, so you can check the locks, the free trial and the purchase. Other accounts are not affected.",
 "Esta ferramenta precisa ver as páginas do PDF, o que chega com o app novo (versão 0.50). Use o navegador ou atualize o My Planner pela loja.": "This tool needs to see the PDF pages, which comes with the new app (version 0.50). Use the browser or update My Planner from the store.",
 "Esta não parece uma chave do {ia}. As chaves do {ia} começam com {ini}.": "This doesn't look like a {ia} key. {ia} keys start with {ini}.",
 "Este aviso está em \"Desligado\": nada vai tocar.": "This notification is set to \"Off\": nothing will ring.",
 "Este celular ainda não recebe avisos com o app fechado. Atualize o My Planner pela loja (versão {v} ou mais nova). Com o app aberto, os avisos já funcionam.": "This phone doesn't receive notifications with the app closed yet. Update My Planner from the store (version {v} or newer). With the app open, notifications already work.",
 "Este tipo de aviso está desligado nas configurações de notificação do celular.": "This type of notification is turned off in the phone's notification settings.",
 "Estudado": "Studied",
 "Estudado: {dur}": "Studied: {dur}",
 "Faltou: {dur}": "Short by: {dur}",
 "Fazer os testes terminarem agora": "Make the trials end now",
 "Fechar a barra do editor": "Close the editor bar",
 "Fichário": "Binder",
 "Figurinhas e emojis": "Stickers and emojis",
 "Garantia terminou": "Warranty ended",
 "Gerando…": "Generating…",
 "Guarda documentos, exames e histórico de saúde com uma senha só dele. Nem o suporte consegue ler. Se você esquecer a senha, não há como recuperar.": "Stores documents, test results and health history with its own password. Not even support can read it. If you forget the password, there is no way to recover it.",
 "Harpa": "Harp",
 "Horas por dia": "Hours per day",
 "Identificação": "Identification",
 "Isso parece um link ou um e-mail, não uma chave. Copie a chave inteira na página de chaves de API.": "This looks like a link or an email, not a key. Copy the entire key from the API keys page.",
 "Isto só aparece no My Planner se você enviar. Quer enviar agora?": "This only shows up in My Planner if you send it. Send it now?",
 "Já dá para confirmar {titulo}?": "Can you confirm {titulo} now?",
 "Lembrar minha escolha nesta aba": "Remember my choice in this tab",
 "Lembrete para confirmar: {data}": "Reminder to confirm: {data}",
 "Marimba": "Marimba",
 "Marque pelo menos um dia da semana no plano.": "Select at least one day of the week in the plan.",
 "Me lembre de confirmar": "Remind me to confirm",
 "Me lembre depois": "Remind me later",
 "Menos": "Less",
 "Meta somada": "Combined goal",
 "Meta somada: {dur}": "Combined goal: {dur}",
 "Meus dados - My Planner {data}": "My data - My Planner {data}",
 "Meus dados do My Planner": "My My Planner data",
 "Mostrar a barra": "Show the bar",
 "Mudar senha do diário": "Change journal password",
 "Na primeira vez, aceite os termos de uso.": "The first time, accept the terms of use.",
 "Na versão das lojas, a compra será pela loja de apps do celular. Por enquanto a chave simula a assinatura para testes.": "In the store version, the purchase will be made through the phone's app store. For now, the key simulates the subscription for testing.",
 "Nada de outras abas vai sozinho para o My Planner. Estes itens têm data e ainda não foram enviados.": "Nothing from other tabs goes to My Planner on its own. These items have a date and have not been sent yet.",
 "Nenhum estudo registrado neste mês.": "No study logged this month.",
 "Nenhum item aguardando envio.": "No items waiting to be sent.",
 "Nenhum teste começado": "No trial started",
 "Nesta tela não há nada para adicionar.": "There is nothing to add on this screen.",
 "No dia": "On the day",
 "Nova nota rápida": "New quick note",
 "Nova página do dia": "New page for the day",
 "Não deu certo": "It didn't work",
 "Não entram: o conteúdo do Diário e os campos do cofre (ficam protegidos pela senha), fotos e arquivos anexados. Para restaurar os dados no app, use o arquivo técnico.": "Not included: the Journal content and the vault fields (they stay protected by the password), photos and attached files. To restore the data in the app, use the technical file.",
 "Não foi possível gerar o PDF.": "Couldn't generate the PDF.",
 "Não foi possível testar agora. Tente de novo em alguns segundos.": "Couldn't test right now. Try again in a few seconds.",
 "Não lembrar": "Don't remember",
 "Não, obrigada": "No, thanks",
 "O Diário é protegido pela senha dele e não entra neste arquivo.": "The Journal is protected by its own password and is not included in this file.",
 "O app abre \"Salvar em Arquivos\" para você escolher a pasta (pode ser o iCloud Drive).": "The app opens \"Save to Files\" so you can choose the folder (it can be iCloud Drive).",
 "O app guarda só o atalho do arquivo escolhido: ele continua onde está (Drive, OneDrive, Downloads) e abre no app do celular. Nada é copiado. Esta opção vale para as fotos tiradas pela câmera.": "The app only keeps a shortcut to the chosen file: it stays where it is (Drive, OneDrive, Downloads) and opens in the phone app. Nothing is copied. This option applies to photos taken with the camera.",
 "O app instalado neste dispositivo é a versão {v}. Para fazer chamadas de áudio e vídeo, atualize o My Planner pela loja (versão 0.35 ou mais nova). As mensagens já funcionam.": "The app installed on this device is version {v}. To make audio and video calls, update My Planner from the store (version 0.35 or newer). Messages already work.",
 "O aviso vai chegar em silêncio, direto na lista de notificações: ligue os alertas do My Planner nas configurações do celular.": "The notification will arrive silently, straight to the notification list: turn on My Planner alerts in the phone's settings.",
 "O aviso vai chegar sem som: o som deste tipo de aviso foi desligado nas configurações do celular.": "The notification will arrive without sound: the sound for this type of notification was turned off in the phone's settings.",
 "O aviso vai chegar, mas o som das notificações do My Planner está desligado no celular.": "The notification will arrive, but the My Planner notification sound is turned off on the phone.",
 "O convite leva o link para baixar o app. Quem entra pelo link cai direto no escritório.": "The invitation includes the link to download the app. Anyone who joins through the link goes straight to the office.",
 "O ditado chega com a versão nova do app. Atualize o My Planner pela loja para usar o microfone.": "Dictation comes with the new version of the app. Update My Planner from the store to use the microphone.",
 "O mesmo desbloqueio do app: senha, biometria ou PIN. Pede uma vez ao entrar; dentro da aba não pede de novo. Abrir a galeria, a câmera ou os arquivos não conta como sair. Itens grandes continuam pedindo a senha para excluir.": "The same unlock as the app: password, biometrics or PIN. It asks once when you enter; inside the tab it doesn't ask again. Opening the gallery, camera or files doesn't count as leaving. Large items still ask for the password to delete.",
 "O modo silencioso do celular pode impedir o alarme. Deixe o celular no modo normal.": "The phone's silent mode may block the alarm. Keep the phone in normal mode.",
 "O plano fica só em Estudos (não vai para o My Planner).": "The plan stays only in Studies (it doesn't go to My Planner).",
 "Opcional: prazo, horas por dia e dias da semana.": "Optional: deadline, hours per day and days of the week.",
 "Os avisos do celular funcionam no app instalado.": "Phone notifications work in the installed app.",
 "Os avisos no celular funcionam no app instalado.": "Notifications on the phone work in the installed app.",
 "Os testes começados terminaram. Abra a aba para ver \"O teste grátis terminou\".": "The trials that were started have ended. Open the tab to see \"The free trial has ended\".",
 "Outros dados": "Other data",
 "Ouvir": "Listen",
 "Pacote em uso": "Pack in use",
 "Para assinar, atualize o My Planner pela loja de apps do celular.": "To subscribe, update My Planner from the phone's app store.",
 "Para ler (PDF): organizado por aba, com títulos e datas. Abre em qualquer dispositivo ou computador.": "To read (PDF): organized by tab, with titles and dates. Opens on any device or computer.",
 "Para o alarme do remédio tocar com o \"Não perturbe\" ligado, o celular precisa permitir o acesso ao \"Não perturbe\" para o My Planner. Toque em \"Abrir configurações\", procure o My Planner na lista e ligue a permissão.": "For the medication alarm to ring with \"Do Not Disturb\" on, the phone needs to allow My Planner access to \"Do Not Disturb\". Tap \"Open settings\", find My Planner in the list and turn on the permission.",
 "Passo a passo para criar a chave": "Step by step to create the key",
 "Pedir de novo": "Ask again",
 "Pedir senha ao abrir esta aba": "Ask for password when opening this tab",
 "Plano com período": "Plan with a period",
 "Plano começa em {d}": "Plan starts on {d}",
 "Por matéria": "By subject",
 "Prolongar": "Extend",
 "Pronto: o aviso chega em até 5 segundos, com som. Se não tocar, confira se o celular está no silencioso.": "Done: the notification arrives within 5 seconds, with sound. If it doesn't ring, check whether the phone is on silent.",
 "Pronto: o aviso chega em até 5 segundos, só vibrando.": "Done: the notification arrives within 5 seconds, vibration only.",
 "Publicado em": "Published on",
 "Pulso": "Pulse",
 "Quando o app bloquear": "When the app locks",
 "Quer proteger esta aba com senha?": "Do you want to protect this tab with a password?",
 "Recolher ou arrastar a barra": "Collapse or drag the bar",
 "Recomeçar os testes grátis": "Restart the free trials",
 "Recomeçar os testes grátis?": "Restart the free trials?",
 "Rolar a folha para os lados": "Scroll the sheet sideways",
 "Se você conectar o relógio: totais de cada dia de passos, distância, calorias, exercício, batimentos e sono, lidos do Health Connect ou do app Saúde do celular. O app só lê e nunca altera esses dados.": "If you connect the watch: daily totals of steps, distance, calories, exercise, heart rate and sleep, read from Health Connect or the phone's Health app. The app only reads and never changes this data.",
 "Sem internet ou a conexão caiu. Confira o Wi-Fi ou os dados móveis e tente de novo.": "No internet or the connection dropped. Check Wi-Fi or mobile data and try again.",
 "Senha desta aba": "This tab's password",
 "Seu plano terminou": "Your plan has ended",
 "Sino": "Bell",
 "Som do alarme": "Alarm sound",
 "Soma a garantia legal e a do fabricante. Confira no termo de garantia.": "Adds up the legal warranty and the manufacturer's warranty. Check the warranty terms.",
 "São dois arquivos com os seus dados do My Planner (portabilidade, LGPD):": "These are two files with your My Planner data (portability, LGPD):",
 "Só quando o app bloquear": "Only when the app locks",
 "Tamanho da borracha": "Eraser size",
 "Tamanho da letra": "Font size",
 "Tempo": "Time",
 "Termina em": "Ends on",
 "Testar": "Test",
 "Texto de exemplo": "Sample text",
 "Toca nos avisos em \"Alarme (som)\". \"Som e vibração\" usa o som de notificação do celular.": "Plays on notifications set to \"Alarm (sound)\". \"Sound and vibration\" uses the phone's notification sound.",
 "Toda vez que sair": "Every time you leave",
 "Toda vez que sair da aba": "Every time you leave the tab",
 "Todas as abas voltam a \"{n} dias grátis para testar\", como numa conta nova. As assinaturas simuladas são desligadas.": "All tabs go back to \"{n} days free to try\", like a new account. Simulated subscriptions are turned off.",
 "Todos os fichários": "All binders",
 "Toque em \"Create API key\" (Criar chave de API). Se pedir um projeto, escolha o que aparecer ou crie um novo.": "Tap \"Create API key\". If it asks for a project, choose the one that appears or create a new one.",
 "Toque em \"Criar minha chave de API\" acima. Abre a plataforma da OpenAI (não é o site do ChatGPT).": "Tap \"Create my API key\" above. It opens the OpenAI platform (not the ChatGPT website).",
 "Toque em \"Criar minha chave de API\" acima. Abre o Console da Anthropic (não é o site do Claude).": "Tap \"Create my API key\" above. It opens the Anthropic Console (not the Claude website).",
 "Toque em \"Criar minha chave de API\" acima. Abre o Google AI Studio.": "Tap \"Create my API key\" above. It opens Google AI Studio.",
 "Toque em Conectar e, na tela do app Saúde, ligue os itens que o My Planner pode ler.": "Tap Connect and, on the Health app screen, turn on the items My Planner can read.",
 "Toque no ícone de copiar ao lado da chave. Ela começa com \"AIza\" ou \"AQ.\".": "Tap the copy icon next to the key. It starts with \"AIza\" or \"AQ.\".",
 "Toque numa célula da tabela (ou em \"Escolher células\") para mudar o tamanho da letra dela.": "Tap a table cell (or \"Select cells\") to change its font size.",
 "Transparência": "Transparency",
 "Técnico (para restaurar): cópia completa que só o My Planner lê. Para usar, vá em Ajustes › Nuvem e cópias de segurança › Importar arquivo.": "Technical (to restore): a full copy that only My Planner can read. To use it, go to Settings › Cloud and backups › Import file.",
 "Uma carta da {nome} abre em {n} dias 💌": "A letter from {nome} opens in {n} days 💌",
 "Usa a senha do app": "Uses the app password",
 "Usar no {ia}": "Use with {ia}",
 "Use o app no celular para baixar o arquivo técnico.": "Use the app on the phone to download the technical file.",
 "Valor final definido pela loja de apps, já na moeda do seu país.": "Final price set by the app store, already in your country's currency.",
 "Você ainda não enviou {titulo} para o My Planner.": "You haven't sent {titulo} to My Planner yet.",
 "Volte aqui, cole no campo abaixo e toque em \"Salvar e testar\".": "Come back here, paste it into the field below and tap \"Save and test\".",
 "Volte em \"API keys\" e toque em \"Create new secret key\" (Criar chave).": "Go back to \"API keys\" and tap \"Create new secret key\".",
 "atualização automática": "automatic update",
 "erro desconhecido": "unknown error",
 "estudados no mês": "studied this month",
 "faltou {dur}": "{dur} short",
 "hoje {feito} de {meta}": "today {feito} of {meta}",
 "hoje é folga": "today is a day off",
 "login do Google (não é chave de API)": "Google login (not an API key)",
 "meta cumprida": "goal met",
 "o que veio com a instalação": "what came with the installation",
 "outro": "other",
 "provisório": "provisional",
 "superou {dur}": "exceeded by {dur}",
 "token de login (não é chave de API)": "login token (not an API key)",
 "{ia} demorou demais para responder. Tente de novo em instantes.": "{ia} took too long to respond. Try again in a moment.",
 "{ia} está fora do ar ou sobrecarregado agora. Não é problema da sua chave: tente de novo mais tarde.": "{ia} is down or overloaded right now. It's not a problem with your key: try again later.",
 "{ia} respondeu ao teste com o modelo {modelo}. Já pode usar nas abas.": "{ia} responded to the test with the model {modelo}. You can now use it in the tabs.",
 "{ia} se recusou a ler este conteúdo (filtro de segurança da empresa).": "{ia} refused to read this content (the company's safety filter).",
 "{ia}: a chave existe, mas não tem permissão para usar a IA. Crie uma chave nova na página indicada no passo a passo.": "{ia}: the key exists, but it doesn't have permission to use the AI. Create a new key on the page shown in the step-by-step guide.",
 "{ia}: chave inválida. Confira se copiou a chave inteira ou crie uma nova.": "{ia}: invalid key. Check that you copied the entire key or create a new one.",
 "{ia}: esta chave foi bloqueada pela empresa porque apareceu publicada na internet. Apague-a e crie outra.": "{ia}: this key was blocked by the company because it was found published on the internet. Delete it and create another one.",
 "{ia}: limite de uso atingido. Espere alguns minutos (ou até amanhã, no plano gratuito) e tente de novo.": "{ia}: usage limit reached. Wait a few minutes (or until tomorrow, on the free plan) and try again.",
 "{ia}: o modelo escolhido não está disponível para a sua conta. Escolha outro em \"Modelo\".": "{ia}: the chosen model is not available for your account. Choose another one under \"Model\".",
 "{ia}: o serviço não está disponível na sua região ou para este tipo de conta.": "{ia}: the service is not available in your region or for this type of account.",
 "{ia}: sua conta de API está sem saldo ou sem forma de pagamento. Adicione créditos no site da empresa.": "{ia}: your API account has no balance or no payment method. Add credits on the company's website.",
 "{item}: a garantia termina hoje ({data}).": "{item}: the warranty ends today ({data}).",
 "{item}: a garantia terminou em {data}.": "{item}: the warranty ended on {data}.",
 "{item}: venceu em {data}.": "{item}: expired on {data}.",
 "{mes} de {ano}": "{mes} {ano}",
 "{nome} protegida com senha": "{nome} protected with a password",
 "{nome}: encerrar o plano ou prolongar com uma nova data final? Nada é apagado.": "{nome}: end the plan or extend it with a new end date? Nothing is deleted.",
 "{n} dias antes": "{n} days before",
 "{n} dias de estudo no plano · {dur} por dia": "{n} study days in the plan · {dur} per day",
 "{n} dias de plano": "{n} days of plan",
 "{n} dias depois": "{n} days after",
 "{n} item(ns) aguardando envio ao My Planner": "{n} item(s) waiting to be sent to My Planner",
 "{n} itens aguardando envio": "{n} items waiting to be sent",
 "{quando} às {hora}": "{quando} at {hora}",
 "ÚLTIMOS 6 MESES": "LAST 6 MONTHS",
 "Abra o My Planner Anne e entre com o seu CPF ou e-mail e a sua senha.": "Open My Planner Anne and sign in with your CPF or email and your password.",
 "Anexo": "Attachment",
 "Assédio ou ameaça": "Harassment or threats",
 "Bloquear {nome}": "Block {nome}",
 "Conte mais (opcional)": "Tell us more (optional)",
 "Conteúdo impróprio": "Inappropriate content",
 "Conteúdo ofensivo e usuários abusivos não são tolerados. As denúncias são analisadas pela nossa equipe em até 24 horas.": "Offensive content and abusive users are not tolerated. Reports are reviewed by our team within 24 hours.",
 "Denunciar": "Report",
 "Denunciar contato": "Report contact",
 "Denunciar grupo": "Report group",
 "Denunciar mensagem": "Report message",
 "Denúncia enviada": "Report sent",
 "Denúncias que você faz nas Mensagens: o motivo, quem foi denunciado e o trecho da mensagem denunciada. Só a equipe do My Planner lê, para analisar o caso.": "Reports you make in Messages: the reason, who was reported and the excerpt of the reported message. Only the My Planner team reads them, to review the case.",
 "Enviar denúncia": "Send report",
 "Mande um e-mail pedindo a exclusão, com o CPF ou o e-mail da conta. Respondemos em até 15 dias.": "Send an email requesting deletion, with the account's CPF or email. We reply within 15 days.",
 "Não toleramos conteúdo ofensivo, ilegal ou impróprio nem usuários abusivos nas Mensagens e nos grupos. Qualquer pessoa pode denunciar uma mensagem, um contato ou um grupo (segure a mensagem ou toque em ⋮ > Denunciar) e bloquear quem quiser. As denúncias são analisadas pela nossa equipe em até 24 horas: o conteúdo pode ser removido e quem o enviou pode ter a conta suspensa ou encerrada.": "We do not tolerate offensive, illegal or inappropriate content or abusive users in Messages and groups. Anyone can report a message, a contact or a group (press and hold the message or tap ⋮ > Report) and block anyone they want. Reports are reviewed by our team within 24 hours: the content may be removed and whoever sent it may have their account suspended or terminated.",
 "Obrigado. Nossa equipe vai analisar em até 24 horas.": "Thank you. Our team will review it within 24 hours.",
 "Para contas que entram com CPF, a senha nova é criada pelo nosso suporte, depois de confirmar que a conta é sua. Escreva para {email} informando o seu CPF ou o e-mail cadastrado.": "For accounts that sign in with CPF, the new password is created by our support team after confirming the account is yours. Write to {email} with your CPF or registered email.",
 "Por que você está denunciando? A pessoa denunciada não fica sabendo quem denunciou.": "Why are you reporting? The reported person will not know who reported them.",
 "Spam": "Spam",
 "{nome} não pode mais conversar com você.": "{nome} can no longer chat with you.",
 "{nome}\nVale até {d}. Ele fica criptografado no seu cofre, só neste dispositivo e na sua cópia da nuvem.": "{nome}\nValid until {d}. It is stored encrypted in your vault, only on this device and in your cloud copy.",
 "1. No computador, abra {url} e escolha Entrar com QR Code.": "1. On the computer, open {url} and choose Sign in with QR code.",
 "2. Aqui, toque em Conectar navegador e aponte a câmera para o QR Code do computador.": "2. Here, tap Connect browser and point the camera at the QR code on the computer.",
 "Abandonados": "Dropped",
 "Bloquear o computador": "Lock the computer",
 "Cheguei na página...": "I'm on page...",
 "Computador conectado": "Connected computer",
 "Computador desconectado": "Computer disconnected",
 "Conectado em {d}": "Connected on {d}",
 "Crie o grupo e mande o link: quem entrar vê o material do livro e acompanha a leitura. Quem administra inclui, edita e põe fotos, e pode liberar isso para quem também usa a aba. Só quem administra coloca ou tira pessoas.": "Create the group and send the link: whoever joins sees the book material and follows the reading. Admins add, edit and post photos, and can allow this for people who also use the tab. Only admins add or remove people.",
 "Depois de {n} minutos parado": "After {n} minutes idle",
 "Desconectar o computador?": "Disconnect the computer?",
 "Difícil demais": "Too hard",
 "Editar livro": "Edit book",
 "Entrar com o QR Code": "Sign in with the QR code",
 "Escreva (ex.: filosofia)": "Type it (e.g. philosophy)",
 "Este computador": "This computer",
 "Este computador foi desconectado (pelo celular ou porque outro computador entrou). Para usar de novo, entre com o QR Code.": "This computer was disconnected (from the phone or because another computer signed in). To use it again, sign in with the QR code.",
 "Já existe um computador conectado": "A computer is already connected",
 "Já existe um computador conectado. Trocar para este? O outro será desconectado.": "A computer is already connected. Switch to this one? The other one will be disconnected.",
 "Navegador": "Browser",
 "Nenhum computador conectado": "No computer connected",
 "Novo livro": "New book",
 "Não gostei": "Didn't like it",
 "Não, abandonei": "No, I dropped it",
 "O My Planner fecha no computador. Para usar de novo, é só conectar pelo QR Code.": "My Planner will close on the computer. To use it again, just connect with the QR code.",
 "O QR Code muda a cada 3 minutos e só vale uma vez. Em computador compartilhado, use Ajustes › Sair deste computador ao terminar.": "The QR code changes every 3 minutes and works only once. On a shared computer, use Settings › Sign out of this computer when you're done.",
 "Os seus dados continuam salvos na nuvem e no celular. Para entrar de novo, use o QR Code.": "Your data stays saved in the cloud and on your phone. To sign in again, use the QR code.",
 "Parei em": "Stopped on",
 "Perdi o interesse": "Lost interest",
 "Por que parei": "Why I stopped",
 "Páginas e meta": "Pages and goal",
 "Quero voltar a ler?": "Do I want to read it again?",
 "Sair deste computador": "Sign out of this computer",
 "Sair deste computador?": "Sign out of this computer?",
 "Se quiser, escreva com as suas palavras": "If you like, write it in your own words",
 "Sem mexer no mouse ou no teclado por esse tempo, o My Planner bloqueia. Para voltar, digite a senha da conta (ou entre com o QR Code de novo).": "If the mouse and keyboard aren't used for this long, My Planner locks. To come back, type your account password (or sign in with the QR code again).",
 "Sem tempo": "No time",
 "Sim, depois": "Yes, later",
 "Só um computador pode ficar conectado por vez.": "Only one computer can be connected at a time.",
 "A foto ou o PDF do certificado vai em \"Fotos, arquivos e links\": marque como Certificado.": "Put the certificate photo or PDF in \"Photos, files and links\" and tag it as Certificate.",
 "ABNT copiada": "ABNT copied",
 "APA copiada": "APA copied",
 "Ano inválido": "Invalid year",
 "Ano ou data de publicação": "Year or date of publication",
 "Assisti em": "Watched on",
 "Buscando os dados...": "Looking up the data...",
 "Calculado pelos módulos": "Calculated from the modules",
 "Carga horária (horas)": "Workload (hours)",
 "Certificado": "Certificate",
 "Certificado emitido em": "Certificate issued on",
 "Cheguei na aula": "I'm on lesson",
 "Cheguei na aula...": "I'm on lesson...",
 "Cheguei na temporada": "I'm on season",
 "Cheguei no episódio": "I'm on episode",
 "Citação copiada": "Quote copied",
 "Colocar em pasta": "Add to folder",
 "Coloque livros, filmes ou cursos nesta pasta para montar a lista.": "Add books, movies or courses to this folder to build the list.",
 "Comentário": "Comment",
 "Copiar ABNT": "Copy ABNT",
 "Copiar APA": "Copy APA",
 "Copiar citação (ABNT)": "Copy quote (ABNT)",
 "Copiar citação (APA)": "Copy quote (APA)",
 "Crie cards com checklist, lista, texto livre ou desenho para esta matéria. Arraste para a direita para excluir e para a esquerda para Arquivar ou Duplicar.": "Create cards with a checklist, list, free text or drawing for this subject. Swipe right to delete and left to Archive or Duplicate.",
 "Crie o grupo e mande o link: quem entrar vê a lista e acompanha. Quem administra inclui, edita e põe fotos, e pode liberar isso para quem também usa a aba. Só quem administra coloca ou tira pessoas.": "Create the group and send the link: whoever joins sees the list and follows along. Admins add, edit and post photos, and can allow this for people who also use the tab. Only admins add or remove people.",
 "Crie o grupo e mande o link: quem entrar vê o material do curso e acompanha. Quem administra inclui, edita e põe fotos, e pode liberar isso para quem também usa a aba. Só quem administra coloca ou tira pessoas.": "Create the group and send the link: whoever joins sees the course material and follows along. Admins add, edit and post photos, and can allow this for people who also use the tab. Only admins add or remove people.",
 "Crie uma pasta primeiro, na parte 📁 Pastas desta aba.": "Create a folder first, in the 📁 Folders part of this tab.",
 "DOI (artigos)": "DOI (articles)",
 "Data de acesso": "Access date",
 "Deixar avulsas": "Keep them separate",
 "Descrição (objetivo)": "Description (goal)",
 "Digite o ano com 4 números (ex.: {a}).": "Type the year with 4 digits (e.g. {a}).",
 "Direção": "Director",
 "Editar pasta": "Edit folder",
 "Editora": "Publisher",
 "Edição": "Edition",
 "Em 1 mês": "In 1 month",
 "Em {n} meses": "In {n} months",
 "Episódios por temporada (opcional)": "Episodes per season (optional)",
 "Escreva o trecho na anotação para copiar a citação.": "Write the passage in the note to copy the quote.",
 "Este item já está em todas as pastas.": "This item is already in every folder.",
 "Ex.: 10.1590/...": "E.g. 10.1590/...",
 "Ex.: TCC — Ética e Direito": "E.g. Thesis — Ethics and Law",
 "Ex.: {a}": "E.g. {a}",
 "Fazendo": "In progress",
 "Grupo de filmes e séries": "Movies and series group",
 "Grupo de leitura": "Reading group",
 "Grupo do curso": "Course group",
 "ISBN": "ISBN",
 "Ideia minha": "My own idea",
 "Instrutor": "Instructor",
 "Itens da pasta": "Folder items",
 "Junte livros, filmes e cursos numa pasta (ex.: \"TCC\", \"Só romances\"). O mesmo item pode estar em várias pastas.": "Gather books, movies and courses in a folder (e.g. \"Thesis\", \"Only novels\"). The same item can be in several folders.",
 "Link (material online)": "Link (online material)",
 "Lista copiada": "List copied",
 "Lista de referências": "Reference list",
 "Mais de um autor: separe com ponto e vírgula (;).": "More than one author: separate with a semicolon (;).",
 "Módulo": "Module",
 "Nada novo": "Nothing new",
 "No ⋮ de um livro, filme ou curso, toque em \"Colocar em pasta\".": "In the ⋮ of a book, movie or course, tap \"Add to folder\".",
 "Nome da pasta": "Folder name",
 "Não achei dados novos para completar a ficha.": "I found no new data to complete the record.",
 "Não foi possível preencher": "Couldn't fill it in",
 "O módulo não tem cards de anotações.": "The module has no note cards.",
 "Organizador": "Editor",
 "Os dados vêm da ficha do livro (Editar › Referência).": "The data comes from the book record (Edit › Reference).",
 "Os livros, filmes e cursos da pasta NÃO são apagados: continuam na aba.": "The books, movies and courses in the folder are NOT deleted: they stay in the tab.",
 "Os {n} card(s) de anotações deste módulo também vão para a lixeira.": "The {n} note card(s) of this module also go to the trash.",
 "Pasta vazia": "Empty folder",
 "Preencha o título (e o que mais tiver) na ficha.": "Fill in the title (and anything else you have) in the record.",
 "Preencher pelo DOI": "Fill in from the DOI",
 "Preencher pelo link": "Fill in from the link",
 "Produtora ou país": "Producer or country",
 "Quero fazer": "Want to take",
 "Quero voltar?": "Do I want to come back to it?",
 "Referência vazia": "Empty reference",
 "Referências": "References",
 "Se deixar avulsas, elas continuam somando no total do curso.": "If you keep them separate, they still count toward the course total.",
 "Subtítulo": "Subtitle",
 "Tirar da pasta": "Remove from folder",
 "Total de episódios (opcional)": "Total episodes (optional)",
 "Total de temporadas (opcional)": "Total seasons (optional)",
 "Tradutor": "Translator",
 "Trecho (citação)": "Passage (quote)",
 "Trecho vazio": "Empty passage",
 "Você já assistiu {n} aula(s). Colocar em qual módulo?": "You've already watched {n} lesson(s). Put them in which module?",
 "Volume": "Volume",
 "{n} item(ns)": "{n} item(s)",
 "{n} referência(s) em ordem alfabética.": "{n} reference(s) in alphabetical order.",
 "Ícone": "Icon",
 "ASSISTIDOS POR DIA": "WATCHED PER DAY",
 "ASSISTIDOS POR MÊS": "WATCHED PER MONTH",
 "AULAS POR DIA": "LESSONS PER DAY",
 "AULAS POR MÊS": "LESSONS PER MONTH",
 "Apagar a meta": "Delete the goal",
 "Assisti {a} · Estou assistindo {b} · Parei {c} · Quero assistir {d}": "Watched {a} · Watching {b} · Stopped {c} · Want to watch {d}",
 "Aulas": "Lessons",
 "CURSOS": "COURSES",
 "Concluí {a} · Fazendo {b} · Parei {c}": "Completed {a} · In progress {b} · Stopped {c}",
 "Datas": "Dates",
 "Datas escolhidas": "Chosen dates",
 "Datas à escolha": "Custom dates",
 "Definir meta de {ano}": "Set {ano} goal",
 "Definir meta do ano": "Set a goal for the year",
 "FILMES E SÉRIES": "MOVIES AND SERIES",
 "Faltam {f} curso(s): dá cerca de {m} por mês": "{f} course(s) to go: about {m} a month",
 "Faltam {f} livro(s): dá cerca de {m} por mês": "{f} book(s) to go: about {m} a month",
 "Faltam {f} título(s): dá cerca de {m} por mês": "{f} title(s) to go: about {m} a month",
 "Gênero": "Genre",
 "Incluir lista de referências no PDF": "Include reference list in the PDF",
 "LIVROS": "BOOKS",
 "Li {a} livro(s) · Parei {b} · Estou lendo {c}": "Read {a} book(s) · Stopped {b} · Reading {c}",
 "Meta de {ano}": "{ano} goal",
 "Meta de {ano}: usar a de {antes} ({n})?": "{ano} goal: use the {antes} one ({n})?",
 "Meta do ano cumprida": "Goal for the year reached",
 "Mudar": "Change",
 "Nada neste período.": "Nothing in this period.",
 "Nota": "Rating",
 "O PDF não leva as suas anotações, resumos e comentários.": "The PDF doesn't include your notes, summaries or comments.",
 "POR ITEM": "BY ITEM",
 "Plataforma": "Platform",
 "PÁGINAS POR DIA": "PAGES PER DAY",
 "PÁGINAS POR MÊS": "PAGES PER MONTH",
 "Quantos no ano?": "How many this year?",
 "Quero ler {a} · Abandonei {b}": "Want to read {a} · Dropped {b}",
 "Relatório de leitura e mídia": "Reading and media report",
 "concluídos no período": "completed in the period",
 "cursos concluídos no período": "courses completed in the period",
 "livros lidos no período": "books read in the period",
 "pág. {a} de {n}": "p. {a} of {n}",
 "títulos assistidos no período": "titles watched in the period",
 "{a} aula(s) assistida(s) no período · {h} hora(s) de cursos concluídos": "{a} lesson(s) watched in the period · {h} hour(s) of completed courses",
 "{a} de {n} aulas ({p}%)": "{a} of {n} lessons ({p}%)",
 "{a} de {n} curso(s) concluído(s) em {ano}": "{a} of {n} course(s) completed in {ano}",
 "{a} de {n} livro(s) em {ano}": "{a} of {n} book(s) in {ano}",
 "{a} de {n} título(s) assistido(s) em {ano}": "{a} of {n} title(s) watched in {ano}",
 "{n} item(ns) sem data de mudança de situação: usei a data de criação.": "{n} item(s) without a status-change date: I used the creation date.",
 "{p} página(s) lida(s) em {d} dia(s) · melhor sequência: {s} dia(s)": "{p} page(s) read on {d} day(s) · best streak: {s} day(s)",
 "{p}% lido · falta {f}%": "{p}% read · {f}% left",
 "Esta aba pede senha. Desbloqueie a aba primeiro e o guia continua daqui.": "This tab asks for a password. Unlock it first and the guide continues from here.",
 "Abrir esta aba": "Open this tab",
 "Mostrar na tela": "Show on screen",
 "Não achei este ponto na tela agora. Confira se a tela certa está aberta e tente de novo.": "I couldn't find this spot on the screen now. Check that the right screen is open and try again.",
 "Primeiros passos": "First steps",
 "Buscar no guia": "Search the guide",
 "Entendi": "Got it",
 "{n} de {total} passos feitos": "{n} of {total} steps done",
 "Já fiz": "Done",
 "Guia em construção": "Guide in progress",
 "Limpar marcações": "Clear checkmarks",
 "Este ponto ainda não está marcado no app.": "This spot isn't marked in the app yet.",
 "Dicas e atalhos": "Tips and shortcuts",
 "Gestos do app": "App gestures",
 "Procurando na tela…": "Looking on the screen…",
 "Guia das abas": "Tab guide",
 "Voltar ao guia": "Back to the guide",
 "Para que serve": "What it's for",
 "Disponível no app do celular.": "Available in the phone app.",
 "Nada encontrado no guia.": "Nothing found in the guide.",
 "Recursos que valem para todas as abas": "Features for every tab",
 "Perguntas comuns": "Common questions",
 "Ligar e desligar partes": "Turn parts on and off",
 "Entrada cancelada. Este computador não foi conectado.": "Sign-in canceled. This computer was not connected.",
 "Alterações ainda não enviadas": "Changes not sent yet",
 "Algumas alterações ainda não foram enviadas para o servidor (sem internet?). Se sair agora, elas se perdem. Sair mesmo assim?": "Some changes have not been sent to the server yet (no internet?). If you sign out now, they will be lost. Sign out anyway?",
 "Sair mesmo assim": "Sign out anyway",
 "O seu papel no grupo não permite mudar aqui.": "Your role in the group does not allow changes here.",
 "Não foi possível consultar o DOI agora (sem internet?). Tente de novo.": "Could not look up the DOI right now (no internet?). Try again.",
 "DOI inválido.": "Invalid DOI.",
 "DOI não encontrado.": "DOI not found.",
 "O site não deixou ler os dados daqui (no navegador do computador isso é comum). Tente pelo app no celular, use o DOI, ou digite os campos.": "The site did not allow reading its data from here (common in a computer browser). Try the app on your phone, use the DOI, or type the fields.",
 "Atualizando...": "Updating...",
 "Banco de dados (Supabase, plano grátis)": "Database (Supabase, free plan)",
 "Cadeado (HTTPS) até": "HTTPS padlock until",
 "Dados das abas: {d}": "Tab data: {d}",
 "Disco": "Disk",
 "Esta conta não tem acesso a estas informações.": "This account does not have access to this information.",
 "Ligado há": "Running for",
 "Livre: {l} · site: {s}": "Free: {l} · site: {s}",
 "Maiores tabelas": "Largest tables",
 "Memória em uso": "Memory in use",
 "O servidor ainda não mandou o relatório. Ele manda a cada 10 minutos depois do 53-SERVIDOR-0.78.bat.": "The server has not sent its report yet. It sends one every 10 minutes after 53-SERVIDOR-0.78.bat.",
 "O servidor ainda não tem esta função. Rode o 53-SERVIDOR-0.78.bat no computador.": "The server does not have this function yet. Run 53-SERVIDOR-0.78.bat on the computer.",
 "O sistema do servidor pede reinício (atualização de segurança instalada).": "The server system asks for a restart (security update installed).",
 "Processador": "Processor",
 "Relatório do servidor: {q}": "Server report: {q}",
 "Servidor": "Server",
 "Servidor do site (Locaweb)": "Website server (Locaweb)",
 "Sistema": "System",
 "Só você vê este quadro.": "Only you see this panel.",
 "Versão do site no ar": "Live website version",
 "atrasado: confira se o servidor está ligado": "late: check that the server is running",
 "sem cadeado": "no padlock",
 "{a} ({n} guardadas)": "{a} ({n} kept)",
 "{d} dia(s) e {h} h": "{d} day(s) and {h} h",
 "{n} núcleo(s) · carga {c}": "{n} core(s) · load {c}",
 "{n} · {novas} nova(s) e {ativas} ativa(s) em 7 dias": "{n} · {novas} new and {ativas} active in 7 days",
 "{u} de {t} ({p}%)": "{u} of {t} ({p}%)",
 "Fechar teclado": "Close keyboard",
 "Mostrar as ferramentas": "Show the tools",
 "Últimas cores usadas": "Recent colors",
 "Voltar ao topo": "Back to top",
 "Topo": "Top",
 "1 atividade do roteiro por fazer": "1 itinerary activity to do",
 "1 dia": "1 day",
 "1 item por pôr na mala": "1 item left to pack",
 "1 lista de Viagens ia inteira para o My Planner e saiu de lá. Agora o envio é item por item, pelo ⋮ de cada item.": "1 Travel list was sent whole to My Planner and has been removed from there. Now items are sent one by one, via each item's ⋮.",
 "1 lugar não visitado": "1 place not visited",
 "1 reserva por confirmar": "1 booking to confirm",
 "Abrir o bloco": "Expand section",
 "Adicionar pessoa": "Add person",
 "Ainda pode gastar {v}": "You can still spend {v}",
 "Ao ligar, o valor entra em Gastos como pago.": "When on, the amount goes into Expenses as paid.",
 "Até (dd/mm/aaaa)": "Until (dd/mm/yyyy)",
 "Coloque as pessoas em \"Quem vai\" (edite a viagem).": "Add people in \"Who's going\" (edit the trip).",
 "Como foi?": "How was it?",
 "Concluído em {d}": "Done on {d}",
 "Confirmada em {d}": "Confirmed on {d}",
 "Confirmadas": "Confirmed",
 "Dia anterior": "Previous day",
 "Dias": "Days",
 "Dias × valor por dia": "Days × daily rate",
 "Documentos (só o tipo e a validade)": "Documents (type and expiry only)",
 "EXIGÊNCIAS DO DESTINO": "DESTINATION REQUIREMENTS",
 "Em mãos": "In hand",
 "Escreva o que o destino pede (ex.: 2 páginas em branco no passaporte, certificado de vacina). Confira no site oficial do país.": "Write what the destination requires (e.g. 2 blank passport pages, vaccination certificate). Check the country's official website.",
 "Ex.: Lisboa (LIS)": "E.g. Lisbon (LIS)",
 "Ex.: São Paulo (GRU)": "E.g. São Paulo (GRU)",
 "Falta confirmar": "To confirm",
 "Falta pôr": "To pack",
 "Faltou ({n}): {l}": "Left behind ({n}): {l}",
 "Foi ({n}): {l}": "Taken ({n}): {l}",
 "Fotos (lista das legendas)": "Photos (list of captions)",
 "Gasto de {nome} em {d}": "{nome}'s expense on {d}",
 "Gastos do dia": "Day's expenses",
 "Gastos em outras moedas (não convertidos): {v}": "Expenses in other currencies (not converted): {v}",
 "Gastos por dia": "Expenses per day",
 "Horário de chegada": "Arrival time",
 "Lugares (visitados, faltam, imperdíveis e a nota)": "Places (visited, remaining, must-sees and rating)",
 "Mala (o que foi e o que faltou)": "Packing (what was taken and what was left behind)",
 "Marcar como acertado": "Mark as settled",
 "Marcar como acertado?": "Mark as settled?",
 "Na mala": "Packed",
 "Nenhuma parada ainda": "No stops yet",
 "Nova exigência": "New requirement",
 "Números de documentos e o que está no cofre nunca vão para o relatório. Valores em moedas diferentes aparecem separados.": "Document numbers and anything in the vault never go into the report. Amounts in different currencies are shown separately.",
 "O QUE AINDA FALTA": "STILL TO DO",
 "O QUE INCLUIR": "WHAT TO INCLUDE",
 "Opcional. O app avisa se o passaporte vencer antes disso, contado da volta. Confira a exigência do país.": "Optional. The app warns you if your passport expires before then, counted from your return. Check the country's requirement.",
 "Orçamento previsto × gasto por categoria": "Planned budget × spent by category",
 "Passou do previsto em {v}": "Over budget by {v}",
 "Ponha a validade de cada documento: o app avisa antes de vencer. As fotos dos documentos ficam protegidas no cofre.": "Enter each document's expiry date: the app warns you before it expires. Document photos stay protected in the vault.",
 "Próximo dia": "Next day",
 "Quem está no grupo da viagem entra sozinho. Use \"+ Adicionar pessoa\" para quem não tem o app.": "People in the trip group are added automatically. Use \"+ Add person\" for those without the app.",
 "Recolher o bloco": "Collapse section",
 "Relatório da viagem": "Trip report",
 "Reserva confirmada": "Booking confirmed",
 "Resumo da viagem": "Trip summary",
 "Resumo da viagem (datas, destino, pessoas)": "Trip summary (dates, destination, people)",
 "Roteiro por dia (feito e falta)": "Itinerary by day (done and to do)",
 "Sem data": "No date",
 "Seu passaporte pode não ser aceito. Confira a exigência do país": "Your passport may not be accepted. Check the country's requirement",
 "Subir": "Move up",
 "Total do dia: {v}": "Day total: {v}",
 "Uma frase (opcional)": "One sentence (optional)",
 "Validade mínima exigida (meses)": "Minimum passport validity required (months)",
 "Validade: {d}": "Expires: {d}",
 "Valor por dia": "Daily rate",
 "Viagens no My Planner": "Travel in My Planner",
 "Visitado": "Visited",
 "Visitado em {d}": "Visited on {d}",
 "Voltaria: {r}": "Would go back: {r}",
 "Voltaria?": "Would you go back?",
 "confirmada": "confirmed",
 "em mãos": "in hand",
 "gasto na viagem {d}": "trip expense {d}",
 "meses": "months",
 "outro gasto": "other expense",
 "vence em {d}": "expires {d}",
 "{a} de {b} confirmadas": "{a} of {b} confirmed",
 "{a} de {b} em mãos": "{a} of {b} in hand",
 "{a} de {b} feitos": "{a} of {b} done",
 "{a} de {b} na mala": "{a} of {b} packed",
 "{a} de {b} pagos": "{a} of {b} paid",
 "{a} de {b} visitados": "{a} of {b} visited",
 "{de} deve {v} a {para}": "{de} owes {para} {v}",
 "{g} de {p}": "{g} of {p}",
 "{n} atividades do roteiro por fazer": "{n} itinerary activities to do",
 "{n} item(ns) enviado(s).": "{n} item(s) sent.",
 "{n} itens por pôr na mala": "{n} items left to pack",
 "{n} já estava(m) no My Planner.": "{n} already in My Planner.",
 "{n} listas de Viagens iam inteiras para o My Planner e saíram de lá. Agora o envio é item por item, pelo ⋮ de cada item.": "{n} Travel lists were sent whole to My Planner and have been removed from there. Now items are sent one by one, via each item's ⋮.",
 "{n} lugares não visitados": "{n} places not visited",
 "{n} reservas por confirmar": "{n} bookings to confirm",
 "{n} sem data (não foi).": "{n} without a date (not sent).",
 "ARTIGOS E SITES": "ARTICLES AND WEBSITES",
 "Agora o envio é item por item (pelo ⋮ do item ou selecionando vários). Estas listas iam inteiras e saíram do My Planner ({n} item(ns), nada foi apagado):": "Sending is now item by item (from the item’s ⋮ or by selecting several). These lists were sent whole and have been removed from My Planner ({n} item(s), nothing was deleted):",
 "Artigo científico": "Scientific article",
 "Artigo de site ou blog": "Website or blog article",
 "Artigo ou site": "Article or website",
 "Artigos e sites": "Articles and websites",
 "Autor(es)": "Author(s)",
 "Cadastrar pela foto ou PDF": "Add from a photo or PDF",
 "Capítulo de livro": "Book chapter",
 "Crie o grupo e mande o link: quem entrar vê os artigos e acompanha a leitura. Quem administra inclui, edita e põe fotos, e pode liberar isso para quem também usa a aba. Só quem administra coloca ou tira pessoas.": "Create the group and send the link: whoever joins sees the articles and follows the reading. Admins add, edit and add photos, and can allow this for people who also use the tab. Only admins add or remove people.",
 "DOI": "DOI",
 "Data ou ano de publicação": "Publication date or year",
 "Editar artigo ou site": "Edit article or website",
 "Enviar para o My Planner (lembrete de renovação)": "Send to My Planner (renewal reminder)",
 "Envio para o My Planner": "Sending to My Planner",
 "Ex.: 2024 ou 12/03/2024": "E.g.: 2024 or 03/12/2024",
 "Ex.: 45-60": "E.g.: 45-60",
 "Grupo de artigos": "Articles group",
 "Guarde artigos, notícias e páginas da internet com a referência pronta (ABNT e APA). Preencha pelo DOI ou pelo link.": "Save articles, news and web pages with the reference ready (ABNT and APA). Fill it in from the DOI or the link.",
 "Li {a} · Lendo {b} · Parei {c} · Quero ler {d}": "Read {a} · Reading {b} · Stopped {c} · Want to read {d}",
 "Minhas anotações do artigo": "My notes on the article",
 "Notícia": "News",
 "Novo artigo ou site": "New article or website",
 "Os dados vêm da ficha do artigo (Editar).": "The data comes from the article’s record (Edit).",
 "Páginas (opcional)": "Pages (optional)",
 "Revista, site ou veículo": "Journal, website or outlet",
 "artigos e sites lidos no período": "articles and websites read in the period",
 "1 confirmado": "1 confirmed",
 "1 convidado que estava em \"Pendente\" passou para \"A convidar\". Ao enviar o convite pelo app, ele passa sozinho para \"Convidado, sem resposta\".": "1 guest who was \"Pending\" moved to \"To invite\". When you send the invitation through the app, they move automatically to \"Invited, no answer\".",
 "1 extra": "1 extra",
 "1 talvez": "1 maybe",
 "A convidar": "To invite",
 "Agendar na igreja": "Book the church",
 "Agora": "Now",
 "Agradeci": "Thanked",
 "Agradeci em {d}": "Thanked on {d}",
 "Agradecidos": "Thanked",
 "Alianças": "Rings",
 "Aluguéis (mesas, cadeiras, louças)": "Rentals (tables, chairs, tableware)",
 "Avisar a data (save the date)": "Announce the date (save the date)",
 "Bebidas": "Drinks",
 "Beca e cerimônia": "Gown and ceremony",
 "Bolo": "Cake",
 "Brincadeiras": "Games",
 "Brincadeiras e amigo secreto": "Games and Secret Santa",
 "Brindes": "Giveaways",
 "Buffet": "Catering",
 "Calculado sozinho: valor menos o sinal.": "Calculated automatically: amount minus the deposit.",
 "Calcular quantidades": "Calculate quantities",
 "Categoria do orçamento": "Budget category",
 "Celebrante": "Officiant",
 "Cerimônia": "Ceremony",
 "Cerveja (adultos)": "Beer (adults)",
 "Checklist de preparação": "Preparation checklist",
 "Coloque a data do evento (edite o evento) para ver até quando fazer cada item.": "Set the event date (edit the event) to see when each item is due.",
 "Coloque as pessoas em \"Pessoas do evento\" (edite o evento).": "Add people in \"Event people\" (edit the event).",
 "Coloque quanto pretende gastar em cada categoria. Use o ⊕ para calcular por convidado. Os fornecedores contratados entram sozinhos na categoria escolhida.": "Enter how much you plan to spend in each category. Use ⊕ to calculate per guest. Hired suppliers are added automatically to the chosen category.",
 "Combinado: {v}": "Agreed: {v}",
 "Comprado": "Bought",
 "Comprados": "Bought",
 "Comprar a decoração e as lembrancinhas": "Buy the decorations and party favors",
 "Comprar as alianças": "Buy the rings",
 "Comprar as lembrancinhas": "Buy the party favors",
 "Comprar bebidas e gelo": "Buy drinks and ice",
 "Comprar comida e bebidas": "Buy food and drinks",
 "Comprar o que falta": "Buy what’s missing",
 "Comprar ou alugar a roupa": "Buy or rent the outfit",
 "Confirmados com os acompanhantes. Muda sozinho quando alguém confirma ou desconfirma.": "Confirmed, including plus-ones. Updates automatically when someone confirms or cancels.",
 "Confirmar a presença dos convidados": "Confirm guest attendance",
 "Confirmar os fornecedores": "Confirm the suppliers",
 "Confirmar os fornecedores e os convidados": "Confirm the suppliers and guests",
 "Contratar a comida": "Hire the food",
 "Contratar a comida e o bolo": "Hire the food and cake",
 "Contratar a decoração": "Hire the decorations",
 "Contratar comida e bebidas": "Hire food and drinks",
 "Contratar foto e vídeo": "Hire photo and video",
 "Contratar o buffet": "Hire the caterer",
 "Convidado, sem resposta": "Invited, no answer",
 "Convidados (por situação, com acompanhantes)": "Guests (by status, with plus-ones)",
 "Convidados que contam no ⊕": "Guests counted in ⊕",
 "Convites": "Invitations",
 "Cronograma do dia (com responsáveis e situação)": "Day schedule (with owners and status)",
 "Data do restante": "Balance due date",
 "Data do sinal": "Deposit date",
 "Decoração": "Decorations",
 "Definir a data e o orçamento": "Set the date and budget",
 "Definir a lista de convidados": "Set the guest list",
 "Doces": "Sweets",
 "Dá para mudar, tirar e incluir itens depois.": "You can change, remove and add items later.",
 "Enviar os convites": "Send the invitations",
 "Equipamentos (projetor, som)": "Equipment (projector, sound)",
 "Equipe (garçons, limpeza)": "Staff (waiters, cleaning)",
 "Escolha \"Outro\" para escrever o nome.": "Choose \"Other\" to type the name.",
 "Escolher a roupa": "Choose the outfit",
 "Escolher a roupa dos noivos": "Choose the couple’s outfits",
 "Escolher os padrinhos": "Choose the best man, bridesmaids and godparents",
 "Estimativa para {n} convidados. Mude o que quiser antes de levar.": "Estimate for {n} guests. Change anything you like before adding it.",
 "Eu faço": "I’ll do it",
 "Ex.: 200 un.": "E.g.: 200 units",
 "Ex.: Copos descartáveis": "E.g.: Disposable cups",
 "Ex.: Jogo de panelas": "E.g.: Cookware set",
 "Ex.: Reservar o local": "E.g.: Book the venue",
 "Ex.: em negociação": "E.g.: in negotiation",
 "Extras de margem (quem aparece sem avisar)": "Extra buffer (people who show up unannounced)",
 "Falta 1 dia": "1 day to go",
 "Falta agradecer": "To thank",
 "Falta comprar": "To buy",
 "Falta pagar": "To pay",
 "Fazer a lista de presentes": "Make the gift list",
 "Fazer o curso de batismo": "Take the baptism course",
 "Fornecedores (contratado, pago, falta)": "Suppliers (agreed, paid, remaining)",
 "Foto e vídeo": "Photo and video",
 "Fraldas": "Diapers",
 "Frase curta (opcional)": "Short phrase (optional)",
 "Hoje é o dia do evento!": "Today is the event day!",
 "Igreja e celebrante": "Church and officiant",
 "Incluir os Talvez": "Include Maybes",
 "Incluir telefones": "Include phone numbers",
 "Item da lista de compras": "Shopping list item",
 "Item da preparação": "Preparation item",
 "Já deram: {d} · Falta: {f}": "Given so far: {d} · Remaining: {f}",
 "Já deu": "Paid in",
 "L": "L",
 "Lance aqui o que foi gasto. Os pagamentos aos fornecedores e as compras marcadas entram sozinhos.": "Record what was spent here. Supplier payments and checked purchases are added automatically.",
 "Lançar o gasto": "Record the expense",
 "Lembrancinhas": "Party favors",
 "Levar para os itens": "Add to items",
 "Local / espaço": "Venue",
 "Mais um extra": "One more extra",
 "Menos um extra": "One less extra",
 "Música / som / DJ": "Music / sound / DJ",
 "No dia do evento": "On the event day",
 "O que comprar": "What to buy",
 "O total muda sozinho quando alguém confirma ou desconfirma.": "The total updates automatically when someone confirms or cancels.",
 "O valor do contrato entra sozinho como previsto nesta categoria, e o que for pago entra nos gastos.": "The contract amount is added automatically as planned in this category, and what is paid goes into expenses.",
 "O valor entra nos gastos do evento, na categoria do item. Se preferir, pule.": "The amount goes into the event expenses, in the item’s category. You can skip it if you prefer.",
 "Onde comprar": "Where to buy",
 "Orçamento do evento": "Event budget",
 "Os itens marcados entram na categoria com o ⊕ por convidado. Depois é só tocar no ⊕ e pôr o valor unitário.": "Checked items go into the category with ⊕ per guest. Then just tap ⊕ and enter the unit price.",
 "Os telefones dos convidados só saem no PDF se você marcar \"Incluir telefones\". Valores em moedas diferentes aparecem separados.": "Guests’ phone numbers only appear in the PDF if you check \"Include phone numbers\". Amounts in different currencies are shown separately.",
 "Pago em {d}": "Paid on {d}",
 "Parte da vaquinha": "Share of the kitty",
 "Pessoas do evento": "Event people",
 "Pessoas do evento: {p}": "Event people: {p}",
 "Preparar as brincadeiras": "Prepare the games",
 "Preparação": "Preparation",
 "Presente recebido": "Gift received",
 "Presentes": "Gifts",
 "Prova final da roupa": "Final fitting",
 "Pular": "Skip",
 "Quantidade por convidado": "Quantity per guest",
 "Quantidade por convidado × valor unitário": "Quantity per guest × unit price",
 "Quanto custou?": "How much did it cost?",
 "Quanto já deu": "Amount paid in",
 "Quanto vai contribuir": "Amount pledged",
 "Quantos dias antes do evento": "How many days before the event",
 "Quem deu": "From",
 "Quem está no grupo do evento entra sozinho. Use \"+ Adicionar pessoa\" para quem não tem o app. Esta lista é usada no cronograma, nos gastos e na vaquinha.": "Everyone in the event group is added automatically. Use \"+ Add person\" for people without the app. This list is used in the schedule, expenses and kitty.",
 "Recreação e brinquedos": "Entertainment and play equipment",
 "Refrigerante": "Soft drinks",
 "Relatório do evento": "Event report",
 "Relatório do evento (PDF)": "Event report (PDF)",
 "Reservar o local": "Book the venue",
 "Reservar o local da cerimônia e da festa": "Book the ceremony and party venues",
 "Reservar o local ou a mesa da festa": "Book the venue or a table for the party",
 "Restante": "Balance",
 "Restante pago": "Balance paid",
 "Resumo do evento": "Event summary",
 "Roupa e beleza": "Outfit and beauty",
 "Salgados": "Savory snacks",
 "Separar a roupa e o que levar": "Set aside the outfit and what to bring",
 "Separar os documentos e as alianças": "Set aside the documents and rings",
 "Separar os documentos e os ingressos": "Set aside the documents and tickets",
 "Sinal": "Deposit",
 "Sinal pago": "Deposit paid",
 "Sinal {v} pago": "Deposit {v} paid",
 "Usar a lista pronta para {tipo}": "Use the ready-made list for {tipo}",
 "Vai contribuir": "Will contribute",
 "Valor unitário": "Unit price",
 "Vaquinha": "Kitty",
 "Você acompanha tudo o que foi compartilhado, sempre atualizado. Para incluir, editar e pegar tarefas, assine a aba.": "You can follow everything that was shared, always up to date. To add, edit and take tasks, subscribe to this tab.",
 "agradeci": "thanked",
 "atrasado": "overdue",
 "completo": "complete",
 "deu {d} de {v}": "gave {d} of {v}",
 "em {l}": "at {l}",
 "falta o valor": "amount missing",
 "falta {v} até {d}": "{v} due by {d}",
 "gasto em {e}": "spent on {e}",
 "kg": "kg",
 "o evento": "the event",
 "restante": "balance",
 "sinal": "deposit",
 "total": "total",
 "un.": "units",
 "{n} confirmados": "{n} confirmed",
 "{n} convidados contam no ⊕ por convidado.": "{n} guests count in ⊕ per guest.",
 "{n} convidados que estavam em \"Pendente\" passaram para \"A convidar\". Ao enviar o convite pelo app, eles passam sozinhos para \"Convidado, sem resposta\".": "{n} guests who were \"Pending\" moved to \"To invite\". When you send the invitation through the app, they move automatically to \"Invited, no answer\".",
 "{n} extras": "{n} extra",
 "{n} talvez": "{n} maybe",
 "{q} por convidado": "{q} per guest",
 "{v} por convidado": "{v} per guest",
 "Item completo": "Full item",
 "Nota rápida": "Quick note",
 "📝 Nota rápida": "📝 Quick note",
 "Conteúdo da nota": "Note",
 "{c} confirmado(s) de {n} convidado(s)": "{c} confirmed of {n} guest(s)",
 "Serão apagados para todos: os documentos, as reuniões marcadas e as gravações do escritório \"{nome}\". A conversa continua no Mensagens.": "This will be deleted for everyone: the documents, scheduled meetings and recordings of the office \"{nome}\". The chat stays in Messages.",
 "Confirme para apagar o escritório": "Confirm to delete the office",
 "Escreva o assunto da reunião para poder marcar.": "Write the meeting subject to schedule it.",
 "{n} min (marcada para {m} min)": "{n} min (scheduled for {m} min)",
 "Não foi possível baixar o arquivo agora. Confira a internet e tente de novo.": "Couldn’t download the file right now. Check your internet and try again.",
 "Meus clientes": "My clients",
 "Uma lista só de clientes, usada por todas as abas de trabalho: contato, endereço, etiquetas, anotações e arquivos.": "One client list, used by every work tab: contact, address, tags, notes and files.",
 "Copiar para Meus clientes": "Copy to My clients",
 "Ver ou mudar": "View or change",
 "Ver o documento completo": "View full document",
 "CEP incompleto": "Incomplete CEP",
 "O CEP tem 8 números.": "The CEP has 8 digits.",
 "CEP não encontrado": "CEP not found",
 "Confira os números ou preencha o endereço à mão.": "Check the numbers or fill in the address by hand.",
 "Não foi possível buscar o CEP": "Couldn’t look up the CEP",
 "Confira a internet ou preencha o endereço à mão.": "Check your internet connection or fill in the address by hand.",
 "Parece que falta algo neste e-mail (ex.: nome@site.com).": "This email seems to be missing something (e.g. name@site.com).",
 "opcional": "optional",
 "Os seus clientes agora ficam numa lista só, usada por todas as abas de trabalho.": "Your clients are now in one list, used by every work tab.",
 "Portal do Cliente: {n} cliente(s).": "Client Portal: {n} client(s).",
 "Freelancer & Projetos: {n} cliente(s).": "Freelancer & Projects: {n} client(s).",
 "{n} eram o mesmo cliente em mais de uma aba e viraram uma ficha só.": "{n} were the same client in more than one tab and became a single record.",
 "Nenhum cliente repetido.": "No duplicate clients.",
 "Nada foi apagado: documentos, pedidos, cartões e horas continuam onde estavam.": "Nothing was deleted: documents, orders, cards and hours stay where they were.",
 "Já está em Meus clientes": "Already in My clients",
 "{nome} já está na lista.": "{nome} is already on the list.",
 "Copiado para Meus clientes": "Copied to My clients",
 "Só o nome e o contato foram copiados.": "Only the name and contact were copied.",
 "Aniversário hoje!": "Birthday today!",
 "Fechar tudo": "Collapse all",
 "Abrir tudo": "Expand all",
 "Quem é": "Who they are",
 "Razão social": "Legal name",
 "Nome fantasia": "Trade name",
 "Data de abertura": "Founded on",
 "Inscrição estadual / municipal": "State / municipal registration",
 "Outras pessoas de contato": "Other contact people",
 "Como chamar": "What to call them",
 "Cliente desde": "Client since",
 "Outro telefone": "Other phone",
 "Site": "Website",
 "Melhor jeito de falar": "Best way to reach them",
 "Autorizou receber mensagens": "Agreed to receive messages",
 "Outros endereços": "Other addresses",
 "Relacionamento": "Relationship",
 "Como me conheceu": "How they found me",
 "Etiquetas": "Tags",
 "Nada anotado ainda.": "No notes yet.",
 "Bloco da aba {aba}": "{aba} tab section",
 "Abrir na aba {aba}": "Open in the {aba} tab",
 "Uma lista só, usada por todas as abas de trabalho.": "One list, used by every work tab.",
 "Escreva o nome do cliente.": "Enter the client’s name.",
 "Telefone / WhatsApp": "Phone / WhatsApp",
 "Só o nome é obrigatório. Abra as partes que quiser preencher.": "Only the name is required. Open the parts you want to fill in.",
 "Como chamar (apelido)": "What to call them (nickname)",
 "Inscrição estadual / municipal (opcional)": "State / municipal registration (optional)",
 "Cargo": "Position",
 "Telefone da pessoa de contato": "Contact person’s phone",
 "Outras pessoas de contato (uma por linha: nome, cargo, telefone)": "Other contact people (one per line: name, position, phone)",
 "O telefone principal é WhatsApp": "Main phone is on WhatsApp",
 "O outro telefone é WhatsApp": "Other phone is on WhatsApp",
 "Instagram": "Instagram",
 "Ex.: @nome": "E.g. @name",
 "Ex.: WhatsApp, à tarde": "E.g. WhatsApp, afternoons",
 "Estado (UF)": "State",
 "Endereço (como estava escrito)": "Address (as it was written)",
 "Outros endereços (trabalho, entrega...)": "Other addresses (work, delivery...)",
 "Google": "Google",
 "Passou na frente": "Walked by",
 "Indicado por": "Referred by",
 "Criar etiqueta": "Create tag",
 "Ex.: VIP, Mensal, Atacado": "E.g. VIP, Monthly, Wholesale",
 "Ativo": "Active",
 "Inativo": "Inactive",
 "Em negociação": "In negotiation",
 "O cliente autorizou receber mensagens?": "Has the client agreed to receive messages?",
 "Sem autorização, nada de mensagem de aniversário, cobrança automática ou promoção para este cliente.": "Without consent, no birthday messages, automatic payment reminders or promotions for this client.",
 "aniversário hoje": "birthday today",
 "contato: {n}": "contact: {n}",
 "com esse telefone": "with this phone",
 "com esse e-mail": "with this email",
 "com esse documento": "with this ID number",
 "com esse nome": "with this name",
 "Cliente parecido": "Similar client",
 "Já existe {nome} {por}. Abrir?": "{nome} already exists {por}. Open?",
 "Cadastrar mesmo assim": "Add anyway",
 "Serão apagados: a ficha, as anotações e os arquivos deste cliente.": "This will delete the client’s record, notes and files.",
 "Também nas abas: {abas} (com os documentos, pedidos, cartões e horas de lá).": "Also in the tabs: {abas} (with their documents, orders, cards and hours).",
 "Juntar com outra ficha": "Merge with another record",
 "Juntar fichas": "Merge records",
 "Não há outra ficha para juntar.": "There’s no other record to merge.",
 "Juntar \"{nome}\" com:": "Merge \"{nome}\" with:",
 "Juntar as duas fichas?": "Merge the two records?",
 "\"{a}\" fica com tudo de \"{b}\" (dados, anotações, arquivos e as ligações com as abas). A ficha \"{b}\" deixa de existir.": "\"{a}\" gets everything from \"{b}\" (details, notes, files and links to tabs). The \"{b}\" record will no longer exist.",
 "Juntar": "Merge",
 "Confirme para juntar as fichas": "Confirm to merge the records",
 "Aniversariantes do mês": "Birthdays this month",
 "Ativos": "Active",
 "Inativos": "Inactive",
 "Cadastre cada cliente uma vez: ele aparece em todas as abas de trabalho que você usa.": "Add each client once: they show up in every work tab you use.",
 "Novo cliente": "New client",
 "Editar cliente": "Edit client",
 "Linha do tempo": "Timeline",
 "{n} registro(s)": "{n} record(s)",
 "Nada ainda. Vendas, pagamentos, documentos e horas aparecem aqui.": "Nothing yet. Sales, payments, documents and hours show up here.",
 "Me deve": "Owes me",
 "Total pago": "Total paid",
 "Última compra ou atendimento": "Last purchase or service",
 "Próximo compromisso": "Next appointment",
 "na entrega": "on delivery",
 "Passou do limite de fiado ({v}).": "Over the credit limit ({v}).",
 "Recebeu {v} ({p})": "Received {v} ({p})",
 "Hoje é aniversário de {n}.": "Today is {n}’s birthday.",
 "Mandar parabéns": "Send wishes",
 "{n}: parcela de {v} atrasada.": "{n}: {v} installment overdue.",
 "Cobrar": "Request payment",
 "{n} não compra há {d} dias.": "{n} hasn’t bought in {d} days.",
 "Chamar de volta": "Reach out",
 "🟢 em dia · 🟡 sumido": "🟢 up to date · 🟡 gone quiet",
 "🟢 em dia · 🟡 algo vencendo ou cliente sumido · 🔴 atrasado": "🟢 up to date · 🟡 something due soon or client gone quiet · 🔴 overdue",
 "Limite de fiado (opcional)": "Credit limit (optional)",
 "Avisa quando o que ele deve passar deste valor.": "Alerts you when what they owe goes over this amount.",
 "A prazo": "In installments",
 "parcela atrasada": "overdue installment",
 "falta na entrega": "due on delivery",
 "Sumidos": "Gone quiet",
 "Sinal pago, falta o resto": "Deposit paid, balance due",
 "Pagou {a} de {b}": "Paid {a} of {b}",
 "Esta parcela vem de Meus clientes. Marque aqui como recebida ou abra o cliente para cobrar e gerar o recibo.": "This installment comes from My clients. Mark it as received here, or open the client to request payment and create the receipt.",
 "Sinal + restante": "Deposit + balance",
 "Pix": "Pix",
 "Cartão de crédito à vista": "Credit card, single payment",
 "Cartão de crédito parcelado": "Credit card, installments",
 "Fiado / a prazo": "On credit / installments",
 "Parcela única": "Single payment",
 "Oi, {nome}! Feliz aniversário! 🎉 Que o seu dia seja lindo. Um abraço!": "Hi, {nome}! Happy birthday! 🎉 Wishing you a wonderful day. Hugs!",
 "Oi, {nome}! Faz tempo que a gente não se fala. Posso ajudar em alguma coisa? Vai ser um prazer te atender de novo!": "Hi, {nome}! It’s been a while. Can I help you with anything? I’d love to serve you again!",
 "Oi, {nome}! Passando para lembrar da parcela de {v} que venceu dia {d}. Qualquer coisa, me chama. Obrigada!": "Hi, {nome}! Just a friendly reminder about the installment of {v} that was due on {d}. Let me know if you need anything. Thank you!",
 "Oi, {nome}! Passando para lembrar da parcela de {v}{d}. Qualquer coisa, me chama. Obrigada!": "Hi, {nome}! Just a friendly reminder about the installment of {v}{d}. Let me know if you need anything. Thank you!",
 "que vence dia {d}": "due on {d}",
 "Quanto recebeu?": "How much did you receive?",
 "Falta {v}. Pode ser só uma parte.": "{v} left. It can be just part of it.",
 "(seu nome ou sua marca, em Como você recebe?)": "(your name or brand, in How do you get paid?)",
 "Recibo {c}": "Receipt {c}",
 "Recebi de {c} a quantia de {v}, referente a {o}.": "I received from {c} the amount of {v} for {o}.",
 "{v} no {f} → recebe {l}": "{v} via {f} → you get {l}",
 "Pagou {a} de {b}, faltam {c}": "Paid {a} of {b}, {c} left",
 "Recebido em {d}": "Received on {d}",
 "Cobrar pelo WhatsApp": "Request payment on WhatsApp",
 "Sem autorização": "Not allowed",
 "Este cliente não autorizou receber mensagens (ficha do cliente › Relacionamento).": "This client hasn’t agreed to receive messages (client profile › Relationship).",
 "Sem telefone": "No phone number",
 "Coloque o telefone na ficha do cliente.": "Add a phone number to the client profile.",
 "Gerar recibo": "Create receipt",
 "Como você recebe?": "How do you get paid?",
 "Só \"À vista\": a tela fica limpa, sem a prazo, parcelas nem vermelho.": "Only \"Upfront\": a clean screen, with no installments or red.",
 "Taxa da maquininha (%)": "Card machine fee (%)",
 "Taxa {k}": "{k} fee",
 "Cliente sumido depois de (dias sem comprar)": "Client gone quiet after (days without buying)",
 "Dias para considerar sumido": "Days before marking as gone quiet",
 "Lembretes de cobrança por parcela atrasada": "Payment reminders for overdue installments",
 "Nome ou marca no recibo": "Name or brand on receipt",
 "Ex.: Ana Beatriz Doces": "e.g. Ana Beatriz Sweets",
 "Venda ou serviço": "Sale or service",
 "O que foi vendido ou feito": "What was sold or done",
 "Ex.: Bolo de aniversário": "e.g. Birthday cake",
 "Como paga": "How they pay",
 "Sinal (%)": "Deposit (%)",
 "Ou escreva o valor do sinal logo abaixo.": "Or enter the deposit amount just below.",
 "Sinal (valor)": "Deposit (amount)",
 "Restante na entrega": "Balance on delivery",
 "Próximo vencimento": "Next due date",
 "Sinal a receber": "Deposit to collect",
 "falta {v}{q}": "{v} left{q}",
 "quitado": "paid off",
 "Parcelas mantidas": "Installments kept",
 "Já há pagamento registrado: as parcelas não foram refeitas. Para mudar, desfaça os pagamentos primeiro.": "A payment is already recorded, so the installments weren’t redone. To change them, undo the payments first.",
 "Registre o que o cliente comprou ou o serviço que você fez, e como ele paga.": "Record what the client bought or the service you provided, and how they pay.",
 "Débito": "Debit",
 "Crédito à vista": "Credit, single payment",
 "Crédito 2x": "Credit, 2 installments",
 "Crédito 3x": "Credit, 3 installments",
 "Crédito 4x": "Credit, 4 installments",
 "Crédito 5x": "Credit, 5 installments",
 "Crédito 6x": "Credit, 6 installments",
 "Crédito 7x": "Credit, 7 installments",
 "Crédito 8x": "Credit, 8 installments",
 "Crédito 9x": "Credit, 9 installments",
 "Crédito 10x": "Credit, 10 installments",
 "Crédito 11x": "Credit, 11 installments",
 "Crédito 12x": "Credit, 12 installments",
 "ATRASADOS": "OVERDUE",
 "Atrasado (hoje): {v}": "Overdue (today): {v}",
 "Buscar um cliente": "Search for a client",
 "CPF/CNPJ completo, endereço completo e data de nascimento. Pede a senha do app.": "Full CPF/CNPJ, full address and date of birth. Asks for the app password.",
 "Cliente cadastrado": "Client added",
 "Com documentos: guarde o arquivo em lugar seguro.": "With documents: keep the file somewhere safe.",
 "Como pagou": "How they paid",
 "Esse contato não tem nome.": "This contact has no name.",
 "Exportar planilha": "Export spreadsheet",
 "Falta receber": "Still to receive",
 "Falta receber (hoje): {v}": "Still to receive (today): {v}",
 "Importar dos contatos": "Import from contacts",
 "Importar dos contatos do celular": "Import from phone contacts",
 "Incluir documentos": "Include documents",
 "Incluir documentos no relatório": "Include documents in the report",
 "MELHORES CLIENTES": "TOP CLIENTS",
 "Melhores clientes": "Top clients",
 "Não foi possível gerar a planilha.": "Couldn’t create the spreadsheet.",
 "O que foi": "What it was",
 "Pago em": "Paid on",
 "Para trazer clientes dos contatos do celular, atualize o My Planner pela loja de aplicativos.": "To bring in clients from your phone contacts, update My Planner from the app store.",
 "RECEBIDO POR DIA": "RECEIVED PER DAY",
 "RECEBIDO POR MÊS": "RECEIVED PER MONTH",
 "Recebeu": "Received",
 "Recebeu no período": "Received in period",
 "Recebeu no período: {v}": "Received in period: {v}",
 "Recebido no período": "Received in period",
 "Relatório de clientes": "Client report",
 "Relatório deste cliente": "Report for this client",
 "Sem a permissão de contatos não dá para escolher um contato. Você pode liberar nos ajustes do celular.": "Without contacts permission you can’t pick a contact. You can allow it in your phone settings.",
 "Sem documentos: o CPF/CNPJ sai só com os 2 últimos números. As anotações nunca saem.": "Without documents: CPF/CNPJ shows only the last 2 digits. Notes are never included.",
 "Todos os clientes": "All clients",
 "Trabalha em: {e}": "Works at: {e}",
 "Trazer outro": "Add another",
 "VENDAS E ATENDIMENTOS": "SALES AND SERVICES",
 "Vence": "Due",
 "Venceu": "Was due",
 "Vendas e atendimentos": "Sales and services",
 "Vendeu": "Sold",
 "Vendeu no período": "Sold in period",
 "Vendeu no período: {v}": "Sold in period: {v}",
 "venceu {d}": "was due {d}",
 "vendido no período": "sold in period",
 "{nome} comprou no período": "{nome} bought in period",
 "{nome} entrou em Meus clientes. Confira a ficha e marque se ele autorizou receber mensagens.": "{nome} was added to My clients. Check their details and mark whether they agreed to receive messages.",
 "{n} compra(s)": "{n} purchase(s)",
 "Arraste uma caixa para a esquerda para arquivar ou para a direita para excluir. Segure numa parte livre da caixa e arraste para mudar a ordem.": "Swipe a box left to archive or right to delete. Hold a free spot on the box and drag to reorder.",
 "Bloco": "Block",
 "Confirme para apagar o grupo": "Confirm to delete the group",
 "Descer": "Move down",
 "Opções do bloco": "Block options",
 "Exigências do destino": "Destination requirements",
 "{n} para acertar": "{n} to settle",
 "{n} parada(s)": "{n} stop(s)",
 "Cor do item selecionado": "Color of the selected item",
 "Abrir o grupo": "Open the group",
 "Recolher o grupo": "Collapse the group",
 "Arraste uma caixa para a direita para excluir ou para a esquerda para arquivar. Segure e arraste para mudar a ordem.": "Swipe a box right to delete or left to archive. Hold and drag to reorder.",
 "Editar subtítulo": "Edit subtitle",
 "Início da caixa": "Top of the box",
 "Mover para…": "Move to…",
 "Mover {n} item(ns) para": "Move {n} item(s) to",
 "Opções do item": "Item options",
 "Transformar em subtítulo": "Turn into subtitle",
 "Transformar em texto": "Turn into text",
 "esta caixa": "this box",
 "{a} de {n} feitos": "{a} of {n} done",
 "1 documento pedido atrasado": "1 requested document overdue",
 "1 pedido vence logo": "1 request due soon",
 "A lista vem de \"Meus clientes\".": "The list comes from \"My clients\".",
 "Abrir Meus clientes": "Open My clients",
 "As abas Escritório e Portal do Cliente agora são uma aba só.": "The Office and Client Portal tabs are now one tab.",
 "Clientes com pendência": "Clients with pending items",
 "Com pendência ({n})": "Pending ({n})",
 "Conversa da equipe": "Team chat",
 "Crie o escritório e chame a equipe (amigos do app ou convite pelo link): conversa, reuniões de vídeo e documentos internos. Trabalha sozinho? Use só os Clientes.": "Create your office and invite your team (app friends or an invite link): chat, video meetings and internal documents. Working solo? Just use Clients.",
 "Documentos internos": "Internal documents",
 "Entrar com um código de convite": "Join with an invite code",
 "Escritório & Clientes": "Office & Clients",
 "Escritórios: {n}": "Offices: {n}",
 "Esta parte é para quem trabalha com equipe": "This part is for people who work with a team",
 "Guias vencendo": "Tax slips due",
 "Minhas tarefas": "My tasks",
 "Nada foi apagado: a equipe, a conversa, as reuniões, os documentos e os clientes convidados continuam como estavam.": "Nothing was deleted: your team, chat, meetings, documents and invited clients are all still there.",
 "Nenhum cliente ainda. Cadastre em \"Meus clientes\": ele aparece aqui na hora.": "No clients yet. Add one in \"My clients\" and it shows up here right away.",
 "Para quem trabalha com clientes, sozinho ou com equipe: a pasta de cada cliente (documentos, pedidos, guias), equipe, conversa, reuniões e documentos internos.": "For anyone who works with clients, solo or with a team: a folder for each client (documents, requests, tax slips), team, chat, meetings and internal documents.",
 "Pastas de clientes do Portal: {c} (com {d} documentos e {p} pedidos)": "Client Portal folders: {c} (with {d} documents and {p} requests)",
 "Pessoa física": "Individual",
 "Procurar por nome, CNPJ ou CPF": "Search by name, CNPJ or CPF",
 "Reuniões hoje": "Meetings today",
 "Sem escritório (equipe). Toque para criar ou entrar com um código.": "No office (team) yet. Tap to create one or join with a code.",
 "Só a equipe vê. Clientes nunca veem esta parte.": "Only your team sees this. Clients never see this part.",
 "Tudo em dia": "All up to date",
 "Vencendo ({n})": "Due soon ({n})",
 "chega na próxima versão": "coming in the next version",
 "nos próximos 7 dias": "in the next 7 days",
 "vence amanhã": "due tomorrow",
 "vence hoje": "due today",
 "{doc} venceu em {d}": "{doc} was due on {d}",
 "{n} documentos pedidos atrasados": "{n} requested documents overdue",
 "{n} pedidos vencem logo": "{n} requests due soon",
 "🟢 em dia · 🟡 algo vence logo · 🔴 pedido atrasado ou guia vencida": "🟢 up to date · 🟡 something due soon · 🔴 overdue request or tax slip",
 "Acesso ao gov.br": "gov.br access",
 "Alvará": "Business license",
 "Até o dia (do mês)": "By day (of the month)",
 "CCMEI (certificado do MEI)": "CCMEI (MEI certificate)",
 "Cadastre o telefone do cliente para lembrar pelo WhatsApp.": "Add the client’s phone to send WhatsApp reminders.",
 "Cartão CNPJ": "CNPJ card",
 "Checklist criado": "Checklist created",
 "Checklist de cliente novo": "New client checklist",
 "Cliente viu {doc}": "Client viewed {doc}",
 "Cole no app do banco, em Pix copia e cola.": "Paste it in your bank app under Pix copy and paste.",
 "Cole no app do banco.": "Paste it in your bank app.",
 "Comprovante de endereço": "Proof of address",
 "Contrato social e alterações": "Articles of association and amendments",
 "Copiado": "Copied",
 "Copiar Pix": "Copy Pix",
 "Copiar código de barras": "Copy barcode",
 "Código de barras (linha digitável)": "Barcode (typeable line)",
 "Dados bancários": "Bank details",
 "Escreva o recado.": "Write the message.",
 "Escritório enviou {doc}": "Office sent {doc}",
 "Este cliente não autorizou receber mensagens (ficha em Meus clientes).": "This client hasn’t agreed to receive messages (see their profile in My clients).",
 "Extratos bancários": "Bank statements",
 "Ficha completa": "Full profile",
 "Guia": "Tax slip",
 "Guias a pagar": "Tax slips to pay",
 "Honorário": "Fee",
 "Honorário por": "Fee per",
 "Informes de rendimentos": "Income statements",
 "Lembrar pelo WhatsApp": "Remind on WhatsApp",
 "Ler a guia ou o boleto com a minha IA": "Read the tax slip or boleto with my AI",
 "Lucro presumido": "Presumed profit",
 "Lucro real": "Actual profit",
 "Nada ainda.": "Nothing yet.",
 "Nenhum pedido em aberto.": "No open requests.",
 "Notas fiscais emitidas": "Issued invoices",
 "O cliente": "The client",
 "O pedido entrou em Pedidos de documentos.": "The request was added to Document requests.",
 "Oi, {nome}! Falta: {itens}. Pode mandar por aqui?": "Hi {nome}! Still missing: {itens}. Can you send it here?",
 "Oi, {nome}! Faltam: {itens}. Pode mandar por aqui?": "Hi {nome}! Still missing: {itens}. Can you send them here?",
 "Oi, {nome}! Tudo certo por aí?": "Hi {nome}! All good on your end?",
 "Pedido criado": "Request created",
 "Pedido feito: {o}": "Request sent: {o}",
 "Pedido recebido: {o}": "Request received: {o}",
 "Pedidos pendentes": "Pending requests",
 "Pedir de novo todo mês": "Request again every month",
 "Pedir nova ({c})": "Request new ({c})",
 "Pendentes": "Pending",
 "Que tipo de cliente?": "What type of client?",
 "RG e CPF": "RG and CPF",
 "RG e CPF do titular": "Owner’s RG and CPF",
 "RG e CPF dos sócios": "Partners’ RG and CPF",
 "Recados": "Messages",
 "Recados entre você e o cliente, presos à pasta dele.": "Messages between you and the client, kept in their folder.",
 "Responde ao pedido": "Answers the request",
 "Tipo / regime": "Type / tax regime",
 "Visto pelo cliente em {d}": "Viewed by the client on {d}",
 "Válido até": "Valid until",
 "ano": "year",
 "código Pix copia e cola, se houver": "Pix copy-and-paste code, if any",
 "data de vencimento": "due date",
 "documento": "document",
 "linha digitável do boleto ou da guia, só números": "typeable line of the boleto or tax slip, digits only",
 "mês": "month",
 "novo": "new",
 "todo mês, até o dia {n}": "every month, by day {n}",
 "valor a pagar": "amount due",
 "válido até {d}": "valid until {d}",
 "{c} nova": "New {c}",
 "{doc} pago": "{doc} paid",
 "{n} a pagar": "{n} to pay",
 "{n} enviou {doc}": "{n} sent {doc}",
 "{n} novo(s)": "{n} new",
 "{n} pedido(s) de documentos criados, com prazo de 7 dias.": "{n} document request(s) created, due in 7 days.",
 "{n} vencida(s)": "{n} overdue",
 "Última declaração do Imposto de Renda": "Latest income tax return",
 "Últimas guias pagas": "Latest paid tax slips",
 "Esta parte do Escritório ainda não foi ligada no servidor. No computador, rode o 56-SERVIDOR-0.96.bat (uma vez só).": "This part of the Office has not been connected to the server yet. On the computer, run 56-SERVIDOR-0.96.bat (just once).",
 "Só vê": "View only",
 "Nova versão": "New version",
 "Já havia um arquivo com este nome: o anterior fica guardado como versão {n}.": "There was already a file with this name: the previous one is kept as version {n}.",
 "Visto por e comentários": "Seen by & comments",
 "Arquivar (só neste aparelho)": "Archive (this device only)",
 "Tirar do topo": "Unpin from top",
 "Fixar no topo (para todos)": "Pin to top (for everyone)",
 "Mover para a pasta…": "Move to folder…",
 "versão {n}": "version {n}",
 "visto por {n}": "seen by {n}",
 "Até 50 MB por arquivo. Enviar um arquivo com o mesmo nome guarda o anterior como versão.": "Up to 50 MB per file. Uploading a file with the same name keeps the previous one as a version.",
 "Procurar documento ou pasta": "Search document or folder",
 "Fixados": "Pinned",
 "Abrir o documento": "Open the document",
 "enviado por {nome}": "uploaded by {nome}",
 "Versões ({n})": "Versions ({n})",
 "Versão {n} (atual)": "Version {n} (current)",
 "Versão {n}": "Version {n}",
 "Visto por ({n})": "Seen by ({n})",
 "Ninguém da equipe abriu ainda.": "Nobody on the team has opened it yet.",
 "{nome} em {d}": "{nome} on {d}",
 "Comentários ({n})": "Comments ({n})",
 "Escreva um comentário": "Write a comment",
 "Contratos": "Contracts",
 "Financeiro do escritório": "Office finance",
 "RH": "HR",
 "Mover para a pasta": "Move to folder",
 "Ou escreva o nome de uma pasta nova": "Or type the name of a new folder",
 "Ela se repete toda semana: cancelando, sai de todas as semanas, da lista e dos Recebidos da equipe.": "It repeats every week: cancelling removes it from all weeks, from the list and from the team’s Inbox.",
 "a equipe toda": "the whole team",
 "Com {quem}": "With {quem}",
 "toda semana": "every week",
 "Vão: {n}": "Going: {n}",
 "Não vão: {n}": "Not going: {n}",
 "Vou": "I’ll go",
 "Não vou": "I won’t go",
 "Pauta": "Agenda",
 "Ata": "Minutes",
 "Escrever a ata": "Write the minutes",
 "Abrir o link": "Open the link",
 "Cada pessoa convidada recebe a reunião em Recebidos e coloca no Planner com um toque, com o alerta.": "Each invited person gets the meeting in Inbox and adds it to the Planner with one tap, with the alert.",
 "Escreva primeiro as anotações da reunião (o que foi falado e decidido); a IA organiza em ata.": "First write your meeting notes (what was said and decided); the AI organizes them into minutes.",
 "Ata: {nome}": "Minutes: {nome}",
 "Gerando...": "Generating...",
 "Gerar ata com a minha IA": "Generate minutes with my AI",
 "A IA organiza a pauta e as suas anotações em ata. Confira antes de salvar.": "The AI organizes the agenda and your notes into minutes. Check before saving.",
 "Ainda sem ata.": "No minutes yet.",
 "Tarefas da reunião ({n})": "Meeting tasks ({n})",
 "Tarefa da reunião": "Meeting task",
 "Salvar a ata": "Save the minutes",
 "Repetir toda semana ({dia})": "Repeat every week ({dia})",
 "Quem participa": "Who is attending",
 "A equipe toda": "The whole team",
 "Link externo (opcional: Meet, Zoom, Teams)": "External link (optional: Meet, Zoom, Teams)",
 "O link precisa começar com https://": "The link must start with https://",
 "Marcar e avisar quem participa": "Schedule and notify attendees",
 "Cargo e papel": "Job title and role",
 "Passar o Admin": "Transfer Admin",
 "Passar o Admin para {nome}?": "Transfer Admin to {nome}?",
 "{nome} passa a ser quem cuida do escritório (pode apagá-lo). Você continua na equipe como administrador (quem recebe pode mudar isso depois).": "{nome} becomes the person in charge of the office (and can delete it). You stay on the team as an administrator (the new Admin can change that later).",
 "Passar": "Transfer",
 "{nome} agora cuida do escritório.": "{nome} is now in charge of the office.",
 "Seu papel aqui é \"Só vê\": você acompanha avisos, tarefas, reuniões e documentos.": "Your role here is \"View only\": you follow notices, tasks, meetings and documents.",
 "Edita": "Can edit",
 "Incluir": "Add",
 "Novo aviso no mural": "New notice on the board",
 "Você só pode ver este escritório: quem administra escolheu o papel \"Só vê\" para você. Peça a quem administra para mudar, se precisar.": "You can only view this office: the administrator chose the \"View only\" role for you. Ask the administrator to change it if you need to.",
 "Quem viu": "Who has seen it",
 "Apagar aviso": "Delete notice",
 "Mural de avisos": "Notice board",
 "Novo aviso": "New notice",
 "Ex.: Feriado na sexta: escritório fechado": "E.g.: Holiday on Friday: office closed",
 "Fixar no mural": "Pin to the board",
 "Nenhum aviso. Os avisos ficam fixados aqui para toda a equipe.": "No notices. Notices stay pinned here for the whole team.",
 "visto por {n} de {m}": "seen by {n} of {m}",
 "sem responsável": "no assignee",
 "atrasada desde {d}": "overdue since {d}",
 "prazo {d}": "due {d}",
 "Comecei": "Started",
 "Terminei": "Done",
 "Reabrir": "Reopen",
 "Tarefas da equipe": "Team tasks",
 "1 aberta": "1 open",
 "{n} abertas": "{n} open",
 "Minhas tarefas ({n})": "My tasks ({n})",
 "Nenhuma tarefa sua aberta. Toque em \"Eu faço\" numa tarefa da equipe.": "None of your tasks are open. Tap \"I’ll do it\" on a team task.",
 "Nenhuma tarefa aberta.": "No open tasks.",
 "Feitas ({n})": "Done ({n})",
 "Apagar a tarefa?": "Delete the task?",
 "O que precisa ser feito? (ex.: Apurar o DAS de março)": "What needs to be done? (e.g.: Calculate the March DAS)",
 "Cliente (opcional)": "Client (optional)",
 "Prazo (opcional)": "Due date (optional)",
 "Responsável (opcional; senão, alguém toca em \"Eu faço\")": "Assignee (optional; otherwise someone taps \"I’ll do it\")",
 "Escreva a tarefa para poder salvar.": "Write the task so you can save it.",
 "Membro": "Member",
 "Cargo (livre)": "Job title (free text)",
 "Ex.: Advogada, Assistente, Estagiário": "E.g.: Lawyer, Assistant, Intern",
 "Papel": "Role",
 "Admin: pode tudo no escritório.": "Admin: can do everything in the office.",
 "Edita: inclui tarefas, avisos, documentos e reuniões": "Can edit: adds tasks, notices, documents and meetings",
 "Só vê: acompanha tudo, sem incluir nem mudar": "View only: follows everything, without adding or changing",
 "Proposta": "Proposal",
 "Documento sensível (pede a senha do app para abrir)": "Sensitive document (asks for the app password to open)",
 "Li e concordo: {d}": "Read and agreed: {d}",
 "Li e concordo": "I have read and agree",
 "Ao tocar em Concordo, o app guarda a data e a hora em que você leu e concordou com \"{doc}\". É um aceite simples: não substitui uma assinatura digital oficial.": "When you tap Agree, the app saves the date and time you read and agreed to \"{doc}\". It is a simple acceptance: it does not replace an official digital signature.",
 "Concordo": "Agree",
 "Fotos (escolha quais entram)": "Photos (choose which ones)",
 "1 foto não pôde ser lida neste dispositivo e ficou de fora.": "1 photo could not be read on this device and was left out.",
 "{n} fotos não puderam ser lidas neste dispositivo e ficaram de fora.": "{n} photos could not be read on this device and were left out.",
 "Nenhuma foto no álbum desta viagem.": "No photos in this trip’s album.",
 "Toque nas fotos para marcar ou desmarcar. Elas entram reduzidas, para o PDF ficar leve.": "Tap the photos to select or unselect them. They go in reduced, so the PDF stays light.",
 "Sugerir até 12": "Suggest up to 12",
 "1 foto marcada": "1 photo selected",
 "{n} fotos marcadas": "{n} photos selected",
 "Com mais de 12 fotos o PDF fica mais pesado.": "With more than 12 photos the PDF gets heavier.",
 "Confirme para abrir este documento": "Confirm to open this document",
 "Como usar esta aba": "How to use this tab",
 "1 cliente estava em mais de uma aba e virou uma ficha só.": "1 client was in more than one tab and became a single record.",
 "Juntar {n} fotos num PDF?": "Merge {n} photos into one PDF?",
 "As fotos viram as páginas de um PDF só, na ordem da lista. As fotos soltas saem desta ficha.": "The photos become the pages of a single PDF, in list order. The loose photos are removed from this record.",
 "Não foi possível ler as fotos neste dispositivo.": "Could not read the photos on this device.",
 "PDF criado": "PDF created",
 "Montando o PDF...": "Building the PDF...",
 "Juntar as {n} fotos num PDF": "Merge the {n} photos into one PDF",
 "Baixar o mês": "Download the month",
 "Os arquivos deste mês estão em outro dispositivo e não puderam ser lidos aqui.": "This month’s files are on another device and could not be read here.",
 "Os documentos deste mês não têm arquivos.": "This month’s documents have no files.",
 "1 arquivo está em outro dispositivo e ficou de fora.": "1 file is on another device and was left out.",
 "{n} arquivos estão em outro dispositivo e ficaram de fora.": "{n} files are on another device and were left out.",
 "Conversa sobre este documento": "Conversation about this document",
 "Pergunte ou responda algo sobre este documento. O escritório e o cliente veem.": "Ask or reply about this document. The office and the client can see it.",
 "Escreva a mensagem": "Write the message",
 "Usar um modelo de pedido ({n})": "Use a request template ({n})",
 "Lembrar {nome} pelo WhatsApp: {o}": "Remind {nome} via WhatsApp: {o}",
 "Sem honorário": "No fee",
 "Cadastre o valor do honorário no bloco \"Escritório\" da ficha do cliente, em Meus clientes.": "Enter the fee amount in the \"Office\" block of the client’s record, under My clients.",
 "Recebi de {c} a quantia de {v}, referente aos honorários da competência {m}.": "Received from {c} the amount of {v}, referring to the fees for the period {m}.",
 "Recibo honorário {m} {c}": "Fee receipt {m} {c}",
 "Recibo do honorário {m}": "Fee receipt {m}",
 "Recibo criado": "Receipt created",
 "O recibo entrou em Documentos, na competência {m}.": "The receipt was added to Documents, under period {m}.",
 "Vendo como o cliente": "Viewing as the client",
 "É assim que o cliente vê a pasta dele: sem as anotações internas e sem o que é só da equipe. Nada pode ser mudado neste modo.": "This is how the client sees their folder: without the internal notes and without what is for the team only. Nothing can be changed in this mode.",
 "Voltar a ver como escritório": "Back to viewing as the office",
 "Ver como o cliente": "View as the client",
 "🔒 Anotações internas (o cliente nunca vê)": "🔒 Internal notes (the client never sees them)",
 "Recibo do honorário…": "Fee receipt…",
 "Competência do recibo": "Receipt period",
 "⬇️ Baixar o mês": "⬇️ Download the month",
 "Me avisar para lembrar o cliente": "Notify me to remind the client",
 "Guardar como modelo": "Save as template",
 "Modelo guardado": "Template saved",
 "Ao criar um pedido para qualquer cliente, toque em \"Usar um modelo de pedido\".": "When creating a request for any client, tap \"Use a request template\".",
 "Relatório do mês": "Monthly report",
 "Notas rápidas": "Quick notes",
 "Item completo: {o}": "Full item: {o}",
 "Reuniões do mês": "Meetings of the month",
 "Tarefas feitas e pendentes": "Completed and pending tasks",
 "Documentos internos enviados": "Internal documents sent",
 "Documentos enviados e recebidos dos clientes": "Documents sent to and received from clients",
 "Documentos da competência": "Documents of the period",
 "Guias pagas e vencidas": "Paid and overdue tax slips",
 "Honorários": "Fees",
 "Relatório do mês · {m}": "Monthly report · {m}",
 "Reuniões ({n})": "Meetings ({n})",
 "Tarefas: {f} feitas no mês · {p} pendentes": "Tasks: {f} done this month · {p} pending",
 "Quem fez": "Done by",
 "Feita em": "Done on",
 "Documentos internos enviados ({n})": "Internal documents sent ({n})",
 "Documentos trocados com os clientes": "Documents exchanged with clients",
 "Enviados pelo escritório": "Sent by the office",
 "Recebidos do cliente": "Received from the client",
 "Nenhum documento trocado neste mês.": "No documents exchanged this month.",
 "Clientes com pendência ({n})": "Clients with pending items ({n})",
 "Pendência": "Pending item",
 "Nenhum cliente com pendência.": "No client has pending items.",
 "Documentos da competência {m} ({n})": "Documents for period {m} ({n})",
 "Pedidos de documentos ({n})": "Document requests ({n})",
 "Guias do mês: {p} pagas · {v} vencidas": "Tax slips this month: {p} paid · {v} overdue",
 "Vencida": "Overdue",
 "Recebido no mês": "Received this month",
 "Relatório {m} {q}": "Report {m} {q}",
 "MÊS": "MONTH",
 "DE QUEM": "FOR WHOM",
 "O escritório": "The office",
 "Reuniões, tarefas e documentos internos entram quando há um escritório (equipe).": "Meetings, tasks and internal documents are included when there is an office (team).",
 "CPF, CNPJ, anotações internas e conversas nunca vão para o relatório.": "CPF, CNPJ, internal notes and conversations never go into the report.",
 "Anotações recebidas": "Received notes",
 "Os valores a receber desta lista aparecem no My Planner, inclusive os novos.": "The amounts to receive from this list appear in My Planner, including new ones.",
 "Envia só os valores a receber desta lista (as consultas já vão sozinhas), inclusive os novos.": "Sends only the amounts to receive from this list (appointments already go on their own), including new ones.",
 "Acrescentar": "Add",
 "As {n} caixas estão em {aba}, em \"Anotações recebidas\".": "The {n} boxes are in {aba}, under \"Received notes\".",
 "Enviadas": "Sent",
 "Enviar para": "Send to",
 "Excluir 1 item?": "Delete 1 item?",
 "Excluir {n} itens?": "Delete {n} items?",
 "Inserir abaixo": "Insert below",
 "Mover para": "Move to",
 "Mover {n} selecionados para": "Move {n} selected to",
 "adicionar aqui": "add here",
 "continue segurando para selecionar": "keep holding to select"
}
